import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
};

export type AffiliationIframely = {
  __typename?: 'AffiliationIframely';
  html: Scalars['String']['output'];
  meta: AffiliationIframelyMeta;
};

export type AffiliationIframelyMeta = {
  __typename?: 'AffiliationIframelyMeta';
  author: Scalars['String']['output'];
  site: Scalars['String']['output'];
  template: CeriseAffiliationTemplate;
  type: Array<CeriseAffiliationType>;
  url: Scalars['String']['output'];
};

export type AffilizzCard = {
  __typename?: 'AffilizzCard';
  contents: Array<AffilizzCardContent>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AffilizzCardContent = {
  __typename?: 'AffilizzCardContent';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  items: Array<AffilizzCardItem>;
  negativePoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offerButtonContent: Scalars['String']['output'];
  positivePoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tag?: Maybe<Scalars['String']['output']>;
  tinyCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<AffilizzPublicationType>;
};

export type AffilizzCardItem = {
  __typename?: 'AffilizzCardItem';
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nbOffers: Scalars['Int']['output'];
};

export type AffilizzCataglogProductCreation = {
  __typename?: 'AffilizzCataglogProductCreation';
  catalogId: Scalars['String']['output'];
  defaultImage: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productCatalogId: Scalars['String']['output'];
  productCatalogLocalizedId: Scalars['String']['output'];
  products: Array<AffilizzCatalogProduct>;
  tinyCode: Scalars['String']['output'];
};

export type AffilizzCatalogProduct = {
  __typename?: 'AffilizzCatalogProduct';
  id: Scalars['String']['output'];
  items: Array<AffilizzCatalogProductItem>;
};

export type AffilizzCatalogProductItem = {
  __typename?: 'AffilizzCatalogProductItem';
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nbOffers: Scalars['Int']['output'];
  productLocalizedIds: Array<Scalars['String']['output']>;
};

export type AffilizzCategoryBrand = {
  __typename?: 'AffilizzCategoryBrand';
  name: Scalars['String']['output'];
};

export enum AffilizzDesignOriginType {
  AFFILIZZ = 'AFFILIZZ',
  USER = 'USER'
}

export enum AffilizzDesignOriginTypeResult {
  AFFILIZZ = 'AFFILIZZ',
  USER = 'USER'
}

export enum AffilizzDesignRenderingType {
  BOX = 'BOX',
  CARD = 'CARD',
  CAROUSEL = 'CAROUSEL',
  CTA = 'CTA',
  LINK = 'LINK'
}

export enum AffilizzDesignRenderingTypeResult {
  BOX = 'BOX',
  CARD = 'CARD',
  CAROUSEL = 'CAROUSEL',
  CTA = 'CTA',
  LINK = 'LINK'
}

export enum AffilizzDesignState {
  PUBLISHED = 'PUBLISHED',
  PUBLISHED_BUT_AMENDED = 'PUBLISHED_BUT_AMENDED',
  UNPUBLISHED = 'UNPUBLISHED'
}

export enum AffilizzDesignStateResult {
  PUBLISHED = 'PUBLISHED',
  PUBLISHED_BUT_AMENDED = 'PUBLISHED_BUT_AMENDED',
  UNPUBLISHED = 'UNPUBLISHED'
}

export type AffilizzProduct = {
  __typename?: 'AffilizzProduct';
  brand?: Maybe<AffilizzProductBrand>;
  categories?: Maybe<Array<AffilizzCategoryBrand>>;
  currencyCode: Scalars['String']['output'];
  defaultImage: Scalars['String']['output'];
  downsides?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  maxPrice: Scalars['Float']['output'];
  minPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nbOffers: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
  productLocalizedId: Scalars['String']['output'];
  type: AffilizzProductType;
  upsides?: Maybe<Array<Scalars['String']['output']>>;
};

export type AffilizzProductBrand = {
  __typename?: 'AffilizzProductBrand';
  name: Scalars['String']['output'];
};

export enum AffilizzProductSearchSor {
  NB_OFFERS = 'NB_OFFERS',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  RELEVANCE = 'RELEVANCE'
}

export enum AffilizzProductType {
  CatalogProduct = 'CatalogProduct',
  Product = 'Product'
}

export enum AffilizzPublicationType {
  CARD = 'CARD'
}

/** An article */
export type Article = {
  __typename?: 'Article';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "ArticleAuthor.article"'s inverse relation count */
  articleAuthorCount: Scalars['Int']['output'];
  /** "ArticleAuthor.article"'s inverse relation */
  articleAuthors: Array<ArticleAuthor>;
  /** "ArticleCategory.article"'s inverse relation */
  articleCategories: Array<ArticleCategory>;
  /** "ArticleCategory.article"'s inverse relation count */
  articleCategoryCount: Scalars['Int']['output'];
  /** "ArticleChannel.article"'s inverse relation count */
  articleChannelCount: Scalars['Int']['output'];
  /** "ArticleChannel.article"'s inverse relation */
  articleChannels: Array<ArticleChannel>;
  /** "ArticleCreatorData.article"'s inverse relation */
  articleCreatorData?: Maybe<ArticleCreatorData>;
  /** "ArticleEvent.article"'s inverse relation count */
  articleEventCount: Scalars['Int']['output'];
  /** "ArticleEvent.article"'s inverse relation */
  articleEvents: Array<ArticleEvent>;
  /** "ArticleExtension.article"'s inverse relation */
  articleExtension?: Maybe<ArticleExtension>;
  /** "ArticleGoodDealAiProcess.article"'s inverse relation count */
  articleGoodDealAiProcessCount: Scalars['Int']['output'];
  /** "ArticleGoodDealAiProcess.article"'s inverse relation */
  articleGoodDealAiProcesses: Array<ArticleGoodDealAiProcess>;
  /** "ArticleGuide.article"'s inverse relation count */
  articleGuideCount: Scalars['Int']['output'];
  /** "ArticleGuide.article"'s inverse relation */
  articleGuides: Array<ArticleGuide>;
  /** "ArticleHistory.article"'s inverse relation */
  articleHistories: Array<ArticleHistory>;
  /** "ArticleHistory.article"'s inverse relation count */
  articleHistoryCount: Scalars['Int']['output'];
  /** "ArticleMachineTag.article"'s inverse relation count */
  articleMachineTagCount: Scalars['Int']['output'];
  /** "ArticleMachineTag.article"'s inverse relation */
  articleMachineTags: Array<ArticleMachineTag>;
  /** "ArticleQualifier.article"'s inverse relation count */
  articleQualifierCount: Scalars['Int']['output'];
  /** "ArticleQualifier.article"'s inverse relation */
  articleQualifiers: Array<ArticleQualifier>;
  /** "ArticleTag.article"'s inverse relation count */
  articleTagCount: Scalars['Int']['output'];
  /** "ArticleTag.article"'s inverse relation */
  articleTags: Array<ArticleTag>;
  /** "ArticleTaxonomy.article"'s inverse relation */
  articleTaxonomies: Array<ArticleTaxonomy>;
  /** "ArticleTaxonomy.article"'s inverse relation count */
  articleTaxonomyCount: Scalars['Int']['output'];
  /** "ArticleUrl.article"'s inverse relation count */
  articleUrlCount: Scalars['Int']['output'];
  /** "ArticleUrl.article"'s inverse relation */
  articleUrls: Array<ArticleUrl>;
  /** "ArticleUser.article"'s inverse relation count */
  articleUserCount: Scalars['Int']['output'];
  /** "ArticleUser.article"'s inverse relation */
  articleUsers: Array<ArticleUser>;
  body?: Maybe<Scalars['String']['output']>;
  bodyMedias?: Maybe<Scalars['String']['output']>;
  brandKey: BrandKey;
  /** The proper article url based on the user device and the server environment */
  contextualizedUrl?: Maybe<Scalars['String']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  discoverTitle?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  format: ArticleFormat;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** Defines whether an article is confidential or not */
  isClassified?: Maybe<Scalars['Boolean']['output']>;
  lead?: Maybe<Scalars['String']['output']>;
  /** "Live.article"'s inverse relation */
  live?: Maybe<Live>;
  medias?: Maybe<Scalars['String']['output']>;
  /** "OpenAiProcess.article"'s inverse relation count */
  openAiProcessCount: Scalars['Int']['output'];
  /** "OpenAiProcess.article"'s inverse relation */
  openAiProcesses: Array<OpenAiProcess>;
  /** "ArticleHistory.duplicatedArticle"'s inverse relation */
  parentArticle: Array<ArticleHistory>;
  /** "ArticleHistory.duplicatedArticle"'s inverse relation count */
  parentArticleCount: Scalars['Int']['output'];
  partnerTitle?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** "Push.article"'s inverse relation count */
  pushCount: Scalars['Int']['output'];
  /** "Push.article"'s inverse relation */
  pushes: Array<Push>;
  secondaryTitle?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Source>;
  status: ArticleStatus;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** An article */
export type ArticleArticleAuthorCountArgs = {
  where?: InputMaybe<ArticleAuthorWhereInput>;
};


/** An article */
export type ArticleArticleAuthorsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleAuthorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleAuthorWhereInput>;
};


/** An article */
export type ArticleArticleCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleCategoryWhereInput>;
};


/** An article */
export type ArticleArticleCategoryCountArgs = {
  where?: InputMaybe<ArticleCategoryWhereInput>;
};


/** An article */
export type ArticleArticleChannelCountArgs = {
  where?: InputMaybe<ArticleChannelWhereInput>;
};


/** An article */
export type ArticleArticleChannelsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleChannelOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleChannelWhereInput>;
};


/** An article */
export type ArticleArticleEventCountArgs = {
  where?: InputMaybe<ArticleEventWhereInput>;
};


/** An article */
export type ArticleArticleEventsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleEventOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleEventWhereInput>;
};


/** An article */
export type ArticleArticleGoodDealAiProcessCountArgs = {
  where?: InputMaybe<ArticleGoodDealAiProcessWhereInput>;
};


/** An article */
export type ArticleArticleGoodDealAiProcessesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiProcessOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleGoodDealAiProcessWhereInput>;
};


/** An article */
export type ArticleArticleGuideCountArgs = {
  where?: InputMaybe<ArticleGuideWhereInput>;
};


/** An article */
export type ArticleArticleGuidesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleGuideOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleGuideWhereInput>;
};


/** An article */
export type ArticleArticleHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleHistoryWhereInput>;
};


/** An article */
export type ArticleArticleHistoryCountArgs = {
  where?: InputMaybe<ArticleHistoryWhereInput>;
};


/** An article */
export type ArticleArticleMachineTagCountArgs = {
  where?: InputMaybe<ArticleMachineTagWhereInput>;
};


/** An article */
export type ArticleArticleMachineTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleMachineTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleMachineTagWhereInput>;
};


/** An article */
export type ArticleArticleQualifierCountArgs = {
  where?: InputMaybe<ArticleQualifierWhereInput>;
};


/** An article */
export type ArticleArticleQualifiersArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleQualifierOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleQualifierWhereInput>;
};


/** An article */
export type ArticleArticleTagCountArgs = {
  where?: InputMaybe<ArticleTagWhereInput>;
};


/** An article */
export type ArticleArticleTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleTagWhereInput>;
};


/** An article */
export type ArticleArticleTaxonomiesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleTaxonomyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleTaxonomyWhereInput>;
};


/** An article */
export type ArticleArticleTaxonomyCountArgs = {
  where?: InputMaybe<ArticleTaxonomyWhereInput>;
};


/** An article */
export type ArticleArticleUrlCountArgs = {
  where?: InputMaybe<ArticleUrlWhereInput>;
};


/** An article */
export type ArticleArticleUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleUrlWhereInput>;
};


/** An article */
export type ArticleArticleUserCountArgs = {
  where?: InputMaybe<ArticleUserWhereInput>;
};


/** An article */
export type ArticleArticleUsersArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleUserOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleUserWhereInput>;
};


/** An article */
export type ArticleContextualizedUrlArgs = {
  device: Device;
  env?: Env;
};


/** An article */
export type ArticleOpenAiProcessCountArgs = {
  where?: InputMaybe<OpenAiProcessWhereInput>;
};


/** An article */
export type ArticleOpenAiProcessesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OpenAiProcessOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OpenAiProcessWhereInput>;
};


/** An article */
export type ArticleParentArticleArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleHistoryWhereInput>;
};


/** An article */
export type ArticleParentArticleCountArgs = {
  where?: InputMaybe<ArticleHistoryWhereInput>;
};


/** An article */
export type ArticlePushCountArgs = {
  where?: InputMaybe<PushWhereInput>;
};


/** An article */
export type ArticlePushesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PushOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushWhereInput>;
};

/** Item of the "Article.articleAuthors" list, a 0-based index collection */
export type ArticleAuthor = {
  __typename?: 'ArticleAuthor';
  article: Article;
  author: Author;
  order: Scalars['Int']['output'];
};

export type ArticleAuthorArticleAuthorsSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleAuthorArticleAuthorsSearchWhereInput>>;
  NOT?: InputMaybe<ArticleAuthorArticleAuthorsSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleAuthorArticleAuthorsSearchWhereInput>>;
  author?: InputMaybe<AuthorArticleAuthorsAuthorSearchWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ArticleAuthorCreateInput = {
  /** Actions for the "ArticleAuthor.article" relation */
  article: ArticleAuthorNestedArticleCreateInput;
  /** Actions for the "ArticleAuthor.author" relation */
  author: ArticleAuthorNestedAuthorCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleAuthorNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleAuthor" node, through the "ArticleAuthor.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleAuthor" node, through the "ArticleAuthor.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleAuthor" node, through the "ArticleAuthor.article" relation. */
  update?: InputMaybe<ArticleAuthorNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleAuthor" node, through the "ArticleAuthor.article" relation. */
  upsert?: InputMaybe<ArticleAuthorNestedUpsertArticleCreateInput>;
};

export type ArticleAuthorNestedAuthorCreateInput = {
  /** Connect an existing "Author" node to the new "ArticleAuthor" node, through the "ArticleAuthor.author" relation. */
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  /** Create a new "Author" node and connect it to the new "ArticleAuthor" node, through the "ArticleAuthor.author" relation. */
  create?: InputMaybe<AuthorCreateInput>;
  /** Update an existing "Author" node and connect it to the new "ArticleAuthor" node, through the "ArticleAuthor.author" relation. */
  update?: InputMaybe<ArticleAuthorNestedUpdateAuthorCreateInput>;
  /** Create or update a "Author" node and connect it to the new "ArticleAuthor" node, through the "ArticleAuthor.author" relation. */
  upsert?: InputMaybe<ArticleAuthorNestedUpsertAuthorCreateInput>;
};

export type ArticleAuthorNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleAuthorNestedUpdateAuthorCreateInput = {
  data: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};

export type ArticleAuthorNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleAuthorNestedUpsertAuthorCreateInput = {
  create: AuthorCreateInput;
  update: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};

export enum ArticleAuthorOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleAuthorUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleAuthor" nodes by specifying some conditions */
export type ArticleAuthorWhereInput = {
  AND?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  NOT?: InputMaybe<ArticleAuthorWhereInput>;
  OR?: InputMaybe<Array<ArticleAuthorWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  author?: InputMaybe<AuthorWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "ArticleAuthor" node with one of these unique combinations of values:
 * - article, author
 * - article, order
 */
export type ArticleAuthorWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  author?: InputMaybe<AuthorWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleAuthorWithForcedArticleCreateInput = {
  /** Actions for the "ArticleAuthor.author" relation */
  author: ArticleAuthorNestedAuthorCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleAuthorWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleAuthor" node with one of these unique values:
 * - author
 * - order
 */
export type ArticleAuthorWithForcedArticleWhereUniqueInput = {
  author?: InputMaybe<AuthorWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleAuthorWithForcedAuthorCreateInput = {
  /** Actions for the "ArticleAuthor.article" relation */
  article: ArticleAuthorNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleAuthorWithForcedAuthorUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "author", identifies exactly one "ArticleAuthor" node. */
export type ArticleAuthorWithForcedAuthorWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

/** Item of the "Article.articleCategories" list, a 0-based index collection */
export type ArticleCategory = {
  __typename?: 'ArticleCategory';
  article: Article;
  category: Category;
  order: Scalars['Int']['output'];
};

export type ArticleCategoryArticleCategoriesSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleCategoryArticleCategoriesSearchWhereInput>>;
  NOT?: InputMaybe<ArticleCategoryArticleCategoriesSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleCategoryArticleCategoriesSearchWhereInput>>;
  category?: InputMaybe<CategoryArticleCategoriesCategorySearchWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ArticleCategoryCreateInput = {
  /** Actions for the "ArticleCategory.article" relation */
  article: ArticleCategoryNestedArticleCreateInput;
  /** Actions for the "ArticleCategory.category" relation */
  category: ArticleCategoryNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleCategoryNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleCategory" node, through the "ArticleCategory.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleCategory" node, through the "ArticleCategory.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleCategory" node, through the "ArticleCategory.article" relation. */
  update?: InputMaybe<ArticleCategoryNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleCategory" node, through the "ArticleCategory.article" relation. */
  upsert?: InputMaybe<ArticleCategoryNestedUpsertArticleCreateInput>;
};

export type ArticleCategoryNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "ArticleCategory" node, through the "ArticleCategory.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "ArticleCategory" node, through the "ArticleCategory.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "ArticleCategory" node, through the "ArticleCategory.category" relation. */
  update?: InputMaybe<ArticleCategoryNestedUpdateCategoryCreateInput>;
  /** Create or update a "Category" node and connect it to the new "ArticleCategory" node, through the "ArticleCategory.category" relation. */
  upsert?: InputMaybe<ArticleCategoryNestedUpsertCategoryCreateInput>;
};

export type ArticleCategoryNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCategoryNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type ArticleCategoryNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCategoryNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export enum ArticleCategoryOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleCategoryUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleCategory" nodes by specifying some conditions */
export type ArticleCategoryWhereInput = {
  AND?: InputMaybe<Array<ArticleCategoryWhereInput>>;
  NOT?: InputMaybe<ArticleCategoryWhereInput>;
  OR?: InputMaybe<Array<ArticleCategoryWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  category?: InputMaybe<CategoryWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "ArticleCategory" node with one of these unique combinations of values:
 * - article, category
 * - article, order
 */
export type ArticleCategoryWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategoryWithForcedArticleCreateInput = {
  /** Actions for the "ArticleCategory.category" relation */
  category: ArticleCategoryNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleCategoryWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleCategory" node with one of these unique values:
 * - category
 * - order
 */
export type ArticleCategoryWithForcedArticleWhereUniqueInput = {
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategoryWithForcedCategoryCreateInput = {
  /** Actions for the "ArticleCategory.article" relation */
  article: ArticleCategoryNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleCategoryWithForcedCategoryUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "category", identifies exactly one "ArticleCategory" node. */
export type ArticleCategoryWithForcedCategoryWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

/** Item of the "Article.articleChannels" list, a 0-based index collection */
export type ArticleChannel = {
  __typename?: 'ArticleChannel';
  article: Article;
  category: Category;
  order: Scalars['Int']['output'];
};

export type ArticleChannelArticleChannelsSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleChannelArticleChannelsSearchWhereInput>>;
  NOT?: InputMaybe<ArticleChannelArticleChannelsSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleChannelArticleChannelsSearchWhereInput>>;
  category?: InputMaybe<CategoryArticleChannelsCategorySearchWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ArticleChannelCreateInput = {
  /** Actions for the "ArticleChannel.article" relation */
  article: ArticleChannelNestedArticleCreateInput;
  /** Actions for the "ArticleChannel.category" relation */
  category: ArticleChannelNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleChannelNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleChannel" node, through the "ArticleChannel.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleChannel" node, through the "ArticleChannel.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleChannel" node, through the "ArticleChannel.article" relation. */
  update?: InputMaybe<ArticleChannelNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleChannel" node, through the "ArticleChannel.article" relation. */
  upsert?: InputMaybe<ArticleChannelNestedUpsertArticleCreateInput>;
};

export type ArticleChannelNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "ArticleChannel" node, through the "ArticleChannel.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "ArticleChannel" node, through the "ArticleChannel.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "ArticleChannel" node, through the "ArticleChannel.category" relation. */
  update?: InputMaybe<ArticleChannelNestedUpdateCategoryCreateInput>;
  /** Create or update a "Category" node and connect it to the new "ArticleChannel" node, through the "ArticleChannel.category" relation. */
  upsert?: InputMaybe<ArticleChannelNestedUpsertCategoryCreateInput>;
};

export type ArticleChannelNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleChannelNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type ArticleChannelNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleChannelNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export enum ArticleChannelOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleChannelUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleChannel" nodes by specifying some conditions */
export type ArticleChannelWhereInput = {
  AND?: InputMaybe<Array<ArticleChannelWhereInput>>;
  NOT?: InputMaybe<ArticleChannelWhereInput>;
  OR?: InputMaybe<Array<ArticleChannelWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  category?: InputMaybe<CategoryWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "ArticleChannel" node with one of these unique combinations of values:
 * - article, category
 * - article, order
 */
export type ArticleChannelWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleChannelWithForcedArticleCreateInput = {
  /** Actions for the "ArticleChannel.category" relation */
  category: ArticleChannelNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleChannelWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleChannel" node with one of these unique values:
 * - category
 * - order
 */
export type ArticleChannelWithForcedArticleWhereUniqueInput = {
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleChannelWithForcedCategoryCreateInput = {
  /** Actions for the "ArticleChannel.article" relation */
  article: ArticleChannelNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleChannelWithForcedCategoryUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "category", identifies exactly one "ArticleChannel" node. */
export type ArticleChannelWithForcedCategoryWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

export type ArticleCreateInput = {
  /** Actions for the "Article.articleAuthors" relation: "ArticleAuthor.article"'s inverse relation */
  articleAuthors?: InputMaybe<ArticleNestedArticleAuthorsCreateInput>;
  /** Actions for the "Article.articleCategories" relation: "ArticleCategory.article"'s inverse relation */
  articleCategories?: InputMaybe<ArticleNestedArticleCategoriesCreateInput>;
  /** Actions for the "Article.articleChannels" relation: "ArticleChannel.article"'s inverse relation */
  articleChannels?: InputMaybe<ArticleNestedArticleChannelsCreateInput>;
  /** Actions for the "Article.articleCreatorData" relation: "ArticleCreatorData.article"'s inverse relation */
  articleCreatorData?: InputMaybe<ArticleNestedArticleCreatorDataCreateInput>;
  /** Actions for the "Article.articleEvents" relation: "ArticleEvent.article"'s inverse relation */
  articleEvents?: InputMaybe<ArticleNestedArticleEventsCreateInput>;
  /** Actions for the "Article.articleExtension" relation: "ArticleExtension.article"'s inverse relation */
  articleExtension?: InputMaybe<ArticleNestedArticleExtensionCreateInput>;
  /** Actions for the "Article.articleGoodDealAiProcesses" relation: "ArticleGoodDealAiProcess.article"'s inverse relation */
  articleGoodDealAiProcesses?: InputMaybe<ArticleNestedArticleGoodDealAiProcessesCreateInput>;
  /** Actions for the "Article.articleGuides" relation: "ArticleGuide.article"'s inverse relation */
  articleGuides?: InputMaybe<ArticleNestedArticleGuidesCreateInput>;
  /** Actions for the "Article.articleHistories" relation: "ArticleHistory.article"'s inverse relation */
  articleHistories?: InputMaybe<ArticleNestedArticleHistoriesCreateInput>;
  /** Actions for the "Article.articleMachineTags" relation: "ArticleMachineTag.article"'s inverse relation */
  articleMachineTags?: InputMaybe<ArticleNestedArticleMachineTagsCreateInput>;
  /** Actions for the "Article.articleQualifiers" relation: "ArticleQualifier.article"'s inverse relation */
  articleQualifiers?: InputMaybe<ArticleNestedArticleQualifiersCreateInput>;
  /** Actions for the "Article.articleTags" relation: "ArticleTag.article"'s inverse relation */
  articleTags?: InputMaybe<ArticleNestedArticleTagsCreateInput>;
  /** Actions for the "Article.articleTaxonomies" relation: "ArticleTaxonomy.article"'s inverse relation */
  articleTaxonomies?: InputMaybe<ArticleNestedArticleTaxonomiesCreateInput>;
  /** Actions for the "Article.articleUrls" relation: "ArticleUrl.article"'s inverse relation */
  articleUrls?: InputMaybe<ArticleNestedArticleUrlsCreateInput>;
  /** Actions for the "Article.articleUsers" relation: "ArticleUser.article"'s inverse relation */
  articleUsers?: InputMaybe<ArticleNestedArticleUsersCreateInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyMedias?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  discoverTitle?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format: ArticleFormat;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.live" relation: "Live.article"'s inverse relation */
  live?: InputMaybe<ArticleNestedLiveCreateInput>;
  medias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.openAiProcesses" relation: "OpenAiProcess.article"'s inverse relation */
  openAiProcesses?: InputMaybe<ArticleNestedOpenAiProcessesCreateInput>;
  /** Actions for the "Article.parentArticle" relation: "ArticleHistory.duplicatedArticle"'s inverse relation */
  parentArticle?: InputMaybe<ArticleNestedParentArticleCreateInput>;
  partnerTitle?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Article.pushes" relation: "Push.article"'s inverse relation */
  pushes?: InputMaybe<ArticleNestedPushesCreateInput>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.source" relation */
  source?: InputMaybe<ArticleNestedSourceCreateInput>;
  status: ArticleStatus;
  title: Scalars['String']['input'];
};

/** "ArticleCreatorData" resource's node */
export type ArticleCreatorData = {
  __typename?: 'ArticleCreatorData';
  article: Article;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  departments?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The date, fixed, of the document's creation */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type ArticleCreatorDataCreateInput = {
  /** Actions for the "ArticleCreatorData.article" relation */
  article: ArticleCreatorDataNestedArticleCreateInput;
  departments?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ArticleCreatorDataNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleCreatorData" node, through the "ArticleCreatorData.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleCreatorData" node, through the "ArticleCreatorData.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleCreatorData" node, through the "ArticleCreatorData.article" relation. */
  update?: InputMaybe<ArticleCreatorDataNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleCreatorData" node, through the "ArticleCreatorData.article" relation. */
  upsert?: InputMaybe<ArticleCreatorDataNestedUpsertArticleCreateInput>;
};

export type ArticleCreatorDataNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreatorDataNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export enum ArticleCreatorDataOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  departments_ASC = 'departments_ASC',
  departments_DESC = 'departments_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type ArticleCreatorDataUpdateInput = {
  departments?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "ArticleCreatorData" nodes by specifying some conditions */
export type ArticleCreatorDataWhereInput = {
  AND?: InputMaybe<Array<ArticleCreatorDataWhereInput>>;
  NOT?: InputMaybe<ArticleCreatorDataWhereInput>;
  OR?: InputMaybe<Array<ArticleCreatorDataWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  departments?: InputMaybe<Scalars['String']['input']>;
  departments_contains?: InputMaybe<Scalars['String']['input']>;
  departments_ends_with?: InputMaybe<Scalars['String']['input']>;
  departments_gt?: InputMaybe<Scalars['String']['input']>;
  departments_gte?: InputMaybe<Scalars['String']['input']>;
  departments_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departments_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  departments_lt?: InputMaybe<Scalars['String']['input']>;
  departments_lte?: InputMaybe<Scalars['String']['input']>;
  departments_not?: InputMaybe<Scalars['String']['input']>;
  departments_not_contains?: InputMaybe<Scalars['String']['input']>;
  departments_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  departments_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departments_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  departments_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Identifies exactly one "ArticleCreatorData" node. */
export type ArticleCreatorDataWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

export type ArticleCreatorDataWithForcedArticleCreateInput = {
  departments?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ArticleCreatorDataWithForcedArticleUpdateInput = {
  departments?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Item of the "Article.articleEvents" list, a 0-based index collection */
export type ArticleEvent = {
  __typename?: 'ArticleEvent';
  article: Article;
  category: Category;
  order: Scalars['Int']['output'];
};

export type ArticleEventArticleEventsSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleEventArticleEventsSearchWhereInput>>;
  NOT?: InputMaybe<ArticleEventArticleEventsSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleEventArticleEventsSearchWhereInput>>;
  category?: InputMaybe<CategoryArticleEventsCategorySearchWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ArticleEventCreateInput = {
  /** Actions for the "ArticleEvent.article" relation */
  article: ArticleEventNestedArticleCreateInput;
  /** Actions for the "ArticleEvent.category" relation */
  category: ArticleEventNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleEventNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleEvent" node, through the "ArticleEvent.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleEvent" node, through the "ArticleEvent.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleEvent" node, through the "ArticleEvent.article" relation. */
  update?: InputMaybe<ArticleEventNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleEvent" node, through the "ArticleEvent.article" relation. */
  upsert?: InputMaybe<ArticleEventNestedUpsertArticleCreateInput>;
};

export type ArticleEventNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "ArticleEvent" node, through the "ArticleEvent.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "ArticleEvent" node, through the "ArticleEvent.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "ArticleEvent" node, through the "ArticleEvent.category" relation. */
  update?: InputMaybe<ArticleEventNestedUpdateCategoryCreateInput>;
  /** Create or update a "Category" node and connect it to the new "ArticleEvent" node, through the "ArticleEvent.category" relation. */
  upsert?: InputMaybe<ArticleEventNestedUpsertCategoryCreateInput>;
};

export type ArticleEventNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleEventNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type ArticleEventNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleEventNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export enum ArticleEventOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleEventUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleEvent" nodes by specifying some conditions */
export type ArticleEventWhereInput = {
  AND?: InputMaybe<Array<ArticleEventWhereInput>>;
  NOT?: InputMaybe<ArticleEventWhereInput>;
  OR?: InputMaybe<Array<ArticleEventWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  category?: InputMaybe<CategoryWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "ArticleEvent" node with one of these unique combinations of values:
 * - article, category
 * - article, order
 */
export type ArticleEventWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleEventWithForcedArticleCreateInput = {
  /** Actions for the "ArticleEvent.category" relation */
  category: ArticleEventNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleEventWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleEvent" node with one of these unique values:
 * - category
 * - order
 */
export type ArticleEventWithForcedArticleWhereUniqueInput = {
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleEventWithForcedCategoryCreateInput = {
  /** Actions for the "ArticleEvent.article" relation */
  article: ArticleEventNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleEventWithForcedCategoryUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "category", identifies exactly one "ArticleEvent" node. */
export type ArticleEventWithForcedCategoryWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

/** "ArticleExtension" resource's node */
export type ArticleExtension = {
  __typename?: 'ArticleExtension';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  article: Article;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  isClassified?: Maybe<Scalars['Boolean']['output']>;
  /** State of current campaign (locked or not) */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** The date of the article's last lock */
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user currently locking the campaign */
  lockedBy?: Maybe<User>;
  lockerId?: Maybe<Scalars['ID']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type ArticleExtensionCreateInput = {
  /** Actions for the "ArticleExtension.article" relation */
  article: ArticleExtensionNestedArticleCreateInput;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticleExtensionNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleExtension" node, through the "ArticleExtension.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleExtension" node, through the "ArticleExtension.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleExtension" node, through the "ArticleExtension.article" relation. */
  update?: InputMaybe<ArticleExtensionNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleExtension" node, through the "ArticleExtension.article" relation. */
  upsert?: InputMaybe<ArticleExtensionNestedUpsertArticleCreateInput>;
};

export type ArticleExtensionNestedArticleUpdateInput = {
  /** Connect an existing "Article" node to the existing "ArticleExtension" node, through the "ArticleExtension.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the existing "ArticleExtension" node, through the "ArticleExtension.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the existing "ArticleExtension" node, through the "ArticleExtension.article" relation. */
  update?: InputMaybe<ArticleExtensionNestedUpdateArticleUpdateInput>;
  /** Create or update a "Article" node and connect it to the existing "ArticleExtension" node, through the "ArticleExtension.article" relation. */
  upsert?: InputMaybe<ArticleExtensionNestedUpsertArticleUpdateInput>;
};

export type ArticleExtensionNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleExtensionNestedUpdateArticleUpdateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleExtensionNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleExtensionNestedUpsertArticleUpdateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export enum ArticleExtensionOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isClassified_ASC = 'isClassified_ASC',
  isClassified_DESC = 'isClassified_DESC',
  lockedAt_ASC = 'lockedAt_ASC',
  lockedAt_DESC = 'lockedAt_DESC',
  lockerId_ASC = 'lockerId_ASC',
  lockerId_DESC = 'lockerId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ArticleExtensionUpdateInput = {
  /** Actions for the "ArticleExtension.article" relation */
  article?: InputMaybe<ArticleExtensionNestedArticleUpdateInput>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "ArticleExtension" nodes by specifying some conditions */
export type ArticleExtensionWhereInput = {
  AND?: InputMaybe<Array<ArticleExtensionWhereInput>>;
  NOT?: InputMaybe<ArticleExtensionWhereInput>;
  OR?: InputMaybe<Array<ArticleExtensionWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  article?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isClassified_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified_not?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lockedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  lockerId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lockerId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId_not?: InputMaybe<Scalars['ID']['input']>;
  lockerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "ArticleExtension" node with one of these unique values:
 * - _id
 * - id
 * - article
 */
export type ArticleExtensionWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  article?: InputMaybe<ArticleWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticleExtensionWithForcedArticleCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticleExtensionWithForcedArticleUpdateInput = {
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Given a known "article", identifies exactly one "ArticleExtension" node with one of these unique values:
 * - _id
 * - id
 * - article (optional)
 */
export type ArticleExtensionWithOptionalArticleWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  article?: InputMaybe<ArticleWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ArticleFormat {
  Rich = 'Rich',
  Slideshow = 'Slideshow',
  Video = 'Video'
}

/** Open AI Process */
export type ArticleGoodDealAiPrompt = {
  __typename?: 'ArticleGoodDealAIPrompt';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id?: Maybe<Scalars['ID']['output']>;
  prompt: Scalars['String']['output'];
  promptOrder: Scalars['Int']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type ArticleGoodDealAiPromptCreateInput = {
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  prompt: Scalars['String']['input'];
  promptOrder: Scalars['Int']['input'];
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ArticleGoodDealAiPromptOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  promptOrder_ASC = 'promptOrder_ASC',
  promptOrder_DESC = 'promptOrder_DESC',
  prompt_ASC = 'prompt_ASC',
  prompt_DESC = 'prompt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ArticleGoodDealAiPromptUpdateInput = {
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  promptOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Filters the "ArticleGoodDealAIPrompt" nodes by specifying some conditions */
export type ArticleGoodDealAiPromptWhereInput = {
  AND?: InputMaybe<Array<ArticleGoodDealAiPromptWhereInput>>;
  NOT?: InputMaybe<ArticleGoodDealAiPromptWhereInput>;
  OR?: InputMaybe<Array<ArticleGoodDealAiPromptWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  promptOrder?: InputMaybe<Scalars['Int']['input']>;
  promptOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  promptOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  promptOrder_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  promptOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  promptOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  promptOrder_not?: InputMaybe<Scalars['Int']['input']>;
  promptOrder_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  prompt_contains?: InputMaybe<Scalars['String']['input']>;
  prompt_ends_with?: InputMaybe<Scalars['String']['input']>;
  prompt_gt?: InputMaybe<Scalars['String']['input']>;
  prompt_gte?: InputMaybe<Scalars['String']['input']>;
  prompt_in?: InputMaybe<Array<Scalars['String']['input']>>;
  prompt_lt?: InputMaybe<Scalars['String']['input']>;
  prompt_lte?: InputMaybe<Scalars['String']['input']>;
  prompt_not?: InputMaybe<Scalars['String']['input']>;
  prompt_not_contains?: InputMaybe<Scalars['String']['input']>;
  prompt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  prompt_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  prompt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  prompt_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "ArticleGoodDealAIPrompt" node with one of these unique values:
 * - _id
 * - id
 * - promptOrder
 */
export type ArticleGoodDealAiPromptWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  promptOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Good Deal Article Generation with AI Process */
export type ArticleGoodDealAiProcess = {
  __typename?: 'ArticleGoodDealAiProcess';
  /** The Internal ID */
  _id: Scalars['Int']['output'];
  article?: Maybe<Article>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  errorMsg?: Maybe<Scalars['String']['output']>;
  /** The public ID, an UUID v4 */
  id?: Maybe<Scalars['ID']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  status: GoodDealProcessStatus;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type ArticleGoodDealAiProcessCreateInput = {
  /** Actions for the "ArticleGoodDealAiProcess.article" relation */
  article?: InputMaybe<ArticleGoodDealAiProcessNestedArticleCreateInput>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  status: GoodDealProcessStatus;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleGoodDealAiProcessNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleGoodDealAiProcess" node, through the "ArticleGoodDealAiProcess.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleGoodDealAiProcess" node, through the "ArticleGoodDealAiProcess.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleGoodDealAiProcess" node, through the "ArticleGoodDealAiProcess.article" relation. */
  update?: InputMaybe<ArticleGoodDealAiProcessNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleGoodDealAiProcess" node, through the "ArticleGoodDealAiProcess.article" relation. */
  upsert?: InputMaybe<ArticleGoodDealAiProcessNestedUpsertArticleCreateInput>;
};

export type ArticleGoodDealAiProcessNestedArticleUpdateInput = {
  /** Connect an existing "Article" node to the existing "ArticleGoodDealAiProcess" node, through the "ArticleGoodDealAiProcess.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the existing "ArticleGoodDealAiProcess" node, through the "ArticleGoodDealAiProcess.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Disconnect the current connected "Article" node, if any, of the "ArticleGoodDealAiProcess.article" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Article" node and connect it to the existing "ArticleGoodDealAiProcess" node, through the "ArticleGoodDealAiProcess.article" relation. */
  update?: InputMaybe<ArticleGoodDealAiProcessNestedUpdateArticleUpdateInput>;
  /** Create or update a "Article" node and connect it to the existing "ArticleGoodDealAiProcess" node, through the "ArticleGoodDealAiProcess.article" relation. */
  upsert?: InputMaybe<ArticleGoodDealAiProcessNestedUpsertArticleUpdateInput>;
};

export type ArticleGoodDealAiProcessNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleGoodDealAiProcessNestedUpdateArticleUpdateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleGoodDealAiProcessNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleGoodDealAiProcessNestedUpsertArticleUpdateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export enum ArticleGoodDealAiProcessOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  errorMsg_ASC = 'errorMsg_ASC',
  errorMsg_DESC = 'errorMsg_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  productTitle_ASC = 'productTitle_ASC',
  productTitle_DESC = 'productTitle_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type ArticleGoodDealAiProcessUpdateInput = {
  /** Actions for the "ArticleGoodDealAiProcess.article" relation */
  article?: InputMaybe<ArticleGoodDealAiProcessNestedArticleUpdateInput>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GoodDealProcessStatus>;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Filters the "ArticleGoodDealAiProcess" nodes by specifying some conditions */
export type ArticleGoodDealAiProcessWhereInput = {
  AND?: InputMaybe<Array<ArticleGoodDealAiProcessWhereInput>>;
  NOT?: InputMaybe<ArticleGoodDealAiProcessWhereInput>;
  OR?: InputMaybe<Array<ArticleGoodDealAiProcessWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  article?: InputMaybe<ArticleWhereInput>;
  article_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  errorMsg_contains?: InputMaybe<Scalars['String']['input']>;
  errorMsg_ends_with?: InputMaybe<Scalars['String']['input']>;
  errorMsg_gt?: InputMaybe<Scalars['String']['input']>;
  errorMsg_gte?: InputMaybe<Scalars['String']['input']>;
  errorMsg_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorMsg_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  errorMsg_lt?: InputMaybe<Scalars['String']['input']>;
  errorMsg_lte?: InputMaybe<Scalars['String']['input']>;
  errorMsg_not?: InputMaybe<Scalars['String']['input']>;
  errorMsg_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorMsg_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  errorMsg_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorMsg_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMsg_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  productTitle_contains?: InputMaybe<Scalars['String']['input']>;
  productTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  productTitle_gt?: InputMaybe<Scalars['String']['input']>;
  productTitle_gte?: InputMaybe<Scalars['String']['input']>;
  productTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  productTitle_lt?: InputMaybe<Scalars['String']['input']>;
  productTitle_lte?: InputMaybe<Scalars['String']['input']>;
  productTitle_not?: InputMaybe<Scalars['String']['input']>;
  productTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  productTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  productTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  productTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GoodDealProcessStatus>;
  status_in?: InputMaybe<Array<GoodDealProcessStatus>>;
  status_not?: InputMaybe<GoodDealProcessStatus>;
  status_not_in?: InputMaybe<Array<GoodDealProcessStatus>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Identifies exactly one "ArticleGoodDealAiProcess" node with one of these unique values:
 * - _id
 * - id
 */
export type ArticleGoodDealAiProcessWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticleGoodDealAiProcessWithForcedArticleCreateInput = {
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  status: GoodDealProcessStatus;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleGoodDealAiProcessWithForcedArticleUpdateInput = {
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GoodDealProcessStatus>;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Item of the "Article.articleGuides" list, a 0-based index collection */
export type ArticleGuide = {
  __typename?: 'ArticleGuide';
  article: Article;
  category: Category;
  order: Scalars['Int']['output'];
};

export type ArticleGuideArticleGuidesSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleGuideArticleGuidesSearchWhereInput>>;
  NOT?: InputMaybe<ArticleGuideArticleGuidesSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleGuideArticleGuidesSearchWhereInput>>;
  category?: InputMaybe<CategoryArticleGuidesCategorySearchWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ArticleGuideCreateInput = {
  /** Actions for the "ArticleGuide.article" relation */
  article: ArticleGuideNestedArticleCreateInput;
  /** Actions for the "ArticleGuide.category" relation */
  category: ArticleGuideNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleGuideNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleGuide" node, through the "ArticleGuide.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleGuide" node, through the "ArticleGuide.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleGuide" node, through the "ArticleGuide.article" relation. */
  update?: InputMaybe<ArticleGuideNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleGuide" node, through the "ArticleGuide.article" relation. */
  upsert?: InputMaybe<ArticleGuideNestedUpsertArticleCreateInput>;
};

export type ArticleGuideNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "ArticleGuide" node, through the "ArticleGuide.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "ArticleGuide" node, through the "ArticleGuide.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "ArticleGuide" node, through the "ArticleGuide.category" relation. */
  update?: InputMaybe<ArticleGuideNestedUpdateCategoryCreateInput>;
  /** Create or update a "Category" node and connect it to the new "ArticleGuide" node, through the "ArticleGuide.category" relation. */
  upsert?: InputMaybe<ArticleGuideNestedUpsertCategoryCreateInput>;
};

export type ArticleGuideNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleGuideNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type ArticleGuideNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleGuideNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export enum ArticleGuideOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleGuideUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleGuide" nodes by specifying some conditions */
export type ArticleGuideWhereInput = {
  AND?: InputMaybe<Array<ArticleGuideWhereInput>>;
  NOT?: InputMaybe<ArticleGuideWhereInput>;
  OR?: InputMaybe<Array<ArticleGuideWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  category?: InputMaybe<CategoryWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "ArticleGuide" node with one of these unique combinations of values:
 * - article, category
 * - article, order
 */
export type ArticleGuideWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleGuideWithForcedArticleCreateInput = {
  /** Actions for the "ArticleGuide.category" relation */
  category: ArticleGuideNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleGuideWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleGuide" node with one of these unique values:
 * - category
 * - order
 */
export type ArticleGuideWithForcedArticleWhereUniqueInput = {
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleGuideWithForcedCategoryCreateInput = {
  /** Actions for the "ArticleGuide.article" relation */
  article: ArticleGuideNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleGuideWithForcedCategoryUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "category", identifies exactly one "ArticleGuide" node. */
export type ArticleGuideWithForcedCategoryWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

/** "ArticleHistory" resource's node */
export type ArticleHistory = {
  __typename?: 'ArticleHistory';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  article: Article;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** This relation is used to keep track of article duplications */
  duplicatedArticle?: Maybe<Article>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  status: ArticleStatus;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type ArticleHistoryCreateInput = {
  /** Actions for the "ArticleHistory.article" relation */
  article: ArticleHistoryNestedArticleCreateInput;
  /** Actions for the "ArticleHistory.duplicatedArticle" relation: This relation is used to keep track of article duplications */
  duplicatedArticle?: InputMaybe<ArticleHistoryNestedDuplicatedArticleCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  status: ArticleStatus;
  userId: Scalars['ID']['input'];
};

export type ArticleHistoryNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleHistory" node, through the "ArticleHistory.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleHistory" node, through the "ArticleHistory.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleHistory" node, through the "ArticleHistory.article" relation. */
  update?: InputMaybe<ArticleHistoryNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleHistory" node, through the "ArticleHistory.article" relation. */
  upsert?: InputMaybe<ArticleHistoryNestedUpsertArticleCreateInput>;
};

export type ArticleHistoryNestedArticleUpdateInput = {
  /** Connect an existing "Article" node to the existing "ArticleHistory" node, through the "ArticleHistory.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the existing "ArticleHistory" node, through the "ArticleHistory.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the existing "ArticleHistory" node, through the "ArticleHistory.article" relation. */
  update?: InputMaybe<ArticleHistoryNestedUpdateArticleUpdateInput>;
  /** Create or update a "Article" node and connect it to the existing "ArticleHistory" node, through the "ArticleHistory.article" relation. */
  upsert?: InputMaybe<ArticleHistoryNestedUpsertArticleUpdateInput>;
};

export type ArticleHistoryNestedDuplicatedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleHistory" node, through the "ArticleHistory.duplicatedArticle" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleHistory" node, through the "ArticleHistory.duplicatedArticle" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleHistory" node, through the "ArticleHistory.duplicatedArticle" relation. */
  update?: InputMaybe<ArticleHistoryNestedUpdateDuplicatedArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleHistory" node, through the "ArticleHistory.duplicatedArticle" relation. */
  upsert?: InputMaybe<ArticleHistoryNestedUpsertDuplicatedArticleCreateInput>;
};

export type ArticleHistoryNestedDuplicatedArticleUpdateInput = {
  /** Connect an existing "Article" node to the existing "ArticleHistory" node, through the "ArticleHistory.duplicatedArticle" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the existing "ArticleHistory" node, through the "ArticleHistory.duplicatedArticle" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Disconnect the current connected "Article" node, if any, of the "ArticleHistory.duplicatedArticle" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Article" node and connect it to the existing "ArticleHistory" node, through the "ArticleHistory.duplicatedArticle" relation. */
  update?: InputMaybe<ArticleHistoryNestedUpdateDuplicatedArticleUpdateInput>;
  /** Create or update a "Article" node and connect it to the existing "ArticleHistory" node, through the "ArticleHistory.duplicatedArticle" relation. */
  upsert?: InputMaybe<ArticleHistoryNestedUpsertDuplicatedArticleUpdateInput>;
};

export type ArticleHistoryNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleHistoryNestedUpdateArticleUpdateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleHistoryNestedUpdateDuplicatedArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleHistoryNestedUpdateDuplicatedArticleUpdateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleHistoryNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleHistoryNestedUpsertArticleUpdateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleHistoryNestedUpsertDuplicatedArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleHistoryNestedUpsertDuplicatedArticleUpdateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export enum ArticleHistoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type ArticleHistoryUpdateInput = {
  /** Actions for the "ArticleHistory.article" relation */
  article?: InputMaybe<ArticleHistoryNestedArticleUpdateInput>;
  /** Actions for the "ArticleHistory.duplicatedArticle" relation: This relation is used to keep track of article duplications */
  duplicatedArticle?: InputMaybe<ArticleHistoryNestedDuplicatedArticleUpdateInput>;
  status?: InputMaybe<ArticleStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "ArticleHistory" nodes by specifying some conditions */
export type ArticleHistoryWhereInput = {
  AND?: InputMaybe<Array<ArticleHistoryWhereInput>>;
  NOT?: InputMaybe<ArticleHistoryWhereInput>;
  OR?: InputMaybe<Array<ArticleHistoryWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  article?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  duplicatedArticle?: InputMaybe<ArticleWhereInput>;
  duplicatedArticle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ArticleStatus>;
  status_in?: InputMaybe<Array<ArticleStatus>>;
  status_not?: InputMaybe<ArticleStatus>;
  status_not_in?: InputMaybe<Array<ArticleStatus>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Identifies exactly one "ArticleHistory" node with one of these unique values:
 * - _id
 * - id
 */
export type ArticleHistoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticleHistoryWithForcedArticleCreateInput = {
  /** Actions for the "ArticleHistory.duplicatedArticle" relation: This relation is used to keep track of article duplications */
  duplicatedArticle?: InputMaybe<ArticleHistoryNestedDuplicatedArticleCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  status: ArticleStatus;
  userId: Scalars['ID']['input'];
};

export type ArticleHistoryWithForcedArticleUpdateInput = {
  /** Actions for the "ArticleHistory.duplicatedArticle" relation: This relation is used to keep track of article duplications */
  duplicatedArticle?: InputMaybe<ArticleHistoryNestedDuplicatedArticleUpdateInput>;
  status?: InputMaybe<ArticleStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticleHistoryWithForcedDuplicatedArticleCreateInput = {
  /** Actions for the "ArticleHistory.article" relation */
  article: ArticleHistoryNestedArticleCreateInput;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  status: ArticleStatus;
  userId: Scalars['ID']['input'];
};

export type ArticleHistoryWithForcedDuplicatedArticleUpdateInput = {
  /** Actions for the "ArticleHistory.article" relation */
  article?: InputMaybe<ArticleHistoryNestedArticleUpdateInput>;
  status?: InputMaybe<ArticleStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Item of the "Article.articleMachineTags" list, a 0-based index collection */
export type ArticleMachineTag = {
  __typename?: 'ArticleMachineTag';
  article: Article;
  machineTag: MachineTag;
  order: Scalars['Int']['output'];
};

export type ArticleMachineTagArticleMachineTagsSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleMachineTagArticleMachineTagsSearchWhereInput>>;
  NOT?: InputMaybe<ArticleMachineTagArticleMachineTagsSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleMachineTagArticleMachineTagsSearchWhereInput>>;
  machineTag?: InputMaybe<MachineTagArticleMachineTagsMachineTagSearchWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ArticleMachineTagCreateInput = {
  /** Actions for the "ArticleMachineTag.article" relation */
  article: ArticleMachineTagNestedArticleCreateInput;
  /** Actions for the "ArticleMachineTag.machineTag" relation */
  machineTag: ArticleMachineTagNestedMachineTagCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleMachineTagNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleMachineTag" node, through the "ArticleMachineTag.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleMachineTag" node, through the "ArticleMachineTag.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleMachineTag" node, through the "ArticleMachineTag.article" relation. */
  update?: InputMaybe<ArticleMachineTagNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleMachineTag" node, through the "ArticleMachineTag.article" relation. */
  upsert?: InputMaybe<ArticleMachineTagNestedUpsertArticleCreateInput>;
};

export type ArticleMachineTagNestedMachineTagCreateInput = {
  /** Connect an existing "MachineTag" node to the new "ArticleMachineTag" node, through the "ArticleMachineTag.machineTag" relation. */
  connect?: InputMaybe<MachineTagWhereUniqueInput>;
  /** Create a new "MachineTag" node and connect it to the new "ArticleMachineTag" node, through the "ArticleMachineTag.machineTag" relation. */
  create?: InputMaybe<MachineTagCreateInput>;
  /** Update an existing "MachineTag" node and connect it to the new "ArticleMachineTag" node, through the "ArticleMachineTag.machineTag" relation. */
  update?: InputMaybe<ArticleMachineTagNestedUpdateMachineTagCreateInput>;
  /** Create or update a "MachineTag" node and connect it to the new "ArticleMachineTag" node, through the "ArticleMachineTag.machineTag" relation. */
  upsert?: InputMaybe<ArticleMachineTagNestedUpsertMachineTagCreateInput>;
};

export type ArticleMachineTagNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleMachineTagNestedUpdateMachineTagCreateInput = {
  data: MachineTagUpdateInput;
  where: MachineTagWhereUniqueInput;
};

export type ArticleMachineTagNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleMachineTagNestedUpsertMachineTagCreateInput = {
  create: MachineTagCreateInput;
  update: MachineTagUpdateInput;
  where: MachineTagWhereUniqueInput;
};

export enum ArticleMachineTagOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleMachineTagUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleMachineTag" nodes by specifying some conditions */
export type ArticleMachineTagWhereInput = {
  AND?: InputMaybe<Array<ArticleMachineTagWhereInput>>;
  NOT?: InputMaybe<ArticleMachineTagWhereInput>;
  OR?: InputMaybe<Array<ArticleMachineTagWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  machineTag?: InputMaybe<MachineTagWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "ArticleMachineTag" node with one of these unique combinations of values:
 * - article, machineTag
 * - article, order
 */
export type ArticleMachineTagWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  machineTag?: InputMaybe<MachineTagWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleMachineTagWithForcedArticleCreateInput = {
  /** Actions for the "ArticleMachineTag.machineTag" relation */
  machineTag: ArticleMachineTagNestedMachineTagCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleMachineTagWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleMachineTag" node with one of these unique values:
 * - machineTag
 * - order
 */
export type ArticleMachineTagWithForcedArticleWhereUniqueInput = {
  machineTag?: InputMaybe<MachineTagWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleMachineTagWithForcedMachineTagCreateInput = {
  /** Actions for the "ArticleMachineTag.article" relation */
  article: ArticleMachineTagNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleMachineTagWithForcedMachineTagUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "machineTag", identifies exactly one "ArticleMachineTag" node. */
export type ArticleMachineTagWithForcedMachineTagWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

export type ArticleMergedResult = {
  __typename?: 'ArticleMergedResult';
  _id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type ArticleNestedArticleAuthorsCreateInput = {
  /** Create new "ArticleAuthor" nodes and connect them to the new "Article" node, through the "Article.articleAuthors" relation. */
  create?: InputMaybe<Array<ArticleAuthorWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleAuthorsUpdateInput = {
  /** Create new "ArticleAuthor" nodes and connect them to the existing "Article" node, through the "Article.articleAuthors" relation. */
  create?: InputMaybe<Array<ArticleAuthorWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleAuthor" nodes from the "Article.articleAuthors" relation. */
  delete?: InputMaybe<Array<ArticleAuthorWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleAuthor" nodes and connect them to the existing "Article" node, through the "Article.articleAuthors" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleAuthorsUpdateInput>>;
  /** Upsert existing "ArticleAuthor" nodes and connect them to the existing "Article" node, through the "Article.articleAuthors" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleAuthorsUpdateInput>>;
};

export type ArticleNestedArticleCategoriesCreateInput = {
  /** Create new "ArticleCategory" nodes and connect them to the new "Article" node, through the "Article.articleCategories" relation. */
  create?: InputMaybe<Array<ArticleCategoryWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleCategoriesUpdateInput = {
  /** Create new "ArticleCategory" nodes and connect them to the existing "Article" node, through the "Article.articleCategories" relation. */
  create?: InputMaybe<Array<ArticleCategoryWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleCategory" nodes from the "Article.articleCategories" relation. */
  delete?: InputMaybe<Array<ArticleCategoryWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleCategory" nodes and connect them to the existing "Article" node, through the "Article.articleCategories" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleCategoriesUpdateInput>>;
  /** Upsert existing "ArticleCategory" nodes and connect them to the existing "Article" node, through the "Article.articleCategories" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleCategoriesUpdateInput>>;
};

export type ArticleNestedArticleChannelsCreateInput = {
  /** Create new "ArticleChannel" nodes and connect them to the new "Article" node, through the "Article.articleChannels" relation. */
  create?: InputMaybe<Array<ArticleChannelWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleChannelsUpdateInput = {
  /** Create new "ArticleChannel" nodes and connect them to the existing "Article" node, through the "Article.articleChannels" relation. */
  create?: InputMaybe<Array<ArticleChannelWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleChannel" nodes from the "Article.articleChannels" relation. */
  delete?: InputMaybe<Array<ArticleChannelWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleChannel" nodes and connect them to the existing "Article" node, through the "Article.articleChannels" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleChannelsUpdateInput>>;
  /** Upsert existing "ArticleChannel" nodes and connect them to the existing "Article" node, through the "Article.articleChannels" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleChannelsUpdateInput>>;
};

export type ArticleNestedArticleCreatorDataCreateInput = {
  /** Create a new "ArticleCreatorData" node and connect it to the new "Article" node, through the "Article.articleCreatorData" relation. */
  create?: InputMaybe<ArticleCreatorDataWithForcedArticleCreateInput>;
};

export type ArticleNestedArticleCreatorDataUpdateInput = {
  /** Create a new "ArticleCreatorData" node and connect it to the existing "Article" node, through the "Article.articleCreatorData" relation. */
  create?: InputMaybe<ArticleCreatorDataWithForcedArticleCreateInput>;
  /** Delete an existing "ArticleCreatorData" node from the "Article.articleCreatorData" relation. */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "ArticleCreatorData" node and connect it to the existing "Article" node, through the "Article.articleCreatorData" relation. */
  update?: InputMaybe<ArticleNestedUpdateArticleCreatorDataUpdateInput>;
  /** Upsert an existing "ArticleCreatorData" node and connect it to the existing "Article" node, through the "Article.articleCreatorData" relation. */
  upsert?: InputMaybe<ArticleNestedUpsertArticleCreatorDataUpdateInput>;
};

export type ArticleNestedArticleEventsCreateInput = {
  /** Create new "ArticleEvent" nodes and connect them to the new "Article" node, through the "Article.articleEvents" relation. */
  create?: InputMaybe<Array<ArticleEventWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleEventsUpdateInput = {
  /** Create new "ArticleEvent" nodes and connect them to the existing "Article" node, through the "Article.articleEvents" relation. */
  create?: InputMaybe<Array<ArticleEventWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleEvent" nodes from the "Article.articleEvents" relation. */
  delete?: InputMaybe<Array<ArticleEventWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleEvent" nodes and connect them to the existing "Article" node, through the "Article.articleEvents" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleEventsUpdateInput>>;
  /** Upsert existing "ArticleEvent" nodes and connect them to the existing "Article" node, through the "Article.articleEvents" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleEventsUpdateInput>>;
};

export type ArticleNestedArticleExtensionCreateInput = {
  /** Connect an existing "ArticleExtension" node to the new "Article" node, through the "Article.articleExtension" relation. */
  connect?: InputMaybe<ArticleExtensionWhereUniqueInput>;
  /** Create a new "ArticleExtension" node and connect it to the new "Article" node, through the "Article.articleExtension" relation. */
  create?: InputMaybe<ArticleExtensionWithForcedArticleCreateInput>;
};

export type ArticleNestedArticleExtensionUpdateInput = {
  /** Connect an existing "ArticleExtension" node to the existing "Article" node, through the "Article.articleExtension" relation. */
  connect?: InputMaybe<ArticleExtensionWhereUniqueInput>;
  /** Create a new "ArticleExtension" node and connect it to the existing "Article" node, through the "Article.articleExtension" relation. */
  create?: InputMaybe<ArticleExtensionWithForcedArticleCreateInput>;
  /** Delete an existing "ArticleExtension" node from the "Article.articleExtension" relation. */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "ArticleExtension" node and connect it to the existing "Article" node, through the "Article.articleExtension" relation. */
  update?: InputMaybe<ArticleNestedUpdateArticleExtensionUpdateInput>;
  /** Upsert an existing "ArticleExtension" node and connect it to the existing "Article" node, through the "Article.articleExtension" relation. */
  upsert?: InputMaybe<ArticleNestedUpsertArticleExtensionUpdateInput>;
};

export type ArticleNestedArticleGoodDealAiProcessesCreateInput = {
  /** Connect existing "ArticleGoodDealAiProcess" nodes to the new "Article" node, through the "Article.articleGoodDealAiProcesses" relation. */
  connect?: InputMaybe<Array<ArticleGoodDealAiProcessWhereUniqueInput>>;
  /** Create new "ArticleGoodDealAiProcess" nodes and connect them to the new "Article" node, through the "Article.articleGoodDealAiProcesses" relation. */
  create?: InputMaybe<Array<ArticleGoodDealAiProcessWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleGoodDealAiProcessesUpdateInput = {
  /** Connect existing "ArticleGoodDealAiProcess" nodes to the existing "Article" node, through the "Article.articleGoodDealAiProcesses" relation. */
  connect?: InputMaybe<Array<ArticleGoodDealAiProcessWhereUniqueInput>>;
  /** Create new "ArticleGoodDealAiProcess" nodes and connect them to the existing "Article" node, through the "Article.articleGoodDealAiProcesses" relation. */
  create?: InputMaybe<Array<ArticleGoodDealAiProcessWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleGoodDealAiProcess" nodes from the "Article.articleGoodDealAiProcesses" relation. */
  delete?: InputMaybe<Array<ArticleGoodDealAiProcessWhereUniqueInput>>;
  /** Disconnect existing "ArticleGoodDealAiProcess" nodes of the "Article.articleGoodDealAiProcesses" relation. */
  disconnect?: InputMaybe<Array<ArticleGoodDealAiProcessWhereUniqueInput>>;
  /** Update existing "ArticleGoodDealAiProcess" nodes and connect them to the existing "Article" node, through the "Article.articleGoodDealAiProcesses" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleGoodDealAiProcessesUpdateInput>>;
  /** Upsert existing "ArticleGoodDealAiProcess" nodes and connect them to the existing "Article" node, through the "Article.articleGoodDealAiProcesses" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleGoodDealAiProcessesUpdateInput>>;
};

export type ArticleNestedArticleGuidesCreateInput = {
  /** Create new "ArticleGuide" nodes and connect them to the new "Article" node, through the "Article.articleGuides" relation. */
  create?: InputMaybe<Array<ArticleGuideWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleGuidesUpdateInput = {
  /** Create new "ArticleGuide" nodes and connect them to the existing "Article" node, through the "Article.articleGuides" relation. */
  create?: InputMaybe<Array<ArticleGuideWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleGuide" nodes from the "Article.articleGuides" relation. */
  delete?: InputMaybe<Array<ArticleGuideWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleGuide" nodes and connect them to the existing "Article" node, through the "Article.articleGuides" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleGuidesUpdateInput>>;
  /** Upsert existing "ArticleGuide" nodes and connect them to the existing "Article" node, through the "Article.articleGuides" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleGuidesUpdateInput>>;
};

export type ArticleNestedArticleHistoriesCreateInput = {
  /** Connect existing "ArticleHistory" nodes to the new "Article" node, through the "Article.articleHistories" relation. */
  connect?: InputMaybe<Array<ArticleHistoryWhereUniqueInput>>;
  /** Create new "ArticleHistory" nodes and connect them to the new "Article" node, through the "Article.articleHistories" relation. */
  create?: InputMaybe<Array<ArticleHistoryWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleHistoriesUpdateInput = {
  /** Connect existing "ArticleHistory" nodes to the existing "Article" node, through the "Article.articleHistories" relation. */
  connect?: InputMaybe<Array<ArticleHistoryWhereUniqueInput>>;
  /** Create new "ArticleHistory" nodes and connect them to the existing "Article" node, through the "Article.articleHistories" relation. */
  create?: InputMaybe<Array<ArticleHistoryWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleHistory" nodes from the "Article.articleHistories" relation. */
  delete?: InputMaybe<Array<ArticleHistoryWhereUniqueInput>>;
  /** Update existing "ArticleHistory" nodes and connect them to the existing "Article" node, through the "Article.articleHistories" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleHistoriesUpdateInput>>;
  /** Upsert existing "ArticleHistory" nodes and connect them to the existing "Article" node, through the "Article.articleHistories" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleHistoriesUpdateInput>>;
};

export type ArticleNestedArticleMachineTagsCreateInput = {
  /** Create new "ArticleMachineTag" nodes and connect them to the new "Article" node, through the "Article.articleMachineTags" relation. */
  create?: InputMaybe<Array<ArticleMachineTagWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleMachineTagsUpdateInput = {
  /** Create new "ArticleMachineTag" nodes and connect them to the existing "Article" node, through the "Article.articleMachineTags" relation. */
  create?: InputMaybe<Array<ArticleMachineTagWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleMachineTag" nodes from the "Article.articleMachineTags" relation. */
  delete?: InputMaybe<Array<ArticleMachineTagWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleMachineTag" nodes and connect them to the existing "Article" node, through the "Article.articleMachineTags" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleMachineTagsUpdateInput>>;
  /** Upsert existing "ArticleMachineTag" nodes and connect them to the existing "Article" node, through the "Article.articleMachineTags" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleMachineTagsUpdateInput>>;
};

export type ArticleNestedArticleQualifiersCreateInput = {
  /** Create new "ArticleQualifier" nodes and connect them to the new "Article" node, through the "Article.articleQualifiers" relation. */
  create?: InputMaybe<Array<ArticleQualifierWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleQualifiersUpdateInput = {
  /** Create new "ArticleQualifier" nodes and connect them to the existing "Article" node, through the "Article.articleQualifiers" relation. */
  create?: InputMaybe<Array<ArticleQualifierWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleQualifier" nodes from the "Article.articleQualifiers" relation. */
  delete?: InputMaybe<Array<ArticleQualifierWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleQualifier" nodes and connect them to the existing "Article" node, through the "Article.articleQualifiers" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleQualifiersUpdateInput>>;
  /** Upsert existing "ArticleQualifier" nodes and connect them to the existing "Article" node, through the "Article.articleQualifiers" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleQualifiersUpdateInput>>;
};

export type ArticleNestedArticleTagsCreateInput = {
  /** Create new "ArticleTag" nodes and connect them to the new "Article" node, through the "Article.articleTags" relation. */
  create?: InputMaybe<Array<ArticleTagWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleTagsUpdateInput = {
  /** Create new "ArticleTag" nodes and connect them to the existing "Article" node, through the "Article.articleTags" relation. */
  create?: InputMaybe<Array<ArticleTagWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleTag" nodes from the "Article.articleTags" relation. */
  delete?: InputMaybe<Array<ArticleTagWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleTag" nodes and connect them to the existing "Article" node, through the "Article.articleTags" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleTagsUpdateInput>>;
  /** Upsert existing "ArticleTag" nodes and connect them to the existing "Article" node, through the "Article.articleTags" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleTagsUpdateInput>>;
};

export type ArticleNestedArticleTaxonomiesCreateInput = {
  /** Create new "ArticleTaxonomy" nodes and connect them to the new "Article" node, through the "Article.articleTaxonomies" relation. */
  create?: InputMaybe<Array<ArticleTaxonomyWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleTaxonomiesUpdateInput = {
  /** Create new "ArticleTaxonomy" nodes and connect them to the existing "Article" node, through the "Article.articleTaxonomies" relation. */
  create?: InputMaybe<Array<ArticleTaxonomyWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleTaxonomy" nodes from the "Article.articleTaxonomies" relation. */
  delete?: InputMaybe<Array<ArticleTaxonomyWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleTaxonomy" nodes and connect them to the existing "Article" node, through the "Article.articleTaxonomies" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleTaxonomiesUpdateInput>>;
  /** Upsert existing "ArticleTaxonomy" nodes and connect them to the existing "Article" node, through the "Article.articleTaxonomies" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleTaxonomiesUpdateInput>>;
};

export type ArticleNestedArticleUrlsCreateInput = {
  /** Create new "ArticleUrl" nodes and connect them to the new "Article" node, through the "Article.articleUrls" relation. */
  create?: InputMaybe<Array<ArticleUrlWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleUrlsUpdateInput = {
  /** Create new "ArticleUrl" nodes and connect them to the existing "Article" node, through the "Article.articleUrls" relation. */
  create?: InputMaybe<Array<ArticleUrlWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleUrl" nodes from the "Article.articleUrls" relation. */
  delete?: InputMaybe<Array<ArticleUrlWithForcedArticleWhereUniqueInput>>;
  /** Update existing "ArticleUrl" nodes and connect them to the existing "Article" node, through the "Article.articleUrls" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleUrlsUpdateInput>>;
  /** Upsert existing "ArticleUrl" nodes and connect them to the existing "Article" node, through the "Article.articleUrls" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleUrlsUpdateInput>>;
};

export type ArticleNestedArticleUsersCreateInput = {
  /** Connect existing "ArticleUser" nodes to the new "Article" node, through the "Article.articleUsers" relation. */
  connect?: InputMaybe<Array<ArticleUserWhereUniqueInput>>;
  /** Create new "ArticleUser" nodes and connect them to the new "Article" node, through the "Article.articleUsers" relation. */
  create?: InputMaybe<Array<ArticleUserWithForcedArticleCreateInput>>;
};

export type ArticleNestedArticleUsersUpdateInput = {
  /** Connect existing "ArticleUser" nodes to the existing "Article" node, through the "Article.articleUsers" relation. */
  connect?: InputMaybe<Array<ArticleUserWhereUniqueInput>>;
  /** Create new "ArticleUser" nodes and connect them to the existing "Article" node, through the "Article.articleUsers" relation. */
  create?: InputMaybe<Array<ArticleUserWithForcedArticleCreateInput>>;
  /** Delete existing "ArticleUser" nodes from the "Article.articleUsers" relation. */
  delete?: InputMaybe<Array<ArticleUserWhereUniqueInput>>;
  /** Update existing "ArticleUser" nodes and connect them to the existing "Article" node, through the "Article.articleUsers" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateArticleUsersUpdateInput>>;
  /** Upsert existing "ArticleUser" nodes and connect them to the existing "Article" node, through the "Article.articleUsers" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertArticleUsersUpdateInput>>;
};

export type ArticleNestedLiveCreateInput = {
  /** Connect an existing "Live" node to the new "Article" node, through the "Article.live" relation. */
  connect?: InputMaybe<LiveWhereUniqueInput>;
  /** Create a new "Live" node and connect it to the new "Article" node, through the "Article.live" relation. */
  create?: InputMaybe<LiveWithForcedArticleCreateInput>;
};

export type ArticleNestedLiveUpdateInput = {
  /** Connect an existing "Live" node to the existing "Article" node, through the "Article.live" relation. */
  connect?: InputMaybe<LiveWhereUniqueInput>;
  /** Create a new "Live" node and connect it to the existing "Article" node, through the "Article.live" relation. */
  create?: InputMaybe<LiveWithForcedArticleCreateInput>;
  /** Delete an existing "Live" node from the "Article.live" relation. */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Live" node and connect it to the existing "Article" node, through the "Article.live" relation. */
  update?: InputMaybe<ArticleNestedUpdateLiveUpdateInput>;
  /** Upsert an existing "Live" node and connect it to the existing "Article" node, through the "Article.live" relation. */
  upsert?: InputMaybe<ArticleNestedUpsertLiveUpdateInput>;
};

export type ArticleNestedOpenAiProcessesCreateInput = {
  /** Connect existing "OpenAiProcess" nodes to the new "Article" node, through the "Article.openAiProcesses" relation. */
  connect?: InputMaybe<Array<OpenAiProcessWhereUniqueInput>>;
  /** Create new "OpenAiProcess" nodes and connect them to the new "Article" node, through the "Article.openAiProcesses" relation. */
  create?: InputMaybe<Array<OpenAiProcessWithForcedArticleCreateInput>>;
};

export type ArticleNestedOpenAiProcessesUpdateInput = {
  /** Connect existing "OpenAiProcess" nodes to the existing "Article" node, through the "Article.openAiProcesses" relation. */
  connect?: InputMaybe<Array<OpenAiProcessWhereUniqueInput>>;
  /** Create new "OpenAiProcess" nodes and connect them to the existing "Article" node, through the "Article.openAiProcesses" relation. */
  create?: InputMaybe<Array<OpenAiProcessWithForcedArticleCreateInput>>;
  /** Delete existing "OpenAiProcess" nodes from the "Article.openAiProcesses" relation. */
  delete?: InputMaybe<Array<OpenAiProcessWhereUniqueInput>>;
  /** Disconnect existing "OpenAiProcess" nodes of the "Article.openAiProcesses" relation. */
  disconnect?: InputMaybe<Array<OpenAiProcessWhereUniqueInput>>;
  /** Update existing "OpenAiProcess" nodes and connect them to the existing "Article" node, through the "Article.openAiProcesses" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateOpenAiProcessesUpdateInput>>;
  /** Upsert existing "OpenAiProcess" nodes and connect them to the existing "Article" node, through the "Article.openAiProcesses" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertOpenAiProcessesUpdateInput>>;
};

export type ArticleNestedParentArticleCreateInput = {
  /** Connect existing "ArticleHistory" nodes to the new "Article" node, through the "Article.parentArticle" relation. */
  connect?: InputMaybe<Array<ArticleHistoryWhereUniqueInput>>;
  /** Create new "ArticleHistory" nodes and connect them to the new "Article" node, through the "Article.parentArticle" relation. */
  create?: InputMaybe<Array<ArticleHistoryWithForcedDuplicatedArticleCreateInput>>;
};

export type ArticleNestedParentArticleUpdateInput = {
  /** Connect existing "ArticleHistory" nodes to the existing "Article" node, through the "Article.parentArticle" relation. */
  connect?: InputMaybe<Array<ArticleHistoryWhereUniqueInput>>;
  /** Create new "ArticleHistory" nodes and connect them to the existing "Article" node, through the "Article.parentArticle" relation. */
  create?: InputMaybe<Array<ArticleHistoryWithForcedDuplicatedArticleCreateInput>>;
  /** Delete existing "ArticleHistory" nodes from the "Article.parentArticle" relation. */
  delete?: InputMaybe<Array<ArticleHistoryWhereUniqueInput>>;
  /** Disconnect existing "ArticleHistory" nodes of the "Article.parentArticle" relation. */
  disconnect?: InputMaybe<Array<ArticleHistoryWhereUniqueInput>>;
  /** Update existing "ArticleHistory" nodes and connect them to the existing "Article" node, through the "Article.parentArticle" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdateParentArticleUpdateInput>>;
  /** Upsert existing "ArticleHistory" nodes and connect them to the existing "Article" node, through the "Article.parentArticle" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertParentArticleUpdateInput>>;
};

export type ArticleNestedPushesCreateInput = {
  /** Connect existing "Push" nodes to the new "Article" node, through the "Article.pushes" relation. */
  connect?: InputMaybe<Array<PushWhereUniqueInput>>;
  /** Create new "Push" nodes and connect them to the new "Article" node, through the "Article.pushes" relation. */
  create?: InputMaybe<Array<PushWithForcedArticleCreateInput>>;
};

export type ArticleNestedPushesUpdateInput = {
  /** Connect existing "Push" nodes to the existing "Article" node, through the "Article.pushes" relation. */
  connect?: InputMaybe<Array<PushWhereUniqueInput>>;
  /** Create new "Push" nodes and connect them to the existing "Article" node, through the "Article.pushes" relation. */
  create?: InputMaybe<Array<PushWithForcedArticleCreateInput>>;
  /** Delete existing "Push" nodes from the "Article.pushes" relation. */
  delete?: InputMaybe<Array<PushWhereUniqueInput>>;
  /** Update existing "Push" nodes and connect them to the existing "Article" node, through the "Article.pushes" relation. */
  update?: InputMaybe<Array<ArticleNestedUpdatePushesUpdateInput>>;
  /** Upsert existing "Push" nodes and connect them to the existing "Article" node, through the "Article.pushes" relation. */
  upsert?: InputMaybe<Array<ArticleNestedUpsertPushesUpdateInput>>;
};

export type ArticleNestedSourceCreateInput = {
  /** Connect an existing "Source" node to the new "Article" node, through the "Article.source" relation. */
  connect?: InputMaybe<SourceWhereUniqueInput>;
  /** Create a new "Source" node and connect it to the new "Article" node, through the "Article.source" relation. */
  create?: InputMaybe<SourceCreateInput>;
  /** Update an existing "Source" node and connect it to the new "Article" node, through the "Article.source" relation. */
  update?: InputMaybe<ArticleNestedUpdateSourceCreateInput>;
  /** Create or update a "Source" node and connect it to the new "Article" node, through the "Article.source" relation. */
  upsert?: InputMaybe<ArticleNestedUpsertSourceCreateInput>;
};

export type ArticleNestedSourceUpdateInput = {
  /** Connect an existing "Source" node to the existing "Article" node, through the "Article.source" relation. */
  connect?: InputMaybe<SourceWhereUniqueInput>;
  /** Create a new "Source" node and connect it to the existing "Article" node, through the "Article.source" relation. */
  create?: InputMaybe<SourceCreateInput>;
  /** Disconnect the current connected "Source" node, if any, of the "Article.source" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Source" node and connect it to the existing "Article" node, through the "Article.source" relation. */
  update?: InputMaybe<ArticleNestedUpdateSourceUpdateInput>;
  /** Create or update a "Source" node and connect it to the existing "Article" node, through the "Article.source" relation. */
  upsert?: InputMaybe<ArticleNestedUpsertSourceUpdateInput>;
};

export type ArticleNestedUpdateArticleAuthorsUpdateInput = {
  data: ArticleAuthorWithForcedArticleUpdateInput;
  where: ArticleAuthorWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleCategoriesUpdateInput = {
  data: ArticleCategoryWithForcedArticleUpdateInput;
  where: ArticleCategoryWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleChannelsUpdateInput = {
  data: ArticleChannelWithForcedArticleUpdateInput;
  where: ArticleChannelWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleCreatorDataUpdateInput = {
  data: ArticleCreatorDataWithForcedArticleUpdateInput;
};

export type ArticleNestedUpdateArticleEventsUpdateInput = {
  data: ArticleEventWithForcedArticleUpdateInput;
  where: ArticleEventWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleExtensionUpdateInput = {
  data: ArticleExtensionWithForcedArticleUpdateInput;
  where: ArticleExtensionWithOptionalArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleGoodDealAiProcessesUpdateInput = {
  data: ArticleGoodDealAiProcessWithForcedArticleUpdateInput;
  where: ArticleGoodDealAiProcessWhereUniqueInput;
};

export type ArticleNestedUpdateArticleGuidesUpdateInput = {
  data: ArticleGuideWithForcedArticleUpdateInput;
  where: ArticleGuideWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleHistoriesUpdateInput = {
  data: ArticleHistoryWithForcedArticleUpdateInput;
  where: ArticleHistoryWhereUniqueInput;
};

export type ArticleNestedUpdateArticleMachineTagsUpdateInput = {
  data: ArticleMachineTagWithForcedArticleUpdateInput;
  where: ArticleMachineTagWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleQualifiersUpdateInput = {
  data: ArticleQualifierWithForcedArticleUpdateInput;
  where: ArticleQualifierWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleTagsUpdateInput = {
  data: ArticleTagWithForcedArticleUpdateInput;
  where: ArticleTagWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleTaxonomiesUpdateInput = {
  data: ArticleTaxonomyWithForcedArticleUpdateInput;
  where: ArticleTaxonomyWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleUrlsUpdateInput = {
  data: ArticleUrlWithForcedArticleUpdateInput;
  where: ArticleUrlWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpdateArticleUsersUpdateInput = {
  data: ArticleUserWithForcedArticleUpdateInput;
  where: ArticleUserWhereUniqueInput;
};

export type ArticleNestedUpdateLiveUpdateInput = {
  data: LiveWithForcedArticleUpdateInput;
  where: LiveWithOptionalArticleWhereUniqueInput;
};

export type ArticleNestedUpdateOpenAiProcessesUpdateInput = {
  data: OpenAiProcessWithForcedArticleUpdateInput;
  where: OpenAiProcessWhereUniqueInput;
};

export type ArticleNestedUpdateParentArticleUpdateInput = {
  data: ArticleHistoryWithForcedDuplicatedArticleUpdateInput;
  where: ArticleHistoryWhereUniqueInput;
};

export type ArticleNestedUpdatePushesUpdateInput = {
  data: PushWithForcedArticleUpdateInput;
  where: PushWhereUniqueInput;
};

export type ArticleNestedUpdateSourceCreateInput = {
  data: SourceUpdateInput;
  where: SourceWhereUniqueInput;
};

export type ArticleNestedUpdateSourceUpdateInput = {
  data: SourceUpdateInput;
  where: SourceWhereUniqueInput;
};

export type ArticleNestedUpsertArticleAuthorsUpdateInput = {
  create: ArticleAuthorWithForcedArticleCreateInput;
  update: ArticleAuthorWithForcedArticleUpdateInput;
  where: ArticleAuthorWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleCategoriesUpdateInput = {
  create: ArticleCategoryWithForcedArticleCreateInput;
  update: ArticleCategoryWithForcedArticleUpdateInput;
  where: ArticleCategoryWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleChannelsUpdateInput = {
  create: ArticleChannelWithForcedArticleCreateInput;
  update: ArticleChannelWithForcedArticleUpdateInput;
  where: ArticleChannelWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleCreatorDataUpdateInput = {
  create: ArticleCreatorDataWithForcedArticleCreateInput;
  update: ArticleCreatorDataWithForcedArticleUpdateInput;
};

export type ArticleNestedUpsertArticleEventsUpdateInput = {
  create: ArticleEventWithForcedArticleCreateInput;
  update: ArticleEventWithForcedArticleUpdateInput;
  where: ArticleEventWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleExtensionUpdateInput = {
  create: ArticleExtensionWithForcedArticleCreateInput;
  update: ArticleExtensionWithForcedArticleUpdateInput;
  where: ArticleExtensionWithOptionalArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleGoodDealAiProcessesUpdateInput = {
  create: ArticleGoodDealAiProcessWithForcedArticleCreateInput;
  update: ArticleGoodDealAiProcessWithForcedArticleUpdateInput;
  where: ArticleGoodDealAiProcessWhereUniqueInput;
};

export type ArticleNestedUpsertArticleGuidesUpdateInput = {
  create: ArticleGuideWithForcedArticleCreateInput;
  update: ArticleGuideWithForcedArticleUpdateInput;
  where: ArticleGuideWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleHistoriesUpdateInput = {
  create: ArticleHistoryWithForcedArticleCreateInput;
  update: ArticleHistoryWithForcedArticleUpdateInput;
  where: ArticleHistoryWhereUniqueInput;
};

export type ArticleNestedUpsertArticleMachineTagsUpdateInput = {
  create: ArticleMachineTagWithForcedArticleCreateInput;
  update: ArticleMachineTagWithForcedArticleUpdateInput;
  where: ArticleMachineTagWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleQualifiersUpdateInput = {
  create: ArticleQualifierWithForcedArticleCreateInput;
  update: ArticleQualifierWithForcedArticleUpdateInput;
  where: ArticleQualifierWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleTagsUpdateInput = {
  create: ArticleTagWithForcedArticleCreateInput;
  update: ArticleTagWithForcedArticleUpdateInput;
  where: ArticleTagWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleTaxonomiesUpdateInput = {
  create: ArticleTaxonomyWithForcedArticleCreateInput;
  update: ArticleTaxonomyWithForcedArticleUpdateInput;
  where: ArticleTaxonomyWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleUrlsUpdateInput = {
  create: ArticleUrlWithForcedArticleCreateInput;
  update: ArticleUrlWithForcedArticleUpdateInput;
  where: ArticleUrlWithForcedArticleWhereUniqueInput;
};

export type ArticleNestedUpsertArticleUsersUpdateInput = {
  create: ArticleUserWithForcedArticleCreateInput;
  update: ArticleUserWithForcedArticleUpdateInput;
  where: ArticleUserWhereUniqueInput;
};

export type ArticleNestedUpsertLiveUpdateInput = {
  create: LiveWithForcedArticleCreateInput;
  update: LiveWithForcedArticleUpdateInput;
  where: LiveWithOptionalArticleWhereUniqueInput;
};

export type ArticleNestedUpsertOpenAiProcessesUpdateInput = {
  create: OpenAiProcessWithForcedArticleCreateInput;
  update: OpenAiProcessWithForcedArticleUpdateInput;
  where: OpenAiProcessWhereUniqueInput;
};

export type ArticleNestedUpsertParentArticleUpdateInput = {
  create: ArticleHistoryWithForcedDuplicatedArticleCreateInput;
  update: ArticleHistoryWithForcedDuplicatedArticleUpdateInput;
  where: ArticleHistoryWhereUniqueInput;
};

export type ArticleNestedUpsertPushesUpdateInput = {
  create: PushWithForcedArticleCreateInput;
  update: PushWithForcedArticleUpdateInput;
  where: PushWhereUniqueInput;
};

export type ArticleNestedUpsertSourceCreateInput = {
  create: SourceCreateInput;
  update: SourceUpdateInput;
  where: SourceWhereUniqueInput;
};

export type ArticleNestedUpsertSourceUpdateInput = {
  create: SourceCreateInput;
  update: SourceUpdateInput;
  where: SourceWhereUniqueInput;
};

export enum ArticleOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  bodyMedias_ASC = 'bodyMedias_ASC',
  bodyMedias_DESC = 'bodyMedias_DESC',
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  creatorId_ASC = 'creatorId_ASC',
  creatorId_DESC = 'creatorId_DESC',
  discoverTitle_ASC = 'discoverTitle_ASC',
  discoverTitle_DESC = 'discoverTitle_DESC',
  editedAt_ASC = 'editedAt_ASC',
  editedAt_DESC = 'editedAt_DESC',
  format_ASC = 'format_ASC',
  format_DESC = 'format_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  lead_ASC = 'lead_ASC',
  lead_DESC = 'lead_DESC',
  medias_ASC = 'medias_ASC',
  medias_DESC = 'medias_DESC',
  partnerTitle_ASC = 'partnerTitle_ASC',
  partnerTitle_DESC = 'partnerTitle_DESC',
  platformId_ASC = 'platformId_ASC',
  platformId_DESC = 'platformId_DESC',
  platform_ASC = 'platform_ASC',
  platform_DESC = 'platform_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  secondaryTitle_ASC = 'secondaryTitle_ASC',
  secondaryTitle_DESC = 'secondaryTitle_DESC',
  signature_ASC = 'signature_ASC',
  signature_DESC = 'signature_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Item of the "Article.articleQualifiers" list, a 0-based index collection */
export type ArticleQualifier = {
  __typename?: 'ArticleQualifier';
  article: Article;
  order: Scalars['Int']['output'];
  qualifier: Qualifier;
};

export type ArticleQualifierArticleQualifiersSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleQualifierArticleQualifiersSearchWhereInput>>;
  NOT?: InputMaybe<ArticleQualifierArticleQualifiersSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleQualifierArticleQualifiersSearchWhereInput>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  qualifier?: InputMaybe<QualifierArticleQualifiersQualifierSearchWhereInput>;
};

export type ArticleQualifierCreateInput = {
  /** Actions for the "ArticleQualifier.article" relation */
  article: ArticleQualifierNestedArticleCreateInput;
  order: Scalars['Int']['input'];
  /** Actions for the "ArticleQualifier.qualifier" relation */
  qualifier: ArticleQualifierNestedQualifierCreateInput;
};

export type ArticleQualifierNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleQualifier" node, through the "ArticleQualifier.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleQualifier" node, through the "ArticleQualifier.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleQualifier" node, through the "ArticleQualifier.article" relation. */
  update?: InputMaybe<ArticleQualifierNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleQualifier" node, through the "ArticleQualifier.article" relation. */
  upsert?: InputMaybe<ArticleQualifierNestedUpsertArticleCreateInput>;
};

export type ArticleQualifierNestedQualifierCreateInput = {
  /** Connect an existing "Qualifier" node to the new "ArticleQualifier" node, through the "ArticleQualifier.qualifier" relation. */
  connect?: InputMaybe<QualifierWhereUniqueInput>;
  /** Create a new "Qualifier" node and connect it to the new "ArticleQualifier" node, through the "ArticleQualifier.qualifier" relation. */
  create?: InputMaybe<QualifierCreateInput>;
  /** Update an existing "Qualifier" node and connect it to the new "ArticleQualifier" node, through the "ArticleQualifier.qualifier" relation. */
  update?: InputMaybe<ArticleQualifierNestedUpdateQualifierCreateInput>;
  /** Create or update a "Qualifier" node and connect it to the new "ArticleQualifier" node, through the "ArticleQualifier.qualifier" relation. */
  upsert?: InputMaybe<ArticleQualifierNestedUpsertQualifierCreateInput>;
};

export type ArticleQualifierNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleQualifierNestedUpdateQualifierCreateInput = {
  data: QualifierUpdateInput;
  where: QualifierWhereUniqueInput;
};

export type ArticleQualifierNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleQualifierNestedUpsertQualifierCreateInput = {
  create: QualifierCreateInput;
  update: QualifierUpdateInput;
  where: QualifierWhereUniqueInput;
};

export enum ArticleQualifierOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleQualifierUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleQualifier" nodes by specifying some conditions */
export type ArticleQualifierWhereInput = {
  AND?: InputMaybe<Array<ArticleQualifierWhereInput>>;
  NOT?: InputMaybe<ArticleQualifierWhereInput>;
  OR?: InputMaybe<Array<ArticleQualifierWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  qualifier?: InputMaybe<QualifierWhereInput>;
};

/**
 * Identifies exactly one "ArticleQualifier" node with one of these unique combinations of values:
 * - article, qualifier
 * - article, order
 */
export type ArticleQualifierWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  order?: InputMaybe<Scalars['Int']['input']>;
  qualifier?: InputMaybe<QualifierWhereUniqueInput>;
};

export type ArticleQualifierWithForcedArticleCreateInput = {
  order: Scalars['Int']['input'];
  /** Actions for the "ArticleQualifier.qualifier" relation */
  qualifier: ArticleQualifierNestedQualifierCreateInput;
};

export type ArticleQualifierWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleQualifier" node with one of these unique values:
 * - qualifier
 * - order
 */
export type ArticleQualifierWithForcedArticleWhereUniqueInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  qualifier?: InputMaybe<QualifierWhereUniqueInput>;
};

export type ArticleQualifierWithForcedQualifierCreateInput = {
  /** Actions for the "ArticleQualifier.article" relation */
  article: ArticleQualifierNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleQualifierWithForcedQualifierUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "qualifier", identifies exactly one "ArticleQualifier" node. */
export type ArticleQualifierWithForcedQualifierWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

export enum ArticleSearchFieldsType {
  Body = 'Body',
  BodyMedias = 'BodyMedias',
  Lead = 'Lead',
  Medias = 'Medias',
  Title = 'Title'
}

export enum ArticleSearchOrderByInput {
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  creatorId_ASC = 'creatorId_ASC',
  creatorId_DESC = 'creatorId_DESC',
  editedAt_ASC = 'editedAt_ASC',
  editedAt_DESC = 'editedAt_DESC',
  format_ASC = 'format_ASC',
  format_DESC = 'format_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ArticleSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleSearchWhereInput>>;
  NOT?: InputMaybe<ArticleSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleSearchWhereInput>>;
  articleAuthors_some?: InputMaybe<ArticleAuthorArticleAuthorsSearchWhereInput>;
  articleCategories_some?: InputMaybe<ArticleCategoryArticleCategoriesSearchWhereInput>;
  articleChannels_some?: InputMaybe<ArticleChannelArticleChannelsSearchWhereInput>;
  articleEvents_some?: InputMaybe<ArticleEventArticleEventsSearchWhereInput>;
  articleGuides_some?: InputMaybe<ArticleGuideArticleGuidesSearchWhereInput>;
  articleMachineTags_some?: InputMaybe<ArticleMachineTagArticleMachineTagsSearchWhereInput>;
  articleQualifiers_some?: InputMaybe<ArticleQualifierArticleQualifiersSearchWhereInput>;
  articleTags_some?: InputMaybe<ArticleTagArticleTagsSearchWhereInput>;
  articleUrls_some?: InputMaybe<ArticleUrlArticleUrlsSearchWhereInput>;
  bodyMedias_contains?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  bodyMedias_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  creatorId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  creatorId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  creatorId_not?: InputMaybe<Scalars['ID']['input']>;
  creatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  format?: InputMaybe<ArticleFormat>;
  format_in?: InputMaybe<Array<ArticleFormat>>;
  format_not?: InputMaybe<ArticleFormat>;
  format_not_in?: InputMaybe<Array<ArticleFormat>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lead_contains?: InputMaybe<Scalars['String']['input']>;
  lead_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lead_not_contains?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<LiveLiveSearchWhereInput>;
  live_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  medias_contains?: InputMaybe<Scalars['String']['input']>;
  medias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  medias_not_contains?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pushes_some?: InputMaybe<PushPushesSearchWhereInput>;
  source?: InputMaybe<SourceSourceSearchWhereInput>;
  source_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ArticleStatus>;
  status_in?: InputMaybe<Array<ArticleStatus>>;
  status_not?: InputMaybe<ArticleStatus>;
  status_not_in?: InputMaybe<Array<ArticleStatus>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum ArticleStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Frozen = 'Frozen',
  Pending = 'Pending',
  Private = 'Private',
  Proposal = 'Proposal',
  Published = 'Published',
  Ready = 'Ready',
  Scheduled = 'Scheduled',
  Todo = 'Todo'
}

export type ArticleSuggestionResult = {
  __typename?: 'ArticleSuggestionResult';
  itemCount: Scalars['Int']['output'];
  items: Array<Article>;
  scores: Array<SearchItemScoreType>;
};

/** Item of the "Article.articleTags" list, a 0-based index collection */
export type ArticleTag = {
  __typename?: 'ArticleTag';
  article: Article;
  order: Scalars['Int']['output'];
  tag: Tag;
};

export type ArticleTagArticleTagsSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleTagArticleTagsSearchWhereInput>>;
  NOT?: InputMaybe<ArticleTagArticleTagsSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleTagArticleTagsSearchWhereInput>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tag?: InputMaybe<TagArticleTagsTagSearchWhereInput>;
};

export type ArticleTagCreateInput = {
  /** Actions for the "ArticleTag.article" relation */
  article: ArticleTagNestedArticleCreateInput;
  order: Scalars['Int']['input'];
  /** Actions for the "ArticleTag.tag" relation */
  tag: ArticleTagNestedTagCreateInput;
};

export type ArticleTagNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleTag" node, through the "ArticleTag.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleTag" node, through the "ArticleTag.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleTag" node, through the "ArticleTag.article" relation. */
  update?: InputMaybe<ArticleTagNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleTag" node, through the "ArticleTag.article" relation. */
  upsert?: InputMaybe<ArticleTagNestedUpsertArticleCreateInput>;
};

export type ArticleTagNestedTagCreateInput = {
  /** Connect an existing "Tag" node to the new "ArticleTag" node, through the "ArticleTag.tag" relation. */
  connect?: InputMaybe<TagWhereUniqueInput>;
  /** Create a new "Tag" node and connect it to the new "ArticleTag" node, through the "ArticleTag.tag" relation. */
  create?: InputMaybe<TagCreateInput>;
  /** Update an existing "Tag" node and connect it to the new "ArticleTag" node, through the "ArticleTag.tag" relation. */
  update?: InputMaybe<ArticleTagNestedUpdateTagCreateInput>;
  /** Create or update a "Tag" node and connect it to the new "ArticleTag" node, through the "ArticleTag.tag" relation. */
  upsert?: InputMaybe<ArticleTagNestedUpsertTagCreateInput>;
};

export type ArticleTagNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleTagNestedUpdateTagCreateInput = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type ArticleTagNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleTagNestedUpsertTagCreateInput = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export enum ArticleTagOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleTagUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleTag" nodes by specifying some conditions */
export type ArticleTagWhereInput = {
  AND?: InputMaybe<Array<ArticleTagWhereInput>>;
  NOT?: InputMaybe<ArticleTagWhereInput>;
  OR?: InputMaybe<Array<ArticleTagWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tag?: InputMaybe<TagWhereInput>;
};

/**
 * Identifies exactly one "ArticleTag" node with one of these unique combinations of values:
 * - article, tag
 * - article, order
 */
export type ArticleTagWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  order?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<TagWhereUniqueInput>;
};

export type ArticleTagWithForcedArticleCreateInput = {
  order: Scalars['Int']['input'];
  /** Actions for the "ArticleTag.tag" relation */
  tag: ArticleTagNestedTagCreateInput;
};

export type ArticleTagWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleTag" node with one of these unique values:
 * - tag
 * - order
 */
export type ArticleTagWithForcedArticleWhereUniqueInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<TagWhereUniqueInput>;
};

export type ArticleTagWithForcedTagCreateInput = {
  /** Actions for the "ArticleTag.article" relation */
  article: ArticleTagNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleTagWithForcedTagUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "tag", identifies exactly one "ArticleTag" node. */
export type ArticleTagWithForcedTagWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

/** Item of the "Article.articleTaxonomies" list, a 0-based index collection */
export type ArticleTaxonomy = {
  __typename?: 'ArticleTaxonomy';
  article: Article;
  order: Scalars['Int']['output'];
  taxonomy: Taxonomy;
};

export type ArticleTaxonomyCreateInput = {
  /** Actions for the "ArticleTaxonomy.article" relation */
  article: ArticleTaxonomyNestedArticleCreateInput;
  order: Scalars['Int']['input'];
  /** Actions for the "ArticleTaxonomy.taxonomy" relation */
  taxonomy: ArticleTaxonomyNestedTaxonomyCreateInput;
};

export type ArticleTaxonomyNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleTaxonomy" node, through the "ArticleTaxonomy.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleTaxonomy" node, through the "ArticleTaxonomy.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleTaxonomy" node, through the "ArticleTaxonomy.article" relation. */
  update?: InputMaybe<ArticleTaxonomyNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleTaxonomy" node, through the "ArticleTaxonomy.article" relation. */
  upsert?: InputMaybe<ArticleTaxonomyNestedUpsertArticleCreateInput>;
};

export type ArticleTaxonomyNestedTaxonomyCreateInput = {
  /** Connect an existing "Taxonomy" node to the new "ArticleTaxonomy" node, through the "ArticleTaxonomy.taxonomy" relation. */
  connect?: InputMaybe<TaxonomyWhereUniqueInput>;
  /** Create a new "Taxonomy" node and connect it to the new "ArticleTaxonomy" node, through the "ArticleTaxonomy.taxonomy" relation. */
  create?: InputMaybe<TaxonomyCreateInput>;
  /** Update an existing "Taxonomy" node and connect it to the new "ArticleTaxonomy" node, through the "ArticleTaxonomy.taxonomy" relation. */
  update?: InputMaybe<ArticleTaxonomyNestedUpdateTaxonomyCreateInput>;
  /** Create or update a "Taxonomy" node and connect it to the new "ArticleTaxonomy" node, through the "ArticleTaxonomy.taxonomy" relation. */
  upsert?: InputMaybe<ArticleTaxonomyNestedUpsertTaxonomyCreateInput>;
};

export type ArticleTaxonomyNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleTaxonomyNestedUpdateTaxonomyCreateInput = {
  data: TaxonomyUpdateInput;
  where: TaxonomyWhereUniqueInput;
};

export type ArticleTaxonomyNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleTaxonomyNestedUpsertTaxonomyCreateInput = {
  create: TaxonomyCreateInput;
  update: TaxonomyUpdateInput;
  where: TaxonomyWhereUniqueInput;
};

export enum ArticleTaxonomyOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type ArticleTaxonomyUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleTaxonomy" nodes by specifying some conditions */
export type ArticleTaxonomyWhereInput = {
  AND?: InputMaybe<Array<ArticleTaxonomyWhereInput>>;
  NOT?: InputMaybe<ArticleTaxonomyWhereInput>;
  OR?: InputMaybe<Array<ArticleTaxonomyWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  taxonomy?: InputMaybe<TaxonomyWhereInput>;
};

/**
 * Identifies exactly one "ArticleTaxonomy" node with one of these unique combinations of values:
 * - article, taxonomy
 * - article, order
 */
export type ArticleTaxonomyWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  order?: InputMaybe<Scalars['Int']['input']>;
  taxonomy?: InputMaybe<TaxonomyWhereUniqueInput>;
};

export type ArticleTaxonomyWithForcedArticleCreateInput = {
  order: Scalars['Int']['input'];
  /** Actions for the "ArticleTaxonomy.taxonomy" relation */
  taxonomy: ArticleTaxonomyNestedTaxonomyCreateInput;
};

export type ArticleTaxonomyWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleTaxonomy" node with one of these unique values:
 * - taxonomy
 * - order
 */
export type ArticleTaxonomyWithForcedArticleWhereUniqueInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  taxonomy?: InputMaybe<TaxonomyWhereUniqueInput>;
};

export type ArticleTaxonomyWithForcedTaxonomyCreateInput = {
  /** Actions for the "ArticleTaxonomy.article" relation */
  article: ArticleTaxonomyNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

export type ArticleTaxonomyWithForcedTaxonomyUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "taxonomy", identifies exactly one "ArticleTaxonomy" node. */
export type ArticleTaxonomyWithForcedTaxonomyWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
};

export type ArticleUpdateInput = {
  /** Actions for the "Article.articleAuthors" relation: "ArticleAuthor.article"'s inverse relation */
  articleAuthors?: InputMaybe<ArticleNestedArticleAuthorsUpdateInput>;
  /** Actions for the "Article.articleCategories" relation: "ArticleCategory.article"'s inverse relation */
  articleCategories?: InputMaybe<ArticleNestedArticleCategoriesUpdateInput>;
  /** Actions for the "Article.articleChannels" relation: "ArticleChannel.article"'s inverse relation */
  articleChannels?: InputMaybe<ArticleNestedArticleChannelsUpdateInput>;
  /** Actions for the "Article.articleCreatorData" relation: "ArticleCreatorData.article"'s inverse relation */
  articleCreatorData?: InputMaybe<ArticleNestedArticleCreatorDataUpdateInput>;
  /** Actions for the "Article.articleEvents" relation: "ArticleEvent.article"'s inverse relation */
  articleEvents?: InputMaybe<ArticleNestedArticleEventsUpdateInput>;
  /** Actions for the "Article.articleExtension" relation: "ArticleExtension.article"'s inverse relation */
  articleExtension?: InputMaybe<ArticleNestedArticleExtensionUpdateInput>;
  /** Actions for the "Article.articleGoodDealAiProcesses" relation: "ArticleGoodDealAiProcess.article"'s inverse relation */
  articleGoodDealAiProcesses?: InputMaybe<ArticleNestedArticleGoodDealAiProcessesUpdateInput>;
  /** Actions for the "Article.articleGuides" relation: "ArticleGuide.article"'s inverse relation */
  articleGuides?: InputMaybe<ArticleNestedArticleGuidesUpdateInput>;
  /** Actions for the "Article.articleHistories" relation: "ArticleHistory.article"'s inverse relation */
  articleHistories?: InputMaybe<ArticleNestedArticleHistoriesUpdateInput>;
  /** Actions for the "Article.articleMachineTags" relation: "ArticleMachineTag.article"'s inverse relation */
  articleMachineTags?: InputMaybe<ArticleNestedArticleMachineTagsUpdateInput>;
  /** Actions for the "Article.articleQualifiers" relation: "ArticleQualifier.article"'s inverse relation */
  articleQualifiers?: InputMaybe<ArticleNestedArticleQualifiersUpdateInput>;
  /** Actions for the "Article.articleTags" relation: "ArticleTag.article"'s inverse relation */
  articleTags?: InputMaybe<ArticleNestedArticleTagsUpdateInput>;
  /** Actions for the "Article.articleTaxonomies" relation: "ArticleTaxonomy.article"'s inverse relation */
  articleTaxonomies?: InputMaybe<ArticleNestedArticleTaxonomiesUpdateInput>;
  /** Actions for the "Article.articleUrls" relation: "ArticleUrl.article"'s inverse relation */
  articleUrls?: InputMaybe<ArticleNestedArticleUrlsUpdateInput>;
  /** Actions for the "Article.articleUsers" relation: "ArticleUser.article"'s inverse relation */
  articleUsers?: InputMaybe<ArticleNestedArticleUsersUpdateInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyMedias?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  discoverTitle?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<ArticleFormat>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.live" relation: "Live.article"'s inverse relation */
  live?: InputMaybe<ArticleNestedLiveUpdateInput>;
  medias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.openAiProcesses" relation: "OpenAiProcess.article"'s inverse relation */
  openAiProcesses?: InputMaybe<ArticleNestedOpenAiProcessesUpdateInput>;
  /** Actions for the "Article.parentArticle" relation: "ArticleHistory.duplicatedArticle"'s inverse relation */
  parentArticle?: InputMaybe<ArticleNestedParentArticleUpdateInput>;
  partnerTitle?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Article.pushes" relation: "Push.article"'s inverse relation */
  pushes?: InputMaybe<ArticleNestedPushesUpdateInput>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.source" relation */
  source?: InputMaybe<ArticleNestedSourceUpdateInput>;
  status?: InputMaybe<ArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Item of the "Article.articleUrls" list, a 0-based index collection */
export type ArticleUrl = {
  __typename?: 'ArticleUrl';
  article: Article;
  order: Scalars['Int']['output'];
  url: Url;
};

export type ArticleUrlArticleUrlsSearchWhereInput = {
  AND?: InputMaybe<Array<ArticleUrlArticleUrlsSearchWhereInput>>;
  NOT?: InputMaybe<ArticleUrlArticleUrlsSearchWhereInput>;
  OR?: InputMaybe<Array<ArticleUrlArticleUrlsSearchWhereInput>>;
  url?: InputMaybe<UrlArticleUrlsUrlSearchWhereInput>;
};

export type ArticleUrlCreateInput = {
  /** Actions for the "ArticleUrl.article" relation */
  article: ArticleUrlNestedArticleCreateInput;
  order: Scalars['Int']['input'];
  /** Actions for the "ArticleUrl.url" relation */
  url: ArticleUrlNestedUrlCreateInput;
};

export type ArticleUrlNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleUrl" node, through the "ArticleUrl.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleUrl" node, through the "ArticleUrl.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleUrl" node, through the "ArticleUrl.article" relation. */
  update?: InputMaybe<ArticleUrlNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleUrl" node, through the "ArticleUrl.article" relation. */
  upsert?: InputMaybe<ArticleUrlNestedUpsertArticleCreateInput>;
};

export type ArticleUrlNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleUrlNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleUrlNestedUrlCreateInput = {
  /** Connect an existing "Url" node to the new "ArticleUrl" node, through the "ArticleUrl.url" relation. */
  connect?: InputMaybe<UrlWhereUniqueInput>;
  /** Create a new "Url" node and connect it to the new "ArticleUrl" node, through the "ArticleUrl.url" relation. */
  create?: InputMaybe<UrlCreateInput>;
};

export enum ArticleUrlOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

/** "ArticleUrlPublicId" resource's node */
export type ArticleUrlPublicId = {
  __typename?: 'ArticleUrlPublicId';
  brandKey: BrandKey;
  format: ArticleFormat;
  maxPublicId: Scalars['Int']['output'];
};

export type ArticleUrlPublicIdCreateInput = {
  brandKey: BrandKey;
  format: ArticleFormat;
  maxPublicId: Scalars['Int']['input'];
};

export enum ArticleUrlPublicIdOrderByInput {
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  format_ASC = 'format_ASC',
  format_DESC = 'format_DESC',
  maxPublicId_ASC = 'maxPublicId_ASC',
  maxPublicId_DESC = 'maxPublicId_DESC'
}

export type ArticleUrlPublicIdUpdateInput = {
  maxPublicId?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleUrlPublicId" nodes by specifying some conditions */
export type ArticleUrlPublicIdWhereInput = {
  AND?: InputMaybe<Array<ArticleUrlPublicIdWhereInput>>;
  NOT?: InputMaybe<ArticleUrlPublicIdWhereInput>;
  OR?: InputMaybe<Array<ArticleUrlPublicIdWhereInput>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  format?: InputMaybe<ArticleFormat>;
  format_in?: InputMaybe<Array<ArticleFormat>>;
  format_not?: InputMaybe<ArticleFormat>;
  format_not_in?: InputMaybe<Array<ArticleFormat>>;
  maxPublicId?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_gt?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_gte?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxPublicId_lt?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_lte?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_not?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Identifies exactly one "ArticleUrlPublicId" node. */
export type ArticleUrlPublicIdWhereUniqueInput = {
  brandKey: BrandKey;
  format: ArticleFormat;
};

export type ArticleUrlUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArticleUrl" nodes by specifying some conditions */
export type ArticleUrlWhereInput = {
  AND?: InputMaybe<Array<ArticleUrlWhereInput>>;
  NOT?: InputMaybe<ArticleUrlWhereInput>;
  OR?: InputMaybe<Array<ArticleUrlWhereInput>>;
  article?: InputMaybe<ArticleWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  url?: InputMaybe<UrlWhereInput>;
};

/**
 * Identifies exactly one "ArticleUrl" node with one of these unique combinations of values:
 * - article, url
 * - article, order
 */
export type ArticleUrlWhereUniqueInput = {
  article: ArticleWhereUniqueInput;
  order?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<UrlWhereUniqueInput>;
};

export type ArticleUrlWithForcedArticleCreateInput = {
  order: Scalars['Int']['input'];
  /** Actions for the "ArticleUrl.url" relation */
  url: ArticleUrlNestedUrlCreateInput;
};

export type ArticleUrlWithForcedArticleUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "article", identifies exactly one "ArticleUrl" node with one of these unique values:
 * - url
 * - order
 */
export type ArticleUrlWithForcedArticleWhereUniqueInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<UrlWhereUniqueInput>;
};

export type ArticleUrlWithForcedUrlCreateInput = {
  /** Actions for the "ArticleUrl.article" relation */
  article: ArticleUrlNestedArticleCreateInput;
  order: Scalars['Int']['input'];
};

/** "ArticleUser" resource's node */
export type ArticleUser = {
  __typename?: 'ArticleUser';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  article: Article;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type ArticleUserCreateInput = {
  /** Actions for the "ArticleUser.article" relation */
  article: ArticleUserNestedArticleCreateInput;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type ArticleUserNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "ArticleUser" node, through the "ArticleUser.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "ArticleUser" node, through the "ArticleUser.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "ArticleUser" node, through the "ArticleUser.article" relation. */
  update?: InputMaybe<ArticleUserNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "ArticleUser" node, through the "ArticleUser.article" relation. */
  upsert?: InputMaybe<ArticleUserNestedUpsertArticleCreateInput>;
};

export type ArticleUserNestedArticleUpdateInput = {
  /** Connect an existing "Article" node to the existing "ArticleUser" node, through the "ArticleUser.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the existing "ArticleUser" node, through the "ArticleUser.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the existing "ArticleUser" node, through the "ArticleUser.article" relation. */
  update?: InputMaybe<ArticleUserNestedUpdateArticleUpdateInput>;
  /** Create or update a "Article" node and connect it to the existing "ArticleUser" node, through the "ArticleUser.article" relation. */
  upsert?: InputMaybe<ArticleUserNestedUpsertArticleUpdateInput>;
};

export type ArticleUserNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleUserNestedUpdateArticleUpdateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleUserNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleUserNestedUpsertArticleUpdateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export enum ArticleUserOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  creatorId_ASC = 'creatorId_ASC',
  creatorId_DESC = 'creatorId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type ArticleUserUpdateInput = {
  /** Actions for the "ArticleUser.article" relation */
  article?: InputMaybe<ArticleUserNestedArticleUpdateInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "ArticleUser" nodes by specifying some conditions */
export type ArticleUserWhereInput = {
  AND?: InputMaybe<Array<ArticleUserWhereInput>>;
  NOT?: InputMaybe<ArticleUserWhereInput>;
  OR?: InputMaybe<Array<ArticleUserWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  article?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  creatorId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  creatorId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  creatorId_not?: InputMaybe<Scalars['ID']['input']>;
  creatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Identifies exactly one "ArticleUser" node with one of these unique values:
 * - _id
 * - id
 */
export type ArticleUserWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ArticleUserWithForcedArticleCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type ArticleUserWithForcedArticleUpdateInput = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "Article" nodes by specifying some conditions */
export type ArticleWhereInput = {
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  NOT?: InputMaybe<ArticleWhereInput>;
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleAuthors_some?: InputMaybe<ArticleAuthorWhereInput>;
  articleCategories_some?: InputMaybe<ArticleCategoryWhereInput>;
  articleChannels_some?: InputMaybe<ArticleChannelWhereInput>;
  articleCreatorData?: InputMaybe<ArticleCreatorDataWhereInput>;
  articleCreatorData_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  articleEvents_some?: InputMaybe<ArticleEventWhereInput>;
  articleExtension?: InputMaybe<ArticleExtensionWhereInput>;
  articleExtension_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  articleGoodDealAiProcesses_some?: InputMaybe<ArticleGoodDealAiProcessWhereInput>;
  articleGuides_some?: InputMaybe<ArticleGuideWhereInput>;
  articleHistories_some?: InputMaybe<ArticleHistoryWhereInput>;
  articleMachineTags_some?: InputMaybe<ArticleMachineTagWhereInput>;
  articleQualifiers_some?: InputMaybe<ArticleQualifierWhereInput>;
  articleTags_some?: InputMaybe<ArticleTagWhereInput>;
  articleTaxonomies_some?: InputMaybe<ArticleTaxonomyWhereInput>;
  articleUrls_some?: InputMaybe<ArticleUrlWhereInput>;
  articleUsers_some?: InputMaybe<ArticleUserWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyMedias?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_contains?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_ends_with?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_gt?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_gte?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyMedias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  bodyMedias_lt?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_lte?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_not?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_not_contains?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyMedias_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  bodyMedias_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_gt?: InputMaybe<Scalars['String']['input']>;
  body_gte?: InputMaybe<Scalars['String']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_lt?: InputMaybe<Scalars['String']['input']>;
  body_lte?: InputMaybe<Scalars['String']['input']>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  creatorId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  creatorId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  creatorId_not?: InputMaybe<Scalars['ID']['input']>;
  creatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  discoverTitle?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_contains?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_gt?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_gte?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discoverTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  discoverTitle_lt?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_lte?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_not?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discoverTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  discoverTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  format?: InputMaybe<ArticleFormat>;
  format_in?: InputMaybe<Array<ArticleFormat>>;
  format_not?: InputMaybe<ArticleFormat>;
  format_not_in?: InputMaybe<Array<ArticleFormat>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lead?: InputMaybe<Scalars['String']['input']>;
  lead_contains?: InputMaybe<Scalars['String']['input']>;
  lead_ends_with?: InputMaybe<Scalars['String']['input']>;
  lead_gt?: InputMaybe<Scalars['String']['input']>;
  lead_gte?: InputMaybe<Scalars['String']['input']>;
  lead_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lead_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lead_lt?: InputMaybe<Scalars['String']['input']>;
  lead_lte?: InputMaybe<Scalars['String']['input']>;
  lead_not?: InputMaybe<Scalars['String']['input']>;
  lead_not_contains?: InputMaybe<Scalars['String']['input']>;
  lead_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lead_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lead_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lead_starts_with?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<LiveWhereInput>;
  live_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  medias_contains?: InputMaybe<Scalars['String']['input']>;
  medias_ends_with?: InputMaybe<Scalars['String']['input']>;
  medias_gt?: InputMaybe<Scalars['String']['input']>;
  medias_gte?: InputMaybe<Scalars['String']['input']>;
  medias_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  medias_lt?: InputMaybe<Scalars['String']['input']>;
  medias_lte?: InputMaybe<Scalars['String']['input']>;
  medias_not?: InputMaybe<Scalars['String']['input']>;
  medias_not_contains?: InputMaybe<Scalars['String']['input']>;
  medias_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  medias_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medias_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  medias_starts_with?: InputMaybe<Scalars['String']['input']>;
  openAiProcesses_some?: InputMaybe<OpenAiProcessWhereInput>;
  parentArticle_some?: InputMaybe<ArticleHistoryWhereInput>;
  partnerTitle?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_gt?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_gte?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  partnerTitle_lt?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_lte?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_not?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  partnerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformId_contains?: InputMaybe<Scalars['String']['input']>;
  platformId_ends_with?: InputMaybe<Scalars['String']['input']>;
  platformId_gt?: InputMaybe<Scalars['String']['input']>;
  platformId_gte?: InputMaybe<Scalars['String']['input']>;
  platformId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platformId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  platformId_lt?: InputMaybe<Scalars['String']['input']>;
  platformId_lte?: InputMaybe<Scalars['String']['input']>;
  platformId_not?: InputMaybe<Scalars['String']['input']>;
  platformId_not_contains?: InputMaybe<Scalars['String']['input']>;
  platformId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  platformId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platformId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  platformId_starts_with?: InputMaybe<Scalars['String']['input']>;
  platform_contains?: InputMaybe<Scalars['String']['input']>;
  platform_ends_with?: InputMaybe<Scalars['String']['input']>;
  platform_gt?: InputMaybe<Scalars['String']['input']>;
  platform_gte?: InputMaybe<Scalars['String']['input']>;
  platform_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  platform_lt?: InputMaybe<Scalars['String']['input']>;
  platform_lte?: InputMaybe<Scalars['String']['input']>;
  platform_not?: InputMaybe<Scalars['String']['input']>;
  platform_not_contains?: InputMaybe<Scalars['String']['input']>;
  platform_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  platform_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  platform_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pushes_some?: InputMaybe<PushWhereInput>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_gt?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_gte?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryTitle_lt?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_lte?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_not?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  signature_contains?: InputMaybe<Scalars['String']['input']>;
  signature_ends_with?: InputMaybe<Scalars['String']['input']>;
  signature_gt?: InputMaybe<Scalars['String']['input']>;
  signature_gte?: InputMaybe<Scalars['String']['input']>;
  signature_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signature_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  signature_lt?: InputMaybe<Scalars['String']['input']>;
  signature_lte?: InputMaybe<Scalars['String']['input']>;
  signature_not?: InputMaybe<Scalars['String']['input']>;
  signature_not_contains?: InputMaybe<Scalars['String']['input']>;
  signature_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  signature_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signature_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  signature_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<SourceWhereInput>;
  source_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ArticleStatus>;
  status_in?: InputMaybe<Array<ArticleStatus>>;
  status_not?: InputMaybe<ArticleStatus>;
  status_not_in?: InputMaybe<Array<ArticleStatus>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Article" node with one of these unique combinations of values:
 * - _id
 * - id
 * - brandKey, platform, platformId
 */
export type ArticleWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  id?: InputMaybe<Scalars['ID']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleWithForcedSourceCreateInput = {
  /** Actions for the "Article.articleAuthors" relation: "ArticleAuthor.article"'s inverse relation */
  articleAuthors?: InputMaybe<ArticleNestedArticleAuthorsCreateInput>;
  /** Actions for the "Article.articleCategories" relation: "ArticleCategory.article"'s inverse relation */
  articleCategories?: InputMaybe<ArticleNestedArticleCategoriesCreateInput>;
  /** Actions for the "Article.articleChannels" relation: "ArticleChannel.article"'s inverse relation */
  articleChannels?: InputMaybe<ArticleNestedArticleChannelsCreateInput>;
  /** Actions for the "Article.articleCreatorData" relation: "ArticleCreatorData.article"'s inverse relation */
  articleCreatorData?: InputMaybe<ArticleNestedArticleCreatorDataCreateInput>;
  /** Actions for the "Article.articleEvents" relation: "ArticleEvent.article"'s inverse relation */
  articleEvents?: InputMaybe<ArticleNestedArticleEventsCreateInput>;
  /** Actions for the "Article.articleExtension" relation: "ArticleExtension.article"'s inverse relation */
  articleExtension?: InputMaybe<ArticleNestedArticleExtensionCreateInput>;
  /** Actions for the "Article.articleGoodDealAiProcesses" relation: "ArticleGoodDealAiProcess.article"'s inverse relation */
  articleGoodDealAiProcesses?: InputMaybe<ArticleNestedArticleGoodDealAiProcessesCreateInput>;
  /** Actions for the "Article.articleGuides" relation: "ArticleGuide.article"'s inverse relation */
  articleGuides?: InputMaybe<ArticleNestedArticleGuidesCreateInput>;
  /** Actions for the "Article.articleHistories" relation: "ArticleHistory.article"'s inverse relation */
  articleHistories?: InputMaybe<ArticleNestedArticleHistoriesCreateInput>;
  /** Actions for the "Article.articleMachineTags" relation: "ArticleMachineTag.article"'s inverse relation */
  articleMachineTags?: InputMaybe<ArticleNestedArticleMachineTagsCreateInput>;
  /** Actions for the "Article.articleQualifiers" relation: "ArticleQualifier.article"'s inverse relation */
  articleQualifiers?: InputMaybe<ArticleNestedArticleQualifiersCreateInput>;
  /** Actions for the "Article.articleTags" relation: "ArticleTag.article"'s inverse relation */
  articleTags?: InputMaybe<ArticleNestedArticleTagsCreateInput>;
  /** Actions for the "Article.articleTaxonomies" relation: "ArticleTaxonomy.article"'s inverse relation */
  articleTaxonomies?: InputMaybe<ArticleNestedArticleTaxonomiesCreateInput>;
  /** Actions for the "Article.articleUrls" relation: "ArticleUrl.article"'s inverse relation */
  articleUrls?: InputMaybe<ArticleNestedArticleUrlsCreateInput>;
  /** Actions for the "Article.articleUsers" relation: "ArticleUser.article"'s inverse relation */
  articleUsers?: InputMaybe<ArticleNestedArticleUsersCreateInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyMedias?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  discoverTitle?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format: ArticleFormat;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.live" relation: "Live.article"'s inverse relation */
  live?: InputMaybe<ArticleNestedLiveCreateInput>;
  medias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.openAiProcesses" relation: "OpenAiProcess.article"'s inverse relation */
  openAiProcesses?: InputMaybe<ArticleNestedOpenAiProcessesCreateInput>;
  /** Actions for the "Article.parentArticle" relation: "ArticleHistory.duplicatedArticle"'s inverse relation */
  parentArticle?: InputMaybe<ArticleNestedParentArticleCreateInput>;
  partnerTitle?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Article.pushes" relation: "Push.article"'s inverse relation */
  pushes?: InputMaybe<ArticleNestedPushesCreateInput>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status: ArticleStatus;
  title: Scalars['String']['input'];
};

export type ArticleWithForcedSourceUpdateInput = {
  /** Actions for the "Article.articleAuthors" relation: "ArticleAuthor.article"'s inverse relation */
  articleAuthors?: InputMaybe<ArticleNestedArticleAuthorsUpdateInput>;
  /** Actions for the "Article.articleCategories" relation: "ArticleCategory.article"'s inverse relation */
  articleCategories?: InputMaybe<ArticleNestedArticleCategoriesUpdateInput>;
  /** Actions for the "Article.articleChannels" relation: "ArticleChannel.article"'s inverse relation */
  articleChannels?: InputMaybe<ArticleNestedArticleChannelsUpdateInput>;
  /** Actions for the "Article.articleCreatorData" relation: "ArticleCreatorData.article"'s inverse relation */
  articleCreatorData?: InputMaybe<ArticleNestedArticleCreatorDataUpdateInput>;
  /** Actions for the "Article.articleEvents" relation: "ArticleEvent.article"'s inverse relation */
  articleEvents?: InputMaybe<ArticleNestedArticleEventsUpdateInput>;
  /** Actions for the "Article.articleExtension" relation: "ArticleExtension.article"'s inverse relation */
  articleExtension?: InputMaybe<ArticleNestedArticleExtensionUpdateInput>;
  /** Actions for the "Article.articleGoodDealAiProcesses" relation: "ArticleGoodDealAiProcess.article"'s inverse relation */
  articleGoodDealAiProcesses?: InputMaybe<ArticleNestedArticleGoodDealAiProcessesUpdateInput>;
  /** Actions for the "Article.articleGuides" relation: "ArticleGuide.article"'s inverse relation */
  articleGuides?: InputMaybe<ArticleNestedArticleGuidesUpdateInput>;
  /** Actions for the "Article.articleHistories" relation: "ArticleHistory.article"'s inverse relation */
  articleHistories?: InputMaybe<ArticleNestedArticleHistoriesUpdateInput>;
  /** Actions for the "Article.articleMachineTags" relation: "ArticleMachineTag.article"'s inverse relation */
  articleMachineTags?: InputMaybe<ArticleNestedArticleMachineTagsUpdateInput>;
  /** Actions for the "Article.articleQualifiers" relation: "ArticleQualifier.article"'s inverse relation */
  articleQualifiers?: InputMaybe<ArticleNestedArticleQualifiersUpdateInput>;
  /** Actions for the "Article.articleTags" relation: "ArticleTag.article"'s inverse relation */
  articleTags?: InputMaybe<ArticleNestedArticleTagsUpdateInput>;
  /** Actions for the "Article.articleTaxonomies" relation: "ArticleTaxonomy.article"'s inverse relation */
  articleTaxonomies?: InputMaybe<ArticleNestedArticleTaxonomiesUpdateInput>;
  /** Actions for the "Article.articleUrls" relation: "ArticleUrl.article"'s inverse relation */
  articleUrls?: InputMaybe<ArticleNestedArticleUrlsUpdateInput>;
  /** Actions for the "Article.articleUsers" relation: "ArticleUser.article"'s inverse relation */
  articleUsers?: InputMaybe<ArticleNestedArticleUsersUpdateInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyMedias?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  discoverTitle?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<ArticleFormat>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.live" relation: "Live.article"'s inverse relation */
  live?: InputMaybe<ArticleNestedLiveUpdateInput>;
  medias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Article.openAiProcesses" relation: "OpenAiProcess.article"'s inverse relation */
  openAiProcesses?: InputMaybe<ArticleNestedOpenAiProcessesUpdateInput>;
  /** Actions for the "Article.parentArticle" relation: "ArticleHistory.duplicatedArticle"'s inverse relation */
  parentArticle?: InputMaybe<ArticleNestedParentArticleUpdateInput>;
  partnerTitle?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Article.pushes" relation: "Push.article"'s inverse relation */
  pushes?: InputMaybe<ArticleNestedPushesUpdateInput>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Authors attribute */
export type Attribute = {
  __typename?: 'Attribute';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "AuthorAttribute.attribute"'s inverse relation count */
  authorAttributeCount: Scalars['Int']['output'];
  /** "AuthorAttribute.attribute"'s inverse relation */
  authorAttributes: Array<AuthorAttribute>;
  brandKey: BrandKey;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** Authors attribute */
export type AttributeAuthorAttributeCountArgs = {
  where?: InputMaybe<AuthorAttributeWhereInput>;
};


/** Authors attribute */
export type AttributeAuthorAttributesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorAttributeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorAttributeWhereInput>;
};

export type AttributeCreateInput = {
  /** Actions for the "Attribute.authorAttributes" relation: "AuthorAttribute.attribute"'s inverse relation */
  authorAttributes?: InputMaybe<AttributeNestedAuthorAttributesCreateInput>;
  brandKey: BrandKey;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AttributeNestedAuthorAttributesCreateInput = {
  /** Create new "AuthorAttribute" nodes and connect them to the new "Attribute" node, through the "Attribute.authorAttributes" relation. */
  create?: InputMaybe<Array<AuthorAttributeWithForcedAttributeCreateInput>>;
};

export type AttributeNestedAuthorAttributesUpdateInput = {
  /** Create new "AuthorAttribute" nodes and connect them to the existing "Attribute" node, through the "Attribute.authorAttributes" relation. */
  create?: InputMaybe<Array<AuthorAttributeWithForcedAttributeCreateInput>>;
  /** Delete existing "AuthorAttribute" nodes from the "Attribute.authorAttributes" relation. */
  delete?: InputMaybe<Array<AuthorAttributeWithForcedAttributeWhereUniqueInput>>;
  /** Update existing "AuthorAttribute" nodes and connect them to the existing "Attribute" node, through the "Attribute.authorAttributes" relation. */
  update?: InputMaybe<Array<AttributeNestedUpdateAuthorAttributesUpdateInput>>;
  /** Upsert existing "AuthorAttribute" nodes and connect them to the existing "Attribute" node, through the "Attribute.authorAttributes" relation. */
  upsert?: InputMaybe<Array<AttributeNestedUpsertAuthorAttributesUpdateInput>>;
};

export type AttributeNestedUpdateAuthorAttributesUpdateInput = {
  data: AuthorAttributeWithForcedAttributeUpdateInput;
  where: AuthorAttributeWithForcedAttributeWhereUniqueInput;
};

export type AttributeNestedUpsertAuthorAttributesUpdateInput = {
  create: AuthorAttributeWithForcedAttributeCreateInput;
  update: AuthorAttributeWithForcedAttributeUpdateInput;
  where: AuthorAttributeWithForcedAttributeWhereUniqueInput;
};

export enum AttributeOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AttributeUpdateInput = {
  /** Actions for the "Attribute.authorAttributes" relation: "AuthorAttribute.attribute"'s inverse relation */
  authorAttributes?: InputMaybe<AttributeNestedAuthorAttributesUpdateInput>;
};

/** Filters the "Attribute" nodes by specifying some conditions */
export type AttributeWhereInput = {
  AND?: InputMaybe<Array<AttributeWhereInput>>;
  NOT?: InputMaybe<AttributeWhereInput>;
  OR?: InputMaybe<Array<AttributeWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  authorAttributes_some?: InputMaybe<AuthorAttributeWhereInput>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Attribute" node with one of these unique combinations of values:
 * - _id
 * - id
 * - brandKey, title
 * - brandKey, slug
 */
export type AttributeWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** An author */
export type Author = {
  __typename?: 'Author';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  activeOnBrandKeys?: Maybe<Scalars['String']['output']>;
  /** "ArticleAuthor.author"'s inverse relation count */
  articleAuthorCount: Scalars['Int']['output'];
  /** "ArticleAuthor.author"'s inverse relation */
  articleAuthors: Array<ArticleAuthor>;
  /** "AuthorAttribute.author"'s inverse relation count */
  authorAttributeCount: Scalars['Int']['output'];
  /** "AuthorAttribute.author"'s inverse relation */
  authorAttributes: Array<AuthorAttribute>;
  /** "AuthorHistory.author"'s inverse relation */
  authorHistories: Array<AuthorHistory>;
  /** "AuthorHistory.author"'s inverse relation count */
  authorHistoryCount: Scalars['Int']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  brandKey?: Maybe<BrandKey>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Contains brandkeys for which author have published articles */
  existsOnBrandKeys?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  googleId?: Maybe<Scalars['String']['output']>;
  hasPublicProfile?: Maybe<Scalars['Boolean']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  instagramId?: Maybe<Scalars['String']['output']>;
  isMain?: Maybe<Scalars['Boolean']['output']>;
  linkedinId?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pinterestId?: Maybe<Scalars['String']['output']>;
  prismaConnectId?: Maybe<Scalars['String']['output']>;
  resume?: Maybe<Scalars['String']['output']>;
  snapshatId?: Maybe<Scalars['String']['output']>;
  twitterId?: Maybe<Scalars['String']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};


/** An author */
export type AuthorArticleAuthorCountArgs = {
  where?: InputMaybe<ArticleAuthorWhereInput>;
};


/** An author */
export type AuthorArticleAuthorsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleAuthorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleAuthorWhereInput>;
};


/** An author */
export type AuthorAuthorAttributeCountArgs = {
  where?: InputMaybe<AuthorAttributeWhereInput>;
};


/** An author */
export type AuthorAuthorAttributesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorAttributeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorAttributeWhereInput>;
};


/** An author */
export type AuthorAuthorHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorHistoryWhereInput>;
};


/** An author */
export type AuthorAuthorHistoryCountArgs = {
  where?: InputMaybe<AuthorHistoryWhereInput>;
};

export type AuthorArticleAuthorsAuthorSearchWhereInput = {
  AND?: InputMaybe<Array<AuthorArticleAuthorsAuthorSearchWhereInput>>;
  NOT?: InputMaybe<AuthorArticleAuthorsAuthorSearchWhereInput>;
  OR?: InputMaybe<Array<AuthorArticleAuthorsAuthorSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
};

/** Item of the "Author.authorAttributes" list, a 0-based index collection */
export type AuthorAttribute = {
  __typename?: 'AuthorAttribute';
  attribute: Attribute;
  author: Author;
  order: Scalars['Int']['output'];
};

export type AuthorAttributeCreateInput = {
  /** Actions for the "AuthorAttribute.attribute" relation */
  attribute: AuthorAttributeNestedAttributeCreateInput;
  /** Actions for the "AuthorAttribute.author" relation */
  author: AuthorAttributeNestedAuthorCreateInput;
  order: Scalars['Int']['input'];
};

export type AuthorAttributeNestedAttributeCreateInput = {
  /** Connect an existing "Attribute" node to the new "AuthorAttribute" node, through the "AuthorAttribute.attribute" relation. */
  connect?: InputMaybe<AttributeWhereUniqueInput>;
  /** Create a new "Attribute" node and connect it to the new "AuthorAttribute" node, through the "AuthorAttribute.attribute" relation. */
  create?: InputMaybe<AttributeCreateInput>;
  /** Update an existing "Attribute" node and connect it to the new "AuthorAttribute" node, through the "AuthorAttribute.attribute" relation. */
  update?: InputMaybe<AuthorAttributeNestedUpdateAttributeCreateInput>;
  /** Create or update a "Attribute" node and connect it to the new "AuthorAttribute" node, through the "AuthorAttribute.attribute" relation. */
  upsert?: InputMaybe<AuthorAttributeNestedUpsertAttributeCreateInput>;
};

export type AuthorAttributeNestedAuthorCreateInput = {
  /** Connect an existing "Author" node to the new "AuthorAttribute" node, through the "AuthorAttribute.author" relation. */
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  /** Create a new "Author" node and connect it to the new "AuthorAttribute" node, through the "AuthorAttribute.author" relation. */
  create?: InputMaybe<AuthorCreateInput>;
  /** Update an existing "Author" node and connect it to the new "AuthorAttribute" node, through the "AuthorAttribute.author" relation. */
  update?: InputMaybe<AuthorAttributeNestedUpdateAuthorCreateInput>;
  /** Create or update a "Author" node and connect it to the new "AuthorAttribute" node, through the "AuthorAttribute.author" relation. */
  upsert?: InputMaybe<AuthorAttributeNestedUpsertAuthorCreateInput>;
};

export type AuthorAttributeNestedUpdateAttributeCreateInput = {
  data: AttributeUpdateInput;
  where: AttributeWhereUniqueInput;
};

export type AuthorAttributeNestedUpdateAuthorCreateInput = {
  data: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorAttributeNestedUpsertAttributeCreateInput = {
  create: AttributeCreateInput;
  update: AttributeUpdateInput;
  where: AttributeWhereUniqueInput;
};

export type AuthorAttributeNestedUpsertAuthorCreateInput = {
  create: AuthorCreateInput;
  update: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};

export enum AuthorAttributeOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type AuthorAttributeUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "AuthorAttribute" nodes by specifying some conditions */
export type AuthorAttributeWhereInput = {
  AND?: InputMaybe<Array<AuthorAttributeWhereInput>>;
  NOT?: InputMaybe<AuthorAttributeWhereInput>;
  OR?: InputMaybe<Array<AuthorAttributeWhereInput>>;
  attribute?: InputMaybe<AttributeWhereInput>;
  author?: InputMaybe<AuthorWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "AuthorAttribute" node with one of these unique combinations of values:
 * - attribute, author
 * - author, order
 */
export type AuthorAttributeWhereUniqueInput = {
  attribute?: InputMaybe<AttributeWhereUniqueInput>;
  author: AuthorWhereUniqueInput;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorAttributeWithForcedAttributeCreateInput = {
  /** Actions for the "AuthorAttribute.author" relation */
  author: AuthorAttributeNestedAuthorCreateInput;
  order: Scalars['Int']['input'];
};

export type AuthorAttributeWithForcedAttributeUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "attribute", identifies exactly one "AuthorAttribute" node. */
export type AuthorAttributeWithForcedAttributeWhereUniqueInput = {
  author: AuthorWhereUniqueInput;
};

export type AuthorAttributeWithForcedAuthorCreateInput = {
  /** Actions for the "AuthorAttribute.attribute" relation */
  attribute: AuthorAttributeNestedAttributeCreateInput;
  order: Scalars['Int']['input'];
};

export type AuthorAttributeWithForcedAuthorUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "author", identifies exactly one "AuthorAttribute" node with one of these unique values:
 * - attribute
 * - order
 */
export type AuthorAttributeWithForcedAuthorWhereUniqueInput = {
  attribute?: InputMaybe<AttributeWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorCreateInput = {
  /** Actions for the "Author.articleAuthors" relation: "ArticleAuthor.author"'s inverse relation */
  articleAuthors?: InputMaybe<AuthorNestedArticleAuthorsCreateInput>;
  /** Actions for the "Author.authorAttributes" relation: "AuthorAttribute.author"'s inverse relation */
  authorAttributes?: InputMaybe<AuthorNestedAuthorAttributesCreateInput>;
  /** Actions for the "Author.authorHistories" relation: "AuthorHistory.author"'s inverse relation */
  authorHistories?: InputMaybe<AuthorNestedAuthorHistoriesCreateInput>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  hasPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  instagramId?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinId?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pinterestId?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId?: InputMaybe<Scalars['String']['input']>;
  resume?: InputMaybe<Scalars['String']['input']>;
  snapshatId?: InputMaybe<Scalars['String']['input']>;
  twitterId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Author creation / update history */
export type AuthorHistory = {
  __typename?: 'AuthorHistory';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  author: Author;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type AuthorHistoryCreateInput = {
  /** Actions for the "AuthorHistory.author" relation */
  author: AuthorHistoryNestedAuthorCreateInput;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type AuthorHistoryNestedAuthorCreateInput = {
  /** Connect an existing "Author" node to the new "AuthorHistory" node, through the "AuthorHistory.author" relation. */
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  /** Create a new "Author" node and connect it to the new "AuthorHistory" node, through the "AuthorHistory.author" relation. */
  create?: InputMaybe<AuthorCreateInput>;
  /** Update an existing "Author" node and connect it to the new "AuthorHistory" node, through the "AuthorHistory.author" relation. */
  update?: InputMaybe<AuthorHistoryNestedUpdateAuthorCreateInput>;
  /** Create or update a "Author" node and connect it to the new "AuthorHistory" node, through the "AuthorHistory.author" relation. */
  upsert?: InputMaybe<AuthorHistoryNestedUpsertAuthorCreateInput>;
};

export type AuthorHistoryNestedAuthorUpdateInput = {
  /** Connect an existing "Author" node to the existing "AuthorHistory" node, through the "AuthorHistory.author" relation. */
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  /** Create a new "Author" node and connect it to the existing "AuthorHistory" node, through the "AuthorHistory.author" relation. */
  create?: InputMaybe<AuthorCreateInput>;
  /** Update an existing "Author" node and connect it to the existing "AuthorHistory" node, through the "AuthorHistory.author" relation. */
  update?: InputMaybe<AuthorHistoryNestedUpdateAuthorUpdateInput>;
  /** Create or update a "Author" node and connect it to the existing "AuthorHistory" node, through the "AuthorHistory.author" relation. */
  upsert?: InputMaybe<AuthorHistoryNestedUpsertAuthorUpdateInput>;
};

export type AuthorHistoryNestedUpdateAuthorCreateInput = {
  data: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorHistoryNestedUpdateAuthorUpdateInput = {
  data: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorHistoryNestedUpsertAuthorCreateInput = {
  create: AuthorCreateInput;
  update: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorHistoryNestedUpsertAuthorUpdateInput = {
  create: AuthorCreateInput;
  update: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};

export enum AuthorHistoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type AuthorHistoryUpdateInput = {
  /** Actions for the "AuthorHistory.author" relation */
  author?: InputMaybe<AuthorHistoryNestedAuthorUpdateInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "AuthorHistory" nodes by specifying some conditions */
export type AuthorHistoryWhereInput = {
  AND?: InputMaybe<Array<AuthorHistoryWhereInput>>;
  NOT?: InputMaybe<AuthorHistoryWhereInput>;
  OR?: InputMaybe<Array<AuthorHistoryWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  author?: InputMaybe<AuthorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Identifies exactly one "AuthorHistory" node with one of these unique values:
 * - _id
 * - id
 */
export type AuthorHistoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AuthorHistoryWithForcedAuthorCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type AuthorHistoryWithForcedAuthorUpdateInput = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AuthorNestedArticleAuthorsCreateInput = {
  /** Create new "ArticleAuthor" nodes and connect them to the new "Author" node, through the "Author.articleAuthors" relation. */
  create?: InputMaybe<Array<ArticleAuthorWithForcedAuthorCreateInput>>;
};

export type AuthorNestedArticleAuthorsUpdateInput = {
  /** Create new "ArticleAuthor" nodes and connect them to the existing "Author" node, through the "Author.articleAuthors" relation. */
  create?: InputMaybe<Array<ArticleAuthorWithForcedAuthorCreateInput>>;
  /** Delete existing "ArticleAuthor" nodes from the "Author.articleAuthors" relation. */
  delete?: InputMaybe<Array<ArticleAuthorWithForcedAuthorWhereUniqueInput>>;
  /** Update existing "ArticleAuthor" nodes and connect them to the existing "Author" node, through the "Author.articleAuthors" relation. */
  update?: InputMaybe<Array<AuthorNestedUpdateArticleAuthorsUpdateInput>>;
  /** Upsert existing "ArticleAuthor" nodes and connect them to the existing "Author" node, through the "Author.articleAuthors" relation. */
  upsert?: InputMaybe<Array<AuthorNestedUpsertArticleAuthorsUpdateInput>>;
};

export type AuthorNestedAuthorAttributesCreateInput = {
  /** Create new "AuthorAttribute" nodes and connect them to the new "Author" node, through the "Author.authorAttributes" relation. */
  create?: InputMaybe<Array<AuthorAttributeWithForcedAuthorCreateInput>>;
};

export type AuthorNestedAuthorAttributesUpdateInput = {
  /** Create new "AuthorAttribute" nodes and connect them to the existing "Author" node, through the "Author.authorAttributes" relation. */
  create?: InputMaybe<Array<AuthorAttributeWithForcedAuthorCreateInput>>;
  /** Delete existing "AuthorAttribute" nodes from the "Author.authorAttributes" relation. */
  delete?: InputMaybe<Array<AuthorAttributeWithForcedAuthorWhereUniqueInput>>;
  /** Update existing "AuthorAttribute" nodes and connect them to the existing "Author" node, through the "Author.authorAttributes" relation. */
  update?: InputMaybe<Array<AuthorNestedUpdateAuthorAttributesUpdateInput>>;
  /** Upsert existing "AuthorAttribute" nodes and connect them to the existing "Author" node, through the "Author.authorAttributes" relation. */
  upsert?: InputMaybe<Array<AuthorNestedUpsertAuthorAttributesUpdateInput>>;
};

export type AuthorNestedAuthorHistoriesCreateInput = {
  /** Connect existing "AuthorHistory" nodes to the new "Author" node, through the "Author.authorHistories" relation. */
  connect?: InputMaybe<Array<AuthorHistoryWhereUniqueInput>>;
  /** Create new "AuthorHistory" nodes and connect them to the new "Author" node, through the "Author.authorHistories" relation. */
  create?: InputMaybe<Array<AuthorHistoryWithForcedAuthorCreateInput>>;
};

export type AuthorNestedAuthorHistoriesUpdateInput = {
  /** Connect existing "AuthorHistory" nodes to the existing "Author" node, through the "Author.authorHistories" relation. */
  connect?: InputMaybe<Array<AuthorHistoryWhereUniqueInput>>;
  /** Create new "AuthorHistory" nodes and connect them to the existing "Author" node, through the "Author.authorHistories" relation. */
  create?: InputMaybe<Array<AuthorHistoryWithForcedAuthorCreateInput>>;
  /** Delete existing "AuthorHistory" nodes from the "Author.authorHistories" relation. */
  delete?: InputMaybe<Array<AuthorHistoryWhereUniqueInput>>;
  /** Update existing "AuthorHistory" nodes and connect them to the existing "Author" node, through the "Author.authorHistories" relation. */
  update?: InputMaybe<Array<AuthorNestedUpdateAuthorHistoriesUpdateInput>>;
  /** Upsert existing "AuthorHistory" nodes and connect them to the existing "Author" node, through the "Author.authorHistories" relation. */
  upsert?: InputMaybe<Array<AuthorNestedUpsertAuthorHistoriesUpdateInput>>;
};

export type AuthorNestedUpdateArticleAuthorsUpdateInput = {
  data: ArticleAuthorWithForcedAuthorUpdateInput;
  where: ArticleAuthorWithForcedAuthorWhereUniqueInput;
};

export type AuthorNestedUpdateAuthorAttributesUpdateInput = {
  data: AuthorAttributeWithForcedAuthorUpdateInput;
  where: AuthorAttributeWithForcedAuthorWhereUniqueInput;
};

export type AuthorNestedUpdateAuthorHistoriesUpdateInput = {
  data: AuthorHistoryWithForcedAuthorUpdateInput;
  where: AuthorHistoryWhereUniqueInput;
};

export type AuthorNestedUpsertArticleAuthorsUpdateInput = {
  create: ArticleAuthorWithForcedAuthorCreateInput;
  update: ArticleAuthorWithForcedAuthorUpdateInput;
  where: ArticleAuthorWithForcedAuthorWhereUniqueInput;
};

export type AuthorNestedUpsertAuthorAttributesUpdateInput = {
  create: AuthorAttributeWithForcedAuthorCreateInput;
  update: AuthorAttributeWithForcedAuthorUpdateInput;
  where: AuthorAttributeWithForcedAuthorWhereUniqueInput;
};

export type AuthorNestedUpsertAuthorHistoriesUpdateInput = {
  create: AuthorHistoryWithForcedAuthorCreateInput;
  update: AuthorHistoryWithForcedAuthorUpdateInput;
  where: AuthorHistoryWhereUniqueInput;
};

export enum AuthorOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  activeOnBrandKeys_ASC = 'activeOnBrandKeys_ASC',
  activeOnBrandKeys_DESC = 'activeOnBrandKeys_DESC',
  avatarUrl_ASC = 'avatarUrl_ASC',
  avatarUrl_DESC = 'avatarUrl_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  email_ASC = 'email_ASC',
  email_DESC = 'email_DESC',
  existsOnBrandKeys_ASC = 'existsOnBrandKeys_ASC',
  existsOnBrandKeys_DESC = 'existsOnBrandKeys_DESC',
  facebookId_ASC = 'facebookId_ASC',
  facebookId_DESC = 'facebookId_DESC',
  googleId_ASC = 'googleId_ASC',
  googleId_DESC = 'googleId_DESC',
  hasPublicProfile_ASC = 'hasPublicProfile_ASC',
  hasPublicProfile_DESC = 'hasPublicProfile_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  instagramId_ASC = 'instagramId_ASC',
  instagramId_DESC = 'instagramId_DESC',
  isMain_ASC = 'isMain_ASC',
  isMain_DESC = 'isMain_DESC',
  linkedinId_ASC = 'linkedinId_ASC',
  linkedinId_DESC = 'linkedinId_DESC',
  media_ASC = 'media_ASC',
  media_DESC = 'media_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  pinterestId_ASC = 'pinterestId_ASC',
  pinterestId_DESC = 'pinterestId_DESC',
  prismaConnectId_ASC = 'prismaConnectId_ASC',
  prismaConnectId_DESC = 'prismaConnectId_DESC',
  resume_ASC = 'resume_ASC',
  resume_DESC = 'resume_DESC',
  snapshatId_ASC = 'snapshatId_ASC',
  snapshatId_DESC = 'snapshatId_DESC',
  twitterId_ASC = 'twitterId_ASC',
  twitterId_DESC = 'twitterId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type AuthorUpdateInput = {
  /** Actions for the "Author.articleAuthors" relation: "ArticleAuthor.author"'s inverse relation */
  articleAuthors?: InputMaybe<AuthorNestedArticleAuthorsUpdateInput>;
  /** Actions for the "Author.authorAttributes" relation: "AuthorAttribute.author"'s inverse relation */
  authorAttributes?: InputMaybe<AuthorNestedAuthorAttributesUpdateInput>;
  /** Actions for the "Author.authorHistories" relation: "AuthorHistory.author"'s inverse relation */
  authorHistories?: InputMaybe<AuthorNestedAuthorHistoriesUpdateInput>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  hasPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  instagramId?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinId?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pinterestId?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId?: InputMaybe<Scalars['String']['input']>;
  resume?: InputMaybe<Scalars['String']['input']>;
  snapshatId?: InputMaybe<Scalars['String']['input']>;
  twitterId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "Author" nodes by specifying some conditions */
export type AuthorWhereInput = {
  AND?: InputMaybe<Array<AuthorWhereInput>>;
  NOT?: InputMaybe<AuthorWhereInput>;
  OR?: InputMaybe<Array<AuthorWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  activeOnBrandKeys?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_contains?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_ends_with?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_gt?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_gte?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activeOnBrandKeys_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  activeOnBrandKeys_lt?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_lte?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_not?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_not_contains?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activeOnBrandKeys_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  activeOnBrandKeys_starts_with?: InputMaybe<Scalars['String']['input']>;
  articleAuthors_some?: InputMaybe<ArticleAuthorWhereInput>;
  authorAttributes_some?: InputMaybe<AuthorAttributeWhereInput>;
  authorHistories_some?: InputMaybe<AuthorHistoryWhereInput>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_contains?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_gt?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_gte?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatarUrl_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl_lt?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_lte?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_not?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatarUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  avatarUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<InputMaybe<BrandKey>>>;
  brandKey_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<InputMaybe<BrandKey>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_contains?: InputMaybe<Scalars['String']['input']>;
  email_ends_with?: InputMaybe<Scalars['String']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_not?: InputMaybe<Scalars['String']['input']>;
  email_not_contains?: InputMaybe<Scalars['String']['input']>;
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  email_starts_with?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_contains?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_ends_with?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_gt?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_gte?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  existsOnBrandKeys_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  existsOnBrandKeys_lt?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_lte?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_not?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_not_contains?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  existsOnBrandKeys_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  existsOnBrandKeys_starts_with?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  facebookId_contains?: InputMaybe<Scalars['String']['input']>;
  facebookId_ends_with?: InputMaybe<Scalars['String']['input']>;
  facebookId_gt?: InputMaybe<Scalars['String']['input']>;
  facebookId_gte?: InputMaybe<Scalars['String']['input']>;
  facebookId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebookId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  facebookId_lt?: InputMaybe<Scalars['String']['input']>;
  facebookId_lte?: InputMaybe<Scalars['String']['input']>;
  facebookId_not?: InputMaybe<Scalars['String']['input']>;
  facebookId_not_contains?: InputMaybe<Scalars['String']['input']>;
  facebookId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  facebookId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebookId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  facebookId_starts_with?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleId_contains?: InputMaybe<Scalars['String']['input']>;
  googleId_ends_with?: InputMaybe<Scalars['String']['input']>;
  googleId_gt?: InputMaybe<Scalars['String']['input']>;
  googleId_gte?: InputMaybe<Scalars['String']['input']>;
  googleId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  googleId_lt?: InputMaybe<Scalars['String']['input']>;
  googleId_lte?: InputMaybe<Scalars['String']['input']>;
  googleId_not?: InputMaybe<Scalars['String']['input']>;
  googleId_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  googleId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  googleId_starts_with?: InputMaybe<Scalars['String']['input']>;
  hasPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPublicProfile_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  hasPublicProfile_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  hasPublicProfile_not?: InputMaybe<Scalars['Boolean']['input']>;
  hasPublicProfile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  instagramId?: InputMaybe<Scalars['String']['input']>;
  instagramId_contains?: InputMaybe<Scalars['String']['input']>;
  instagramId_ends_with?: InputMaybe<Scalars['String']['input']>;
  instagramId_gt?: InputMaybe<Scalars['String']['input']>;
  instagramId_gte?: InputMaybe<Scalars['String']['input']>;
  instagramId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagramId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  instagramId_lt?: InputMaybe<Scalars['String']['input']>;
  instagramId_lte?: InputMaybe<Scalars['String']['input']>;
  instagramId_not?: InputMaybe<Scalars['String']['input']>;
  instagramId_not_contains?: InputMaybe<Scalars['String']['input']>;
  instagramId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  instagramId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagramId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  instagramId_starts_with?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  isMain_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isMain_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isMain_not?: InputMaybe<Scalars['Boolean']['input']>;
  isMain_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  linkedinId?: InputMaybe<Scalars['String']['input']>;
  linkedinId_contains?: InputMaybe<Scalars['String']['input']>;
  linkedinId_ends_with?: InputMaybe<Scalars['String']['input']>;
  linkedinId_gt?: InputMaybe<Scalars['String']['input']>;
  linkedinId_gte?: InputMaybe<Scalars['String']['input']>;
  linkedinId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedinId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinId_lt?: InputMaybe<Scalars['String']['input']>;
  linkedinId_lte?: InputMaybe<Scalars['String']['input']>;
  linkedinId_not?: InputMaybe<Scalars['String']['input']>;
  linkedinId_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkedinId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  linkedinId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedinId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkedinId_starts_with?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  media_contains?: InputMaybe<Scalars['String']['input']>;
  media_ends_with?: InputMaybe<Scalars['String']['input']>;
  media_gt?: InputMaybe<Scalars['String']['input']>;
  media_gte?: InputMaybe<Scalars['String']['input']>;
  media_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  media_lt?: InputMaybe<Scalars['String']['input']>;
  media_lte?: InputMaybe<Scalars['String']['input']>;
  media_not?: InputMaybe<Scalars['String']['input']>;
  media_not_contains?: InputMaybe<Scalars['String']['input']>;
  media_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  media_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  media_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  pinterestId?: InputMaybe<Scalars['String']['input']>;
  pinterestId_contains?: InputMaybe<Scalars['String']['input']>;
  pinterestId_ends_with?: InputMaybe<Scalars['String']['input']>;
  pinterestId_gt?: InputMaybe<Scalars['String']['input']>;
  pinterestId_gte?: InputMaybe<Scalars['String']['input']>;
  pinterestId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pinterestId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  pinterestId_lt?: InputMaybe<Scalars['String']['input']>;
  pinterestId_lte?: InputMaybe<Scalars['String']['input']>;
  pinterestId_not?: InputMaybe<Scalars['String']['input']>;
  pinterestId_not_contains?: InputMaybe<Scalars['String']['input']>;
  pinterestId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pinterestId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pinterestId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pinterestId_starts_with?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_contains?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_ends_with?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_gt?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_gte?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prismaConnectId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  prismaConnectId_lt?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_lte?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_not?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_not_contains?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prismaConnectId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  prismaConnectId_starts_with?: InputMaybe<Scalars['String']['input']>;
  resume?: InputMaybe<Scalars['String']['input']>;
  resume_contains?: InputMaybe<Scalars['String']['input']>;
  resume_ends_with?: InputMaybe<Scalars['String']['input']>;
  resume_gt?: InputMaybe<Scalars['String']['input']>;
  resume_gte?: InputMaybe<Scalars['String']['input']>;
  resume_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resume_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  resume_lt?: InputMaybe<Scalars['String']['input']>;
  resume_lte?: InputMaybe<Scalars['String']['input']>;
  resume_not?: InputMaybe<Scalars['String']['input']>;
  resume_not_contains?: InputMaybe<Scalars['String']['input']>;
  resume_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  resume_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resume_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  resume_starts_with?: InputMaybe<Scalars['String']['input']>;
  snapshatId?: InputMaybe<Scalars['String']['input']>;
  snapshatId_contains?: InputMaybe<Scalars['String']['input']>;
  snapshatId_ends_with?: InputMaybe<Scalars['String']['input']>;
  snapshatId_gt?: InputMaybe<Scalars['String']['input']>;
  snapshatId_gte?: InputMaybe<Scalars['String']['input']>;
  snapshatId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snapshatId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  snapshatId_lt?: InputMaybe<Scalars['String']['input']>;
  snapshatId_lte?: InputMaybe<Scalars['String']['input']>;
  snapshatId_not?: InputMaybe<Scalars['String']['input']>;
  snapshatId_not_contains?: InputMaybe<Scalars['String']['input']>;
  snapshatId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  snapshatId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snapshatId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  snapshatId_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitterId?: InputMaybe<Scalars['String']['input']>;
  twitterId_contains?: InputMaybe<Scalars['String']['input']>;
  twitterId_ends_with?: InputMaybe<Scalars['String']['input']>;
  twitterId_gt?: InputMaybe<Scalars['String']['input']>;
  twitterId_gte?: InputMaybe<Scalars['String']['input']>;
  twitterId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitterId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  twitterId_lt?: InputMaybe<Scalars['String']['input']>;
  twitterId_lte?: InputMaybe<Scalars['String']['input']>;
  twitterId_not?: InputMaybe<Scalars['String']['input']>;
  twitterId_not_contains?: InputMaybe<Scalars['String']['input']>;
  twitterId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  twitterId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitterId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitterId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/**
 * Identifies exactly one "Author" node with one of these unique values:
 * - _id
 * - id
 * - name
 */
export type AuthorWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum BrandKey {
  BEA = 'BEA',
  BIN = 'BIN',
  BONE = 'BONE',
  BRGTS = 'BRGTS',
  BROMM = 'BROMM',
  CAC = 'CAC',
  CAM = 'CAM',
  CAP = 'CAP',
  CTR = 'CTR',
  DEGTS = 'DEGTS',
  DEOMM = 'DEOMM',
  DESAS = 'DESAS',
  ESGTS = 'ESGTS',
  ESOMM = 'ESOMM',
  FAC = 'FAC',
  FRGSD = 'FRGSD',
  FRGSG = 'FRGSG',
  FRGSL = 'FRGSL',
  FRGSS = 'FRGSS',
  FRGSV = 'FRGSV',
  FROMM = 'FROMM',
  GAL = 'GAL',
  GEO = 'GEO',
  HBR = 'HBR',
  HBZ = 'HBZ',
  ITGTS = 'ITGTS',
  ITOMM = 'ITOMM',
  NEO = 'NEO',
  SHGFAC = 'SHGFAC',
  SIM = 'SIM',
  TEL = 'TEL',
  TESTBRAND = 'TESTBRAND',
  TGC = 'TGC',
  TLA = 'TLA',
  TLS = 'TLS',
  UKGTS = 'UKGTS',
  UKOMM = 'UKOMM',
  UKSAS = 'UKSAS',
  VDF = 'VDF',
  VOI = 'VOI'
}

/** A Card */
export type Card = {
  __typename?: 'Card';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  body?: Maybe<Scalars['String']['output']>;
  brandKey: BrandKey;
  /** "CardCategory.card"'s inverse relation */
  cardCategories: Array<CardCategory>;
  /** "CardCategory.card"'s inverse relation count */
  cardCategoryCount: Scalars['Int']['output'];
  /** "CardTag.card"'s inverse relation count */
  cardTagCount: Scalars['Int']['output'];
  /** "CardTag.card"'s inverse relation */
  cardTags: Array<CardTag>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The public ID, an UUID v4 */
  id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
  media?: Maybe<Scalars['String']['output']>;
  secondaryTitle?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: CardStatus;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};


/** A Card */
export type CardCardCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CardCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardCategoryWhereInput>;
};


/** A Card */
export type CardCardCategoryCountArgs = {
  where?: InputMaybe<CardCategoryWhereInput>;
};


/** A Card */
export type CardCardTagCountArgs = {
  where?: InputMaybe<CardTagWhereInput>;
};


/** A Card */
export type CardCardTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CardTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardTagWhereInput>;
};

/** Item of the "Card.cardCategories" list, a 0-based index collection */
export type CardCategory = {
  __typename?: 'CardCategory';
  card: Card;
  category: Category;
  order: Scalars['Int']['output'];
};

export type CardCategoryCreateInput = {
  /** Actions for the "CardCategory.card" relation */
  card: CardCategoryNestedCardCreateInput;
  /** Actions for the "CardCategory.category" relation */
  category: CardCategoryNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type CardCategoryNestedCardCreateInput = {
  /** Connect an existing "Card" node to the new "CardCategory" node, through the "CardCategory.card" relation. */
  connect?: InputMaybe<CardWhereUniqueInput>;
  /** Create a new "Card" node and connect it to the new "CardCategory" node, through the "CardCategory.card" relation. */
  create?: InputMaybe<CardCreateInput>;
  /** Update an existing "Card" node and connect it to the new "CardCategory" node, through the "CardCategory.card" relation. */
  update?: InputMaybe<CardCategoryNestedUpdateCardCreateInput>;
  /** Create or update a "Card" node and connect it to the new "CardCategory" node, through the "CardCategory.card" relation. */
  upsert?: InputMaybe<CardCategoryNestedUpsertCardCreateInput>;
};

export type CardCategoryNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "CardCategory" node, through the "CardCategory.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "CardCategory" node, through the "CardCategory.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "CardCategory" node, through the "CardCategory.category" relation. */
  update?: InputMaybe<CardCategoryNestedUpdateCategoryCreateInput>;
  /** Create or update a "Category" node and connect it to the new "CardCategory" node, through the "CardCategory.category" relation. */
  upsert?: InputMaybe<CardCategoryNestedUpsertCategoryCreateInput>;
};

export type CardCategoryNestedUpdateCardCreateInput = {
  data: CardUpdateInput;
  where: CardWhereUniqueInput;
};

export type CardCategoryNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CardCategoryNestedUpsertCardCreateInput = {
  create: CardCreateInput;
  update: CardUpdateInput;
  where: CardWhereUniqueInput;
};

export type CardCategoryNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export enum CardCategoryOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type CardCategoryUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "CardCategory" nodes by specifying some conditions */
export type CardCategoryWhereInput = {
  AND?: InputMaybe<Array<CardCategoryWhereInput>>;
  NOT?: InputMaybe<CardCategoryWhereInput>;
  OR?: InputMaybe<Array<CardCategoryWhereInput>>;
  card?: InputMaybe<CardWhereInput>;
  category?: InputMaybe<CategoryWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "CardCategory" node with one of these unique combinations of values:
 * - card, category
 * - card, order
 */
export type CardCategoryWhereUniqueInput = {
  card: CardWhereUniqueInput;
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CardCategoryWithForcedCardCreateInput = {
  /** Actions for the "CardCategory.category" relation */
  category: CardCategoryNestedCategoryCreateInput;
  order: Scalars['Int']['input'];
};

export type CardCategoryWithForcedCardUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "card", identifies exactly one "CardCategory" node with one of these unique values:
 * - category
 * - order
 */
export type CardCategoryWithForcedCardWhereUniqueInput = {
  category?: InputMaybe<CategoryWhereUniqueInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CardCategoryWithForcedCategoryCreateInput = {
  /** Actions for the "CardCategory.card" relation */
  card: CardCategoryNestedCardCreateInput;
  order: Scalars['Int']['input'];
};

export type CardCategoryWithForcedCategoryUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "category", identifies exactly one "CardCategory" node. */
export type CardCategoryWithForcedCategoryWhereUniqueInput = {
  card: CardWhereUniqueInput;
};

export type CardCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  /** Actions for the "Card.cardCategories" relation: "CardCategory.card"'s inverse relation */
  cardCategories?: InputMaybe<CardNestedCardCategoriesCreateInput>;
  /** Actions for the "Card.cardTags" relation: "CardTag.card"'s inverse relation */
  cardTags?: InputMaybe<CardNestedCardTagsCreateInput>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  media?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status: CardStatus;
  title: Scalars['String']['input'];
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type CardNestedCardCategoriesCreateInput = {
  /** Create new "CardCategory" nodes and connect them to the new "Card" node, through the "Card.cardCategories" relation. */
  create?: InputMaybe<Array<CardCategoryWithForcedCardCreateInput>>;
};

export type CardNestedCardCategoriesUpdateInput = {
  /** Create new "CardCategory" nodes and connect them to the existing "Card" node, through the "Card.cardCategories" relation. */
  create?: InputMaybe<Array<CardCategoryWithForcedCardCreateInput>>;
  /** Delete existing "CardCategory" nodes from the "Card.cardCategories" relation. */
  delete?: InputMaybe<Array<CardCategoryWithForcedCardWhereUniqueInput>>;
  /** Update existing "CardCategory" nodes and connect them to the existing "Card" node, through the "Card.cardCategories" relation. */
  update?: InputMaybe<Array<CardNestedUpdateCardCategoriesUpdateInput>>;
  /** Upsert existing "CardCategory" nodes and connect them to the existing "Card" node, through the "Card.cardCategories" relation. */
  upsert?: InputMaybe<Array<CardNestedUpsertCardCategoriesUpdateInput>>;
};

export type CardNestedCardTagsCreateInput = {
  /** Create new "CardTag" nodes and connect them to the new "Card" node, through the "Card.cardTags" relation. */
  create?: InputMaybe<Array<CardTagWithForcedCardCreateInput>>;
};

export type CardNestedCardTagsUpdateInput = {
  /** Create new "CardTag" nodes and connect them to the existing "Card" node, through the "Card.cardTags" relation. */
  create?: InputMaybe<Array<CardTagWithForcedCardCreateInput>>;
  /** Delete existing "CardTag" nodes from the "Card.cardTags" relation. */
  delete?: InputMaybe<Array<CardTagWithForcedCardWhereUniqueInput>>;
  /** Update existing "CardTag" nodes and connect them to the existing "Card" node, through the "Card.cardTags" relation. */
  update?: InputMaybe<Array<CardNestedUpdateCardTagsUpdateInput>>;
  /** Upsert existing "CardTag" nodes and connect them to the existing "Card" node, through the "Card.cardTags" relation. */
  upsert?: InputMaybe<Array<CardNestedUpsertCardTagsUpdateInput>>;
};

export type CardNestedUpdateCardCategoriesUpdateInput = {
  data: CardCategoryWithForcedCardUpdateInput;
  where: CardCategoryWithForcedCardWhereUniqueInput;
};

export type CardNestedUpdateCardTagsUpdateInput = {
  data: CardTagWithForcedCardUpdateInput;
  where: CardTagWithForcedCardWhereUniqueInput;
};

export type CardNestedUpsertCardCategoriesUpdateInput = {
  create: CardCategoryWithForcedCardCreateInput;
  update: CardCategoryWithForcedCardUpdateInput;
  where: CardCategoryWithForcedCardWhereUniqueInput;
};

export type CardNestedUpsertCardTagsUpdateInput = {
  create: CardTagWithForcedCardCreateInput;
  update: CardTagWithForcedCardUpdateInput;
  where: CardTagWithForcedCardWhereUniqueInput;
};

export enum CardOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  media_ASC = 'media_ASC',
  media_DESC = 'media_DESC',
  secondaryTitle_ASC = 'secondaryTitle_ASC',
  secondaryTitle_DESC = 'secondaryTitle_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export enum CardStatus {
  Archived = 'Archived',
  Published = 'Published'
}

/** Item of the "Card.cardTags" list, a 0-based index collection */
export type CardTag = {
  __typename?: 'CardTag';
  card: Card;
  order: Scalars['Int']['output'];
  tag: Tag;
};

export type CardTagCreateInput = {
  /** Actions for the "CardTag.card" relation */
  card: CardTagNestedCardCreateInput;
  order: Scalars['Int']['input'];
  /** Actions for the "CardTag.tag" relation */
  tag: CardTagNestedTagCreateInput;
};

export type CardTagNestedCardCreateInput = {
  /** Connect an existing "Card" node to the new "CardTag" node, through the "CardTag.card" relation. */
  connect?: InputMaybe<CardWhereUniqueInput>;
  /** Create a new "Card" node and connect it to the new "CardTag" node, through the "CardTag.card" relation. */
  create?: InputMaybe<CardCreateInput>;
  /** Update an existing "Card" node and connect it to the new "CardTag" node, through the "CardTag.card" relation. */
  update?: InputMaybe<CardTagNestedUpdateCardCreateInput>;
  /** Create or update a "Card" node and connect it to the new "CardTag" node, through the "CardTag.card" relation. */
  upsert?: InputMaybe<CardTagNestedUpsertCardCreateInput>;
};

export type CardTagNestedTagCreateInput = {
  /** Connect an existing "Tag" node to the new "CardTag" node, through the "CardTag.tag" relation. */
  connect?: InputMaybe<TagWhereUniqueInput>;
  /** Create a new "Tag" node and connect it to the new "CardTag" node, through the "CardTag.tag" relation. */
  create?: InputMaybe<TagCreateInput>;
  /** Update an existing "Tag" node and connect it to the new "CardTag" node, through the "CardTag.tag" relation. */
  update?: InputMaybe<CardTagNestedUpdateTagCreateInput>;
  /** Create or update a "Tag" node and connect it to the new "CardTag" node, through the "CardTag.tag" relation. */
  upsert?: InputMaybe<CardTagNestedUpsertTagCreateInput>;
};

export type CardTagNestedUpdateCardCreateInput = {
  data: CardUpdateInput;
  where: CardWhereUniqueInput;
};

export type CardTagNestedUpdateTagCreateInput = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type CardTagNestedUpsertCardCreateInput = {
  create: CardCreateInput;
  update: CardUpdateInput;
  where: CardWhereUniqueInput;
};

export type CardTagNestedUpsertTagCreateInput = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export enum CardTagOrderByInput {
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC'
}

export type CardTagUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "CardTag" nodes by specifying some conditions */
export type CardTagWhereInput = {
  AND?: InputMaybe<Array<CardTagWhereInput>>;
  NOT?: InputMaybe<CardTagWhereInput>;
  OR?: InputMaybe<Array<CardTagWhereInput>>;
  card?: InputMaybe<CardWhereInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tag?: InputMaybe<TagWhereInput>;
};

/**
 * Identifies exactly one "CardTag" node with one of these unique combinations of values:
 * - card, tag
 * - card, order
 */
export type CardTagWhereUniqueInput = {
  card: CardWhereUniqueInput;
  order?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<TagWhereUniqueInput>;
};

export type CardTagWithForcedCardCreateInput = {
  order: Scalars['Int']['input'];
  /** Actions for the "CardTag.tag" relation */
  tag: CardTagNestedTagCreateInput;
};

export type CardTagWithForcedCardUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a forced "card", identifies exactly one "CardTag" node with one of these unique values:
 * - tag
 * - order
 */
export type CardTagWithForcedCardWhereUniqueInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<TagWhereUniqueInput>;
};

export type CardTagWithForcedTagCreateInput = {
  /** Actions for the "CardTag.card" relation */
  card: CardTagNestedCardCreateInput;
  order: Scalars['Int']['input'];
};

export type CardTagWithForcedTagUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Given a forced "tag", identifies exactly one "CardTag" node. */
export type CardTagWithForcedTagWhereUniqueInput = {
  card: CardWhereUniqueInput;
};

export type CardUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  /** Actions for the "Card.cardCategories" relation: "CardCategory.card"'s inverse relation */
  cardCategories?: InputMaybe<CardNestedCardCategoriesUpdateInput>;
  /** Actions for the "Card.cardTags" relation: "CardTag.card"'s inverse relation */
  cardTags?: InputMaybe<CardNestedCardTagsUpdateInput>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CardStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "Card" nodes by specifying some conditions */
export type CardWhereInput = {
  AND?: InputMaybe<Array<CardWhereInput>>;
  NOT?: InputMaybe<CardWhereInput>;
  OR?: InputMaybe<Array<CardWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_gt?: InputMaybe<Scalars['String']['input']>;
  body_gte?: InputMaybe<Scalars['String']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_lt?: InputMaybe<Scalars['String']['input']>;
  body_lte?: InputMaybe<Scalars['String']['input']>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  cardCategories_some?: InputMaybe<CardCategoryWhereInput>;
  cardTags_some?: InputMaybe<CardTagWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_gt?: InputMaybe<Scalars['String']['input']>;
  label_gte?: InputMaybe<Scalars['String']['input']>;
  label_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_lt?: InputMaybe<Scalars['String']['input']>;
  label_lte?: InputMaybe<Scalars['String']['input']>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  media_contains?: InputMaybe<Scalars['String']['input']>;
  media_ends_with?: InputMaybe<Scalars['String']['input']>;
  media_gt?: InputMaybe<Scalars['String']['input']>;
  media_gte?: InputMaybe<Scalars['String']['input']>;
  media_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  media_lt?: InputMaybe<Scalars['String']['input']>;
  media_lte?: InputMaybe<Scalars['String']['input']>;
  media_not?: InputMaybe<Scalars['String']['input']>;
  media_not_contains?: InputMaybe<Scalars['String']['input']>;
  media_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  media_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  media_starts_with?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_gt?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_gte?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryTitle_lt?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_lte?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_not?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  secondaryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CardStatus>;
  status_in?: InputMaybe<Array<CardStatus>>;
  status_not?: InputMaybe<CardStatus>;
  status_not_in?: InputMaybe<Array<CardStatus>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_gt?: InputMaybe<Scalars['String']['input']>;
  url_gte?: InputMaybe<Scalars['String']['input']>;
  url_in?: InputMaybe<Array<Scalars['String']['input']>>;
  url_lt?: InputMaybe<Scalars['String']['input']>;
  url_lte?: InputMaybe<Scalars['String']['input']>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Identifies exactly one "Card" node with one of these unique values:
 * - _id
 * - id
 */
export type CardWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A category */
export type Category = {
  __typename?: 'Category';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "ArticleCategory.category"'s inverse relation */
  articleCategories: Array<ArticleCategory>;
  /** "ArticleCategory.category"'s inverse relation count */
  articleCategoryCount: Scalars['Int']['output'];
  /** "ArticleChannel.category"'s inverse relation count */
  articleChannelCount: Scalars['Int']['output'];
  /** "ArticleChannel.category"'s inverse relation */
  articleChannels: Array<ArticleChannel>;
  /** "ArticleEvent.category"'s inverse relation count */
  articleEventCount: Scalars['Int']['output'];
  /** "ArticleEvent.category"'s inverse relation */
  articleEvents: Array<ArticleEvent>;
  /** "ArticleGuide.category"'s inverse relation count */
  articleGuideCount: Scalars['Int']['output'];
  /** "ArticleGuide.category"'s inverse relation */
  articleGuides: Array<ArticleGuide>;
  bodyDraft?: Maybe<Scalars['String']['output']>;
  brandKey: BrandKey;
  /** "CardCategory.category"'s inverse relation */
  cardCategories: Array<CardCategory>;
  /** "CardCategory.category"'s inverse relation count */
  cardCategoryCount: Scalars['Int']['output'];
  /** "CategoryHistory.category"'s inverse relation */
  categoryHistories: Array<CategoryHistory>;
  /** "CategoryHistory.category"'s inverse relation count */
  categoryHistoryCount: Scalars['Int']['output'];
  /** "Category.parent"'s inverse relation count */
  childCount: Scalars['Int']['output'];
  /** "Category.parent"'s inverse relation */
  children: Array<Category>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  format: CategoryFormat;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  isHeadlined: Scalars['Boolean']['output'];
  /** State of current campaign (locked or not) */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  left?: Maybe<Scalars['Int']['output']>;
  level: Scalars['Int']['output'];
  /** The date of the category's last lock */
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user currently locking the campaign */
  lockedBy?: Maybe<User>;
  lockerId?: Maybe<Scalars['ID']['output']>;
  maxBoardPinned?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Scalars['String']['output']>;
  metas?: Maybe<Scalars['String']['output']>;
  minBoardPinned?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Category>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  right?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  status: CategoryStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  /** "Tab.category"'s inverse relation count */
  tabCount: Scalars['Int']['output'];
  /** "Tab.category"'s inverse relation */
  tabs: Array<Tab>;
  tags?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  urls?: Maybe<Scalars['String']['output']>;
};


/** A category */
export type CategoryArticleCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleCategoryWhereInput>;
};


/** A category */
export type CategoryArticleCategoryCountArgs = {
  where?: InputMaybe<ArticleCategoryWhereInput>;
};


/** A category */
export type CategoryArticleChannelCountArgs = {
  where?: InputMaybe<ArticleChannelWhereInput>;
};


/** A category */
export type CategoryArticleChannelsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleChannelOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleChannelWhereInput>;
};


/** A category */
export type CategoryArticleEventCountArgs = {
  where?: InputMaybe<ArticleEventWhereInput>;
};


/** A category */
export type CategoryArticleEventsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleEventOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleEventWhereInput>;
};


/** A category */
export type CategoryArticleGuideCountArgs = {
  where?: InputMaybe<ArticleGuideWhereInput>;
};


/** A category */
export type CategoryArticleGuidesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleGuideOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleGuideWhereInput>;
};


/** A category */
export type CategoryCardCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CardCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardCategoryWhereInput>;
};


/** A category */
export type CategoryCardCategoryCountArgs = {
  where?: InputMaybe<CardCategoryWhereInput>;
};


/** A category */
export type CategoryCategoryHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryHistoryWhereInput>;
};


/** A category */
export type CategoryCategoryHistoryCountArgs = {
  where?: InputMaybe<CategoryHistoryWhereInput>;
};


/** A category */
export type CategoryChildCountArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


/** A category */
export type CategoryChildrenArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** A category */
export type CategoryTabCountArgs = {
  where?: InputMaybe<TabWhereInput>;
};


/** A category */
export type CategoryTabsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TabOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabWhereInput>;
};

export type CategoryArticleCategoriesCategorySearchWhereInput = {
  AND?: InputMaybe<Array<CategoryArticleCategoriesCategorySearchWhereInput>>;
  NOT?: InputMaybe<CategoryArticleCategoriesCategorySearchWhereInput>;
  OR?: InputMaybe<Array<CategoryArticleCategoriesCategorySearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryArticleChannelsCategorySearchWhereInput = {
  AND?: InputMaybe<Array<CategoryArticleChannelsCategorySearchWhereInput>>;
  NOT?: InputMaybe<CategoryArticleChannelsCategorySearchWhereInput>;
  OR?: InputMaybe<Array<CategoryArticleChannelsCategorySearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryArticleEventsCategorySearchWhereInput = {
  AND?: InputMaybe<Array<CategoryArticleEventsCategorySearchWhereInput>>;
  NOT?: InputMaybe<CategoryArticleEventsCategorySearchWhereInput>;
  OR?: InputMaybe<Array<CategoryArticleEventsCategorySearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryArticleGuidesCategorySearchWhereInput = {
  AND?: InputMaybe<Array<CategoryArticleGuidesCategorySearchWhereInput>>;
  NOT?: InputMaybe<CategoryArticleGuidesCategorySearchWhereInput>;
  OR?: InputMaybe<Array<CategoryArticleGuidesCategorySearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryCreateInput = {
  /** Actions for the "Category.articleCategories" relation: "ArticleCategory.category"'s inverse relation */
  articleCategories?: InputMaybe<CategoryNestedArticleCategoriesCreateInput>;
  /** Actions for the "Category.articleChannels" relation: "ArticleChannel.category"'s inverse relation */
  articleChannels?: InputMaybe<CategoryNestedArticleChannelsCreateInput>;
  /** Actions for the "Category.articleEvents" relation: "ArticleEvent.category"'s inverse relation */
  articleEvents?: InputMaybe<CategoryNestedArticleEventsCreateInput>;
  /** Actions for the "Category.articleGuides" relation: "ArticleGuide.category"'s inverse relation */
  articleGuides?: InputMaybe<CategoryNestedArticleGuidesCreateInput>;
  bodyDraft?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  /** Actions for the "Category.cardCategories" relation: "CardCategory.category"'s inverse relation */
  cardCategories?: InputMaybe<CategoryNestedCardCategoriesCreateInput>;
  /** Actions for the "Category.categoryHistories" relation: "CategoryHistory.category"'s inverse relation */
  categoryHistories?: InputMaybe<CategoryNestedCategoryHistoriesCreateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenCreateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format: CategoryFormat;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  isHeadlined?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  maxBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  minBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "Category.parent" relation */
  parent?: InputMaybe<CategoryNestedParentCreateInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  right?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status: CategoryStatus;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.tabs" relation: "Tab.category"'s inverse relation */
  tabs?: InputMaybe<CategoryNestedTabsCreateInput>;
  tags?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  urls?: InputMaybe<Scalars['String']['input']>;
};

export enum CategoryFormat {
  Category = 'Category',
  Channel = 'Channel',
  Event = 'Event',
  Guide = 'Guide'
}

/** "CategoryHistory" resource's node */
export type CategoryHistory = {
  __typename?: 'CategoryHistory';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  category: Category;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  status: CategoryStatus;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type CategoryHistoryCreateInput = {
  /** Actions for the "CategoryHistory.category" relation */
  category: CategoryHistoryNestedCategoryCreateInput;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  status: CategoryStatus;
  userId: Scalars['ID']['input'];
};

export type CategoryHistoryNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "CategoryHistory" node, through the "CategoryHistory.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "CategoryHistory" node, through the "CategoryHistory.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "CategoryHistory" node, through the "CategoryHistory.category" relation. */
  update?: InputMaybe<CategoryHistoryNestedUpdateCategoryCreateInput>;
  /** Create or update a "Category" node and connect it to the new "CategoryHistory" node, through the "CategoryHistory.category" relation. */
  upsert?: InputMaybe<CategoryHistoryNestedUpsertCategoryCreateInput>;
};

export type CategoryHistoryNestedCategoryUpdateInput = {
  /** Connect an existing "Category" node to the existing "CategoryHistory" node, through the "CategoryHistory.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the existing "CategoryHistory" node, through the "CategoryHistory.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the existing "CategoryHistory" node, through the "CategoryHistory.category" relation. */
  update?: InputMaybe<CategoryHistoryNestedUpdateCategoryUpdateInput>;
  /** Create or update a "Category" node and connect it to the existing "CategoryHistory" node, through the "CategoryHistory.category" relation. */
  upsert?: InputMaybe<CategoryHistoryNestedUpsertCategoryUpdateInput>;
};

export type CategoryHistoryNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryHistoryNestedUpdateCategoryUpdateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryHistoryNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryHistoryNestedUpsertCategoryUpdateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export enum CategoryHistoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type CategoryHistoryUpdateInput = {
  /** Actions for the "CategoryHistory.category" relation */
  category?: InputMaybe<CategoryHistoryNestedCategoryUpdateInput>;
  status?: InputMaybe<CategoryStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "CategoryHistory" nodes by specifying some conditions */
export type CategoryHistoryWhereInput = {
  AND?: InputMaybe<Array<CategoryHistoryWhereInput>>;
  NOT?: InputMaybe<CategoryHistoryWhereInput>;
  OR?: InputMaybe<Array<CategoryHistoryWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  category?: InputMaybe<CategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<CategoryStatus>;
  status_in?: InputMaybe<Array<CategoryStatus>>;
  status_not?: InputMaybe<CategoryStatus>;
  status_not_in?: InputMaybe<Array<CategoryStatus>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Identifies exactly one "CategoryHistory" node with one of these unique values:
 * - _id
 * - id
 */
export type CategoryHistoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CategoryHistoryWithForcedCategoryCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  status: CategoryStatus;
  userId: Scalars['ID']['input'];
};

export type CategoryHistoryWithForcedCategoryUpdateInput = {
  status?: InputMaybe<CategoryStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CategoryNestedArticleCategoriesCreateInput = {
  /** Create new "ArticleCategory" nodes and connect them to the new "Category" node, through the "Category.articleCategories" relation. */
  create?: InputMaybe<Array<ArticleCategoryWithForcedCategoryCreateInput>>;
};

export type CategoryNestedArticleCategoriesUpdateInput = {
  /** Create new "ArticleCategory" nodes and connect them to the existing "Category" node, through the "Category.articleCategories" relation. */
  create?: InputMaybe<Array<ArticleCategoryWithForcedCategoryCreateInput>>;
  /** Delete existing "ArticleCategory" nodes from the "Category.articleCategories" relation. */
  delete?: InputMaybe<Array<ArticleCategoryWithForcedCategoryWhereUniqueInput>>;
  /** Update existing "ArticleCategory" nodes and connect them to the existing "Category" node, through the "Category.articleCategories" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateArticleCategoriesUpdateInput>>;
  /** Upsert existing "ArticleCategory" nodes and connect them to the existing "Category" node, through the "Category.articleCategories" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertArticleCategoriesUpdateInput>>;
};

export type CategoryNestedArticleChannelsCreateInput = {
  /** Create new "ArticleChannel" nodes and connect them to the new "Category" node, through the "Category.articleChannels" relation. */
  create?: InputMaybe<Array<ArticleChannelWithForcedCategoryCreateInput>>;
};

export type CategoryNestedArticleChannelsUpdateInput = {
  /** Create new "ArticleChannel" nodes and connect them to the existing "Category" node, through the "Category.articleChannels" relation. */
  create?: InputMaybe<Array<ArticleChannelWithForcedCategoryCreateInput>>;
  /** Delete existing "ArticleChannel" nodes from the "Category.articleChannels" relation. */
  delete?: InputMaybe<Array<ArticleChannelWithForcedCategoryWhereUniqueInput>>;
  /** Update existing "ArticleChannel" nodes and connect them to the existing "Category" node, through the "Category.articleChannels" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateArticleChannelsUpdateInput>>;
  /** Upsert existing "ArticleChannel" nodes and connect them to the existing "Category" node, through the "Category.articleChannels" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertArticleChannelsUpdateInput>>;
};

export type CategoryNestedArticleEventsCreateInput = {
  /** Create new "ArticleEvent" nodes and connect them to the new "Category" node, through the "Category.articleEvents" relation. */
  create?: InputMaybe<Array<ArticleEventWithForcedCategoryCreateInput>>;
};

export type CategoryNestedArticleEventsUpdateInput = {
  /** Create new "ArticleEvent" nodes and connect them to the existing "Category" node, through the "Category.articleEvents" relation. */
  create?: InputMaybe<Array<ArticleEventWithForcedCategoryCreateInput>>;
  /** Delete existing "ArticleEvent" nodes from the "Category.articleEvents" relation. */
  delete?: InputMaybe<Array<ArticleEventWithForcedCategoryWhereUniqueInput>>;
  /** Update existing "ArticleEvent" nodes and connect them to the existing "Category" node, through the "Category.articleEvents" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateArticleEventsUpdateInput>>;
  /** Upsert existing "ArticleEvent" nodes and connect them to the existing "Category" node, through the "Category.articleEvents" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertArticleEventsUpdateInput>>;
};

export type CategoryNestedArticleGuidesCreateInput = {
  /** Create new "ArticleGuide" nodes and connect them to the new "Category" node, through the "Category.articleGuides" relation. */
  create?: InputMaybe<Array<ArticleGuideWithForcedCategoryCreateInput>>;
};

export type CategoryNestedArticleGuidesUpdateInput = {
  /** Create new "ArticleGuide" nodes and connect them to the existing "Category" node, through the "Category.articleGuides" relation. */
  create?: InputMaybe<Array<ArticleGuideWithForcedCategoryCreateInput>>;
  /** Delete existing "ArticleGuide" nodes from the "Category.articleGuides" relation. */
  delete?: InputMaybe<Array<ArticleGuideWithForcedCategoryWhereUniqueInput>>;
  /** Update existing "ArticleGuide" nodes and connect them to the existing "Category" node, through the "Category.articleGuides" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateArticleGuidesUpdateInput>>;
  /** Upsert existing "ArticleGuide" nodes and connect them to the existing "Category" node, through the "Category.articleGuides" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertArticleGuidesUpdateInput>>;
};

export type CategoryNestedCardCategoriesCreateInput = {
  /** Create new "CardCategory" nodes and connect them to the new "Category" node, through the "Category.cardCategories" relation. */
  create?: InputMaybe<Array<CardCategoryWithForcedCategoryCreateInput>>;
};

export type CategoryNestedCardCategoriesUpdateInput = {
  /** Create new "CardCategory" nodes and connect them to the existing "Category" node, through the "Category.cardCategories" relation. */
  create?: InputMaybe<Array<CardCategoryWithForcedCategoryCreateInput>>;
  /** Delete existing "CardCategory" nodes from the "Category.cardCategories" relation. */
  delete?: InputMaybe<Array<CardCategoryWithForcedCategoryWhereUniqueInput>>;
  /** Update existing "CardCategory" nodes and connect them to the existing "Category" node, through the "Category.cardCategories" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateCardCategoriesUpdateInput>>;
  /** Upsert existing "CardCategory" nodes and connect them to the existing "Category" node, through the "Category.cardCategories" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertCardCategoriesUpdateInput>>;
};

export type CategoryNestedCategoryHistoriesCreateInput = {
  /** Connect existing "CategoryHistory" nodes to the new "Category" node, through the "Category.categoryHistories" relation. */
  connect?: InputMaybe<Array<CategoryHistoryWhereUniqueInput>>;
  /** Create new "CategoryHistory" nodes and connect them to the new "Category" node, through the "Category.categoryHistories" relation. */
  create?: InputMaybe<Array<CategoryHistoryWithForcedCategoryCreateInput>>;
};

export type CategoryNestedCategoryHistoriesUpdateInput = {
  /** Connect existing "CategoryHistory" nodes to the existing "Category" node, through the "Category.categoryHistories" relation. */
  connect?: InputMaybe<Array<CategoryHistoryWhereUniqueInput>>;
  /** Create new "CategoryHistory" nodes and connect them to the existing "Category" node, through the "Category.categoryHistories" relation. */
  create?: InputMaybe<Array<CategoryHistoryWithForcedCategoryCreateInput>>;
  /** Delete existing "CategoryHistory" nodes from the "Category.categoryHistories" relation. */
  delete?: InputMaybe<Array<CategoryHistoryWhereUniqueInput>>;
  /** Update existing "CategoryHistory" nodes and connect them to the existing "Category" node, through the "Category.categoryHistories" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateCategoryHistoriesUpdateInput>>;
  /** Upsert existing "CategoryHistory" nodes and connect them to the existing "Category" node, through the "Category.categoryHistories" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertCategoryHistoriesUpdateInput>>;
};

export type CategoryNestedChildrenCreateInput = {
  /** Connect existing "Category" nodes to the new "Category" node, through the "Category.children" relation. */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create new "Category" nodes and connect them to the new "Category" node, through the "Category.children" relation. */
  create?: InputMaybe<Array<CategoryWithForcedParentCreateInput>>;
};

export type CategoryNestedChildrenUpdateInput = {
  /** Connect existing "Category" nodes to the existing "Category" node, through the "Category.children" relation. */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create new "Category" nodes and connect them to the existing "Category" node, through the "Category.children" relation. */
  create?: InputMaybe<Array<CategoryWithForcedParentCreateInput>>;
  /** Delete existing "Category" nodes from the "Category.children" relation. */
  delete?: InputMaybe<Array<CategoryWithForcedParentWhereUniqueInput>>;
  /** Disconnect existing "Category" nodes of the "Category.children" relation. */
  disconnect?: InputMaybe<Array<CategoryWithForcedParentWhereUniqueInput>>;
  /** Update existing "Category" nodes and connect them to the existing "Category" node, through the "Category.children" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateChildrenUpdateInput>>;
  /** Upsert existing "Category" nodes and connect them to the existing "Category" node, through the "Category.children" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertChildrenUpdateInput>>;
};

export type CategoryNestedParentCreateInput = {
  /** Connect an existing "Category" node to the new "Category" node, through the "Category.parent" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  update?: InputMaybe<CategoryNestedUpdateParentCreateInput>;
  /** Create or update a "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  upsert?: InputMaybe<CategoryNestedUpsertParentCreateInput>;
};

export type CategoryNestedParentUpdateInput = {
  /** Connect an existing "Category" node to the existing "Category" node, through the "Category.parent" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Disconnect the current connected "Category" node, if any, of the "Category.parent" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  update?: InputMaybe<CategoryNestedUpdateParentUpdateInput>;
  /** Create or update a "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  upsert?: InputMaybe<CategoryNestedUpsertParentUpdateInput>;
};

export type CategoryNestedTabsCreateInput = {
  /** Connect existing "Tab" nodes to the new "Category" node, through the "Category.tabs" relation. */
  connect?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Create new "Tab" nodes and connect them to the new "Category" node, through the "Category.tabs" relation. */
  create?: InputMaybe<Array<TabWithForcedCategoryCreateInput>>;
};

export type CategoryNestedTabsUpdateInput = {
  /** Connect existing "Tab" nodes to the existing "Category" node, through the "Category.tabs" relation. */
  connect?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Create new "Tab" nodes and connect them to the existing "Category" node, through the "Category.tabs" relation. */
  create?: InputMaybe<Array<TabWithForcedCategoryCreateInput>>;
  /** Delete existing "Tab" nodes from the "Category.tabs" relation. */
  delete?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Update existing "Tab" nodes and connect them to the existing "Category" node, through the "Category.tabs" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateTabsUpdateInput>>;
  /** Upsert existing "Tab" nodes and connect them to the existing "Category" node, through the "Category.tabs" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertTabsUpdateInput>>;
};

export type CategoryNestedUpdateArticleCategoriesUpdateInput = {
  data: ArticleCategoryWithForcedCategoryUpdateInput;
  where: ArticleCategoryWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpdateArticleChannelsUpdateInput = {
  data: ArticleChannelWithForcedCategoryUpdateInput;
  where: ArticleChannelWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpdateArticleEventsUpdateInput = {
  data: ArticleEventWithForcedCategoryUpdateInput;
  where: ArticleEventWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpdateArticleGuidesUpdateInput = {
  data: ArticleGuideWithForcedCategoryUpdateInput;
  where: ArticleGuideWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpdateCardCategoriesUpdateInput = {
  data: CardCategoryWithForcedCategoryUpdateInput;
  where: CardCategoryWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpdateCategoryHistoriesUpdateInput = {
  data: CategoryHistoryWithForcedCategoryUpdateInput;
  where: CategoryHistoryWhereUniqueInput;
};

export type CategoryNestedUpdateChildrenUpdateInput = {
  data: CategoryWithForcedParentUpdateInput;
  where: CategoryWithOptionalParentWhereUniqueInput;
};

export type CategoryNestedUpdateParentCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpdateParentUpdateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpdateTabsUpdateInput = {
  data: TabWithForcedCategoryUpdateInput;
  where: TabWhereUniqueInput;
};

export type CategoryNestedUpsertArticleCategoriesUpdateInput = {
  create: ArticleCategoryWithForcedCategoryCreateInput;
  update: ArticleCategoryWithForcedCategoryUpdateInput;
  where: ArticleCategoryWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpsertArticleChannelsUpdateInput = {
  create: ArticleChannelWithForcedCategoryCreateInput;
  update: ArticleChannelWithForcedCategoryUpdateInput;
  where: ArticleChannelWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpsertArticleEventsUpdateInput = {
  create: ArticleEventWithForcedCategoryCreateInput;
  update: ArticleEventWithForcedCategoryUpdateInput;
  where: ArticleEventWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpsertArticleGuidesUpdateInput = {
  create: ArticleGuideWithForcedCategoryCreateInput;
  update: ArticleGuideWithForcedCategoryUpdateInput;
  where: ArticleGuideWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpsertCardCategoriesUpdateInput = {
  create: CardCategoryWithForcedCategoryCreateInput;
  update: CardCategoryWithForcedCategoryUpdateInput;
  where: CardCategoryWithForcedCategoryWhereUniqueInput;
};

export type CategoryNestedUpsertCategoryHistoriesUpdateInput = {
  create: CategoryHistoryWithForcedCategoryCreateInput;
  update: CategoryHistoryWithForcedCategoryUpdateInput;
  where: CategoryHistoryWhereUniqueInput;
};

export type CategoryNestedUpsertChildrenUpdateInput = {
  create: CategoryWithForcedParentCreateInput;
  update: CategoryWithForcedParentUpdateInput;
  where: CategoryWithOptionalParentWhereUniqueInput;
};

export type CategoryNestedUpsertParentCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpsertParentUpdateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpsertTabsUpdateInput = {
  create: TabWithForcedCategoryCreateInput;
  update: TabWithForcedCategoryUpdateInput;
  where: TabWhereUniqueInput;
};

export enum CategoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  bodyDraft_ASC = 'bodyDraft_ASC',
  bodyDraft_DESC = 'bodyDraft_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  editedAt_ASC = 'editedAt_ASC',
  editedAt_DESC = 'editedAt_DESC',
  format_ASC = 'format_ASC',
  format_DESC = 'format_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isHeadlined_ASC = 'isHeadlined_ASC',
  isHeadlined_DESC = 'isHeadlined_DESC',
  left_ASC = 'left_ASC',
  left_DESC = 'left_DESC',
  level_ASC = 'level_ASC',
  level_DESC = 'level_DESC',
  lockedAt_ASC = 'lockedAt_ASC',
  lockedAt_DESC = 'lockedAt_DESC',
  lockerId_ASC = 'lockerId_ASC',
  lockerId_DESC = 'lockerId_DESC',
  maxBoardPinned_ASC = 'maxBoardPinned_ASC',
  maxBoardPinned_DESC = 'maxBoardPinned_DESC',
  medias_ASC = 'medias_ASC',
  medias_DESC = 'medias_DESC',
  metas_ASC = 'metas_ASC',
  metas_DESC = 'metas_DESC',
  minBoardPinned_ASC = 'minBoardPinned_ASC',
  minBoardPinned_DESC = 'minBoardPinned_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  right_ASC = 'right_ASC',
  right_DESC = 'right_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  tags_ASC = 'tags_ASC',
  tags_DESC = 'tags_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  urls_ASC = 'urls_ASC',
  urls_DESC = 'urls_DESC'
}

export enum CategoryStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published',
  Scheduled = 'Scheduled'
}

export type CategorySuggestion = {
  __typename?: 'CategorySuggestion';
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CategorySuggestionResult = {
  __typename?: 'CategorySuggestionResult';
  itemCount: Scalars['Int']['output'];
  items: Array<CategorySuggestion>;
  scores: Array<SearchItemScoreType>;
};

export type CategoryUpdateInput = {
  /** Actions for the "Category.articleCategories" relation: "ArticleCategory.category"'s inverse relation */
  articleCategories?: InputMaybe<CategoryNestedArticleCategoriesUpdateInput>;
  /** Actions for the "Category.articleChannels" relation: "ArticleChannel.category"'s inverse relation */
  articleChannels?: InputMaybe<CategoryNestedArticleChannelsUpdateInput>;
  /** Actions for the "Category.articleEvents" relation: "ArticleEvent.category"'s inverse relation */
  articleEvents?: InputMaybe<CategoryNestedArticleEventsUpdateInput>;
  /** Actions for the "Category.articleGuides" relation: "ArticleGuide.category"'s inverse relation */
  articleGuides?: InputMaybe<CategoryNestedArticleGuidesUpdateInput>;
  bodyDraft?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  /** Actions for the "Category.cardCategories" relation: "CardCategory.category"'s inverse relation */
  cardCategories?: InputMaybe<CategoryNestedCardCategoriesUpdateInput>;
  /** Actions for the "Category.categoryHistories" relation: "CategoryHistory.category"'s inverse relation */
  categoryHistories?: InputMaybe<CategoryNestedCategoryHistoriesUpdateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<CategoryFormat>;
  isHeadlined?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  maxBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  minBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "Category.parent" relation */
  parent?: InputMaybe<CategoryNestedParentUpdateInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  right?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CategoryStatus>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.tabs" relation: "Tab.category"'s inverse relation */
  tabs?: InputMaybe<CategoryNestedTabsUpdateInput>;
  tags?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urls?: InputMaybe<Scalars['String']['input']>;
};

/** "CategoryUrlPublicId" resource's node */
export type CategoryUrlPublicId = {
  __typename?: 'CategoryUrlPublicId';
  brandKey: BrandKey;
  format: CategoryFormat;
  maxPublicId: Scalars['Int']['output'];
};

export type CategoryUrlPublicIdCreateInput = {
  brandKey: BrandKey;
  format: CategoryFormat;
  maxPublicId: Scalars['Int']['input'];
};

export enum CategoryUrlPublicIdOrderByInput {
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  format_ASC = 'format_ASC',
  format_DESC = 'format_DESC',
  maxPublicId_ASC = 'maxPublicId_ASC',
  maxPublicId_DESC = 'maxPublicId_DESC'
}

export type CategoryUrlPublicIdUpdateInput = {
  maxPublicId?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "CategoryUrlPublicId" nodes by specifying some conditions */
export type CategoryUrlPublicIdWhereInput = {
  AND?: InputMaybe<Array<CategoryUrlPublicIdWhereInput>>;
  NOT?: InputMaybe<CategoryUrlPublicIdWhereInput>;
  OR?: InputMaybe<Array<CategoryUrlPublicIdWhereInput>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  format?: InputMaybe<CategoryFormat>;
  format_in?: InputMaybe<Array<CategoryFormat>>;
  format_not?: InputMaybe<CategoryFormat>;
  format_not_in?: InputMaybe<Array<CategoryFormat>>;
  maxPublicId?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_gt?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_gte?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxPublicId_lt?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_lte?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_not?: InputMaybe<Scalars['Int']['input']>;
  maxPublicId_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Identifies exactly one "CategoryUrlPublicId" node. */
export type CategoryUrlPublicIdWhereUniqueInput = {
  brandKey: BrandKey;
  format: CategoryFormat;
};

/** Filters the "Category" nodes by specifying some conditions */
export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<CategoryWhereInput>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleCategories_some?: InputMaybe<ArticleCategoryWhereInput>;
  articleChannels_some?: InputMaybe<ArticleChannelWhereInput>;
  articleEvents_some?: InputMaybe<ArticleEventWhereInput>;
  articleGuides_some?: InputMaybe<ArticleGuideWhereInput>;
  bodyDraft?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_contains?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_ends_with?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_gt?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_gte?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyDraft_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  bodyDraft_lt?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_lte?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_not?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_not_contains?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyDraft_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  bodyDraft_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  cardCategories_some?: InputMaybe<CardCategoryWhereInput>;
  categoryHistories_some?: InputMaybe<CategoryHistoryWhereInput>;
  children_some?: InputMaybe<CategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  format?: InputMaybe<CategoryFormat>;
  format_in?: InputMaybe<Array<CategoryFormat>>;
  format_not?: InputMaybe<CategoryFormat>;
  format_not_in?: InputMaybe<Array<CategoryFormat>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isHeadlined?: InputMaybe<Scalars['Boolean']['input']>;
  isHeadlined_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isHeadlined_not?: InputMaybe<Scalars['Boolean']['input']>;
  isHeadlined_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  left?: InputMaybe<Scalars['Int']['input']>;
  left_gt?: InputMaybe<Scalars['Int']['input']>;
  left_gte?: InputMaybe<Scalars['Int']['input']>;
  left_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  left_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  left_lt?: InputMaybe<Scalars['Int']['input']>;
  left_lte?: InputMaybe<Scalars['Int']['input']>;
  left_not?: InputMaybe<Scalars['Int']['input']>;
  left_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  level?: InputMaybe<Scalars['Int']['input']>;
  level_gt?: InputMaybe<Scalars['Int']['input']>;
  level_gte?: InputMaybe<Scalars['Int']['input']>;
  level_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  level_lt?: InputMaybe<Scalars['Int']['input']>;
  level_lte?: InputMaybe<Scalars['Int']['input']>;
  level_not?: InputMaybe<Scalars['Int']['input']>;
  level_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lockedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  lockerId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lockerId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId_not?: InputMaybe<Scalars['ID']['input']>;
  lockerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  maxBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  maxBoardPinned_gt?: InputMaybe<Scalars['Int']['input']>;
  maxBoardPinned_gte?: InputMaybe<Scalars['Int']['input']>;
  maxBoardPinned_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxBoardPinned_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  maxBoardPinned_lt?: InputMaybe<Scalars['Int']['input']>;
  maxBoardPinned_lte?: InputMaybe<Scalars['Int']['input']>;
  maxBoardPinned_not?: InputMaybe<Scalars['Int']['input']>;
  maxBoardPinned_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  medias?: InputMaybe<Scalars['String']['input']>;
  medias_contains?: InputMaybe<Scalars['String']['input']>;
  medias_ends_with?: InputMaybe<Scalars['String']['input']>;
  medias_gt?: InputMaybe<Scalars['String']['input']>;
  medias_gte?: InputMaybe<Scalars['String']['input']>;
  medias_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  medias_lt?: InputMaybe<Scalars['String']['input']>;
  medias_lte?: InputMaybe<Scalars['String']['input']>;
  medias_not?: InputMaybe<Scalars['String']['input']>;
  medias_not_contains?: InputMaybe<Scalars['String']['input']>;
  medias_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  medias_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medias_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  medias_starts_with?: InputMaybe<Scalars['String']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  metas_contains?: InputMaybe<Scalars['String']['input']>;
  metas_ends_with?: InputMaybe<Scalars['String']['input']>;
  metas_gt?: InputMaybe<Scalars['String']['input']>;
  metas_gte?: InputMaybe<Scalars['String']['input']>;
  metas_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metas_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  metas_lt?: InputMaybe<Scalars['String']['input']>;
  metas_lte?: InputMaybe<Scalars['String']['input']>;
  metas_not?: InputMaybe<Scalars['String']['input']>;
  metas_not_contains?: InputMaybe<Scalars['String']['input']>;
  metas_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  metas_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metas_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  metas_starts_with?: InputMaybe<Scalars['String']['input']>;
  minBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  minBoardPinned_gt?: InputMaybe<Scalars['Int']['input']>;
  minBoardPinned_gte?: InputMaybe<Scalars['Int']['input']>;
  minBoardPinned_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minBoardPinned_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  minBoardPinned_lt?: InputMaybe<Scalars['Int']['input']>;
  minBoardPinned_lte?: InputMaybe<Scalars['Int']['input']>;
  minBoardPinned_not?: InputMaybe<Scalars['Int']['input']>;
  minBoardPinned_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  parent?: InputMaybe<CategoryWhereInput>;
  parent_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  right?: InputMaybe<Scalars['Int']['input']>;
  right_gt?: InputMaybe<Scalars['Int']['input']>;
  right_gte?: InputMaybe<Scalars['Int']['input']>;
  right_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  right_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  right_lt?: InputMaybe<Scalars['Int']['input']>;
  right_lte?: InputMaybe<Scalars['Int']['input']>;
  right_not?: InputMaybe<Scalars['Int']['input']>;
  right_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CategoryStatus>;
  status_in?: InputMaybe<Array<CategoryStatus>>;
  status_not?: InputMaybe<CategoryStatus>;
  status_not_in?: InputMaybe<Array<CategoryStatus>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  subtitle_gt?: InputMaybe<Scalars['String']['input']>;
  subtitle_gte?: InputMaybe<Scalars['String']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_lt?: InputMaybe<Scalars['String']['input']>;
  subtitle_lte?: InputMaybe<Scalars['String']['input']>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabs_some?: InputMaybe<TabWhereInput>;
  tags?: InputMaybe<Scalars['String']['input']>;
  tags_contains?: InputMaybe<Scalars['String']['input']>;
  tags_ends_with?: InputMaybe<Scalars['String']['input']>;
  tags_gt?: InputMaybe<Scalars['String']['input']>;
  tags_gte?: InputMaybe<Scalars['String']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  tags_lt?: InputMaybe<Scalars['String']['input']>;
  tags_lte?: InputMaybe<Scalars['String']['input']>;
  tags_not?: InputMaybe<Scalars['String']['input']>;
  tags_not_contains?: InputMaybe<Scalars['String']['input']>;
  tags_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tags_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tags_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  urls?: InputMaybe<Scalars['String']['input']>;
  urls_contains?: InputMaybe<Scalars['String']['input']>;
  urls_ends_with?: InputMaybe<Scalars['String']['input']>;
  urls_gt?: InputMaybe<Scalars['String']['input']>;
  urls_gte?: InputMaybe<Scalars['String']['input']>;
  urls_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urls_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  urls_lt?: InputMaybe<Scalars['String']['input']>;
  urls_lte?: InputMaybe<Scalars['String']['input']>;
  urls_not?: InputMaybe<Scalars['String']['input']>;
  urls_not_contains?: InputMaybe<Scalars['String']['input']>;
  urls_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  urls_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urls_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  urls_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - parent, slug
 * - brandKey, format, title
 */
export type CategoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  format?: InputMaybe<CategoryFormat>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parent?: InputMaybe<CategoryWhereUniqueInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryWithForcedParentCreateInput = {
  /** Actions for the "Category.articleCategories" relation: "ArticleCategory.category"'s inverse relation */
  articleCategories?: InputMaybe<CategoryNestedArticleCategoriesCreateInput>;
  /** Actions for the "Category.articleChannels" relation: "ArticleChannel.category"'s inverse relation */
  articleChannels?: InputMaybe<CategoryNestedArticleChannelsCreateInput>;
  /** Actions for the "Category.articleEvents" relation: "ArticleEvent.category"'s inverse relation */
  articleEvents?: InputMaybe<CategoryNestedArticleEventsCreateInput>;
  /** Actions for the "Category.articleGuides" relation: "ArticleGuide.category"'s inverse relation */
  articleGuides?: InputMaybe<CategoryNestedArticleGuidesCreateInput>;
  bodyDraft?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  /** Actions for the "Category.cardCategories" relation: "CardCategory.category"'s inverse relation */
  cardCategories?: InputMaybe<CategoryNestedCardCategoriesCreateInput>;
  /** Actions for the "Category.categoryHistories" relation: "CategoryHistory.category"'s inverse relation */
  categoryHistories?: InputMaybe<CategoryNestedCategoryHistoriesCreateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenCreateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format: CategoryFormat;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  isHeadlined?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  maxBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  minBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  right?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status: CategoryStatus;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.tabs" relation: "Tab.category"'s inverse relation */
  tabs?: InputMaybe<CategoryNestedTabsCreateInput>;
  tags?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  urls?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryWithForcedParentUpdateInput = {
  /** Actions for the "Category.articleCategories" relation: "ArticleCategory.category"'s inverse relation */
  articleCategories?: InputMaybe<CategoryNestedArticleCategoriesUpdateInput>;
  /** Actions for the "Category.articleChannels" relation: "ArticleChannel.category"'s inverse relation */
  articleChannels?: InputMaybe<CategoryNestedArticleChannelsUpdateInput>;
  /** Actions for the "Category.articleEvents" relation: "ArticleEvent.category"'s inverse relation */
  articleEvents?: InputMaybe<CategoryNestedArticleEventsUpdateInput>;
  /** Actions for the "Category.articleGuides" relation: "ArticleGuide.category"'s inverse relation */
  articleGuides?: InputMaybe<CategoryNestedArticleGuidesUpdateInput>;
  bodyDraft?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  /** Actions for the "Category.cardCategories" relation: "CardCategory.category"'s inverse relation */
  cardCategories?: InputMaybe<CategoryNestedCardCategoriesUpdateInput>;
  /** Actions for the "Category.categoryHistories" relation: "CategoryHistory.category"'s inverse relation */
  categoryHistories?: InputMaybe<CategoryNestedCategoryHistoriesUpdateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<CategoryFormat>;
  isHeadlined?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  maxBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  minBoardPinned?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  right?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CategoryStatus>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.tabs" relation: "Tab.category"'s inverse relation */
  tabs?: InputMaybe<CategoryNestedTabsUpdateInput>;
  tags?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urls?: InputMaybe<Scalars['String']['input']>;
};

/** Given a forced "parent", identifies exactly one "Category" node. */
export type CategoryWithForcedParentWhereUniqueInput = {
  slug: Scalars['String']['input'];
};

/**
 * Given a known "parent", identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - parent (optional), slug
 * - brandKey, format, title
 */
export type CategoryWithOptionalParentWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  format?: InputMaybe<CategoryFormat>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parent?: InputMaybe<CategoryWhereUniqueInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CeriseAffiliationEmbedResult = {
  __typename?: 'CeriseAffiliationEmbedResult';
  iframely: AffiliationIframely;
};

export enum CeriseAffiliationTemplate {
  AmazonOnly = 'AmazonOnly',
  MultiMerchant = 'MultiMerchant'
}

export enum CeriseAffiliationType {
  AAC = 'AAC',
  AFF = 'AFF'
}

export type CreateCampaignResult = {
  __typename?: 'CreateCampaignResult';
  campaign_token: Scalars['String']['output'];
};

export enum CurrentPlatform {
  Brightcove = 'Brightcove',
  Igor = 'Igor'
}

/** dailymotion logs */
export type DailymotionLog = {
  __typename?: 'DailymotionLog';
  /** autoincrement id */
  _id: Scalars['Int']['output'];
  brandKey: BrandKey;
  context?: Maybe<Scalars['String']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  privateId?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
};

export type DailymotionLogCreateInput = {
  brandKey: BrandKey;
  context?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  privateId?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export enum DailymotionLogOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  context_ASC = 'context_ASC',
  context_DESC = 'context_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  error_ASC = 'error_ASC',
  error_DESC = 'error_DESC',
  log_ASC = 'log_ASC',
  log_DESC = 'log_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  privateId_ASC = 'privateId_ASC',
  privateId_DESC = 'privateId_DESC',
  response_ASC = 'response_ASC',
  response_DESC = 'response_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  videoId_ASC = 'videoId_ASC',
  videoId_DESC = 'videoId_DESC'
}

export type DailymotionLogUpdateInput = {
  brandKey?: InputMaybe<BrandKey>;
  context?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  privateId?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "DailymotionLog" nodes by specifying some conditions */
export type DailymotionLogWhereInput = {
  AND?: InputMaybe<Array<DailymotionLogWhereInput>>;
  NOT?: InputMaybe<DailymotionLogWhereInput>;
  OR?: InputMaybe<Array<DailymotionLogWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  context?: InputMaybe<Scalars['String']['input']>;
  context_contains?: InputMaybe<Scalars['String']['input']>;
  context_ends_with?: InputMaybe<Scalars['String']['input']>;
  context_gt?: InputMaybe<Scalars['String']['input']>;
  context_gte?: InputMaybe<Scalars['String']['input']>;
  context_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  context_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  context_lt?: InputMaybe<Scalars['String']['input']>;
  context_lte?: InputMaybe<Scalars['String']['input']>;
  context_not?: InputMaybe<Scalars['String']['input']>;
  context_not_contains?: InputMaybe<Scalars['String']['input']>;
  context_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  context_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  context_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  context_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  error?: InputMaybe<Scalars['String']['input']>;
  error_contains?: InputMaybe<Scalars['String']['input']>;
  error_ends_with?: InputMaybe<Scalars['String']['input']>;
  error_gt?: InputMaybe<Scalars['String']['input']>;
  error_gte?: InputMaybe<Scalars['String']['input']>;
  error_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  error_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  error_lt?: InputMaybe<Scalars['String']['input']>;
  error_lte?: InputMaybe<Scalars['String']['input']>;
  error_not?: InputMaybe<Scalars['String']['input']>;
  error_not_contains?: InputMaybe<Scalars['String']['input']>;
  error_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  error_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  error_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  error_starts_with?: InputMaybe<Scalars['String']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  log_contains?: InputMaybe<Scalars['String']['input']>;
  log_ends_with?: InputMaybe<Scalars['String']['input']>;
  log_gt?: InputMaybe<Scalars['String']['input']>;
  log_gte?: InputMaybe<Scalars['String']['input']>;
  log_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  log_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  log_lt?: InputMaybe<Scalars['String']['input']>;
  log_lte?: InputMaybe<Scalars['String']['input']>;
  log_not?: InputMaybe<Scalars['String']['input']>;
  log_not_contains?: InputMaybe<Scalars['String']['input']>;
  log_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  log_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  log_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  log_starts_with?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_contains?: InputMaybe<Scalars['String']['input']>;
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  message_gt?: InputMaybe<Scalars['String']['input']>;
  message_gte?: InputMaybe<Scalars['String']['input']>;
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  message_lt?: InputMaybe<Scalars['String']['input']>;
  message_lte?: InputMaybe<Scalars['String']['input']>;
  message_not?: InputMaybe<Scalars['String']['input']>;
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  privateId?: InputMaybe<Scalars['String']['input']>;
  privateId_contains?: InputMaybe<Scalars['String']['input']>;
  privateId_ends_with?: InputMaybe<Scalars['String']['input']>;
  privateId_gt?: InputMaybe<Scalars['String']['input']>;
  privateId_gte?: InputMaybe<Scalars['String']['input']>;
  privateId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privateId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  privateId_lt?: InputMaybe<Scalars['String']['input']>;
  privateId_lte?: InputMaybe<Scalars['String']['input']>;
  privateId_not?: InputMaybe<Scalars['String']['input']>;
  privateId_not_contains?: InputMaybe<Scalars['String']['input']>;
  privateId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  privateId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privateId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  privateId_starts_with?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  response_contains?: InputMaybe<Scalars['String']['input']>;
  response_ends_with?: InputMaybe<Scalars['String']['input']>;
  response_gt?: InputMaybe<Scalars['String']['input']>;
  response_gte?: InputMaybe<Scalars['String']['input']>;
  response_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  response_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  response_lt?: InputMaybe<Scalars['String']['input']>;
  response_lte?: InputMaybe<Scalars['String']['input']>;
  response_not?: InputMaybe<Scalars['String']['input']>;
  response_not_contains?: InputMaybe<Scalars['String']['input']>;
  response_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  response_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  response_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  response_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  status_gt?: InputMaybe<Scalars['Int']['input']>;
  status_gte?: InputMaybe<Scalars['Int']['input']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status_lt?: InputMaybe<Scalars['Int']['input']>;
  status_lte?: InputMaybe<Scalars['Int']['input']>;
  status_not?: InputMaybe<Scalars['Int']['input']>;
  status_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  videoId_gt?: InputMaybe<Scalars['String']['input']>;
  videoId_gte?: InputMaybe<Scalars['String']['input']>;
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  videoId_lt?: InputMaybe<Scalars['String']['input']>;
  videoId_lte?: InputMaybe<Scalars['String']['input']>;
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "DailymotionLog" node. */
export type DailymotionLogWhereUniqueInput = {
  _id: Scalars['Int']['input'];
};

/** dailymotion migration table */
export type DailymotionMigration = {
  __typename?: 'DailymotionMigration';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  brandKey: BrandKey;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  currentPlatform: CurrentPlatform;
  dailymotionId: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** reference rich articles */
  referenceArticles: Array<Article>;
  retry: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  status: GraphQlMigrationItemStatus;
  step: Scalars['Int']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** associated video articles */
  videoArticle?: Maybe<Article>;
};


/** dailymotion migration table */
export type DailymotionMigrationReferenceArticlesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type DailymotionMigrationCreateInput = {
  brandKey: BrandKey;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentPlatform: CurrentPlatform;
  dailymotionId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  retry: Scalars['Int']['input'];
  source: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  status: GraphQlMigrationItemStatus;
  step: Scalars['Int']['input'];
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum DailymotionMigrationOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  creatorId_ASC = 'creatorId_ASC',
  creatorId_DESC = 'creatorId_DESC',
  currentPlatform_ASC = 'currentPlatform_ASC',
  currentPlatform_DESC = 'currentPlatform_DESC',
  dailymotionId_ASC = 'dailymotionId_ASC',
  dailymotionId_DESC = 'dailymotionId_DESC',
  externalId_ASC = 'externalId_ASC',
  externalId_DESC = 'externalId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  retry_ASC = 'retry_ASC',
  retry_DESC = 'retry_DESC',
  sourceId_ASC = 'sourceId_ASC',
  sourceId_DESC = 'sourceId_DESC',
  source_ASC = 'source_ASC',
  source_DESC = 'source_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  step_ASC = 'step_ASC',
  step_DESC = 'step_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type DailymotionMigrationUpdateInput = {
  brandKey?: InputMaybe<BrandKey>;
  currentPlatform?: InputMaybe<CurrentPlatform>;
  dailymotionId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GraphQlMigrationItemStatus>;
  step?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "DailymotionMigration" nodes by specifying some conditions */
export type DailymotionMigrationWhereInput = {
  AND?: InputMaybe<Array<DailymotionMigrationWhereInput>>;
  NOT?: InputMaybe<DailymotionMigrationWhereInput>;
  OR?: InputMaybe<Array<DailymotionMigrationWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  creatorId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  creatorId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  creatorId_not?: InputMaybe<Scalars['ID']['input']>;
  creatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  currentPlatform?: InputMaybe<CurrentPlatform>;
  currentPlatform_in?: InputMaybe<Array<CurrentPlatform>>;
  currentPlatform_not?: InputMaybe<CurrentPlatform>;
  currentPlatform_not_in?: InputMaybe<Array<CurrentPlatform>>;
  dailymotionId?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_contains?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_ends_with?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_gt?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_gte?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dailymotionId_lt?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_lte?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_not?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_not_contains?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dailymotionId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dailymotionId_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalId_contains?: InputMaybe<Scalars['String']['input']>;
  externalId_ends_with?: InputMaybe<Scalars['String']['input']>;
  externalId_gt?: InputMaybe<Scalars['String']['input']>;
  externalId_gte?: InputMaybe<Scalars['String']['input']>;
  externalId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  externalId_lt?: InputMaybe<Scalars['String']['input']>;
  externalId_lte?: InputMaybe<Scalars['String']['input']>;
  externalId_not?: InputMaybe<Scalars['String']['input']>;
  externalId_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  externalId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  externalId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_contains?: InputMaybe<Scalars['String']['input']>;
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  message_gt?: InputMaybe<Scalars['String']['input']>;
  message_gte?: InputMaybe<Scalars['String']['input']>;
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  message_lt?: InputMaybe<Scalars['String']['input']>;
  message_lte?: InputMaybe<Scalars['String']['input']>;
  message_not?: InputMaybe<Scalars['String']['input']>;
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  retry_gt?: InputMaybe<Scalars['Int']['input']>;
  retry_gte?: InputMaybe<Scalars['Int']['input']>;
  retry_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  retry_lt?: InputMaybe<Scalars['Int']['input']>;
  retry_lte?: InputMaybe<Scalars['Int']['input']>;
  retry_not?: InputMaybe<Scalars['Int']['input']>;
  retry_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceId_contains?: InputMaybe<Scalars['String']['input']>;
  sourceId_ends_with?: InputMaybe<Scalars['String']['input']>;
  sourceId_gt?: InputMaybe<Scalars['String']['input']>;
  sourceId_gte?: InputMaybe<Scalars['String']['input']>;
  sourceId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId_lt?: InputMaybe<Scalars['String']['input']>;
  sourceId_lte?: InputMaybe<Scalars['String']['input']>;
  sourceId_not?: InputMaybe<Scalars['String']['input']>;
  sourceId_not_contains?: InputMaybe<Scalars['String']['input']>;
  sourceId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  sourceId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  sourceId_starts_with?: InputMaybe<Scalars['String']['input']>;
  source_contains?: InputMaybe<Scalars['String']['input']>;
  source_ends_with?: InputMaybe<Scalars['String']['input']>;
  source_gt?: InputMaybe<Scalars['String']['input']>;
  source_gte?: InputMaybe<Scalars['String']['input']>;
  source_in?: InputMaybe<Array<Scalars['String']['input']>>;
  source_lt?: InputMaybe<Scalars['String']['input']>;
  source_lte?: InputMaybe<Scalars['String']['input']>;
  source_not?: InputMaybe<Scalars['String']['input']>;
  source_not_contains?: InputMaybe<Scalars['String']['input']>;
  source_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  source_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  source_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  source_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GraphQlMigrationItemStatus>;
  status_in?: InputMaybe<Array<GraphQlMigrationItemStatus>>;
  status_not?: InputMaybe<GraphQlMigrationItemStatus>;
  status_not_in?: InputMaybe<Array<GraphQlMigrationItemStatus>>;
  step?: InputMaybe<Scalars['Int']['input']>;
  step_gt?: InputMaybe<Scalars['Int']['input']>;
  step_gte?: InputMaybe<Scalars['Int']['input']>;
  step_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  step_lt?: InputMaybe<Scalars['Int']['input']>;
  step_lte?: InputMaybe<Scalars['Int']['input']>;
  step_not?: InputMaybe<Scalars['Int']['input']>;
  step_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_gt?: InputMaybe<Scalars['String']['input']>;
  url_gte?: InputMaybe<Scalars['String']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  url_lt?: InputMaybe<Scalars['String']['input']>;
  url_lte?: InputMaybe<Scalars['String']['input']>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Identifies exactly one "DailymotionMigration" node with one of these unique values:
 * - _id
 * - id
 * - dailymotionId
 */
export type DailymotionMigrationWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  dailymotionId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DailymotionUpdateResult = {
  __typename?: 'DailymotionUpdateResult';
  id: Scalars['String']['output'];
  private_id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DailymotionUploadUrlResult = {
  __typename?: 'DailymotionUploadURLResult';
  progressURL: Scalars['String']['output'];
  uploadURL: Scalars['String']['output'];
};

export type DeleteCampaignResult = {
  __typename?: 'DeleteCampaignResult';
  response: Scalars['String']['output'];
};

export enum Device {
  Desktop = 'Desktop',
  Mobile = 'Mobile'
}

export enum Env {
  PRD2 = 'PRD2',
  REC1 = 'REC1',
  REC2 = 'REC2',
  REC3 = 'REC3'
}

export type GetCampaignResult = {
  __typename?: 'GetCampaignResult';
  campaign_token?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  dev_only?: Maybe<Scalars['Boolean']['output']>;
  from_api?: Maybe<Scalars['Boolean']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<MediaPushType>;
  messages?: Maybe<Array<Maybe<MessagePushType>>>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  push_time?: Maybe<Scalars['String']['output']>;
  push_type?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  targeting?: Maybe<TargetingPushType>;
};

export type GetCampaignsResult = {
  __typename?: 'GetCampaignsResult';
  campaign_token?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  dev_only?: Maybe<Scalars['Boolean']['output']>;
  from_api?: Maybe<Scalars['Boolean']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  push_time?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
};

export type GetSegmentations = {
  __typename?: 'GetSegmentations';
  name?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
};

export type GoodDealProcessReturnType = {
  __typename?: 'GoodDealProcessReturnType';
  /** Internal Good Deal Article Generation Process ID */
  processId: Scalars['String']['output'];
};

export enum GoodDealProcessStatus {
  error = 'error',
  running = 'running',
  success = 'success'
}

export enum GraphQlMigrationItemStatus {
  Failed = 'Failed',
  Finished = 'Finished',
  Pending = 'Pending',
  Running = 'Running'
}

export type HtmlArticleMedia = {
  credit?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<HtmlArticleMediaFormat>;
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<HtmlArticleMediaType>;
  url: Scalars['String']['input'];
};

export enum HtmlArticleMediaFormat {
  Article = 'Article',
  Facebook = 'Facebook',
  Pinterest = 'Pinterest'
}

export enum HtmlArticleMediaType {
  Generic = 'Generic',
  Image = 'Image'
}

export type HtmlArticleTag = {
  /** Lang of the tag, default : FR */
  lang?: InputMaybe<TagLang>;
  title: Scalars['String']['input'];
  /** Type of the tag, default : Tag */
  type?: InputMaybe<TagType>;
};

/** An image source */
export type ImageSource = {
  __typename?: 'ImageSource';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  imageSourceCategory: ImageSourceCategory;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

/** An image source category */
export type ImageSourceCategory = {
  __typename?: 'ImageSourceCategory';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** "ImageSource.imageSourceCategory"'s inverse relation count */
  imageSourceCount: Scalars['Int']['output'];
  /** "ImageSource.imageSourceCategory"'s inverse relation */
  imageSources: Array<ImageSource>;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** An image source category */
export type ImageSourceCategoryImageSourceCountArgs = {
  where?: InputMaybe<ImageSourceWhereInput>;
};


/** An image source category */
export type ImageSourceCategoryImageSourcesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ImageSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageSourceWhereInput>;
};

export type ImageSourceCategoryCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "ImageSourceCategory.imageSources" relation: "ImageSource.imageSourceCategory"'s inverse relation */
  imageSources?: InputMaybe<ImageSourceCategoryNestedImageSourcesCreateInput>;
  title: Scalars['String']['input'];
};

export type ImageSourceCategoryNestedImageSourcesCreateInput = {
  /** Connect existing "ImageSource" nodes to the new "ImageSourceCategory" node, through the "ImageSourceCategory.imageSources" relation. */
  connect?: InputMaybe<Array<ImageSourceWhereUniqueInput>>;
  /** Create new "ImageSource" nodes and connect them to the new "ImageSourceCategory" node, through the "ImageSourceCategory.imageSources" relation. */
  create?: InputMaybe<Array<ImageSourceWithForcedImageSourceCategoryCreateInput>>;
};

export type ImageSourceCategoryNestedImageSourcesUpdateInput = {
  /** Connect existing "ImageSource" nodes to the existing "ImageSourceCategory" node, through the "ImageSourceCategory.imageSources" relation. */
  connect?: InputMaybe<Array<ImageSourceWhereUniqueInput>>;
  /** Create new "ImageSource" nodes and connect them to the existing "ImageSourceCategory" node, through the "ImageSourceCategory.imageSources" relation. */
  create?: InputMaybe<Array<ImageSourceWithForcedImageSourceCategoryCreateInput>>;
  /** Delete existing "ImageSource" nodes from the "ImageSourceCategory.imageSources" relation. */
  delete?: InputMaybe<Array<ImageSourceWhereUniqueInput>>;
  /** Update existing "ImageSource" nodes and connect them to the existing "ImageSourceCategory" node, through the "ImageSourceCategory.imageSources" relation. */
  update?: InputMaybe<Array<ImageSourceCategoryNestedUpdateImageSourcesUpdateInput>>;
  /** Upsert existing "ImageSource" nodes and connect them to the existing "ImageSourceCategory" node, through the "ImageSourceCategory.imageSources" relation. */
  upsert?: InputMaybe<Array<ImageSourceCategoryNestedUpsertImageSourcesUpdateInput>>;
};

export type ImageSourceCategoryNestedUpdateImageSourcesUpdateInput = {
  data: Scalars['Boolean']['input'];
  where: ImageSourceWhereUniqueInput;
};

export type ImageSourceCategoryNestedUpsertImageSourcesUpdateInput = {
  create: ImageSourceWithForcedImageSourceCategoryCreateInput;
  update: Scalars['Boolean']['input'];
  where: ImageSourceWhereUniqueInput;
};

export enum ImageSourceCategoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ImageSourceCategoryUpdateInput = {
  /** Actions for the "ImageSourceCategory.imageSources" relation: "ImageSource.imageSourceCategory"'s inverse relation */
  imageSources?: InputMaybe<ImageSourceCategoryNestedImageSourcesUpdateInput>;
};

/** Filters the "ImageSourceCategory" nodes by specifying some conditions */
export type ImageSourceCategoryWhereInput = {
  AND?: InputMaybe<Array<ImageSourceCategoryWhereInput>>;
  NOT?: InputMaybe<ImageSourceCategoryWhereInput>;
  OR?: InputMaybe<Array<ImageSourceCategoryWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  imageSources_some?: InputMaybe<ImageSourceWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "ImageSourceCategory" node with one of these unique values:
 * - _id
 * - id
 * - title
 */
export type ImageSourceCategoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageSourceCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "ImageSource.imageSourceCategory" relation */
  imageSourceCategory: ImageSourceNestedImageSourceCategoryCreateInput;
  title: Scalars['String']['input'];
};

export type ImageSourceNestedImageSourceCategoryCreateInput = {
  /** Connect an existing "ImageSourceCategory" node to the new "ImageSource" node, through the "ImageSource.imageSourceCategory" relation. */
  connect?: InputMaybe<ImageSourceCategoryWhereUniqueInput>;
  /** Create a new "ImageSourceCategory" node and connect it to the new "ImageSource" node, through the "ImageSource.imageSourceCategory" relation. */
  create?: InputMaybe<ImageSourceCategoryCreateInput>;
  /** Update an existing "ImageSourceCategory" node and connect it to the new "ImageSource" node, through the "ImageSource.imageSourceCategory" relation. */
  update?: InputMaybe<ImageSourceNestedUpdateImageSourceCategoryCreateInput>;
  /** Create or update a "ImageSourceCategory" node and connect it to the new "ImageSource" node, through the "ImageSource.imageSourceCategory" relation. */
  upsert?: InputMaybe<ImageSourceNestedUpsertImageSourceCategoryCreateInput>;
};

export type ImageSourceNestedImageSourceCategoryUpdateInput = {
  /** Connect an existing "ImageSourceCategory" node to the existing "ImageSource" node, through the "ImageSource.imageSourceCategory" relation. */
  connect?: InputMaybe<ImageSourceCategoryWhereUniqueInput>;
  /** Create a new "ImageSourceCategory" node and connect it to the existing "ImageSource" node, through the "ImageSource.imageSourceCategory" relation. */
  create?: InputMaybe<ImageSourceCategoryCreateInput>;
  /** Update an existing "ImageSourceCategory" node and connect it to the existing "ImageSource" node, through the "ImageSource.imageSourceCategory" relation. */
  update?: InputMaybe<ImageSourceNestedUpdateImageSourceCategoryUpdateInput>;
  /** Create or update a "ImageSourceCategory" node and connect it to the existing "ImageSource" node, through the "ImageSource.imageSourceCategory" relation. */
  upsert?: InputMaybe<ImageSourceNestedUpsertImageSourceCategoryUpdateInput>;
};

export type ImageSourceNestedUpdateImageSourceCategoryCreateInput = {
  data: ImageSourceCategoryUpdateInput;
  where: ImageSourceCategoryWhereUniqueInput;
};

export type ImageSourceNestedUpdateImageSourceCategoryUpdateInput = {
  data: ImageSourceCategoryUpdateInput;
  where: ImageSourceCategoryWhereUniqueInput;
};

export type ImageSourceNestedUpsertImageSourceCategoryCreateInput = {
  create: ImageSourceCategoryCreateInput;
  update: ImageSourceCategoryUpdateInput;
  where: ImageSourceCategoryWhereUniqueInput;
};

export type ImageSourceNestedUpsertImageSourceCategoryUpdateInput = {
  create: ImageSourceCategoryCreateInput;
  update: ImageSourceCategoryUpdateInput;
  where: ImageSourceCategoryWhereUniqueInput;
};

export enum ImageSourceOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ImageSourceUpdateInput = {
  /** Actions for the "ImageSource.imageSourceCategory" relation */
  imageSourceCategory?: InputMaybe<ImageSourceNestedImageSourceCategoryUpdateInput>;
};

/** Filters the "ImageSource" nodes by specifying some conditions */
export type ImageSourceWhereInput = {
  AND?: InputMaybe<Array<ImageSourceWhereInput>>;
  NOT?: InputMaybe<ImageSourceWhereInput>;
  OR?: InputMaybe<Array<ImageSourceWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  imageSourceCategory?: InputMaybe<ImageSourceCategoryWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "ImageSource" node with one of these unique values:
 * - _id
 * - id
 * - title
 */
export type ImageSourceWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageSourceWithForcedImageSourceCategoryCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

/** A live */
export type Live = {
  __typename?: 'Live';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  article: Article;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** "LivePost.live"'s inverse relation count */
  postCount: Scalars['Int']['output'];
  /** "LivePost.live"'s inverse relation */
  posts: Array<LivePost>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** A live */
export type LivePostCountArgs = {
  where?: InputMaybe<LivePostWhereInput>;
};


/** A live */
export type LivePostsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<LivePostOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LivePostWhereInput>;
};

export type LiveCreateInput = {
  /** Actions for the "Live.article" relation */
  article: LiveNestedArticleCreateInput;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "Live.posts" relation: "LivePost.live"'s inverse relation */
  posts?: InputMaybe<LiveNestedPostsCreateInput>;
};

export type LiveLiveSearchWhereInput = {
  AND?: InputMaybe<Array<LiveLiveSearchWhereInput>>;
  NOT?: InputMaybe<LiveLiveSearchWhereInput>;
  OR?: InputMaybe<Array<LiveLiveSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  posts_some?: InputMaybe<LivePostLivePostsSearchWhereInput>;
};

export type LiveNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "Live" node, through the "Live.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "Live" node, through the "Live.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "Live" node, through the "Live.article" relation. */
  update?: InputMaybe<LiveNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "Live" node, through the "Live.article" relation. */
  upsert?: InputMaybe<LiveNestedUpsertArticleCreateInput>;
};

export type LiveNestedArticleUpdateInput = {
  /** Connect an existing "Article" node to the existing "Live" node, through the "Live.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the existing "Live" node, through the "Live.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the existing "Live" node, through the "Live.article" relation. */
  update?: InputMaybe<LiveNestedUpdateArticleUpdateInput>;
  /** Create or update a "Article" node and connect it to the existing "Live" node, through the "Live.article" relation. */
  upsert?: InputMaybe<LiveNestedUpsertArticleUpdateInput>;
};

export type LiveNestedPostsCreateInput = {
  /** Connect existing "LivePost" nodes to the new "Live" node, through the "Live.posts" relation. */
  connect?: InputMaybe<Array<LivePostWhereUniqueInput>>;
  /** Create new "LivePost" nodes and connect them to the new "Live" node, through the "Live.posts" relation. */
  create?: InputMaybe<Array<LivePostWithForcedLiveCreateInput>>;
};

export type LiveNestedPostsUpdateInput = {
  /** Connect existing "LivePost" nodes to the existing "Live" node, through the "Live.posts" relation. */
  connect?: InputMaybe<Array<LivePostWhereUniqueInput>>;
  /** Create new "LivePost" nodes and connect them to the existing "Live" node, through the "Live.posts" relation. */
  create?: InputMaybe<Array<LivePostWithForcedLiveCreateInput>>;
  /** Delete existing "LivePost" nodes from the "Live.posts" relation. */
  delete?: InputMaybe<Array<LivePostWhereUniqueInput>>;
  /** Update existing "LivePost" nodes and connect them to the existing "Live" node, through the "Live.posts" relation. */
  update?: InputMaybe<Array<LiveNestedUpdatePostsUpdateInput>>;
  /** Upsert existing "LivePost" nodes and connect them to the existing "Live" node, through the "Live.posts" relation. */
  upsert?: InputMaybe<Array<LiveNestedUpsertPostsUpdateInput>>;
};

export type LiveNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type LiveNestedUpdateArticleUpdateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type LiveNestedUpdatePostsUpdateInput = {
  data: LivePostWithForcedLiveUpdateInput;
  where: LivePostWhereUniqueInput;
};

export type LiveNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type LiveNestedUpsertArticleUpdateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type LiveNestedUpsertPostsUpdateInput = {
  create: LivePostWithForcedLiveCreateInput;
  update: LivePostWithForcedLiveUpdateInput;
  where: LivePostWhereUniqueInput;
};

export enum LiveOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  endedAt_ASC = 'endedAt_ASC',
  endedAt_DESC = 'endedAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A live-post */
export type LivePost = {
  __typename?: 'LivePost';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  body?: Maybe<Scalars['String']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['ID']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  live: Live;
  publishedAt: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type LivePostCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "LivePost.live" relation */
  live: LivePostNestedLiveCreateInput;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LivePostLivePostsSearchWhereInput = {
  AND?: InputMaybe<Array<LivePostLivePostsSearchWhereInput>>;
  NOT?: InputMaybe<LivePostLivePostsSearchWhereInput>;
  OR?: InputMaybe<Array<LivePostLivePostsSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type LivePostNestedLiveCreateInput = {
  /** Connect an existing "Live" node to the new "LivePost" node, through the "LivePost.live" relation. */
  connect?: InputMaybe<LiveWhereUniqueInput>;
  /** Create a new "Live" node and connect it to the new "LivePost" node, through the "LivePost.live" relation. */
  create?: InputMaybe<LiveCreateInput>;
  /** Update an existing "Live" node and connect it to the new "LivePost" node, through the "LivePost.live" relation. */
  update?: InputMaybe<LivePostNestedUpdateLiveCreateInput>;
  /** Create or update a "Live" node and connect it to the new "LivePost" node, through the "LivePost.live" relation. */
  upsert?: InputMaybe<LivePostNestedUpsertLiveCreateInput>;
};

export type LivePostNestedLiveUpdateInput = {
  /** Connect an existing "Live" node to the existing "LivePost" node, through the "LivePost.live" relation. */
  connect?: InputMaybe<LiveWhereUniqueInput>;
  /** Create a new "Live" node and connect it to the existing "LivePost" node, through the "LivePost.live" relation. */
  create?: InputMaybe<LiveCreateInput>;
  /** Update an existing "Live" node and connect it to the existing "LivePost" node, through the "LivePost.live" relation. */
  update?: InputMaybe<LivePostNestedUpdateLiveUpdateInput>;
  /** Create or update a "Live" node and connect it to the existing "LivePost" node, through the "LivePost.live" relation. */
  upsert?: InputMaybe<LivePostNestedUpsertLiveUpdateInput>;
};

export type LivePostNestedUpdateLiveCreateInput = {
  data: LiveUpdateInput;
  where: LiveWhereUniqueInput;
};

export type LivePostNestedUpdateLiveUpdateInput = {
  data: LiveUpdateInput;
  where: LiveWhereUniqueInput;
};

export type LivePostNestedUpsertLiveCreateInput = {
  create: LiveCreateInput;
  update: LiveUpdateInput;
  where: LiveWhereUniqueInput;
};

export type LivePostNestedUpsertLiveUpdateInput = {
  create: LiveCreateInput;
  update: LiveUpdateInput;
  where: LiveWhereUniqueInput;
};

export enum LivePostOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  creatorId_ASC = 'creatorId_ASC',
  creatorId_DESC = 'creatorId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type LivePostUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "LivePost.live" relation */
  live?: InputMaybe<LivePostNestedLiveUpdateInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "LivePost" nodes by specifying some conditions */
export type LivePostWhereInput = {
  AND?: InputMaybe<Array<LivePostWhereInput>>;
  NOT?: InputMaybe<LivePostWhereInput>;
  OR?: InputMaybe<Array<LivePostWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_gt?: InputMaybe<Scalars['String']['input']>;
  body_gte?: InputMaybe<Scalars['String']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_lt?: InputMaybe<Scalars['String']['input']>;
  body_lte?: InputMaybe<Scalars['String']['input']>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  creatorId_not?: InputMaybe<Scalars['ID']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  live?: InputMaybe<LiveWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "LivePost" node with one of these unique values:
 * - _id
 * - id
 */
export type LivePostWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type LivePostWithForcedLiveCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LivePostWithForcedLiveUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LiveUpdateInput = {
  /** Actions for the "Live.article" relation */
  article?: InputMaybe<LiveNestedArticleUpdateInput>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Live.posts" relation: "LivePost.live"'s inverse relation */
  posts?: InputMaybe<LiveNestedPostsUpdateInput>;
};

/** Filters the "Live" nodes by specifying some conditions */
export type LiveWhereInput = {
  AND?: InputMaybe<Array<LiveWhereInput>>;
  NOT?: InputMaybe<LiveWhereInput>;
  OR?: InputMaybe<Array<LiveWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  article?: InputMaybe<ArticleWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  endedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  posts_some?: InputMaybe<LivePostWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Live" node with one of these unique values:
 * - _id
 * - id
 * - article
 */
export type LiveWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  article?: InputMaybe<ArticleWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type LiveWithForcedArticleCreateInput = {
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "Live.posts" relation: "LivePost.live"'s inverse relation */
  posts?: InputMaybe<LiveNestedPostsCreateInput>;
};

export type LiveWithForcedArticleUpdateInput = {
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Live.posts" relation: "LivePost.live"'s inverse relation */
  posts?: InputMaybe<LiveNestedPostsUpdateInput>;
};

/**
 * Given a known "article", identifies exactly one "Live" node with one of these unique values:
 * - _id
 * - id
 * - article (optional)
 */
export type LiveWithOptionalArticleWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  article?: InputMaybe<ArticleWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A machine tag */
export type MachineTag = {
  __typename?: 'MachineTag';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "ArticleMachineTag.machineTag"'s inverse relation count */
  articleMachineTagCount: Scalars['Int']['output'];
  /** "ArticleMachineTag.machineTag"'s inverse relation */
  articleMachineTags: Array<ArticleMachineTag>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  tag: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** A machine tag */
export type MachineTagArticleMachineTagCountArgs = {
  where?: InputMaybe<ArticleMachineTagWhereInput>;
};


/** A machine tag */
export type MachineTagArticleMachineTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleMachineTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleMachineTagWhereInput>;
};

export type MachineTagArticleMachineTagsMachineTagSearchWhereInput = {
  AND?: InputMaybe<Array<MachineTagArticleMachineTagsMachineTagSearchWhereInput>>;
  NOT?: InputMaybe<MachineTagArticleMachineTagsMachineTagSearchWhereInput>;
  OR?: InputMaybe<Array<MachineTagArticleMachineTagsMachineTagSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  tag_contains?: InputMaybe<Scalars['String']['input']>;
  tag_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type MachineTagCreateInput = {
  /** Actions for the "MachineTag.articleMachineTags" relation: "ArticleMachineTag.machineTag"'s inverse relation */
  articleMachineTags?: InputMaybe<MachineTagNestedArticleMachineTagsCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
};

export type MachineTagNestedArticleMachineTagsCreateInput = {
  /** Create new "ArticleMachineTag" nodes and connect them to the new "MachineTag" node, through the "MachineTag.articleMachineTags" relation. */
  create?: InputMaybe<Array<ArticleMachineTagWithForcedMachineTagCreateInput>>;
};

export type MachineTagNestedArticleMachineTagsUpdateInput = {
  /** Create new "ArticleMachineTag" nodes and connect them to the existing "MachineTag" node, through the "MachineTag.articleMachineTags" relation. */
  create?: InputMaybe<Array<ArticleMachineTagWithForcedMachineTagCreateInput>>;
  /** Delete existing "ArticleMachineTag" nodes from the "MachineTag.articleMachineTags" relation. */
  delete?: InputMaybe<Array<ArticleMachineTagWithForcedMachineTagWhereUniqueInput>>;
  /** Update existing "ArticleMachineTag" nodes and connect them to the existing "MachineTag" node, through the "MachineTag.articleMachineTags" relation. */
  update?: InputMaybe<Array<MachineTagNestedUpdateArticleMachineTagsUpdateInput>>;
  /** Upsert existing "ArticleMachineTag" nodes and connect them to the existing "MachineTag" node, through the "MachineTag.articleMachineTags" relation. */
  upsert?: InputMaybe<Array<MachineTagNestedUpsertArticleMachineTagsUpdateInput>>;
};

export type MachineTagNestedUpdateArticleMachineTagsUpdateInput = {
  data: ArticleMachineTagWithForcedMachineTagUpdateInput;
  where: ArticleMachineTagWithForcedMachineTagWhereUniqueInput;
};

export type MachineTagNestedUpsertArticleMachineTagsUpdateInput = {
  create: ArticleMachineTagWithForcedMachineTagCreateInput;
  update: ArticleMachineTagWithForcedMachineTagUpdateInput;
  where: ArticleMachineTagWithForcedMachineTagWhereUniqueInput;
};

export enum MachineTagOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  tag_ASC = 'tag_ASC',
  tag_DESC = 'tag_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MachineTagUpdateInput = {
  /** Actions for the "MachineTag.articleMachineTags" relation: "ArticleMachineTag.machineTag"'s inverse relation */
  articleMachineTags?: InputMaybe<MachineTagNestedArticleMachineTagsUpdateInput>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MachineTag" nodes by specifying some conditions */
export type MachineTagWhereInput = {
  AND?: InputMaybe<Array<MachineTagWhereInput>>;
  NOT?: InputMaybe<MachineTagWhereInput>;
  OR?: InputMaybe<Array<MachineTagWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleMachineTags_some?: InputMaybe<ArticleMachineTagWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tag_contains?: InputMaybe<Scalars['String']['input']>;
  tag_ends_with?: InputMaybe<Scalars['String']['input']>;
  tag_gt?: InputMaybe<Scalars['String']['input']>;
  tag_gte?: InputMaybe<Scalars['String']['input']>;
  tag_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tag_lt?: InputMaybe<Scalars['String']['input']>;
  tag_lte?: InputMaybe<Scalars['String']['input']>;
  tag_not?: InputMaybe<Scalars['String']['input']>;
  tag_not_contains?: InputMaybe<Scalars['String']['input']>;
  tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tag_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tag_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "MachineTag" node with one of these unique values:
 * - _id
 * - id
 * - tag
 */
export type MachineTagWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type MediaPushType = {
  __typename?: 'MediaPushType';
  picture?: Maybe<Scalars['String']['output']>;
};

export type MessagePushType = {
  __typename?: 'MessagePushType';
  body?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaPushType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Generate Slideshow with Vertex AI and ChatGpt */
  completeSlideshowIA: OpenAiProcessReturnType;
  /** Compute article count by brandKey for an author */
  computeAuthorBrandKeys?: Maybe<Author>;
  /** Affilizz search query */
  createAffiliationCard: AffilizzCard;
  /** Affilizz search query */
  createAffiliationCatalogProduct: AffilizzCataglogProductCreation;
  /** Create a single "Article" node. */
  createArticle: Article;
  /** Create a single "ArticleAuthor" node. */
  createArticleAuthor: ArticleAuthor;
  /** Create a single "ArticleCategory" node. */
  createArticleCategory: ArticleCategory;
  /** Create a single "ArticleChannel" node. */
  createArticleChannel: ArticleChannel;
  /** Create a single "ArticleCreatorData" node. */
  createArticleCreatorData: ArticleCreatorData;
  /** Create a single "ArticleEvent" node. */
  createArticleEvent: ArticleEvent;
  /** Create a single "ArticleExtension" node. */
  createArticleExtension: ArticleExtension;
  /** Create a single "ArticleGoodDealAIPrompt" node. */
  createArticleGoodDealAIPrompt: ArticleGoodDealAiPrompt;
  /** Create a single "ArticleGoodDealAiProcess" node. */
  createArticleGoodDealAiProcess: ArticleGoodDealAiProcess;
  /** Create a single "ArticleGuide" node. */
  createArticleGuide: ArticleGuide;
  /** Create a single "ArticleHistory" node. */
  createArticleHistory: ArticleHistory;
  /** Create a single "ArticleMachineTag" node. */
  createArticleMachineTag: ArticleMachineTag;
  /** Create a single "ArticleQualifier" node. */
  createArticleQualifier: ArticleQualifier;
  /** Create a single "ArticleTag" node. */
  createArticleTag: ArticleTag;
  /** Create a single "ArticleTaxonomy" node. */
  createArticleTaxonomy: ArticleTaxonomy;
  /** Create a single "ArticleUrl" node. */
  createArticleUrl: ArticleUrl;
  /** Create a single "ArticleUrlPublicId" node. */
  createArticleUrlPublicId: ArticleUrlPublicId;
  /** Create a single "ArticleUser" node. */
  createArticleUser: ArticleUser;
  /** Create a single "Attribute" node. */
  createAttribute: Attribute;
  /** Create a single "Author" node. */
  createAuthor: Author;
  /** Create a single "AuthorAttribute" node. */
  createAuthorAttribute: AuthorAttribute;
  /** Create a single "AuthorHistory" node. */
  createAuthorHistory: AuthorHistory;
  /** Get one or list campaigns by brandKey and TargetDevices */
  createCampaign?: Maybe<CreateCampaignResult>;
  /** Create a single "Card" node. */
  createCard: Card;
  /** Create a single "CardCategory" node. */
  createCardCategory: CardCategory;
  /** Create a single "CardTag" node. */
  createCardTag: CardTag;
  /** Create a single "Category" node. */
  createCategory: Category;
  /** Create a single "CategoryHistory" node. */
  createCategoryHistory: CategoryHistory;
  /** Create a single "CategoryUrlPublicId" node. */
  createCategoryUrlPublicId: CategoryUrlPublicId;
  /** Create a single "DailymotionLog" node. */
  createDailymotionLog: DailymotionLog;
  /** Create a single "DailymotionMigration" node. */
  createDailymotionMigration: DailymotionMigration;
  /** Create a single "ImageSource" node. */
  createImageSource: ImageSource;
  /** Create a single "ImageSourceCategory" node. */
  createImageSourceCategory: ImageSourceCategory;
  /** Create a single "Live" node. */
  createLive: Live;
  /** Create a single "LivePost" node. */
  createLivePost: LivePost;
  /** Create a single "MachineTag" node. */
  createMachineTag: MachineTag;
  /** Create a single "OpenAiProcess" node. */
  createOpenAiProcess: OpenAiProcess;
  /** Create a single "OrphanPage" node. */
  createOrphanPage: OrphanPage;
  /** Create a single "Prompt" node. */
  createPrompt: Prompt;
  /** Create a single "Push" node. */
  createPush: Push;
  /** Create a single "PushError" node. */
  createPushError: PushError;
  /** Create a single "PushSegment" node. */
  createPushSegment: PushSegment;
  /** Create a single "Qualifier" node. */
  createQualifier: Qualifier;
  /** Create a single "Segment" node. */
  createSegment: Segment;
  /** Create a single "Source" node. */
  createSource: Source;
  /** Create a single "Tab" node. */
  createTab: Tab;
  /** Create a single "Tag" node. */
  createTag: Tag;
  /** Create a single "TagBrandUsage" node. */
  createTagBrandUsage: TagBrandUsage;
  /** Create a single "Taxonomy" node. */
  createTaxonomy: Taxonomy;
  /** Create a single "Url" node. */
  createUrl: Url;
  /** update dailymotion video */
  dailymotionUpdate: DailymotionUpdateResult;
  /** Delete a single "Article" node. */
  deleteArticle?: Maybe<Article>;
  /** Delete a single "ArticleAuthor" node. */
  deleteArticleAuthor?: Maybe<ArticleAuthor>;
  /** Delete a single "ArticleCategory" node. */
  deleteArticleCategory?: Maybe<ArticleCategory>;
  /** Delete a single "ArticleChannel" node. */
  deleteArticleChannel?: Maybe<ArticleChannel>;
  /** Delete a single "ArticleCreatorData" node. */
  deleteArticleCreatorData?: Maybe<ArticleCreatorData>;
  /** Delete a single "ArticleEvent" node. */
  deleteArticleEvent?: Maybe<ArticleEvent>;
  /** Delete a single "ArticleExtension" node. */
  deleteArticleExtension?: Maybe<ArticleExtension>;
  /** Delete a single "ArticleGoodDealAIPrompt" node. */
  deleteArticleGoodDealAIPrompt?: Maybe<ArticleGoodDealAiPrompt>;
  /** Delete a single "ArticleGoodDealAiProcess" node. */
  deleteArticleGoodDealAiProcess?: Maybe<ArticleGoodDealAiProcess>;
  /** Delete a single "ArticleGuide" node. */
  deleteArticleGuide?: Maybe<ArticleGuide>;
  /** Delete a single "ArticleHistory" node. */
  deleteArticleHistory?: Maybe<ArticleHistory>;
  /** Delete a single "ArticleMachineTag" node. */
  deleteArticleMachineTag?: Maybe<ArticleMachineTag>;
  /** Delete a single "ArticleQualifier" node. */
  deleteArticleQualifier?: Maybe<ArticleQualifier>;
  /** Delete a single "ArticleTag" node. */
  deleteArticleTag?: Maybe<ArticleTag>;
  /** Delete a single "ArticleTaxonomy" node. */
  deleteArticleTaxonomy?: Maybe<ArticleTaxonomy>;
  /** Delete a single "ArticleUrl" node. */
  deleteArticleUrl?: Maybe<ArticleUrl>;
  /** Delete a single "ArticleUrlPublicId" node. */
  deleteArticleUrlPublicId?: Maybe<ArticleUrlPublicId>;
  /** Delete a single "ArticleUser" node. */
  deleteArticleUser?: Maybe<ArticleUser>;
  /** Delete a single "Attribute" node. */
  deleteAttribute?: Maybe<Attribute>;
  /** Delete a single "Author" node. */
  deleteAuthor?: Maybe<Author>;
  /** Delete a single "AuthorAttribute" node. */
  deleteAuthorAttribute?: Maybe<AuthorAttribute>;
  /** Delete a single "AuthorHistory" node. */
  deleteAuthorHistory?: Maybe<AuthorHistory>;
  /** Delete one campaign by brandKey and TargetDevices */
  deleteCampaign?: Maybe<DeleteCampaignResult>;
  /** Delete a single "Card" node. */
  deleteCard?: Maybe<Card>;
  /** Delete a single "CardCategory" node. */
  deleteCardCategory?: Maybe<CardCategory>;
  /** Delete a single "CardTag" node. */
  deleteCardTag?: Maybe<CardTag>;
  /** Delete a single "Category" node. */
  deleteCategory?: Maybe<Category>;
  /** Delete a single "CategoryHistory" node. */
  deleteCategoryHistory?: Maybe<CategoryHistory>;
  /** Delete a single "CategoryUrlPublicId" node. */
  deleteCategoryUrlPublicId?: Maybe<CategoryUrlPublicId>;
  /** Delete a single "DailymotionLog" node. */
  deleteDailymotionLog?: Maybe<DailymotionLog>;
  /** Delete a single "DailymotionMigration" node. */
  deleteDailymotionMigration?: Maybe<DailymotionMigration>;
  /** Delete a single "ImageSource" node. */
  deleteImageSource?: Maybe<ImageSource>;
  /** Delete a single "ImageSourceCategory" node. */
  deleteImageSourceCategory?: Maybe<ImageSourceCategory>;
  /** Delete a single "Live" node. */
  deleteLive?: Maybe<Live>;
  /** Delete a single "LivePost" node. */
  deleteLivePost?: Maybe<LivePost>;
  /** Delete a single "MachineTag" node. */
  deleteMachineTag?: Maybe<MachineTag>;
  /** Delete a single "OpenAiProcess" node. */
  deleteOpenAiProcess?: Maybe<OpenAiProcess>;
  /** Delete a single "OrphanPage" node. */
  deleteOrphanPage?: Maybe<OrphanPage>;
  /** Delete a single "Prompt" node. */
  deletePrompt?: Maybe<Prompt>;
  /** Delete a single "Push" node. */
  deletePush?: Maybe<Push>;
  /** Delete a single "PushError" node. */
  deletePushError?: Maybe<PushError>;
  /** Delete a single "PushSegment" node. */
  deletePushSegment?: Maybe<PushSegment>;
  /** Delete a single "Qualifier" node. */
  deleteQualifier?: Maybe<Qualifier>;
  /** Delete a single "Segment" node. */
  deleteSegment?: Maybe<Segment>;
  /** Delete a single "Source" node. */
  deleteSource?: Maybe<Source>;
  /** Delete a single "Tab" node. */
  deleteTab?: Maybe<Tab>;
  /** Delete a single "Tag" node. */
  deleteTag?: Maybe<Tag>;
  /** Delete a single "TagBrandUsage" node. */
  deleteTagBrandUsage?: Maybe<TagBrandUsage>;
  /** Delete a single "Taxonomy" node. */
  deleteTaxonomy?: Maybe<Taxonomy>;
  /** Generate good deal article with ChatGPT */
  generateGoodDealArticleIA: GoodDealProcessReturnType;
  /** Generate Slideshow with Vertex AI and ChatGPT */
  generateSlideshowIA: OpenAiProcessReturnType;
  /** import video from Dailymotion using dailymotion id */
  importDailymotionVideo?: Maybe<Scalars['String']['output']>;
  /**
   * Import article with html body/lead and non-iframely medias.
   *       Expect the whole article as a state, in case of update, all old relation will be removed and replace by the new
   *       Undefined param will be ignored, null param will set the field to null or delete all relations
   */
  importHtmlArticle?: Maybe<Article>;
  /** Merge normals tags */
  mergeNormalTags: TagMergeResult;
  /** Refresh article media with iframely data */
  refreshArticleMedias?: Maybe<Article>;
  /** Share article with others users */
  shareArticle?: Maybe<Article>;
  /** Update a single "Article" node. */
  updateArticle?: Maybe<Article>;
  /** Update a single "ArticleAuthor" node. */
  updateArticleAuthor?: Maybe<ArticleAuthor>;
  /** Update a single "ArticleCategory" node. */
  updateArticleCategory?: Maybe<ArticleCategory>;
  /** Update a single "ArticleChannel" node. */
  updateArticleChannel?: Maybe<ArticleChannel>;
  /** Update a single "ArticleCreatorData" node. */
  updateArticleCreatorData?: Maybe<ArticleCreatorData>;
  /** Update a single "ArticleEvent" node. */
  updateArticleEvent?: Maybe<ArticleEvent>;
  /** Update a single "ArticleExtension" node. */
  updateArticleExtension?: Maybe<ArticleExtension>;
  /** Update a single "ArticleGoodDealAIPrompt" node. */
  updateArticleGoodDealAIPrompt?: Maybe<ArticleGoodDealAiPrompt>;
  /** Update a single "ArticleGoodDealAiProcess" node. */
  updateArticleGoodDealAiProcess?: Maybe<ArticleGoodDealAiProcess>;
  /** Update a single "ArticleGuide" node. */
  updateArticleGuide?: Maybe<ArticleGuide>;
  /** Update a single "ArticleHistory" node. */
  updateArticleHistory?: Maybe<ArticleHistory>;
  /** Update a single "ArticleMachineTag" node. */
  updateArticleMachineTag?: Maybe<ArticleMachineTag>;
  /** Update a single "ArticleQualifier" node. */
  updateArticleQualifier?: Maybe<ArticleQualifier>;
  /** Update a single "ArticleTag" node. */
  updateArticleTag?: Maybe<ArticleTag>;
  /** Update a single "ArticleTaxonomy" node. */
  updateArticleTaxonomy?: Maybe<ArticleTaxonomy>;
  /** Update a single "ArticleUrl" node. */
  updateArticleUrl?: Maybe<ArticleUrl>;
  /** Update a single "ArticleUrlPublicId" node. */
  updateArticleUrlPublicId?: Maybe<ArticleUrlPublicId>;
  /** Update a single "ArticleUser" node. */
  updateArticleUser?: Maybe<ArticleUser>;
  /** Update a single "Attribute" node. */
  updateAttribute?: Maybe<Attribute>;
  /** Update a single "Author" node. */
  updateAuthor?: Maybe<Author>;
  /** Update a single "AuthorAttribute" node. */
  updateAuthorAttribute?: Maybe<AuthorAttribute>;
  /** Update a single "AuthorHistory" node. */
  updateAuthorHistory?: Maybe<AuthorHistory>;
  /** Update a batch campaign by brandKey and TargetDevices */
  updateCampaign?: Maybe<UpdateCampaignResult>;
  /** Update a single "Card" node. */
  updateCard?: Maybe<Card>;
  /** Update a single "CardCategory" node. */
  updateCardCategory?: Maybe<CardCategory>;
  /** Update a single "CardTag" node. */
  updateCardTag?: Maybe<CardTag>;
  /** Update a single "Category" node. */
  updateCategory?: Maybe<Category>;
  /** Update a single "CategoryHistory" node. */
  updateCategoryHistory?: Maybe<CategoryHistory>;
  /** Update a single "CategoryUrlPublicId" node. */
  updateCategoryUrlPublicId?: Maybe<CategoryUrlPublicId>;
  /** Update a single "DailymotionLog" node. */
  updateDailymotionLog?: Maybe<DailymotionLog>;
  /** Update a single "DailymotionMigration" node. */
  updateDailymotionMigration?: Maybe<DailymotionMigration>;
  /** Update a single "ImageSource" node. */
  updateImageSource?: Maybe<ImageSource>;
  /** Update a single "ImageSourceCategory" node. */
  updateImageSourceCategory?: Maybe<ImageSourceCategory>;
  /** Update a single "Live" node. */
  updateLive?: Maybe<Live>;
  /** Update a single "LivePost" node. */
  updateLivePost?: Maybe<LivePost>;
  /** Update a single "MachineTag" node. */
  updateMachineTag?: Maybe<MachineTag>;
  /** Update a single "OpenAiProcess" node. */
  updateOpenAiProcess?: Maybe<OpenAiProcess>;
  /** Update a single "OrphanPage" node. */
  updateOrphanPage?: Maybe<OrphanPage>;
  /** Update a single "Prompt" node. */
  updatePrompt?: Maybe<Prompt>;
  /** Update a single "Push" node. */
  updatePush?: Maybe<Push>;
  /** Update a single "PushError" node. */
  updatePushError?: Maybe<PushError>;
  /** Update a single "Qualifier" node. */
  updateQualifier?: Maybe<Qualifier>;
  /** Update a single "Segment" node. */
  updateSegment?: Maybe<Segment>;
  /** Generate Description with Vertex AI and ChatGpt */
  updateSlideshowDescriptionsIA: OpenAiProcessReturnType;
  /** Update a single "Source" node. */
  updateSource?: Maybe<Source>;
  /** Update a single "Tab" node. */
  updateTab?: Maybe<Tab>;
  /** Update a single "Tag" node. */
  updateTag?: Maybe<Tag>;
  /** Update a single "TagBrandUsage" node. */
  updateTagBrandUsage?: Maybe<TagBrandUsage>;
  /** Update a single "Taxonomy" node. */
  updateTaxonomy?: Maybe<Taxonomy>;
  /** Update or create a single "Article" node. */
  upsertArticle: Article;
  /** Update or create a single "ArticleAuthor" node. */
  upsertArticleAuthor: ArticleAuthor;
  /** Update or create a single "ArticleCategory" node. */
  upsertArticleCategory: ArticleCategory;
  /** Update or create a single "ArticleChannel" node. */
  upsertArticleChannel: ArticleChannel;
  /** Update or create a single "ArticleCreatorData" node. */
  upsertArticleCreatorData: ArticleCreatorData;
  /** Update or create a single "ArticleEvent" node. */
  upsertArticleEvent: ArticleEvent;
  /** Update or create a single "ArticleExtension" node. */
  upsertArticleExtension: ArticleExtension;
  /** Update or create a single "ArticleGoodDealAIPrompt" node. */
  upsertArticleGoodDealAIPrompt: ArticleGoodDealAiPrompt;
  /** Update or create a single "ArticleGoodDealAiProcess" node. */
  upsertArticleGoodDealAiProcess: ArticleGoodDealAiProcess;
  /** Update or create a single "ArticleGuide" node. */
  upsertArticleGuide: ArticleGuide;
  /** Update or create a single "ArticleHistory" node. */
  upsertArticleHistory: ArticleHistory;
  /** Update or create a single "ArticleMachineTag" node. */
  upsertArticleMachineTag: ArticleMachineTag;
  /** Update or create a single "ArticleQualifier" node. */
  upsertArticleQualifier: ArticleQualifier;
  /** Update or create a single "ArticleTag" node. */
  upsertArticleTag: ArticleTag;
  /** Update or create a single "ArticleTaxonomy" node. */
  upsertArticleTaxonomy: ArticleTaxonomy;
  /** Update or create a single "ArticleUrl" node. */
  upsertArticleUrl: ArticleUrl;
  /** Update or create a single "ArticleUrlPublicId" node. */
  upsertArticleUrlPublicId: ArticleUrlPublicId;
  /** Update or create a single "ArticleUser" node. */
  upsertArticleUser: ArticleUser;
  /** Update or create a single "Attribute" node. */
  upsertAttribute: Attribute;
  /** Update or create a single "Author" node. */
  upsertAuthor: Author;
  /** Update or create a single "AuthorAttribute" node. */
  upsertAuthorAttribute: AuthorAttribute;
  /** Update or create a single "AuthorHistory" node. */
  upsertAuthorHistory: AuthorHistory;
  /** Update or create a single "Card" node. */
  upsertCard: Card;
  /** Update or create a single "CardCategory" node. */
  upsertCardCategory: CardCategory;
  /** Update or create a single "CardTag" node. */
  upsertCardTag: CardTag;
  /** Update or create a single "Category" node. */
  upsertCategory: Category;
  /** Update or create a single "CategoryHistory" node. */
  upsertCategoryHistory: CategoryHistory;
  /** Update or create a single "CategoryUrlPublicId" node. */
  upsertCategoryUrlPublicId: CategoryUrlPublicId;
  /** Update or create a single "DailymotionLog" node. */
  upsertDailymotionLog: DailymotionLog;
  /** Update or create a single "DailymotionMigration" node. */
  upsertDailymotionMigration: DailymotionMigration;
  /** Update or create a single "ImageSource" node. */
  upsertImageSource: ImageSource;
  /** Update or create a single "ImageSourceCategory" node. */
  upsertImageSourceCategory: ImageSourceCategory;
  /** Update or create a single "Live" node. */
  upsertLive: Live;
  /** Update or create a single "LivePost" node. */
  upsertLivePost: LivePost;
  /** Update or create a single "MachineTag" node. */
  upsertMachineTag: MachineTag;
  /** Update or create a single "OpenAiProcess" node. */
  upsertOpenAiProcess: OpenAiProcess;
  /** Update or create a single "OrphanPage" node. */
  upsertOrphanPage: OrphanPage;
  /** Update or create a single "Prompt" node. */
  upsertPrompt: Prompt;
  /** Update or create a single "Push" node. */
  upsertPush: Push;
  /** Update or create a single "PushError" node. */
  upsertPushError: PushError;
  /** Update or create a single "Qualifier" node. */
  upsertQualifier: Qualifier;
  /** Update or create a single "Segment" node. */
  upsertSegment: Segment;
  /** Update or create a single "Source" node. */
  upsertSource: Source;
  /** Update or create a single "Tab" node. */
  upsertTab: Tab;
  /** Update or create a single "Tag" node. */
  upsertTag: Tag;
  /** Update or create a single "TagBrandUsage" node. */
  upsertTagBrandUsage: TagBrandUsage;
  /** Update or create a single "Taxonomy" node. */
  upsertTaxonomy: Taxonomy;
};


export type MutationCompleteSlideshowIaArgs = {
  brandKey: BrandKey;
  recipeNumber: Scalars['Int']['input'];
  slideshowEditionId: Scalars['String']['input'];
  slideshowSubject: Scalars['String']['input'];
};


export type MutationComputeAuthorBrandKeysArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateAffiliationCardArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  localizedProductId: Scalars['String']['input'];
  negativePoints?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positivePoints?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationCreateAffiliationCatalogProductArgs = {
  localizedProductId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateArticleArgs = {
  data: ArticleCreateInput;
};


export type MutationCreateArticleAuthorArgs = {
  data: ArticleAuthorCreateInput;
};


export type MutationCreateArticleCategoryArgs = {
  data: ArticleCategoryCreateInput;
};


export type MutationCreateArticleChannelArgs = {
  data: ArticleChannelCreateInput;
};


export type MutationCreateArticleCreatorDataArgs = {
  data: ArticleCreatorDataCreateInput;
};


export type MutationCreateArticleEventArgs = {
  data: ArticleEventCreateInput;
};


export type MutationCreateArticleExtensionArgs = {
  data: ArticleExtensionCreateInput;
};


export type MutationCreateArticleGoodDealAiPromptArgs = {
  data: ArticleGoodDealAiPromptCreateInput;
};


export type MutationCreateArticleGoodDealAiProcessArgs = {
  data: ArticleGoodDealAiProcessCreateInput;
};


export type MutationCreateArticleGuideArgs = {
  data: ArticleGuideCreateInput;
};


export type MutationCreateArticleHistoryArgs = {
  data: ArticleHistoryCreateInput;
};


export type MutationCreateArticleMachineTagArgs = {
  data: ArticleMachineTagCreateInput;
};


export type MutationCreateArticleQualifierArgs = {
  data: ArticleQualifierCreateInput;
};


export type MutationCreateArticleTagArgs = {
  data: ArticleTagCreateInput;
};


export type MutationCreateArticleTaxonomyArgs = {
  data: ArticleTaxonomyCreateInput;
};


export type MutationCreateArticleUrlArgs = {
  data: ArticleUrlCreateInput;
};


export type MutationCreateArticleUrlPublicIdArgs = {
  data: ArticleUrlPublicIdCreateInput;
};


export type MutationCreateArticleUserArgs = {
  data: ArticleUserCreateInput;
};


export type MutationCreateAttributeArgs = {
  data: AttributeCreateInput;
};


export type MutationCreateAuthorArgs = {
  data: AuthorCreateInput;
};


export type MutationCreateAuthorAttributeArgs = {
  data: AuthorAttributeCreateInput;
};


export type MutationCreateAuthorHistoryArgs = {
  data: AuthorHistoryCreateInput;
};


export type MutationCreateCampaignArgs = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  customDeeplink?: InputMaybe<Scalars['String']['input']>;
  device: TargetDevice;
  format: ArticleFormat;
  media: Scalars['String']['input'];
  message: Scalars['String']['input'];
  publicId?: InputMaybe<Scalars['String']['input']>;
  pushTime: Scalars['String']['input'];
  query: Scalars['String']['input'];
  segments: Array<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateCardArgs = {
  data: CardCreateInput;
};


export type MutationCreateCardCategoryArgs = {
  data: CardCategoryCreateInput;
};


export type MutationCreateCardTagArgs = {
  data: CardTagCreateInput;
};


export type MutationCreateCategoryArgs = {
  data: CategoryCreateInput;
};


export type MutationCreateCategoryHistoryArgs = {
  data: CategoryHistoryCreateInput;
};


export type MutationCreateCategoryUrlPublicIdArgs = {
  data: CategoryUrlPublicIdCreateInput;
};


export type MutationCreateDailymotionLogArgs = {
  data: DailymotionLogCreateInput;
};


export type MutationCreateDailymotionMigrationArgs = {
  data: DailymotionMigrationCreateInput;
};


export type MutationCreateImageSourceArgs = {
  data: ImageSourceCreateInput;
};


export type MutationCreateImageSourceCategoryArgs = {
  data: ImageSourceCategoryCreateInput;
};


export type MutationCreateLiveArgs = {
  data: LiveCreateInput;
};


export type MutationCreateLivePostArgs = {
  data: LivePostCreateInput;
};


export type MutationCreateMachineTagArgs = {
  data: MachineTagCreateInput;
};


export type MutationCreateOpenAiProcessArgs = {
  data: OpenAiProcessCreateInput;
};


export type MutationCreateOrphanPageArgs = {
  data: OrphanPageCreateInput;
};


export type MutationCreatePromptArgs = {
  data: PromptCreateInput;
};


export type MutationCreatePushArgs = {
  data: PushCreateInput;
};


export type MutationCreatePushErrorArgs = {
  data: PushErrorCreateInput;
};


export type MutationCreatePushSegmentArgs = {
  data: PushSegmentCreateInput;
};


export type MutationCreateQualifierArgs = {
  data: QualifierCreateInput;
};


export type MutationCreateSegmentArgs = {
  data: SegmentCreateInput;
};


export type MutationCreateSourceArgs = {
  data: SourceCreateInput;
};


export type MutationCreateTabArgs = {
  data: TabCreateInput;
};


export type MutationCreateTagArgs = {
  data: TagCreateInput;
};


export type MutationCreateTagBrandUsageArgs = {
  data: TagBrandUsageCreateInput;
};


export type MutationCreateTaxonomyArgs = {
  data: TaxonomyCreateInput;
};


export type MutationCreateUrlArgs = {
  data: UrlCreateInput;
};


export type MutationDailymotionUpdateArgs = {
  brandKey: BrandKey;
  thumbnailUrl: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};


export type MutationDeleteArticleArgs = {
  where: ArticleWhereUniqueInput;
};


export type MutationDeleteArticleAuthorArgs = {
  where: ArticleAuthorWhereUniqueInput;
};


export type MutationDeleteArticleCategoryArgs = {
  where: ArticleCategoryWhereUniqueInput;
};


export type MutationDeleteArticleChannelArgs = {
  where: ArticleChannelWhereUniqueInput;
};


export type MutationDeleteArticleCreatorDataArgs = {
  where: ArticleCreatorDataWhereUniqueInput;
};


export type MutationDeleteArticleEventArgs = {
  where: ArticleEventWhereUniqueInput;
};


export type MutationDeleteArticleExtensionArgs = {
  where: ArticleExtensionWhereUniqueInput;
};


export type MutationDeleteArticleGoodDealAiPromptArgs = {
  where: ArticleGoodDealAiPromptWhereUniqueInput;
};


export type MutationDeleteArticleGoodDealAiProcessArgs = {
  where: ArticleGoodDealAiProcessWhereUniqueInput;
};


export type MutationDeleteArticleGuideArgs = {
  where: ArticleGuideWhereUniqueInput;
};


export type MutationDeleteArticleHistoryArgs = {
  where: ArticleHistoryWhereUniqueInput;
};


export type MutationDeleteArticleMachineTagArgs = {
  where: ArticleMachineTagWhereUniqueInput;
};


export type MutationDeleteArticleQualifierArgs = {
  where: ArticleQualifierWhereUniqueInput;
};


export type MutationDeleteArticleTagArgs = {
  where: ArticleTagWhereUniqueInput;
};


export type MutationDeleteArticleTaxonomyArgs = {
  where: ArticleTaxonomyWhereUniqueInput;
};


export type MutationDeleteArticleUrlArgs = {
  where: ArticleUrlWhereUniqueInput;
};


export type MutationDeleteArticleUrlPublicIdArgs = {
  where: ArticleUrlPublicIdWhereUniqueInput;
};


export type MutationDeleteArticleUserArgs = {
  where: ArticleUserWhereUniqueInput;
};


export type MutationDeleteAttributeArgs = {
  where: AttributeWhereUniqueInput;
};


export type MutationDeleteAuthorArgs = {
  where: AuthorWhereUniqueInput;
};


export type MutationDeleteAuthorAttributeArgs = {
  where: AuthorAttributeWhereUniqueInput;
};


export type MutationDeleteAuthorHistoryArgs = {
  where: AuthorHistoryWhereUniqueInput;
};


export type MutationDeleteCampaignArgs = {
  brandKey?: InputMaybe<BrandKey>;
  device?: InputMaybe<TargetDevice>;
  pushId: Scalars['String']['input'];
};


export type MutationDeleteCardArgs = {
  where: CardWhereUniqueInput;
};


export type MutationDeleteCardCategoryArgs = {
  where: CardCategoryWhereUniqueInput;
};


export type MutationDeleteCardTagArgs = {
  where: CardTagWhereUniqueInput;
};


export type MutationDeleteCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type MutationDeleteCategoryHistoryArgs = {
  where: CategoryHistoryWhereUniqueInput;
};


export type MutationDeleteCategoryUrlPublicIdArgs = {
  where: CategoryUrlPublicIdWhereUniqueInput;
};


export type MutationDeleteDailymotionLogArgs = {
  where: DailymotionLogWhereUniqueInput;
};


export type MutationDeleteDailymotionMigrationArgs = {
  where: DailymotionMigrationWhereUniqueInput;
};


export type MutationDeleteImageSourceArgs = {
  where: ImageSourceWhereUniqueInput;
};


export type MutationDeleteImageSourceCategoryArgs = {
  where: ImageSourceCategoryWhereUniqueInput;
};


export type MutationDeleteLiveArgs = {
  where: LiveWhereUniqueInput;
};


export type MutationDeleteLivePostArgs = {
  where: LivePostWhereUniqueInput;
};


export type MutationDeleteMachineTagArgs = {
  where: MachineTagWhereUniqueInput;
};


export type MutationDeleteOpenAiProcessArgs = {
  where: OpenAiProcessWhereUniqueInput;
};


export type MutationDeleteOrphanPageArgs = {
  where: OrphanPageWhereUniqueInput;
};


export type MutationDeletePromptArgs = {
  where: PromptWhereUniqueInput;
};


export type MutationDeletePushArgs = {
  where: PushWhereUniqueInput;
};


export type MutationDeletePushErrorArgs = {
  where: PushErrorWhereUniqueInput;
};


export type MutationDeletePushSegmentArgs = {
  where: PushSegmentWhereUniqueInput;
};


export type MutationDeleteQualifierArgs = {
  where: QualifierWhereUniqueInput;
};


export type MutationDeleteSegmentArgs = {
  where: SegmentWhereUniqueInput;
};


export type MutationDeleteSourceArgs = {
  where: SourceWhereUniqueInput;
};


export type MutationDeleteTabArgs = {
  where: TabWhereUniqueInput;
};


export type MutationDeleteTagArgs = {
  where: TagWhereUniqueInput;
};


export type MutationDeleteTagBrandUsageArgs = {
  where: TagBrandUsageWhereUniqueInput;
};


export type MutationDeleteTaxonomyArgs = {
  where: TaxonomyWhereUniqueInput;
};


export type MutationGenerateGoodDealArticleIaArgs = {
  amazonProductUrl: Scalars['String']['input'];
};


export type MutationGenerateSlideshowIaArgs = {
  brandKey: BrandKey;
  recipeIds: Array<Scalars['String']['input']>;
  recipeNumber: Scalars['Int']['input'];
  slideshowSubject: Scalars['String']['input'];
};


export type MutationImportDailymotionVideoArgs = {
  brandKey: BrandKey;
  dailymotionId: Scalars['String']['input'];
};


export type MutationImportHtmlArticleArgs = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<Array<Scalars['ID']['input']>>;
  format: ArticleFormat;
  guides?: InputMaybe<Array<Scalars['ID']['input']>>;
  lead?: InputMaybe<Scalars['String']['input']>;
  machineTags?: InputMaybe<Array<Scalars['String']['input']>>;
  medias?: InputMaybe<Array<HtmlArticleMedia>>;
  partnerTitle?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  platformId: Scalars['String']['input'];
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  qualifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  secondaryTitle?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status: ArticleStatus;
  tags?: InputMaybe<Array<HtmlArticleTag>>;
  title: Scalars['String']['input'];
};


export type MutationMergeNormalTagsArgs = {
  mainTagId: Scalars['String']['input'];
  slaveTagId: Scalars['String']['input'];
};


export type MutationRefreshArticleMediasArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationShareArticleArgs = {
  articleId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  userIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateArticleArgs = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};


export type MutationUpdateArticleAuthorArgs = {
  data: ArticleAuthorUpdateInput;
  where: ArticleAuthorWhereUniqueInput;
};


export type MutationUpdateArticleCategoryArgs = {
  data: ArticleCategoryUpdateInput;
  where: ArticleCategoryWhereUniqueInput;
};


export type MutationUpdateArticleChannelArgs = {
  data: ArticleChannelUpdateInput;
  where: ArticleChannelWhereUniqueInput;
};


export type MutationUpdateArticleCreatorDataArgs = {
  data: ArticleCreatorDataUpdateInput;
  where: ArticleCreatorDataWhereUniqueInput;
};


export type MutationUpdateArticleEventArgs = {
  data: ArticleEventUpdateInput;
  where: ArticleEventWhereUniqueInput;
};


export type MutationUpdateArticleExtensionArgs = {
  data: ArticleExtensionUpdateInput;
  where: ArticleExtensionWhereUniqueInput;
};


export type MutationUpdateArticleGoodDealAiPromptArgs = {
  data: ArticleGoodDealAiPromptUpdateInput;
  where: ArticleGoodDealAiPromptWhereUniqueInput;
};


export type MutationUpdateArticleGoodDealAiProcessArgs = {
  data: ArticleGoodDealAiProcessUpdateInput;
  where: ArticleGoodDealAiProcessWhereUniqueInput;
};


export type MutationUpdateArticleGuideArgs = {
  data: ArticleGuideUpdateInput;
  where: ArticleGuideWhereUniqueInput;
};


export type MutationUpdateArticleHistoryArgs = {
  data: ArticleHistoryUpdateInput;
  where: ArticleHistoryWhereUniqueInput;
};


export type MutationUpdateArticleMachineTagArgs = {
  data: ArticleMachineTagUpdateInput;
  where: ArticleMachineTagWhereUniqueInput;
};


export type MutationUpdateArticleQualifierArgs = {
  data: ArticleQualifierUpdateInput;
  where: ArticleQualifierWhereUniqueInput;
};


export type MutationUpdateArticleTagArgs = {
  data: ArticleTagUpdateInput;
  where: ArticleTagWhereUniqueInput;
};


export type MutationUpdateArticleTaxonomyArgs = {
  data: ArticleTaxonomyUpdateInput;
  where: ArticleTaxonomyWhereUniqueInput;
};


export type MutationUpdateArticleUrlArgs = {
  data: ArticleUrlUpdateInput;
  where: ArticleUrlWhereUniqueInput;
};


export type MutationUpdateArticleUrlPublicIdArgs = {
  data: ArticleUrlPublicIdUpdateInput;
  where: ArticleUrlPublicIdWhereUniqueInput;
};


export type MutationUpdateArticleUserArgs = {
  data: ArticleUserUpdateInput;
  where: ArticleUserWhereUniqueInput;
};


export type MutationUpdateAttributeArgs = {
  data: AttributeUpdateInput;
  where: AttributeWhereUniqueInput;
};


export type MutationUpdateAuthorArgs = {
  data: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};


export type MutationUpdateAuthorAttributeArgs = {
  data: AuthorAttributeUpdateInput;
  where: AuthorAttributeWhereUniqueInput;
};


export type MutationUpdateAuthorHistoryArgs = {
  data: AuthorHistoryUpdateInput;
  where: AuthorHistoryWhereUniqueInput;
};


export type MutationUpdateCampaignArgs = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  brandKey: BrandKey;
  customDeeplink?: InputMaybe<Scalars['String']['input']>;
  device: TargetDevice;
  format: ArticleFormat;
  media?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  pushId: Scalars['String']['input'];
  pushTime?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCardArgs = {
  data: CardUpdateInput;
  where: CardWhereUniqueInput;
};


export type MutationUpdateCardCategoryArgs = {
  data: CardCategoryUpdateInput;
  where: CardCategoryWhereUniqueInput;
};


export type MutationUpdateCardTagArgs = {
  data: CardTagUpdateInput;
  where: CardTagWhereUniqueInput;
};


export type MutationUpdateCategoryArgs = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpdateCategoryHistoryArgs = {
  data: CategoryHistoryUpdateInput;
  where: CategoryHistoryWhereUniqueInput;
};


export type MutationUpdateCategoryUrlPublicIdArgs = {
  data: CategoryUrlPublicIdUpdateInput;
  where: CategoryUrlPublicIdWhereUniqueInput;
};


export type MutationUpdateDailymotionLogArgs = {
  data: DailymotionLogUpdateInput;
  where: DailymotionLogWhereUniqueInput;
};


export type MutationUpdateDailymotionMigrationArgs = {
  data: DailymotionMigrationUpdateInput;
  where: DailymotionMigrationWhereUniqueInput;
};


export type MutationUpdateImageSourceArgs = {
  data: ImageSourceUpdateInput;
  where: ImageSourceWhereUniqueInput;
};


export type MutationUpdateImageSourceCategoryArgs = {
  data: ImageSourceCategoryUpdateInput;
  where: ImageSourceCategoryWhereUniqueInput;
};


export type MutationUpdateLiveArgs = {
  data: LiveUpdateInput;
  where: LiveWhereUniqueInput;
};


export type MutationUpdateLivePostArgs = {
  data: LivePostUpdateInput;
  where: LivePostWhereUniqueInput;
};


export type MutationUpdateMachineTagArgs = {
  data: MachineTagUpdateInput;
  where: MachineTagWhereUniqueInput;
};


export type MutationUpdateOpenAiProcessArgs = {
  data: OpenAiProcessUpdateInput;
  where: OpenAiProcessWhereUniqueInput;
};


export type MutationUpdateOrphanPageArgs = {
  data: OrphanPageUpdateInput;
  where: OrphanPageWhereUniqueInput;
};


export type MutationUpdatePromptArgs = {
  data: PromptUpdateInput;
  where: PromptWhereUniqueInput;
};


export type MutationUpdatePushArgs = {
  data: PushUpdateInput;
  where: PushWhereUniqueInput;
};


export type MutationUpdatePushErrorArgs = {
  data: PushErrorUpdateInput;
  where: PushErrorWhereUniqueInput;
};


export type MutationUpdateQualifierArgs = {
  data: QualifierUpdateInput;
  where: QualifierWhereUniqueInput;
};


export type MutationUpdateSegmentArgs = {
  data: SegmentUpdateInput;
  where: SegmentWhereUniqueInput;
};


export type MutationUpdateSlideshowDescriptionsIaArgs = {
  recipesUrls: Array<InputMaybe<Scalars['String']['input']>>;
  slideshowEditionId: Scalars['String']['input'];
};


export type MutationUpdateSourceArgs = {
  data: SourceUpdateInput;
  where: SourceWhereUniqueInput;
};


export type MutationUpdateTabArgs = {
  data: TabUpdateInput;
  where: TabWhereUniqueInput;
};


export type MutationUpdateTagArgs = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};


export type MutationUpdateTagBrandUsageArgs = {
  data: TagBrandUsageUpdateInput;
  where: TagBrandUsageWhereUniqueInput;
};


export type MutationUpdateTaxonomyArgs = {
  data: TaxonomyUpdateInput;
  where: TaxonomyWhereUniqueInput;
};


export type MutationUpsertArticleArgs = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};


export type MutationUpsertArticleAuthorArgs = {
  create: ArticleAuthorCreateInput;
  update: ArticleAuthorUpdateInput;
  where: ArticleAuthorWhereUniqueInput;
};


export type MutationUpsertArticleCategoryArgs = {
  create: ArticleCategoryCreateInput;
  update: ArticleCategoryUpdateInput;
  where: ArticleCategoryWhereUniqueInput;
};


export type MutationUpsertArticleChannelArgs = {
  create: ArticleChannelCreateInput;
  update: ArticleChannelUpdateInput;
  where: ArticleChannelWhereUniqueInput;
};


export type MutationUpsertArticleCreatorDataArgs = {
  create: ArticleCreatorDataCreateInput;
  update: ArticleCreatorDataUpdateInput;
  where: ArticleCreatorDataWhereUniqueInput;
};


export type MutationUpsertArticleEventArgs = {
  create: ArticleEventCreateInput;
  update: ArticleEventUpdateInput;
  where: ArticleEventWhereUniqueInput;
};


export type MutationUpsertArticleExtensionArgs = {
  create: ArticleExtensionCreateInput;
  update: ArticleExtensionUpdateInput;
  where: ArticleExtensionWhereUniqueInput;
};


export type MutationUpsertArticleGoodDealAiPromptArgs = {
  create: ArticleGoodDealAiPromptCreateInput;
  update: ArticleGoodDealAiPromptUpdateInput;
  where: ArticleGoodDealAiPromptWhereUniqueInput;
};


export type MutationUpsertArticleGoodDealAiProcessArgs = {
  create: ArticleGoodDealAiProcessCreateInput;
  update: ArticleGoodDealAiProcessUpdateInput;
  where: ArticleGoodDealAiProcessWhereUniqueInput;
};


export type MutationUpsertArticleGuideArgs = {
  create: ArticleGuideCreateInput;
  update: ArticleGuideUpdateInput;
  where: ArticleGuideWhereUniqueInput;
};


export type MutationUpsertArticleHistoryArgs = {
  create: ArticleHistoryCreateInput;
  update: ArticleHistoryUpdateInput;
  where: ArticleHistoryWhereUniqueInput;
};


export type MutationUpsertArticleMachineTagArgs = {
  create: ArticleMachineTagCreateInput;
  update: ArticleMachineTagUpdateInput;
  where: ArticleMachineTagWhereUniqueInput;
};


export type MutationUpsertArticleQualifierArgs = {
  create: ArticleQualifierCreateInput;
  update: ArticleQualifierUpdateInput;
  where: ArticleQualifierWhereUniqueInput;
};


export type MutationUpsertArticleTagArgs = {
  create: ArticleTagCreateInput;
  update: ArticleTagUpdateInput;
  where: ArticleTagWhereUniqueInput;
};


export type MutationUpsertArticleTaxonomyArgs = {
  create: ArticleTaxonomyCreateInput;
  update: ArticleTaxonomyUpdateInput;
  where: ArticleTaxonomyWhereUniqueInput;
};


export type MutationUpsertArticleUrlArgs = {
  create: ArticleUrlCreateInput;
  update: ArticleUrlUpdateInput;
  where: ArticleUrlWhereUniqueInput;
};


export type MutationUpsertArticleUrlPublicIdArgs = {
  create: ArticleUrlPublicIdCreateInput;
  update: ArticleUrlPublicIdUpdateInput;
  where: ArticleUrlPublicIdWhereUniqueInput;
};


export type MutationUpsertArticleUserArgs = {
  create: ArticleUserCreateInput;
  update: ArticleUserUpdateInput;
  where: ArticleUserWhereUniqueInput;
};


export type MutationUpsertAttributeArgs = {
  create: AttributeCreateInput;
  update: AttributeUpdateInput;
  where: AttributeWhereUniqueInput;
};


export type MutationUpsertAuthorArgs = {
  create: AuthorCreateInput;
  update: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};


export type MutationUpsertAuthorAttributeArgs = {
  create: AuthorAttributeCreateInput;
  update: AuthorAttributeUpdateInput;
  where: AuthorAttributeWhereUniqueInput;
};


export type MutationUpsertAuthorHistoryArgs = {
  create: AuthorHistoryCreateInput;
  update: AuthorHistoryUpdateInput;
  where: AuthorHistoryWhereUniqueInput;
};


export type MutationUpsertCardArgs = {
  create: CardCreateInput;
  update: CardUpdateInput;
  where: CardWhereUniqueInput;
};


export type MutationUpsertCardCategoryArgs = {
  create: CardCategoryCreateInput;
  update: CardCategoryUpdateInput;
  where: CardCategoryWhereUniqueInput;
};


export type MutationUpsertCardTagArgs = {
  create: CardTagCreateInput;
  update: CardTagUpdateInput;
  where: CardTagWhereUniqueInput;
};


export type MutationUpsertCategoryArgs = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpsertCategoryHistoryArgs = {
  create: CategoryHistoryCreateInput;
  update: CategoryHistoryUpdateInput;
  where: CategoryHistoryWhereUniqueInput;
};


export type MutationUpsertCategoryUrlPublicIdArgs = {
  create: CategoryUrlPublicIdCreateInput;
  update: CategoryUrlPublicIdUpdateInput;
  where: CategoryUrlPublicIdWhereUniqueInput;
};


export type MutationUpsertDailymotionLogArgs = {
  create: DailymotionLogCreateInput;
  update: DailymotionLogUpdateInput;
  where: DailymotionLogWhereUniqueInput;
};


export type MutationUpsertDailymotionMigrationArgs = {
  create: DailymotionMigrationCreateInput;
  update: DailymotionMigrationUpdateInput;
  where: DailymotionMigrationWhereUniqueInput;
};


export type MutationUpsertImageSourceArgs = {
  create: ImageSourceCreateInput;
  update: ImageSourceUpdateInput;
  where: ImageSourceWhereUniqueInput;
};


export type MutationUpsertImageSourceCategoryArgs = {
  create: ImageSourceCategoryCreateInput;
  update: ImageSourceCategoryUpdateInput;
  where: ImageSourceCategoryWhereUniqueInput;
};


export type MutationUpsertLiveArgs = {
  create: LiveCreateInput;
  update: LiveUpdateInput;
  where: LiveWhereUniqueInput;
};


export type MutationUpsertLivePostArgs = {
  create: LivePostCreateInput;
  update: LivePostUpdateInput;
  where: LivePostWhereUniqueInput;
};


export type MutationUpsertMachineTagArgs = {
  create: MachineTagCreateInput;
  update: MachineTagUpdateInput;
  where: MachineTagWhereUniqueInput;
};


export type MutationUpsertOpenAiProcessArgs = {
  create: OpenAiProcessCreateInput;
  update: OpenAiProcessUpdateInput;
  where: OpenAiProcessWhereUniqueInput;
};


export type MutationUpsertOrphanPageArgs = {
  create: OrphanPageCreateInput;
  update: OrphanPageUpdateInput;
  where: OrphanPageWhereUniqueInput;
};


export type MutationUpsertPromptArgs = {
  create: PromptCreateInput;
  update: PromptUpdateInput;
  where: PromptWhereUniqueInput;
};


export type MutationUpsertPushArgs = {
  create: PushCreateInput;
  update: PushUpdateInput;
  where: PushWhereUniqueInput;
};


export type MutationUpsertPushErrorArgs = {
  create: PushErrorCreateInput;
  update: PushErrorUpdateInput;
  where: PushErrorWhereUniqueInput;
};


export type MutationUpsertQualifierArgs = {
  create: QualifierCreateInput;
  update: QualifierUpdateInput;
  where: QualifierWhereUniqueInput;
};


export type MutationUpsertSegmentArgs = {
  create: SegmentCreateInput;
  update: SegmentUpdateInput;
  where: SegmentWhereUniqueInput;
};


export type MutationUpsertSourceArgs = {
  create: SourceCreateInput;
  update: SourceUpdateInput;
  where: SourceWhereUniqueInput;
};


export type MutationUpsertTabArgs = {
  create: TabCreateInput;
  update: TabUpdateInput;
  where: TabWhereUniqueInput;
};


export type MutationUpsertTagArgs = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};


export type MutationUpsertTagBrandUsageArgs = {
  create: TagBrandUsageCreateInput;
  update: TagBrandUsageUpdateInput;
  where: TagBrandUsageWhereUniqueInput;
};


export type MutationUpsertTaxonomyArgs = {
  create: TaxonomyCreateInput;
  update: TaxonomyUpdateInput;
  where: TaxonomyWhereUniqueInput;
};

export enum OpenAiProcessStatus {
  error = 'error',
  running = 'running',
  success = 'success'
}

/** Open AI Process */
export type OpenAiProcess = {
  __typename?: 'OpenAiProcess';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  article?: Maybe<Article>;
  brandKey?: Maybe<BrandKey>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  errorMsg?: Maybe<Scalars['String']['output']>;
  generatedTitle?: Maybe<Scalars['String']['output']>;
  /** The public ID, an UUID v4 */
  id?: Maybe<Scalars['ID']['output']>;
  recipeNumber?: Maybe<Scalars['Int']['output']>;
  recipePaths?: Maybe<Scalars['String']['output']>;
  slideshowSubject?: Maybe<Scalars['String']['output']>;
  status: OpenAiProcessStatus;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type OpenAiProcessCreateInput = {
  /** Actions for the "OpenAiProcess.article" relation */
  article?: InputMaybe<OpenAiProcessNestedArticleCreateInput>;
  brandKey?: InputMaybe<BrandKey>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  recipeNumber?: InputMaybe<Scalars['Int']['input']>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  status: OpenAiProcessStatus;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OpenAiProcessNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "OpenAiProcess" node, through the "OpenAiProcess.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "OpenAiProcess" node, through the "OpenAiProcess.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "OpenAiProcess" node, through the "OpenAiProcess.article" relation. */
  update?: InputMaybe<OpenAiProcessNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "OpenAiProcess" node, through the "OpenAiProcess.article" relation. */
  upsert?: InputMaybe<OpenAiProcessNestedUpsertArticleCreateInput>;
};

export type OpenAiProcessNestedArticleUpdateInput = {
  /** Connect an existing "Article" node to the existing "OpenAiProcess" node, through the "OpenAiProcess.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the existing "OpenAiProcess" node, through the "OpenAiProcess.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Disconnect the current connected "Article" node, if any, of the "OpenAiProcess.article" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Article" node and connect it to the existing "OpenAiProcess" node, through the "OpenAiProcess.article" relation. */
  update?: InputMaybe<OpenAiProcessNestedUpdateArticleUpdateInput>;
  /** Create or update a "Article" node and connect it to the existing "OpenAiProcess" node, through the "OpenAiProcess.article" relation. */
  upsert?: InputMaybe<OpenAiProcessNestedUpsertArticleUpdateInput>;
};

export type OpenAiProcessNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type OpenAiProcessNestedUpdateArticleUpdateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type OpenAiProcessNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type OpenAiProcessNestedUpsertArticleUpdateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export enum OpenAiProcessOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  errorMsg_ASC = 'errorMsg_ASC',
  errorMsg_DESC = 'errorMsg_DESC',
  generatedTitle_ASC = 'generatedTitle_ASC',
  generatedTitle_DESC = 'generatedTitle_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  recipeNumber_ASC = 'recipeNumber_ASC',
  recipeNumber_DESC = 'recipeNumber_DESC',
  recipePaths_ASC = 'recipePaths_ASC',
  recipePaths_DESC = 'recipePaths_DESC',
  slideshowSubject_ASC = 'slideshowSubject_ASC',
  slideshowSubject_DESC = 'slideshowSubject_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type OpenAiProcessUpdateInput = {
  /** Actions for the "OpenAiProcess.article" relation */
  article?: InputMaybe<OpenAiProcessNestedArticleUpdateInput>;
  brandKey?: InputMaybe<BrandKey>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  recipeNumber?: InputMaybe<Scalars['Int']['input']>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpenAiProcessStatus>;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Filters the "OpenAiProcess" nodes by specifying some conditions */
export type OpenAiProcessWhereInput = {
  AND?: InputMaybe<Array<OpenAiProcessWhereInput>>;
  NOT?: InputMaybe<OpenAiProcessWhereInput>;
  OR?: InputMaybe<Array<OpenAiProcessWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  article?: InputMaybe<ArticleWhereInput>;
  article_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<InputMaybe<BrandKey>>>;
  brandKey_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<InputMaybe<BrandKey>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  errorMsg_contains?: InputMaybe<Scalars['String']['input']>;
  errorMsg_ends_with?: InputMaybe<Scalars['String']['input']>;
  errorMsg_gt?: InputMaybe<Scalars['String']['input']>;
  errorMsg_gte?: InputMaybe<Scalars['String']['input']>;
  errorMsg_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorMsg_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  errorMsg_lt?: InputMaybe<Scalars['String']['input']>;
  errorMsg_lte?: InputMaybe<Scalars['String']['input']>;
  errorMsg_not?: InputMaybe<Scalars['String']['input']>;
  errorMsg_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorMsg_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  errorMsg_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorMsg_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMsg_starts_with?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_contains?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_gt?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_gte?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generatedTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  generatedTitle_lt?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_lte?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_not?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generatedTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  generatedTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recipeNumber?: InputMaybe<Scalars['Int']['input']>;
  recipeNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  recipeNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  recipeNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recipeNumber_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  recipeNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  recipeNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  recipeNumber_not?: InputMaybe<Scalars['Int']['input']>;
  recipeNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  recipePaths_contains?: InputMaybe<Scalars['String']['input']>;
  recipePaths_ends_with?: InputMaybe<Scalars['String']['input']>;
  recipePaths_gt?: InputMaybe<Scalars['String']['input']>;
  recipePaths_gte?: InputMaybe<Scalars['String']['input']>;
  recipePaths_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recipePaths_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  recipePaths_lt?: InputMaybe<Scalars['String']['input']>;
  recipePaths_lte?: InputMaybe<Scalars['String']['input']>;
  recipePaths_not?: InputMaybe<Scalars['String']['input']>;
  recipePaths_not_contains?: InputMaybe<Scalars['String']['input']>;
  recipePaths_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  recipePaths_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recipePaths_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipePaths_starts_with?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_contains?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_ends_with?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_gt?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_gte?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slideshowSubject_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  slideshowSubject_lt?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_lte?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_not?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_not_contains?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slideshowSubject_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpenAiProcessStatus>;
  status_in?: InputMaybe<Array<OpenAiProcessStatus>>;
  status_not?: InputMaybe<OpenAiProcessStatus>;
  status_not_in?: InputMaybe<Array<OpenAiProcessStatus>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Identifies exactly one "OpenAiProcess" node with one of these unique values:
 * - _id
 * - id
 */
export type OpenAiProcessWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type OpenAiProcessWithForcedArticleCreateInput = {
  brandKey?: InputMaybe<BrandKey>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  recipeNumber?: InputMaybe<Scalars['Int']['input']>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  status: OpenAiProcessStatus;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OpenAiProcessWithForcedArticleUpdateInput = {
  brandKey?: InputMaybe<BrandKey>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  recipeNumber?: InputMaybe<Scalars['Int']['input']>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpenAiProcessStatus>;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A OrphanPage */
export type OrphanPage = {
  __typename?: 'OrphanPage';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  brandKey: BrandKey;
  content?: Maybe<Scalars['String']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The public ID, an UUID v4 */
  id?: Maybe<Scalars['ID']['output']>;
  isAdsEnabled: Scalars['Boolean']['output'];
  isCMPEnabled: Scalars['Boolean']['output'];
  isFullScreen?: Maybe<Scalars['Boolean']['output']>;
  metas?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status: OrphanPageStatus;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};

export type OrphanPageCreateInput = {
  brandKey: BrandKey;
  content?: InputMaybe<Scalars['String']['input']>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  isAdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCMPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullScreen?: InputMaybe<Scalars['Boolean']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: OrphanPageStatus;
  title: Scalars['String']['input'];
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export enum OrphanPageOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  content_ASC = 'content_ASC',
  content_DESC = 'content_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  editedAt_ASC = 'editedAt_ASC',
  editedAt_DESC = 'editedAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isAdsEnabled_ASC = 'isAdsEnabled_ASC',
  isAdsEnabled_DESC = 'isAdsEnabled_DESC',
  isCMPEnabled_ASC = 'isCMPEnabled_ASC',
  isCMPEnabled_DESC = 'isCMPEnabled_DESC',
  isFullScreen_ASC = 'isFullScreen_ASC',
  isFullScreen_DESC = 'isFullScreen_DESC',
  metas_ASC = 'metas_ASC',
  metas_DESC = 'metas_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  uri_ASC = 'uri_ASC',
  uri_DESC = 'uri_DESC'
}

export enum OrphanPageStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type OrphanPageUpdateInput = {
  brandKey?: InputMaybe<BrandKey>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** The date, fixed, of the document's creation */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  isAdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCMPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullScreen?: InputMaybe<Scalars['Boolean']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OrphanPageStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** The date of the document's last update */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "OrphanPage" nodes by specifying some conditions */
export type OrphanPageWhereInput = {
  AND?: InputMaybe<Array<OrphanPageWhereInput>>;
  NOT?: InputMaybe<OrphanPageWhereInput>;
  OR?: InputMaybe<Array<OrphanPageWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_not?: InputMaybe<Scalars['String']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isAdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAdsEnabled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isAdsEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  isAdsEnabled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCMPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCMPEnabled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCMPEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCMPEnabled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isFullScreen?: InputMaybe<Scalars['Boolean']['input']>;
  isFullScreen_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isFullScreen_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isFullScreen_not?: InputMaybe<Scalars['Boolean']['input']>;
  isFullScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  metas?: InputMaybe<Scalars['String']['input']>;
  metas_contains?: InputMaybe<Scalars['String']['input']>;
  metas_ends_with?: InputMaybe<Scalars['String']['input']>;
  metas_gt?: InputMaybe<Scalars['String']['input']>;
  metas_gte?: InputMaybe<Scalars['String']['input']>;
  metas_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metas_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  metas_lt?: InputMaybe<Scalars['String']['input']>;
  metas_lte?: InputMaybe<Scalars['String']['input']>;
  metas_not?: InputMaybe<Scalars['String']['input']>;
  metas_not_contains?: InputMaybe<Scalars['String']['input']>;
  metas_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  metas_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metas_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  metas_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<OrphanPageStatus>;
  status_in?: InputMaybe<Array<OrphanPageStatus>>;
  status_not?: InputMaybe<OrphanPageStatus>;
  status_not_in?: InputMaybe<Array<OrphanPageStatus>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uri?: InputMaybe<Scalars['String']['input']>;
  uri_contains?: InputMaybe<Scalars['String']['input']>;
  uri_ends_with?: InputMaybe<Scalars['String']['input']>;
  uri_gt?: InputMaybe<Scalars['String']['input']>;
  uri_gte?: InputMaybe<Scalars['String']['input']>;
  uri_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uri_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  uri_lt?: InputMaybe<Scalars['String']['input']>;
  uri_lte?: InputMaybe<Scalars['String']['input']>;
  uri_not?: InputMaybe<Scalars['String']['input']>;
  uri_not_contains?: InputMaybe<Scalars['String']['input']>;
  uri_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  uri_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uri_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  uri_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Identifies exactly one "OrphanPage" node with one of these unique values:
 * - _id
 * - id
 */
export type OrphanPageWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PhotoPreview = {
  __typename?: 'PhotoPreview';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum PhotoProvider {
  Getty = 'Getty',
  Pixabay = 'Pixabay',
  Unsplash = 'Unsplash'
}

export type PhotoProviderResult = {
  __typename?: 'PhotoProviderResult';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<PhotoPreview>;
  small?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type PhotoSearchResult = {
  __typename?: 'PhotoSearchResult';
  items: Array<PhotoProviderResult>;
  /** Provider name */
  name: PhotoProvider;
};

/** A prompt for Article to generate AI title */
export type Prompt = {
  __typename?: 'Prompt';
  body: Scalars['String']['output'];
  brandKey: BrandKey;
  field: PromptField;
  /** Icon's name in the Material Design Icons set: https://fonts.google.com/icons */
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type PromptCreateInput = {
  body: Scalars['String']['input'];
  brandKey: BrandKey;
  field: PromptField;
  /** Icon's name in the Material Design Icons set: https://fonts.google.com/icons */
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export enum PromptField {
  Body = 'Body',
  Clickbait = 'Clickbait',
  DiscoverTitle = 'DiscoverTitle',
  Head = 'Head',
  Title = 'Title'
}

export enum PromptOrderByInput {
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  field_ASC = 'field_ASC',
  field_DESC = 'field_DESC',
  icon_ASC = 'icon_ASC',
  icon_DESC = 'icon_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC'
}

export type PromptUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** Icon's name in the Material Design Icons set: https://fonts.google.com/icons */
  icon?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "Prompt" nodes by specifying some conditions */
export type PromptWhereInput = {
  AND?: InputMaybe<Array<PromptWhereInput>>;
  NOT?: InputMaybe<PromptWhereInput>;
  OR?: InputMaybe<Array<PromptWhereInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_gt?: InputMaybe<Scalars['String']['input']>;
  body_gte?: InputMaybe<Scalars['String']['input']>;
  body_in?: InputMaybe<Array<Scalars['String']['input']>>;
  body_lt?: InputMaybe<Scalars['String']['input']>;
  body_lte?: InputMaybe<Scalars['String']['input']>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  field?: InputMaybe<PromptField>;
  field_in?: InputMaybe<Array<PromptField>>;
  field_not?: InputMaybe<PromptField>;
  field_not_in?: InputMaybe<Array<PromptField>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_ends_with?: InputMaybe<Scalars['String']['input']>;
  icon_gt?: InputMaybe<Scalars['String']['input']>;
  icon_gte?: InputMaybe<Scalars['String']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  icon_lt?: InputMaybe<Scalars['String']['input']>;
  icon_lte?: InputMaybe<Scalars['String']['input']>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_gt?: InputMaybe<Scalars['String']['input']>;
  label_gte?: InputMaybe<Scalars['String']['input']>;
  label_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_lt?: InputMaybe<Scalars['String']['input']>;
  label_lte?: InputMaybe<Scalars['String']['input']>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "Prompt" node. */
export type PromptWhereUniqueInput = {
  brandKey: BrandKey;
  field: PromptField;
  label: Scalars['String']['input'];
};

/** A push */
export type Push = {
  __typename?: 'Push';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  article: Article;
  body: Scalars['String']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The reason of the error */
  errorReason?: Maybe<Scalars['String']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** Define if the push is in error */
  inError?: Maybe<Scalars['Boolean']['output']>;
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  media: Scalars['String']['output'];
  /** "PushSegment.push"'s inverse relation count */
  pushSegmentCount: Scalars['Int']['output'];
  /** "PushSegment.push"'s inverse relation */
  pushSegments: Array<PushSegment>;
  scheduledAt: Scalars['DateTime']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  targetDevice: Scalars['String']['output'];
  targeting?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};


/** A push */
export type PushPushSegmentCountArgs = {
  where?: InputMaybe<PushSegmentWhereInput>;
};


/** A push */
export type PushPushSegmentsArgs = {
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushSegmentWhereInput>;
};

export type PushCreateInput = {
  /** Actions for the "Push.article" relation */
  article: PushNestedArticleCreateInput;
  body: Scalars['String']['input'];
  /** The reason of the error */
  errorReason?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Define if the push is in error */
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  media: Scalars['String']['input'];
  /** Actions for the "Push.pushSegments" relation: "PushSegment.push"'s inverse relation */
  pushSegments?: InputMaybe<PushNestedPushSegmentsCreateInput>;
  scheduledAt: Scalars['DateTime']['input'];
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetDevice: Scalars['String']['input'];
  targeting?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** A Push in error */
export type PushError = {
  __typename?: 'PushError';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type PushErrorCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum PushErrorOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  reason_ASC = 'reason_ASC',
  reason_DESC = 'reason_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PushErrorUpdateInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "PushError" nodes by specifying some conditions */
export type PushErrorWhereInput = {
  AND?: InputMaybe<Array<PushErrorWhereInput>>;
  NOT?: InputMaybe<PushErrorWhereInput>;
  OR?: InputMaybe<Array<PushErrorWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_contains?: InputMaybe<Scalars['String']['input']>;
  reason_ends_with?: InputMaybe<Scalars['String']['input']>;
  reason_gt?: InputMaybe<Scalars['String']['input']>;
  reason_gte?: InputMaybe<Scalars['String']['input']>;
  reason_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reason_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  reason_lt?: InputMaybe<Scalars['String']['input']>;
  reason_lte?: InputMaybe<Scalars['String']['input']>;
  reason_not?: InputMaybe<Scalars['String']['input']>;
  reason_not_contains?: InputMaybe<Scalars['String']['input']>;
  reason_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  reason_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reason_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  reason_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "PushError" node with one of these unique values:
 * - _id
 * - id
 */
export type PushErrorWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PushNestedArticleCreateInput = {
  /** Connect an existing "Article" node to the new "Push" node, through the "Push.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the new "Push" node, through the "Push.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the new "Push" node, through the "Push.article" relation. */
  update?: InputMaybe<PushNestedUpdateArticleCreateInput>;
  /** Create or update a "Article" node and connect it to the new "Push" node, through the "Push.article" relation. */
  upsert?: InputMaybe<PushNestedUpsertArticleCreateInput>;
};

export type PushNestedArticleUpdateInput = {
  /** Connect an existing "Article" node to the existing "Push" node, through the "Push.article" relation. */
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  /** Create a new "Article" node and connect it to the existing "Push" node, through the "Push.article" relation. */
  create?: InputMaybe<ArticleCreateInput>;
  /** Update an existing "Article" node and connect it to the existing "Push" node, through the "Push.article" relation. */
  update?: InputMaybe<PushNestedUpdateArticleUpdateInput>;
  /** Create or update a "Article" node and connect it to the existing "Push" node, through the "Push.article" relation. */
  upsert?: InputMaybe<PushNestedUpsertArticleUpdateInput>;
};

export type PushNestedPushSegmentsCreateInput = {
  /** Create new "PushSegment" nodes and connect them to the new "Push" node, through the "Push.pushSegments" relation. */
  create?: InputMaybe<Array<PushSegmentWithForcedPushCreateInput>>;
};

export type PushNestedPushSegmentsUpdateInput = {
  /** Create new "PushSegment" nodes and connect them to the existing "Push" node, through the "Push.pushSegments" relation. */
  create?: InputMaybe<Array<PushSegmentWithForcedPushCreateInput>>;
  /** Delete existing "PushSegment" nodes from the "Push.pushSegments" relation. */
  delete?: InputMaybe<Array<PushSegmentWithForcedPushWhereUniqueInput>>;
};

export type PushNestedUpdateArticleCreateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type PushNestedUpdateArticleUpdateInput = {
  data: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type PushNestedUpsertArticleCreateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type PushNestedUpsertArticleUpdateInput = {
  create: ArticleCreateInput;
  update: ArticleUpdateInput;
  where: ArticleWhereUniqueInput;
};

export enum PushOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  errorReason_ASC = 'errorReason_ASC',
  errorReason_DESC = 'errorReason_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  inError_ASC = 'inError_ASC',
  inError_DESC = 'inError_DESC',
  isCancelled_ASC = 'isCancelled_ASC',
  isCancelled_DESC = 'isCancelled_DESC',
  media_ASC = 'media_ASC',
  media_DESC = 'media_DESC',
  scheduledAt_ASC = 'scheduledAt_ASC',
  scheduledAt_DESC = 'scheduledAt_DESC',
  sentAt_ASC = 'sentAt_ASC',
  sentAt_DESC = 'sentAt_DESC',
  targetDevice_ASC = 'targetDevice_ASC',
  targetDevice_DESC = 'targetDevice_DESC',
  targeting_ASC = 'targeting_ASC',
  targeting_DESC = 'targeting_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

export type PushPushesSearchWhereInput = {
  AND?: InputMaybe<Array<PushPushesSearchWhereInput>>;
  NOT?: InputMaybe<PushPushesSearchWhereInput>;
  OR?: InputMaybe<Array<PushPushesSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sentAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

/** A pushSegment */
export type PushSegment = {
  __typename?: 'PushSegment';
  push: Push;
  segment: Segment;
};

export type PushSegmentCreateInput = {
  /** Actions for the "PushSegment.push" relation */
  push: PushSegmentNestedPushCreateInput;
  /** Actions for the "PushSegment.segment" relation */
  segment: PushSegmentNestedSegmentCreateInput;
};

export type PushSegmentNestedPushCreateInput = {
  /** Connect an existing "Push" node to the new "PushSegment" node, through the "PushSegment.push" relation. */
  connect?: InputMaybe<PushWhereUniqueInput>;
  /** Create a new "Push" node and connect it to the new "PushSegment" node, through the "PushSegment.push" relation. */
  create?: InputMaybe<PushCreateInput>;
  /** Update an existing "Push" node and connect it to the new "PushSegment" node, through the "PushSegment.push" relation. */
  update?: InputMaybe<PushSegmentNestedUpdatePushCreateInput>;
  /** Create or update a "Push" node and connect it to the new "PushSegment" node, through the "PushSegment.push" relation. */
  upsert?: InputMaybe<PushSegmentNestedUpsertPushCreateInput>;
};

export type PushSegmentNestedSegmentCreateInput = {
  /** Connect an existing "Segment" node to the new "PushSegment" node, through the "PushSegment.segment" relation. */
  connect?: InputMaybe<SegmentWhereUniqueInput>;
  /** Create a new "Segment" node and connect it to the new "PushSegment" node, through the "PushSegment.segment" relation. */
  create?: InputMaybe<SegmentCreateInput>;
  /** Update an existing "Segment" node and connect it to the new "PushSegment" node, through the "PushSegment.segment" relation. */
  update?: InputMaybe<PushSegmentNestedUpdateSegmentCreateInput>;
  /** Create or update a "Segment" node and connect it to the new "PushSegment" node, through the "PushSegment.segment" relation. */
  upsert?: InputMaybe<PushSegmentNestedUpsertSegmentCreateInput>;
};

export type PushSegmentNestedUpdatePushCreateInput = {
  data: PushUpdateInput;
  where: PushWhereUniqueInput;
};

export type PushSegmentNestedUpdateSegmentCreateInput = {
  data: SegmentUpdateInput;
  where: SegmentWhereUniqueInput;
};

export type PushSegmentNestedUpsertPushCreateInput = {
  create: PushCreateInput;
  update: PushUpdateInput;
  where: PushWhereUniqueInput;
};

export type PushSegmentNestedUpsertSegmentCreateInput = {
  create: SegmentCreateInput;
  update: SegmentUpdateInput;
  where: SegmentWhereUniqueInput;
};

/** Filters the "PushSegment" nodes by specifying some conditions */
export type PushSegmentWhereInput = {
  AND?: InputMaybe<Array<PushSegmentWhereInput>>;
  NOT?: InputMaybe<PushSegmentWhereInput>;
  OR?: InputMaybe<Array<PushSegmentWhereInput>>;
  push?: InputMaybe<PushWhereInput>;
  segment?: InputMaybe<SegmentWhereInput>;
};

/** Identifies exactly one "PushSegment" node. */
export type PushSegmentWhereUniqueInput = {
  push: PushWhereUniqueInput;
  segment: SegmentWhereUniqueInput;
};

export type PushSegmentWithForcedPushCreateInput = {
  /** Actions for the "PushSegment.segment" relation */
  segment: PushSegmentNestedSegmentCreateInput;
};

/** Given a forced "push", identifies exactly one "PushSegment" node. */
export type PushSegmentWithForcedPushWhereUniqueInput = {
  segment: SegmentWhereUniqueInput;
};

export type PushSegmentWithForcedSegmentCreateInput = {
  /** Actions for the "PushSegment.push" relation */
  push: PushSegmentNestedPushCreateInput;
};

/** Given a forced "segment", identifies exactly one "PushSegment" node. */
export type PushSegmentWithForcedSegmentWhereUniqueInput = {
  push: PushWhereUniqueInput;
};

export type PushUpdateInput = {
  /** Actions for the "Push.article" relation */
  article?: InputMaybe<PushNestedArticleUpdateInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** The reason of the error */
  errorReason?: InputMaybe<Scalars['String']['input']>;
  /** Define if the push is in error */
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Push.pushSegments" relation: "PushSegment.push"'s inverse relation */
  pushSegments?: InputMaybe<PushNestedPushSegmentsUpdateInput>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetDevice?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filters the "Push" nodes by specifying some conditions */
export type PushWhereInput = {
  AND?: InputMaybe<Array<PushWhereInput>>;
  NOT?: InputMaybe<PushWhereInput>;
  OR?: InputMaybe<Array<PushWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  article?: InputMaybe<ArticleWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_gt?: InputMaybe<Scalars['String']['input']>;
  body_gte?: InputMaybe<Scalars['String']['input']>;
  body_in?: InputMaybe<Array<Scalars['String']['input']>>;
  body_lt?: InputMaybe<Scalars['String']['input']>;
  body_lte?: InputMaybe<Scalars['String']['input']>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  errorReason?: InputMaybe<Scalars['String']['input']>;
  errorReason_contains?: InputMaybe<Scalars['String']['input']>;
  errorReason_ends_with?: InputMaybe<Scalars['String']['input']>;
  errorReason_gt?: InputMaybe<Scalars['String']['input']>;
  errorReason_gte?: InputMaybe<Scalars['String']['input']>;
  errorReason_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorReason_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  errorReason_lt?: InputMaybe<Scalars['String']['input']>;
  errorReason_lte?: InputMaybe<Scalars['String']['input']>;
  errorReason_not?: InputMaybe<Scalars['String']['input']>;
  errorReason_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorReason_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  errorReason_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorReason_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorReason_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  inError_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  inError_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  inError_not?: InputMaybe<Scalars['Boolean']['input']>;
  inError_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isCancelled_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  media?: InputMaybe<Scalars['String']['input']>;
  media_contains?: InputMaybe<Scalars['String']['input']>;
  media_ends_with?: InputMaybe<Scalars['String']['input']>;
  media_gt?: InputMaybe<Scalars['String']['input']>;
  media_gte?: InputMaybe<Scalars['String']['input']>;
  media_in?: InputMaybe<Array<Scalars['String']['input']>>;
  media_lt?: InputMaybe<Scalars['String']['input']>;
  media_lte?: InputMaybe<Scalars['String']['input']>;
  media_not?: InputMaybe<Scalars['String']['input']>;
  media_not_contains?: InputMaybe<Scalars['String']['input']>;
  media_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  media_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  media_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  media_starts_with?: InputMaybe<Scalars['String']['input']>;
  pushSegments_some?: InputMaybe<PushSegmentWhereInput>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  scheduledAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sentAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  targetDevice?: InputMaybe<Scalars['String']['input']>;
  targetDevice_contains?: InputMaybe<Scalars['String']['input']>;
  targetDevice_ends_with?: InputMaybe<Scalars['String']['input']>;
  targetDevice_gt?: InputMaybe<Scalars['String']['input']>;
  targetDevice_gte?: InputMaybe<Scalars['String']['input']>;
  targetDevice_in?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDevice_lt?: InputMaybe<Scalars['String']['input']>;
  targetDevice_lte?: InputMaybe<Scalars['String']['input']>;
  targetDevice_not?: InputMaybe<Scalars['String']['input']>;
  targetDevice_not_contains?: InputMaybe<Scalars['String']['input']>;
  targetDevice_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  targetDevice_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  targetDevice_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  targetDevice_starts_with?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<Scalars['String']['input']>;
  targeting_contains?: InputMaybe<Scalars['String']['input']>;
  targeting_ends_with?: InputMaybe<Scalars['String']['input']>;
  targeting_gt?: InputMaybe<Scalars['String']['input']>;
  targeting_gte?: InputMaybe<Scalars['String']['input']>;
  targeting_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targeting_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  targeting_lt?: InputMaybe<Scalars['String']['input']>;
  targeting_lte?: InputMaybe<Scalars['String']['input']>;
  targeting_not?: InputMaybe<Scalars['String']['input']>;
  targeting_not_contains?: InputMaybe<Scalars['String']['input']>;
  targeting_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  targeting_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targeting_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  targeting_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Identifies exactly one "Push" node with one of these unique values:
 * - _id
 * - id
 */
export type PushWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PushWithForcedArticleCreateInput = {
  body: Scalars['String']['input'];
  /** The reason of the error */
  errorReason?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Define if the push is in error */
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  media: Scalars['String']['input'];
  /** Actions for the "Push.pushSegments" relation: "PushSegment.push"'s inverse relation */
  pushSegments?: InputMaybe<PushNestedPushSegmentsCreateInput>;
  scheduledAt: Scalars['DateTime']['input'];
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetDevice: Scalars['String']['input'];
  targeting?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type PushWithForcedArticleUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** The reason of the error */
  errorReason?: InputMaybe<Scalars['String']['input']>;
  /** Define if the push is in error */
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Push.pushSegments" relation: "PushSegment.push"'s inverse relation */
  pushSegments?: InputMaybe<PushNestedPushSegmentsUpdateInput>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetDevice?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** A qualifier */
export type Qualifier = {
  __typename?: 'Qualifier';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "ArticleQualifier.qualifier"'s inverse relation count */
  articleQualifierCount: Scalars['Int']['output'];
  /** "ArticleQualifier.qualifier"'s inverse relation */
  articleQualifiers: Array<ArticleQualifier>;
  brandKey: BrandKey;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  format: ArticleFormat;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  status: QualifierStatus;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** A qualifier */
export type QualifierArticleQualifierCountArgs = {
  where?: InputMaybe<ArticleQualifierWhereInput>;
};


/** A qualifier */
export type QualifierArticleQualifiersArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleQualifierOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleQualifierWhereInput>;
};

export type QualifierArticleQualifiersQualifierSearchWhereInput = {
  AND?: InputMaybe<Array<QualifierArticleQualifiersQualifierSearchWhereInput>>;
  NOT?: InputMaybe<QualifierArticleQualifiersQualifierSearchWhereInput>;
  OR?: InputMaybe<Array<QualifierArticleQualifiersQualifierSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export type QualifierCreateInput = {
  /** Actions for the "Qualifier.articleQualifiers" relation: "ArticleQualifier.qualifier"'s inverse relation */
  articleQualifiers?: InputMaybe<QualifierNestedArticleQualifiersCreateInput>;
  brandKey: BrandKey;
  format?: InputMaybe<ArticleFormat>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QualifierStatus>;
  title: Scalars['String']['input'];
};

export type QualifierNestedArticleQualifiersCreateInput = {
  /** Create new "ArticleQualifier" nodes and connect them to the new "Qualifier" node, through the "Qualifier.articleQualifiers" relation. */
  create?: InputMaybe<Array<ArticleQualifierWithForcedQualifierCreateInput>>;
};

export type QualifierNestedArticleQualifiersUpdateInput = {
  /** Create new "ArticleQualifier" nodes and connect them to the existing "Qualifier" node, through the "Qualifier.articleQualifiers" relation. */
  create?: InputMaybe<Array<ArticleQualifierWithForcedQualifierCreateInput>>;
  /** Delete existing "ArticleQualifier" nodes from the "Qualifier.articleQualifiers" relation. */
  delete?: InputMaybe<Array<ArticleQualifierWithForcedQualifierWhereUniqueInput>>;
  /** Update existing "ArticleQualifier" nodes and connect them to the existing "Qualifier" node, through the "Qualifier.articleQualifiers" relation. */
  update?: InputMaybe<Array<QualifierNestedUpdateArticleQualifiersUpdateInput>>;
  /** Upsert existing "ArticleQualifier" nodes and connect them to the existing "Qualifier" node, through the "Qualifier.articleQualifiers" relation. */
  upsert?: InputMaybe<Array<QualifierNestedUpsertArticleQualifiersUpdateInput>>;
};

export type QualifierNestedUpdateArticleQualifiersUpdateInput = {
  data: ArticleQualifierWithForcedQualifierUpdateInput;
  where: ArticleQualifierWithForcedQualifierWhereUniqueInput;
};

export type QualifierNestedUpsertArticleQualifiersUpdateInput = {
  create: ArticleQualifierWithForcedQualifierCreateInput;
  update: ArticleQualifierWithForcedQualifierUpdateInput;
  where: ArticleQualifierWithForcedQualifierWhereUniqueInput;
};

export enum QualifierOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  format_ASC = 'format_ASC',
  format_DESC = 'format_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum QualifierStatus {
  Draft = 'Draft',
  Published = 'Published'
}

export type QualifierUpdateInput = {
  /** Actions for the "Qualifier.articleQualifiers" relation: "ArticleQualifier.qualifier"'s inverse relation */
  articleQualifiers?: InputMaybe<QualifierNestedArticleQualifiersUpdateInput>;
  format?: InputMaybe<ArticleFormat>;
  status?: InputMaybe<QualifierStatus>;
};

/** Filters the "Qualifier" nodes by specifying some conditions */
export type QualifierWhereInput = {
  AND?: InputMaybe<Array<QualifierWhereInput>>;
  NOT?: InputMaybe<QualifierWhereInput>;
  OR?: InputMaybe<Array<QualifierWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleQualifiers_some?: InputMaybe<ArticleQualifierWhereInput>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  format?: InputMaybe<ArticleFormat>;
  format_in?: InputMaybe<Array<ArticleFormat>>;
  format_not?: InputMaybe<ArticleFormat>;
  format_not_in?: InputMaybe<Array<ArticleFormat>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QualifierStatus>;
  status_in?: InputMaybe<Array<QualifierStatus>>;
  status_not?: InputMaybe<QualifierStatus>;
  status_not_in?: InputMaybe<Array<QualifierStatus>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Qualifier" node with one of these unique combinations of values:
 * - _id
 * - id
 * - brandKey, format, slug
 * - brandKey, format, title
 */
export type QualifierWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  format?: InputMaybe<ArticleFormat>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single "Article" node. */
  article?: Maybe<Article>;
  /** Retrieve a single "ArticleAuthor" node. */
  articleAuthor?: Maybe<ArticleAuthor>;
  /** Retrieve the number of "ArticleAuthor" nodes. */
  articleAuthorCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleAuthor" nodes. */
  articleAuthors: Array<ArticleAuthor>;
  /** Retrieve a list of "ArticleCategory" nodes. */
  articleCategories: Array<ArticleCategory>;
  /** Retrieve a single "ArticleCategory" node. */
  articleCategory?: Maybe<ArticleCategory>;
  /** Retrieve the number of "ArticleCategory" nodes. */
  articleCategoryCount: Scalars['Int']['output'];
  /** Retrieve a single "ArticleChannel" node. */
  articleChannel?: Maybe<ArticleChannel>;
  /** Retrieve the number of "ArticleChannel" nodes. */
  articleChannelCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleChannel" nodes. */
  articleChannels: Array<ArticleChannel>;
  /** Retrieve the number of "Article" nodes. */
  articleCount: Scalars['Int']['output'];
  /** Retrieve a single "ArticleCreatorData" node. */
  articleCreatorData?: Maybe<ArticleCreatorData>;
  /** Retrieve the number of "ArticleCreatorData" nodes. */
  articleCreatorDataCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleCreatorData" nodes. */
  articleCreatorDatas: Array<ArticleCreatorData>;
  /** Retrieve a single "ArticleEvent" node. */
  articleEvent?: Maybe<ArticleEvent>;
  /** Retrieve the number of "ArticleEvent" nodes. */
  articleEventCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleEvent" nodes. */
  articleEvents: Array<ArticleEvent>;
  /** Retrieve a single "ArticleExtension" node. */
  articleExtension?: Maybe<ArticleExtension>;
  /** Retrieve the number of "ArticleExtension" nodes. */
  articleExtensionCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleExtension" nodes. */
  articleExtensions: Array<ArticleExtension>;
  /** Retrieve a single "ArticleGoodDealAIPrompt" node. */
  articleGoodDealAIPrompt?: Maybe<ArticleGoodDealAiPrompt>;
  /** Retrieve the number of "ArticleGoodDealAIPrompt" nodes. */
  articleGoodDealAIPromptCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleGoodDealAIPrompt" nodes. */
  articleGoodDealAIPrompts: Array<ArticleGoodDealAiPrompt>;
  /** Retrieve a single "ArticleGoodDealAiProcess" node. */
  articleGoodDealAiProcess?: Maybe<ArticleGoodDealAiProcess>;
  /** Retrieve the number of "ArticleGoodDealAiProcess" nodes. */
  articleGoodDealAiProcessCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleGoodDealAiProcess" nodes. */
  articleGoodDealAiProcesses: Array<ArticleGoodDealAiProcess>;
  /** Retrieve a single "ArticleGuide" node. */
  articleGuide?: Maybe<ArticleGuide>;
  /** Retrieve the number of "ArticleGuide" nodes. */
  articleGuideCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleGuide" nodes. */
  articleGuides: Array<ArticleGuide>;
  /** Retrieve a list of "ArticleHistory" nodes. */
  articleHistories: Array<ArticleHistory>;
  /** Retrieve a single "ArticleHistory" node. */
  articleHistory?: Maybe<ArticleHistory>;
  /** Retrieve the number of "ArticleHistory" nodes. */
  articleHistoryCount: Scalars['Int']['output'];
  /** Retrieve a single "ArticleMachineTag" node. */
  articleMachineTag?: Maybe<ArticleMachineTag>;
  /** Retrieve the number of "ArticleMachineTag" nodes. */
  articleMachineTagCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleMachineTag" nodes. */
  articleMachineTags: Array<ArticleMachineTag>;
  /** Retrieve a single "ArticleQualifier" node. */
  articleQualifier?: Maybe<ArticleQualifier>;
  /** Retrieve the number of "ArticleQualifier" nodes. */
  articleQualifierCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleQualifier" nodes. */
  articleQualifiers: Array<ArticleQualifier>;
  /** Retrieve a single "ArticleTag" node. */
  articleTag?: Maybe<ArticleTag>;
  /** Retrieve the number of "ArticleTag" nodes. */
  articleTagCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleTag" nodes. */
  articleTags: Array<ArticleTag>;
  /** Retrieve a list of "ArticleTaxonomy" nodes. */
  articleTaxonomies: Array<ArticleTaxonomy>;
  /** Retrieve a single "ArticleTaxonomy" node. */
  articleTaxonomy?: Maybe<ArticleTaxonomy>;
  /** Retrieve the number of "ArticleTaxonomy" nodes. */
  articleTaxonomyCount: Scalars['Int']['output'];
  /** Retrieve a single "ArticleUrl" node. */
  articleUrl?: Maybe<ArticleUrl>;
  /** Retrieve the number of "ArticleUrl" nodes. */
  articleUrlCount: Scalars['Int']['output'];
  /** Retrieve a single "ArticleUrlPublicId" node. */
  articleUrlPublicId?: Maybe<ArticleUrlPublicId>;
  /** Retrieve the number of "ArticleUrlPublicId" nodes. */
  articleUrlPublicIdCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleUrlPublicId" nodes. */
  articleUrlPublicIds: Array<ArticleUrlPublicId>;
  /** Retrieve a list of "ArticleUrl" nodes. */
  articleUrls: Array<ArticleUrl>;
  /** Retrieve a single "ArticleUser" node. */
  articleUser?: Maybe<ArticleUser>;
  /** Retrieve the number of "ArticleUser" nodes. */
  articleUserCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArticleUser" nodes. */
  articleUsers: Array<ArticleUser>;
  /** Retrieve a list of "Article" nodes. */
  articles: Array<Article>;
  /** Retrieve a single "Attribute" node. */
  attribute?: Maybe<Attribute>;
  /** Retrieve the number of "Attribute" nodes. */
  attributeCount: Scalars['Int']['output'];
  /** Retrieve a list of "Attribute" nodes. */
  attributes: Array<Attribute>;
  /** Retrieve a single "Author" node. */
  author?: Maybe<Author>;
  /** Retrieve a single "AuthorAttribute" node. */
  authorAttribute?: Maybe<AuthorAttribute>;
  /** Retrieve the number of "AuthorAttribute" nodes. */
  authorAttributeCount: Scalars['Int']['output'];
  /** Retrieve a list of "AuthorAttribute" nodes. */
  authorAttributes: Array<AuthorAttribute>;
  /** Retrieve the number of "Author" nodes. */
  authorCount: Scalars['Int']['output'];
  /** Retrieve a list of "AuthorHistory" nodes. */
  authorHistories: Array<AuthorHistory>;
  /** Retrieve a single "AuthorHistory" node. */
  authorHistory?: Maybe<AuthorHistory>;
  /** Retrieve the number of "AuthorHistory" nodes. */
  authorHistoryCount: Scalars['Int']['output'];
  /** Retrieve a list of "Author" nodes. */
  authors: Array<Author>;
  /** Retrieve a single "Card" node. */
  card?: Maybe<Card>;
  /** Retrieve a list of "CardCategory" nodes. */
  cardCategories: Array<CardCategory>;
  /** Retrieve a single "CardCategory" node. */
  cardCategory?: Maybe<CardCategory>;
  /** Retrieve the number of "CardCategory" nodes. */
  cardCategoryCount: Scalars['Int']['output'];
  /** Retrieve the number of "Card" nodes. */
  cardCount: Scalars['Int']['output'];
  /** Retrieve a single "CardTag" node. */
  cardTag?: Maybe<CardTag>;
  /** Retrieve the number of "CardTag" nodes. */
  cardTagCount: Scalars['Int']['output'];
  /** Retrieve a list of "CardTag" nodes. */
  cardTags: Array<CardTag>;
  /** Retrieve a list of "Card" nodes. */
  cards: Array<Card>;
  /** Retrieve a list of "Category" nodes. */
  categories: Array<Category>;
  /** Retrieve a single "Category" node. */
  category?: Maybe<Category>;
  /** Retrieve the number of "Category" nodes. */
  categoryCount: Scalars['Int']['output'];
  /** Retrieve a list of "CategoryHistory" nodes. */
  categoryHistories: Array<CategoryHistory>;
  /** Retrieve a single "CategoryHistory" node. */
  categoryHistory?: Maybe<CategoryHistory>;
  /** Retrieve the number of "CategoryHistory" nodes. */
  categoryHistoryCount: Scalars['Int']['output'];
  /** Retrieve a single "CategoryUrlPublicId" node. */
  categoryUrlPublicId?: Maybe<CategoryUrlPublicId>;
  /** Retrieve the number of "CategoryUrlPublicId" nodes. */
  categoryUrlPublicIdCount: Scalars['Int']['output'];
  /** Retrieve a list of "CategoryUrlPublicId" nodes. */
  categoryUrlPublicIds: Array<CategoryUrlPublicId>;
  /** Retrieve a single "DailymotionLog" node. */
  dailymotionLog?: Maybe<DailymotionLog>;
  /** Retrieve the number of "DailymotionLog" nodes. */
  dailymotionLogCount: Scalars['Int']['output'];
  /** Retrieve a list of "DailymotionLog" nodes. */
  dailymotionLogs: Array<DailymotionLog>;
  /** Retrieve a single "DailymotionMigration" node. */
  dailymotionMigration?: Maybe<DailymotionMigration>;
  /** Retrieve the number of "DailymotionMigration" nodes. */
  dailymotionMigrationCount: Scalars['Int']['output'];
  /** Retrieve a list of "DailymotionMigration" nodes. */
  dailymotionMigrations: Array<DailymotionMigration>;
  /** dailymotion upload url */
  dailymotionUploadURL: Array<DailymotionUploadUrlResult>;
  /** Get one campaign by brandKey and TargetDevices */
  getCampaign?: Maybe<GetCampaignResult>;
  /** List campaigns by brandKey and TargetDevices */
  getCampaigns?: Maybe<Array<Maybe<GetCampaignsResult>>>;
  /** affiliate cerise v2 */
  getCeriseAffiliationEmbed: CeriseAffiliationEmbedResult;
  /** List segmentations by brandKey and TargetDevices */
  getSegmentations?: Maybe<Array<Maybe<GetSegmentations>>>;
  /** List segmentations by brandKey and TargetDevices */
  getVertexAIRecipes?: Maybe<VertexAiRecipesResultType>;
  /** Retrieve a single "ImageSource" node. */
  imageSource?: Maybe<ImageSource>;
  /** Retrieve a list of "ImageSourceCategory" nodes. */
  imageSourceCategories: Array<ImageSourceCategory>;
  /** Retrieve a single "ImageSourceCategory" node. */
  imageSourceCategory?: Maybe<ImageSourceCategory>;
  /** Retrieve the number of "ImageSourceCategory" nodes. */
  imageSourceCategoryCount: Scalars['Int']['output'];
  /** Retrieve the number of "ImageSource" nodes. */
  imageSourceCount: Scalars['Int']['output'];
  /** Retrieve a list of "ImageSource" nodes. */
  imageSources: Array<ImageSource>;
  /** Retrieve a single "Live" node. */
  live?: Maybe<Live>;
  /** Retrieve the number of "Live" nodes. */
  liveCount: Scalars['Int']['output'];
  /** Retrieve a single "LivePost" node. */
  livePost?: Maybe<LivePost>;
  /** Retrieve the number of "LivePost" nodes. */
  livePostCount: Scalars['Int']['output'];
  /** Retrieve a list of "LivePost" nodes. */
  livePosts: Array<LivePost>;
  /** Retrieve a list of "Live" nodes. */
  lives: Array<Live>;
  /** Retrieve a single "MachineTag" node. */
  machineTag?: Maybe<MachineTag>;
  /** Retrieve the number of "MachineTag" nodes. */
  machineTagCount: Scalars['Int']['output'];
  /** Retrieve a list of "MachineTag" nodes. */
  machineTags: Array<MachineTag>;
  /** Retrieve a single "OpenAiProcess" node. */
  openAiProcess?: Maybe<OpenAiProcess>;
  /** Retrieve the number of "OpenAiProcess" nodes. */
  openAiProcessCount: Scalars['Int']['output'];
  /** Retrieve a list of "OpenAiProcess" nodes. */
  openAiProcesses: Array<OpenAiProcess>;
  /** Retrieve a single "OrphanPage" node. */
  orphanPage?: Maybe<OrphanPage>;
  /** Retrieve the number of "OrphanPage" nodes. */
  orphanPageCount: Scalars['Int']['output'];
  /** Retrieve a list of "OrphanPage" nodes. */
  orphanPages: Array<OrphanPage>;
  /** Retrieve a single "Prompt" node. */
  prompt?: Maybe<Prompt>;
  /** Retrieve the number of "Prompt" nodes. */
  promptCount: Scalars['Int']['output'];
  /** Retrieve a list of "Prompt" nodes. */
  prompts: Array<Prompt>;
  /** Retrieve a single "Push" node. */
  push?: Maybe<Push>;
  /** Retrieve the number of "Push" nodes. */
  pushCount: Scalars['Int']['output'];
  /** Retrieve a single "PushError" node. */
  pushError?: Maybe<PushError>;
  /** Retrieve the number of "PushError" nodes. */
  pushErrorCount: Scalars['Int']['output'];
  /** Retrieve a list of "PushError" nodes. */
  pushErrors: Array<PushError>;
  /** Retrieve a single "PushSegment" node. */
  pushSegment?: Maybe<PushSegment>;
  /** Retrieve the number of "PushSegment" nodes. */
  pushSegmentCount: Scalars['Int']['output'];
  /** Retrieve a list of "PushSegment" nodes. */
  pushSegments: Array<PushSegment>;
  /** Retrieve a list of "Push" nodes. */
  pushes: Array<Push>;
  /** Retrieve a single "Qualifier" node. */
  qualifier?: Maybe<Qualifier>;
  /** Retrieve the number of "Qualifier" nodes. */
  qualifierCount: Scalars['Int']['output'];
  /** Retrieve a list of "Qualifier" nodes. */
  qualifiers: Array<Qualifier>;
  /** Affilizz search query */
  searchAffiliationProduct: SearchAffilizzProductResult;
  /** Affilizz design search query */
  searchAffilliationDesign: Array<SearchAffilizzDesignResult>;
  /** Count articles using ElasticSearch */
  searchArticleCount: Scalars['Int']['output'];
  /** Search articles using ElasticSearch */
  searchArticles: Array<Article>;
  /** Search "tags" across the different services */
  searchEnabledTags: Array<TagSearchResult>;
  /** Count Media Elements in an Articles */
  searchMediaArticleCount: Array<Maybe<SearchMediaArticleCountResultType>>;
  /** Search "tags" for Newsletter Front */
  searchNewsletterTags: Array<TagNewsletterSearchResult>;
  /** Search images by providers */
  searchPhotosByProviders: Array<PhotoSearchResult>;
  /** Retrieve a single "Segment" node. */
  segment?: Maybe<Segment>;
  /** Retrieve the number of "Segment" nodes. */
  segmentCount: Scalars['Int']['output'];
  /** Retrieve a list of "Segment" nodes. */
  segments: Array<Segment>;
  /** Retrieve a single "Source" node. */
  source?: Maybe<Source>;
  /** Retrieve the number of "Source" nodes. */
  sourceCount: Scalars['Int']['output'];
  /** Retrieve a list of "Source" nodes. */
  sources: Array<Source>;
  /** Search similar articles */
  suggestArticles?: Maybe<ArticleSuggestionResult>;
  /** Search category used in similar articles */
  suggestCategories: CategorySuggestionResult;
  /** Suggest tags used in similar articles */
  suggestTags?: Maybe<TagSuggestResult>;
  /** Retrieve a single "Tab" node. */
  tab?: Maybe<Tab>;
  /** Retrieve the number of "Tab" nodes. */
  tabCount: Scalars['Int']['output'];
  /** Retrieve a list of "Tab" nodes. */
  tabs: Array<Tab>;
  /** Retrieve a single "Tag" node. */
  tag?: Maybe<Tag>;
  /** Retrieve a single "TagBrandUsage" node. */
  tagBrandUsage?: Maybe<TagBrandUsage>;
  /** Retrieve the number of "TagBrandUsage" nodes. */
  tagBrandUsageCount: Scalars['Int']['output'];
  /** Retrieve a list of "TagBrandUsage" nodes. */
  tagBrandUsages: Array<TagBrandUsage>;
  /** Retrieve the number of "Tag" nodes. */
  tagCount: Scalars['Int']['output'];
  /** Retrieve a list of "Tag" nodes. */
  tags: Array<Tag>;
  /** Retrieve a list of "Taxonomy" nodes. */
  taxonomies: Array<Taxonomy>;
  /** Retrieve a single "Taxonomy" node. */
  taxonomy?: Maybe<Taxonomy>;
  /** Retrieve the number of "Taxonomy" nodes. */
  taxonomyCount: Scalars['Int']['output'];
  /** Translate article */
  translateArticle?: Maybe<TranslateArticleType>;
  /** Retrieve a single "Url" node. */
  url?: Maybe<Url>;
  /** Retrieve the number of "Url" nodes. */
  urlCount: Scalars['Int']['output'];
  /** Retrieve a list of "Url" nodes. */
  urls: Array<Url>;
};


export type QueryArticleArgs = {
  where: ArticleWhereUniqueInput;
};


export type QueryArticleAuthorArgs = {
  where: ArticleAuthorWhereUniqueInput;
};


export type QueryArticleAuthorCountArgs = {
  where?: InputMaybe<ArticleAuthorWhereInput>;
};


export type QueryArticleAuthorsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleAuthorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleAuthorWhereInput>;
};


export type QueryArticleCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleCategoryWhereInput>;
};


export type QueryArticleCategoryArgs = {
  where: ArticleCategoryWhereUniqueInput;
};


export type QueryArticleCategoryCountArgs = {
  where?: InputMaybe<ArticleCategoryWhereInput>;
};


export type QueryArticleChannelArgs = {
  where: ArticleChannelWhereUniqueInput;
};


export type QueryArticleChannelCountArgs = {
  where?: InputMaybe<ArticleChannelWhereInput>;
};


export type QueryArticleChannelsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleChannelOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleChannelWhereInput>;
};


export type QueryArticleCountArgs = {
  where?: InputMaybe<ArticleWhereInput>;
};


export type QueryArticleCreatorDataArgs = {
  where: ArticleCreatorDataWhereUniqueInput;
};


export type QueryArticleCreatorDataCountArgs = {
  where?: InputMaybe<ArticleCreatorDataWhereInput>;
};


export type QueryArticleCreatorDatasArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleCreatorDataOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleCreatorDataWhereInput>;
};


export type QueryArticleEventArgs = {
  where: ArticleEventWhereUniqueInput;
};


export type QueryArticleEventCountArgs = {
  where?: InputMaybe<ArticleEventWhereInput>;
};


export type QueryArticleEventsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleEventOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleEventWhereInput>;
};


export type QueryArticleExtensionArgs = {
  where: ArticleExtensionWhereUniqueInput;
};


export type QueryArticleExtensionCountArgs = {
  where?: InputMaybe<ArticleExtensionWhereInput>;
};


export type QueryArticleExtensionsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleExtensionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleExtensionWhereInput>;
};


export type QueryArticleGoodDealAiPromptArgs = {
  where: ArticleGoodDealAiPromptWhereUniqueInput;
};


export type QueryArticleGoodDealAiPromptCountArgs = {
  where?: InputMaybe<ArticleGoodDealAiPromptWhereInput>;
};


export type QueryArticleGoodDealAiPromptsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiPromptOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleGoodDealAiPromptWhereInput>;
};


export type QueryArticleGoodDealAiProcessArgs = {
  where: ArticleGoodDealAiProcessWhereUniqueInput;
};


export type QueryArticleGoodDealAiProcessCountArgs = {
  where?: InputMaybe<ArticleGoodDealAiProcessWhereInput>;
};


export type QueryArticleGoodDealAiProcessesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiProcessOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleGoodDealAiProcessWhereInput>;
};


export type QueryArticleGuideArgs = {
  where: ArticleGuideWhereUniqueInput;
};


export type QueryArticleGuideCountArgs = {
  where?: InputMaybe<ArticleGuideWhereInput>;
};


export type QueryArticleGuidesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleGuideOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleGuideWhereInput>;
};


export type QueryArticleHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleHistoryWhereInput>;
};


export type QueryArticleHistoryArgs = {
  where: ArticleHistoryWhereUniqueInput;
};


export type QueryArticleHistoryCountArgs = {
  where?: InputMaybe<ArticleHistoryWhereInput>;
};


export type QueryArticleMachineTagArgs = {
  where: ArticleMachineTagWhereUniqueInput;
};


export type QueryArticleMachineTagCountArgs = {
  where?: InputMaybe<ArticleMachineTagWhereInput>;
};


export type QueryArticleMachineTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleMachineTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleMachineTagWhereInput>;
};


export type QueryArticleQualifierArgs = {
  where: ArticleQualifierWhereUniqueInput;
};


export type QueryArticleQualifierCountArgs = {
  where?: InputMaybe<ArticleQualifierWhereInput>;
};


export type QueryArticleQualifiersArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleQualifierOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleQualifierWhereInput>;
};


export type QueryArticleTagArgs = {
  where: ArticleTagWhereUniqueInput;
};


export type QueryArticleTagCountArgs = {
  where?: InputMaybe<ArticleTagWhereInput>;
};


export type QueryArticleTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleTagWhereInput>;
};


export type QueryArticleTaxonomiesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleTaxonomyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleTaxonomyWhereInput>;
};


export type QueryArticleTaxonomyArgs = {
  where: ArticleTaxonomyWhereUniqueInput;
};


export type QueryArticleTaxonomyCountArgs = {
  where?: InputMaybe<ArticleTaxonomyWhereInput>;
};


export type QueryArticleUrlArgs = {
  where: ArticleUrlWhereUniqueInput;
};


export type QueryArticleUrlCountArgs = {
  where?: InputMaybe<ArticleUrlWhereInput>;
};


export type QueryArticleUrlPublicIdArgs = {
  where: ArticleUrlPublicIdWhereUniqueInput;
};


export type QueryArticleUrlPublicIdCountArgs = {
  where?: InputMaybe<ArticleUrlPublicIdWhereInput>;
};


export type QueryArticleUrlPublicIdsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleUrlPublicIdOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleUrlPublicIdWhereInput>;
};


export type QueryArticleUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleUrlWhereInput>;
};


export type QueryArticleUserArgs = {
  where: ArticleUserWhereUniqueInput;
};


export type QueryArticleUserCountArgs = {
  where?: InputMaybe<ArticleUserWhereInput>;
};


export type QueryArticleUsersArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleUserOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleUserWhereInput>;
};


export type QueryArticlesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


export type QueryAttributeArgs = {
  where: AttributeWhereUniqueInput;
};


export type QueryAttributeCountArgs = {
  where?: InputMaybe<AttributeWhereInput>;
};


export type QueryAttributesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AttributeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AttributeWhereInput>;
};


export type QueryAuthorArgs = {
  where: AuthorWhereUniqueInput;
};


export type QueryAuthorAttributeArgs = {
  where: AuthorAttributeWhereUniqueInput;
};


export type QueryAuthorAttributeCountArgs = {
  where?: InputMaybe<AuthorAttributeWhereInput>;
};


export type QueryAuthorAttributesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorAttributeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorAttributeWhereInput>;
};


export type QueryAuthorCountArgs = {
  where?: InputMaybe<AuthorWhereInput>;
};


export type QueryAuthorHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorHistoryWhereInput>;
};


export type QueryAuthorHistoryArgs = {
  where: AuthorHistoryWhereUniqueInput;
};


export type QueryAuthorHistoryCountArgs = {
  where?: InputMaybe<AuthorHistoryWhereInput>;
};


export type QueryAuthorsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorWhereInput>;
};


export type QueryCardArgs = {
  where: CardWhereUniqueInput;
};


export type QueryCardCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CardCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardCategoryWhereInput>;
};


export type QueryCardCategoryArgs = {
  where: CardCategoryWhereUniqueInput;
};


export type QueryCardCategoryCountArgs = {
  where?: InputMaybe<CardCategoryWhereInput>;
};


export type QueryCardCountArgs = {
  where?: InputMaybe<CardWhereInput>;
};


export type QueryCardTagArgs = {
  where: CardTagWhereUniqueInput;
};


export type QueryCardTagCountArgs = {
  where?: InputMaybe<CardTagWhereInput>;
};


export type QueryCardTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CardTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardTagWhereInput>;
};


export type QueryCardsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CardOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardWhereInput>;
};


export type QueryCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type QueryCategoryCountArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryHistoryWhereInput>;
};


export type QueryCategoryHistoryArgs = {
  where: CategoryHistoryWhereUniqueInput;
};


export type QueryCategoryHistoryCountArgs = {
  where?: InputMaybe<CategoryHistoryWhereInput>;
};


export type QueryCategoryUrlPublicIdArgs = {
  where: CategoryUrlPublicIdWhereUniqueInput;
};


export type QueryCategoryUrlPublicIdCountArgs = {
  where?: InputMaybe<CategoryUrlPublicIdWhereInput>;
};


export type QueryCategoryUrlPublicIdsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryUrlPublicIdOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryUrlPublicIdWhereInput>;
};


export type QueryDailymotionLogArgs = {
  where: DailymotionLogWhereUniqueInput;
};


export type QueryDailymotionLogCountArgs = {
  where?: InputMaybe<DailymotionLogWhereInput>;
};


export type QueryDailymotionLogsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DailymotionLogOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DailymotionLogWhereInput>;
};


export type QueryDailymotionMigrationArgs = {
  where: DailymotionMigrationWhereUniqueInput;
};


export type QueryDailymotionMigrationCountArgs = {
  where?: InputMaybe<DailymotionMigrationWhereInput>;
};


export type QueryDailymotionMigrationsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DailymotionMigrationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DailymotionMigrationWhereInput>;
};


export type QueryDailymotionUploadUrlArgs = {
  brandKey?: InputMaybe<BrandKey>;
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCampaignArgs = {
  brandKey?: InputMaybe<BrandKey>;
  device?: InputMaybe<TargetDevice>;
  pushId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCampaignsArgs = {
  brandKey?: InputMaybe<BrandKey>;
  device?: InputMaybe<TargetDevice>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCeriseAffiliationEmbedArgs = {
  articleId: Scalars['String']['input'];
  brandKey: BrandKey;
  template: CeriseAffiliationTemplate;
  type: Array<CeriseAffiliationType>;
  url: Scalars['String']['input'];
};


export type QueryGetSegmentationsArgs = {
  brandKey?: InputMaybe<BrandKey>;
  device?: InputMaybe<TargetDevice>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVertexAiRecipesArgs = {
  brandKey: BrandKey;
  excludedIngredients?: InputMaybe<Array<Scalars['String']['input']>>;
  recipeNumber: Scalars['Int']['input'];
  slideshowSubject: Scalars['String']['input'];
};


export type QueryImageSourceArgs = {
  where: ImageSourceWhereUniqueInput;
};


export type QueryImageSourceCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ImageSourceCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageSourceCategoryWhereInput>;
};


export type QueryImageSourceCategoryArgs = {
  where: ImageSourceCategoryWhereUniqueInput;
};


export type QueryImageSourceCategoryCountArgs = {
  where?: InputMaybe<ImageSourceCategoryWhereInput>;
};


export type QueryImageSourceCountArgs = {
  where?: InputMaybe<ImageSourceWhereInput>;
};


export type QueryImageSourcesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ImageSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageSourceWhereInput>;
};


export type QueryLiveArgs = {
  where: LiveWhereUniqueInput;
};


export type QueryLiveCountArgs = {
  where?: InputMaybe<LiveWhereInput>;
};


export type QueryLivePostArgs = {
  where: LivePostWhereUniqueInput;
};


export type QueryLivePostCountArgs = {
  where?: InputMaybe<LivePostWhereInput>;
};


export type QueryLivePostsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<LivePostOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LivePostWhereInput>;
};


export type QueryLivesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<LiveOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LiveWhereInput>;
};


export type QueryMachineTagArgs = {
  where: MachineTagWhereUniqueInput;
};


export type QueryMachineTagCountArgs = {
  where?: InputMaybe<MachineTagWhereInput>;
};


export type QueryMachineTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MachineTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MachineTagWhereInput>;
};


export type QueryOpenAiProcessArgs = {
  where: OpenAiProcessWhereUniqueInput;
};


export type QueryOpenAiProcessCountArgs = {
  where?: InputMaybe<OpenAiProcessWhereInput>;
};


export type QueryOpenAiProcessesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OpenAiProcessOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OpenAiProcessWhereInput>;
};


export type QueryOrphanPageArgs = {
  where: OrphanPageWhereUniqueInput;
};


export type QueryOrphanPageCountArgs = {
  where?: InputMaybe<OrphanPageWhereInput>;
};


export type QueryOrphanPagesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrphanPageOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrphanPageWhereInput>;
};


export type QueryPromptArgs = {
  where: PromptWhereUniqueInput;
};


export type QueryPromptCountArgs = {
  where?: InputMaybe<PromptWhereInput>;
};


export type QueryPromptsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PromptOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromptWhereInput>;
};


export type QueryPushArgs = {
  where: PushWhereUniqueInput;
};


export type QueryPushCountArgs = {
  where?: InputMaybe<PushWhereInput>;
};


export type QueryPushErrorArgs = {
  where: PushErrorWhereUniqueInput;
};


export type QueryPushErrorCountArgs = {
  where?: InputMaybe<PushErrorWhereInput>;
};


export type QueryPushErrorsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PushErrorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushErrorWhereInput>;
};


export type QueryPushSegmentArgs = {
  where: PushSegmentWhereUniqueInput;
};


export type QueryPushSegmentCountArgs = {
  where?: InputMaybe<PushSegmentWhereInput>;
};


export type QueryPushSegmentsArgs = {
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushSegmentWhereInput>;
};


export type QueryPushesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PushOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushWhereInput>;
};


export type QueryQualifierArgs = {
  where: QualifierWhereUniqueInput;
};


export type QueryQualifierCountArgs = {
  where?: InputMaybe<QualifierWhereInput>;
};


export type QueryQualifiersArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QualifierOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QualifierWhereInput>;
};


export type QuerySearchAffiliationProductArgs = {
  keyword: Scalars['String']['input'];
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AffilizzProductSearchSor>;
};


export type QuerySearchAffilliationDesignArgs = {
  originTypes?: InputMaybe<Array<AffilizzDesignOriginType>>;
  renderingTypes?: InputMaybe<Array<AffilizzDesignRenderingType>>;
  states?: InputMaybe<Array<AffilizzDesignState>>;
};


export type QuerySearchArticleCountArgs = {
  where?: InputMaybe<ArticleSearchWhereInput>;
};


export type QuerySearchArticlesArgs = {
  first: Scalars['Int']['input'];
  isTransverse?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<ArticleSearchOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleSearchWhereInput>;
};


export type QuerySearchEnabledTagsArgs = {
  brandKey?: InputMaybe<BrandKey>;
  first?: InputMaybe<Scalars['Int']['input']>;
  providers: Array<TagProviderName>;
  query: Scalars['String']['input'];
  types: Array<TagSearchTypes>;
};


export type QuerySearchMediaArticleCountArgs = {
  mediaElements: Array<InputMaybe<Scalars['String']['input']>>;
  mediaSite?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchNewsletterTagsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchPhotosByProvidersArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  perPage: Scalars['Int']['input'];
  providers: Array<PhotoProvider>;
  query: Scalars['String']['input'];
};


export type QuerySegmentArgs = {
  where: SegmentWhereUniqueInput;
};


export type QuerySegmentCountArgs = {
  where?: InputMaybe<SegmentWhereInput>;
};


export type QuerySegmentsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SegmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentWhereInput>;
};


export type QuerySourceArgs = {
  where: SourceWhereUniqueInput;
};


export type QuerySourceCountArgs = {
  where?: InputMaybe<SourceWhereInput>;
};


export type QuerySourcesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SourceWhereInput>;
};


export type QuerySuggestArticlesArgs = {
  search: SimilarArticleArgsInputType;
};


export type QuerySuggestCategoriesArgs = {
  categoryFormat?: InputMaybe<CategoryFormat>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search: SimilarArticleArgsInputType;
};


export type QuerySuggestTagsArgs = {
  brandKey: BrandKey;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providers: Array<TagProviderName>;
  search: SimilarArticleArgsInputType;
};


export type QueryTabArgs = {
  where: TabWhereUniqueInput;
};


export type QueryTabCountArgs = {
  where?: InputMaybe<TabWhereInput>;
};


export type QueryTabsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TabOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabWhereInput>;
};


export type QueryTagArgs = {
  where: TagWhereUniqueInput;
};


export type QueryTagBrandUsageArgs = {
  where: TagBrandUsageWhereUniqueInput;
};


export type QueryTagBrandUsageCountArgs = {
  where?: InputMaybe<TagBrandUsageWhereInput>;
};


export type QueryTagBrandUsagesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TagBrandUsageOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagBrandUsageWhereInput>;
};


export type QueryTagCountArgs = {
  where?: InputMaybe<TagWhereInput>;
};


export type QueryTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryTaxonomiesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TaxonomyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TaxonomyWhereInput>;
};


export type QueryTaxonomyArgs = {
  where: TaxonomyWhereUniqueInput;
};


export type QueryTaxonomyCountArgs = {
  where?: InputMaybe<TaxonomyWhereInput>;
};


export type QueryTranslateArticleArgs = {
  id: Scalars['String']['input'];
  source_lang: Scalars['String']['input'];
  target_lang: Scalars['String']['input'];
};


export type QueryUrlArgs = {
  where: UrlWhereUniqueInput;
};


export type QueryUrlCountArgs = {
  where?: InputMaybe<UrlWhereInput>;
};


export type QueryUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<UrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UrlWhereInput>;
};

export type SearchItemScoreType = {
  __typename?: 'SearchItemScoreType';
  itemId: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
};

/** A segment */
export type Segment = {
  __typename?: 'Segment';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  android?: Maybe<Scalars['String']['output']>;
  brandKey?: Maybe<BrandKey>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  device?: Maybe<Scalars['String']['output']>;
  editorialAlert?: Maybe<Scalars['String']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  ios?: Maybe<Scalars['String']['output']>;
  /** "PushSegment.segment"'s inverse relation count */
  pushSegmentCount: Scalars['Int']['output'];
  /** "PushSegment.segment"'s inverse relation */
  pushSegments: Array<PushSegment>;
  status: SegmentStatus;
  title?: Maybe<Scalars['String']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** A segment */
export type SegmentPushSegmentCountArgs = {
  where?: InputMaybe<PushSegmentWhereInput>;
};


/** A segment */
export type SegmentPushSegmentsArgs = {
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushSegmentWhereInput>;
};

export type SegmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  android?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  device?: InputMaybe<Scalars['String']['input']>;
  editorialAlert?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  ios?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Segment.pushSegments" relation: "PushSegment.segment"'s inverse relation */
  pushSegments?: InputMaybe<SegmentNestedPushSegmentsCreateInput>;
  status?: InputMaybe<SegmentStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentNestedPushSegmentsCreateInput = {
  /** Create new "PushSegment" nodes and connect them to the new "Segment" node, through the "Segment.pushSegments" relation. */
  create?: InputMaybe<Array<PushSegmentWithForcedSegmentCreateInput>>;
};

export type SegmentNestedPushSegmentsUpdateInput = {
  /** Create new "PushSegment" nodes and connect them to the existing "Segment" node, through the "Segment.pushSegments" relation. */
  create?: InputMaybe<Array<PushSegmentWithForcedSegmentCreateInput>>;
  /** Delete existing "PushSegment" nodes from the "Segment.pushSegments" relation. */
  delete?: InputMaybe<Array<PushSegmentWithForcedSegmentWhereUniqueInput>>;
};

export enum SegmentOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  active_ASC = 'active_ASC',
  active_DESC = 'active_DESC',
  android_ASC = 'android_ASC',
  android_DESC = 'android_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  device_ASC = 'device_ASC',
  device_DESC = 'device_DESC',
  editorialAlert_ASC = 'editorialAlert_ASC',
  editorialAlert_DESC = 'editorialAlert_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  ios_ASC = 'ios_ASC',
  ios_DESC = 'ios_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum SegmentStatus {
  Draft = 'Draft',
  Published = 'Published'
}

export type SegmentUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  android?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  device?: InputMaybe<Scalars['String']['input']>;
  editorialAlert?: InputMaybe<Scalars['String']['input']>;
  ios?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Segment.pushSegments" relation: "PushSegment.segment"'s inverse relation */
  pushSegments?: InputMaybe<SegmentNestedPushSegmentsUpdateInput>;
  status?: InputMaybe<SegmentStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "Segment" nodes by specifying some conditions */
export type SegmentWhereInput = {
  AND?: InputMaybe<Array<SegmentWhereInput>>;
  NOT?: InputMaybe<SegmentWhereInput>;
  OR?: InputMaybe<Array<SegmentWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  active_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  active_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  android?: InputMaybe<Scalars['String']['input']>;
  android_contains?: InputMaybe<Scalars['String']['input']>;
  android_ends_with?: InputMaybe<Scalars['String']['input']>;
  android_gt?: InputMaybe<Scalars['String']['input']>;
  android_gte?: InputMaybe<Scalars['String']['input']>;
  android_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  android_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  android_lt?: InputMaybe<Scalars['String']['input']>;
  android_lte?: InputMaybe<Scalars['String']['input']>;
  android_not?: InputMaybe<Scalars['String']['input']>;
  android_not_contains?: InputMaybe<Scalars['String']['input']>;
  android_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  android_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  android_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  android_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<InputMaybe<BrandKey>>>;
  brandKey_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<InputMaybe<BrandKey>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  device?: InputMaybe<Scalars['String']['input']>;
  device_contains?: InputMaybe<Scalars['String']['input']>;
  device_ends_with?: InputMaybe<Scalars['String']['input']>;
  device_gt?: InputMaybe<Scalars['String']['input']>;
  device_gte?: InputMaybe<Scalars['String']['input']>;
  device_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  device_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  device_lt?: InputMaybe<Scalars['String']['input']>;
  device_lte?: InputMaybe<Scalars['String']['input']>;
  device_not?: InputMaybe<Scalars['String']['input']>;
  device_not_contains?: InputMaybe<Scalars['String']['input']>;
  device_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  device_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  device_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  device_starts_with?: InputMaybe<Scalars['String']['input']>;
  editorialAlert?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_contains?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_ends_with?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_gt?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_gte?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editorialAlert_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editorialAlert_lt?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_lte?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_not?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_not_contains?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editorialAlert_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  editorialAlert_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  ios?: InputMaybe<Scalars['String']['input']>;
  ios_contains?: InputMaybe<Scalars['String']['input']>;
  ios_ends_with?: InputMaybe<Scalars['String']['input']>;
  ios_gt?: InputMaybe<Scalars['String']['input']>;
  ios_gte?: InputMaybe<Scalars['String']['input']>;
  ios_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ios_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  ios_lt?: InputMaybe<Scalars['String']['input']>;
  ios_lte?: InputMaybe<Scalars['String']['input']>;
  ios_not?: InputMaybe<Scalars['String']['input']>;
  ios_not_contains?: InputMaybe<Scalars['String']['input']>;
  ios_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  ios_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ios_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  ios_starts_with?: InputMaybe<Scalars['String']['input']>;
  pushSegments_some?: InputMaybe<PushSegmentWhereInput>;
  status?: InputMaybe<SegmentStatus>;
  status_in?: InputMaybe<Array<SegmentStatus>>;
  status_not?: InputMaybe<SegmentStatus>;
  status_not_in?: InputMaybe<Array<SegmentStatus>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Segment" node with one of these unique values:
 * - _id
 * - id
 */
export type SegmentWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SimilarArticleArgsInputType = {
  article?: InputMaybe<SimilarArticleInputType>;
  fields?: InputMaybe<Array<InputMaybe<ArticleSearchFieldsType>>>;
  first: Scalars['Int']['input'];
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type SimilarArticleInputType = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** search article body-medias using medias properties */
  bodyMedias?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  format?: InputMaybe<ArticleFormat>;
  /** current article id, to be excluded from the result set */
  id?: InputMaybe<Scalars['ID']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** search article medias using medias properties */
  medias?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A source */
export type Source = {
  __typename?: 'Source';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "Article.source"'s inverse relation count */
  articleCount: Scalars['Int']['output'];
  /** "Article.source"'s inverse relation */
  articles: Array<Article>;
  brandKey: BrandKey;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  status: SourceStatus;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** A source */
export type SourceArticleCountArgs = {
  where?: InputMaybe<ArticleWhereInput>;
};


/** A source */
export type SourceArticlesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};

export type SourceCreateInput = {
  /** Actions for the "Source.articles" relation: "Article.source"'s inverse relation */
  articles?: InputMaybe<SourceNestedArticlesCreateInput>;
  brandKey: BrandKey;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status: SourceStatus;
  title: Scalars['String']['input'];
};

export type SourceNestedArticlesCreateInput = {
  /** Connect existing "Article" nodes to the new "Source" node, through the "Source.articles" relation. */
  connect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Create new "Article" nodes and connect them to the new "Source" node, through the "Source.articles" relation. */
  create?: InputMaybe<Array<ArticleWithForcedSourceCreateInput>>;
};

export type SourceNestedArticlesUpdateInput = {
  /** Connect existing "Article" nodes to the existing "Source" node, through the "Source.articles" relation. */
  connect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Create new "Article" nodes and connect them to the existing "Source" node, through the "Source.articles" relation. */
  create?: InputMaybe<Array<ArticleWithForcedSourceCreateInput>>;
  /** Delete existing "Article" nodes from the "Source.articles" relation. */
  delete?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Disconnect existing "Article" nodes of the "Source.articles" relation. */
  disconnect?: InputMaybe<Array<ArticleWhereUniqueInput>>;
  /** Update existing "Article" nodes and connect them to the existing "Source" node, through the "Source.articles" relation. */
  update?: InputMaybe<Array<SourceNestedUpdateArticlesUpdateInput>>;
  /** Upsert existing "Article" nodes and connect them to the existing "Source" node, through the "Source.articles" relation. */
  upsert?: InputMaybe<Array<SourceNestedUpsertArticlesUpdateInput>>;
};

export type SourceNestedUpdateArticlesUpdateInput = {
  data: ArticleWithForcedSourceUpdateInput;
  where: ArticleWhereUniqueInput;
};

export type SourceNestedUpsertArticlesUpdateInput = {
  create: ArticleWithForcedSourceCreateInput;
  update: ArticleWithForcedSourceUpdateInput;
  where: ArticleWhereUniqueInput;
};

export enum SourceOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SourceSourceSearchWhereInput = {
  AND?: InputMaybe<Array<SourceSourceSearchWhereInput>>;
  NOT?: InputMaybe<SourceSourceSearchWhereInput>;
  OR?: InputMaybe<Array<SourceSourceSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

export enum SourceStatus {
  Draft = 'Draft',
  Published = 'Published'
}

export type SourceUpdateInput = {
  /** Actions for the "Source.articles" relation: "Article.source"'s inverse relation */
  articles?: InputMaybe<SourceNestedArticlesUpdateInput>;
  brandKey?: InputMaybe<BrandKey>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SourceStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "Source" nodes by specifying some conditions */
export type SourceWhereInput = {
  AND?: InputMaybe<Array<SourceWhereInput>>;
  NOT?: InputMaybe<SourceWhereInput>;
  OR?: InputMaybe<Array<SourceWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articles_some?: InputMaybe<ArticleWhereInput>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SourceStatus>;
  status_in?: InputMaybe<Array<SourceStatus>>;
  status_not?: InputMaybe<SourceStatus>;
  status_not_in?: InputMaybe<Array<SourceStatus>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Source" node with one of these unique combinations of values:
 * - _id
 * - id
 * - brandKey, title
 * - brandKey, slug
 */
export type SourceWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A tab */
export type Tab = {
  __typename?: 'Tab';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  category: Category;
  content?: Maybe<Scalars['String']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabledLabel?: Maybe<Scalars['String']['output']>;
  enabledLabel?: Maybe<Scalars['String']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  isOnline: Scalars['Boolean']['output'];
  metas?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: TabType;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type TabCreateInput = {
  /** Actions for the "Tab.category" relation */
  category: TabNestedCategoryCreateInput;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabledLabel?: InputMaybe<Scalars['String']['input']>;
  enabledLabel?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  isOnline: Scalars['Boolean']['input'];
  metas?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: TabType;
};

export type TabNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "Tab" node, through the "Tab.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "Tab" node, through the "Tab.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "Tab" node, through the "Tab.category" relation. */
  update?: InputMaybe<TabNestedUpdateCategoryCreateInput>;
  /** Create or update a "Category" node and connect it to the new "Tab" node, through the "Tab.category" relation. */
  upsert?: InputMaybe<TabNestedUpsertCategoryCreateInput>;
};

export type TabNestedCategoryUpdateInput = {
  /** Connect an existing "Category" node to the existing "Tab" node, through the "Tab.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the existing "Tab" node, through the "Tab.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the existing "Tab" node, through the "Tab.category" relation. */
  update?: InputMaybe<TabNestedUpdateCategoryUpdateInput>;
  /** Create or update a "Category" node and connect it to the existing "Tab" node, through the "Tab.category" relation. */
  upsert?: InputMaybe<TabNestedUpsertCategoryUpdateInput>;
};

export type TabNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type TabNestedUpdateCategoryUpdateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type TabNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type TabNestedUpsertCategoryUpdateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export enum TabOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  content_ASC = 'content_ASC',
  content_DESC = 'content_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  disabledLabel_ASC = 'disabledLabel_ASC',
  disabledLabel_DESC = 'disabledLabel_DESC',
  enabledLabel_ASC = 'enabledLabel_ASC',
  enabledLabel_DESC = 'enabledLabel_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isOnline_ASC = 'isOnline_ASC',
  isOnline_DESC = 'isOnline_DESC',
  metas_ASC = 'metas_ASC',
  metas_DESC = 'metas_DESC',
  order_ASC = 'order_ASC',
  order_DESC = 'order_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum TabType {
  Board = 'Board',
  Broadcast = 'Broadcast',
  People = 'People',
  Text = 'Text',
  Url = 'Url'
}

export type TabUpdateInput = {
  /** Actions for the "Tab.category" relation */
  category?: InputMaybe<TabNestedCategoryUpdateInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabledLabel?: InputMaybe<Scalars['String']['input']>;
  enabledLabel?: InputMaybe<Scalars['String']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TabType>;
};

/** Filters the "Tab" nodes by specifying some conditions */
export type TabWhereInput = {
  AND?: InputMaybe<Array<TabWhereInput>>;
  NOT?: InputMaybe<TabWhereInput>;
  OR?: InputMaybe<Array<TabWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  category?: InputMaybe<CategoryWhereInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_not?: InputMaybe<Scalars['String']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  disabledLabel?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_contains?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_gt?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_gte?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disabledLabel_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  disabledLabel_lt?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_lte?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_not?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disabledLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  disabledLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  enabledLabel?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_contains?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_gt?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_gte?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enabledLabel_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  enabledLabel_lt?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_lte?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_not?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enabledLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  enabledLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isOnline_not?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  metas?: InputMaybe<Scalars['String']['input']>;
  metas_contains?: InputMaybe<Scalars['String']['input']>;
  metas_ends_with?: InputMaybe<Scalars['String']['input']>;
  metas_gt?: InputMaybe<Scalars['String']['input']>;
  metas_gte?: InputMaybe<Scalars['String']['input']>;
  metas_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metas_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  metas_lt?: InputMaybe<Scalars['String']['input']>;
  metas_lte?: InputMaybe<Scalars['String']['input']>;
  metas_not?: InputMaybe<Scalars['String']['input']>;
  metas_not_contains?: InputMaybe<Scalars['String']['input']>;
  metas_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  metas_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metas_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  metas_starts_with?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_gt?: InputMaybe<Scalars['Int']['input']>;
  order_gte?: InputMaybe<Scalars['Int']['input']>;
  order_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_lt?: InputMaybe<Scalars['Int']['input']>;
  order_lte?: InputMaybe<Scalars['Int']['input']>;
  order_not?: InputMaybe<Scalars['Int']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TabType>;
  type_in?: InputMaybe<Array<TabType>>;
  type_not?: InputMaybe<TabType>;
  type_not_in?: InputMaybe<Array<TabType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Tab" node with one of these unique values:
 * - _id
 * - id
 */
export type TabWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TabWithForcedCategoryCreateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabledLabel?: InputMaybe<Scalars['String']['input']>;
  enabledLabel?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  isOnline: Scalars['Boolean']['input'];
  metas?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: TabType;
};

export type TabWithForcedCategoryUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabledLabel?: InputMaybe<Scalars['String']['input']>;
  enabledLabel?: InputMaybe<Scalars['String']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  metas?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TabType>;
};

/** A tag */
export type Tag = {
  __typename?: 'Tag';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "ArticleTag.tag"'s inverse relation count */
  articleTagCount: Scalars['Int']['output'];
  /** "ArticleTag.tag"'s inverse relation */
  articleTags: Array<ArticleTag>;
  /** "CardTag.tag"'s inverse relation count */
  cardTagCount: Scalars['Int']['output'];
  /** "CardTag.tag"'s inverse relation */
  cardTags: Array<CardTag>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** ISO 639-1 tag language */
  lang: TagLang;
  mergedTo?: Maybe<Scalars['Int']['output']>;
  relationId?: Maybe<Scalars['ID']['output']>;
  slug: Scalars['String']['output'];
  /** "TagBrandUsage.tag"'s inverse relation count */
  tagBrandUsageCount: Scalars['Int']['output'];
  /** "TagBrandUsage.tag"'s inverse relation */
  tagBrandUsages: Array<TagBrandUsage>;
  title: Scalars['String']['output'];
  type: TagType;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** A tag */
export type TagArticleTagCountArgs = {
  where?: InputMaybe<ArticleTagWhereInput>;
};


/** A tag */
export type TagArticleTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleTagWhereInput>;
};


/** A tag */
export type TagCardTagCountArgs = {
  where?: InputMaybe<CardTagWhereInput>;
};


/** A tag */
export type TagCardTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CardTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardTagWhereInput>;
};


/** A tag */
export type TagTagBrandUsageCountArgs = {
  where?: InputMaybe<TagBrandUsageWhereInput>;
};


/** A tag */
export type TagTagBrandUsagesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TagBrandUsageOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagBrandUsageWhereInput>;
};

export type TagArticleTagsTagSearchWhereInput = {
  AND?: InputMaybe<Array<TagArticleTagsTagSearchWhereInput>>;
  NOT?: InputMaybe<TagArticleTagsTagSearchWhereInput>;
  OR?: InputMaybe<Array<TagArticleTagsTagSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
};

/** "TagBrandUsage" resource's node */
export type TagBrandUsage = {
  __typename?: 'TagBrandUsage';
  articleCount: Scalars['Int']['output'];
  brandKey: BrandKey;
  /** Last time the articleCount was computed */
  computedAt: Scalars['Date']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  isEnabled: Scalars['Boolean']['output'];
  /** Last time the articleCount status was changed */
  statusSwitchedAt: Scalars['Date']['output'];
  tag: Tag;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type TagBrandUsageCreateInput = {
  articleCount: Scalars['Int']['input'];
  brandKey: BrandKey;
  /** Last time the articleCount was computed */
  computedAt: Scalars['Date']['input'];
  isEnabled: Scalars['Boolean']['input'];
  /** Last time the articleCount status was changed */
  statusSwitchedAt: Scalars['Date']['input'];
  /** Actions for the "TagBrandUsage.tag" relation */
  tag: TagBrandUsageNestedTagCreateInput;
};

export type TagBrandUsageNestedTagCreateInput = {
  /** Connect an existing "Tag" node to the new "TagBrandUsage" node, through the "TagBrandUsage.tag" relation. */
  connect?: InputMaybe<TagWhereUniqueInput>;
  /** Create a new "Tag" node and connect it to the new "TagBrandUsage" node, through the "TagBrandUsage.tag" relation. */
  create?: InputMaybe<TagCreateInput>;
  /** Update an existing "Tag" node and connect it to the new "TagBrandUsage" node, through the "TagBrandUsage.tag" relation. */
  update?: InputMaybe<TagBrandUsageNestedUpdateTagCreateInput>;
  /** Create or update a "Tag" node and connect it to the new "TagBrandUsage" node, through the "TagBrandUsage.tag" relation. */
  upsert?: InputMaybe<TagBrandUsageNestedUpsertTagCreateInput>;
};

export type TagBrandUsageNestedTagUpdateInput = {
  /** Connect an existing "Tag" node to the existing "TagBrandUsage" node, through the "TagBrandUsage.tag" relation. */
  connect?: InputMaybe<TagWhereUniqueInput>;
  /** Create a new "Tag" node and connect it to the existing "TagBrandUsage" node, through the "TagBrandUsage.tag" relation. */
  create?: InputMaybe<TagCreateInput>;
  /** Update an existing "Tag" node and connect it to the existing "TagBrandUsage" node, through the "TagBrandUsage.tag" relation. */
  update?: InputMaybe<TagBrandUsageNestedUpdateTagUpdateInput>;
  /** Create or update a "Tag" node and connect it to the existing "TagBrandUsage" node, through the "TagBrandUsage.tag" relation. */
  upsert?: InputMaybe<TagBrandUsageNestedUpsertTagUpdateInput>;
};

export type TagBrandUsageNestedUpdateTagCreateInput = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type TagBrandUsageNestedUpdateTagUpdateInput = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type TagBrandUsageNestedUpsertTagCreateInput = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type TagBrandUsageNestedUpsertTagUpdateInput = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export enum TagBrandUsageOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  articleCount_ASC = 'articleCount_ASC',
  articleCount_DESC = 'articleCount_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  computedAt_ASC = 'computedAt_ASC',
  computedAt_DESC = 'computedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  isEnabled_ASC = 'isEnabled_ASC',
  isEnabled_DESC = 'isEnabled_DESC',
  statusSwitchedAt_ASC = 'statusSwitchedAt_ASC',
  statusSwitchedAt_DESC = 'statusSwitchedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TagBrandUsageUpdateInput = {
  articleCount?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  /** Last time the articleCount was computed */
  computedAt?: InputMaybe<Scalars['Date']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last time the articleCount status was changed */
  statusSwitchedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Actions for the "TagBrandUsage.tag" relation */
  tag?: InputMaybe<TagBrandUsageNestedTagUpdateInput>;
};

/** Filters the "TagBrandUsage" nodes by specifying some conditions */
export type TagBrandUsageWhereInput = {
  AND?: InputMaybe<Array<TagBrandUsageWhereInput>>;
  NOT?: InputMaybe<TagBrandUsageWhereInput>;
  OR?: InputMaybe<Array<TagBrandUsageWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleCount?: InputMaybe<Scalars['Int']['input']>;
  articleCount_gt?: InputMaybe<Scalars['Int']['input']>;
  articleCount_gte?: InputMaybe<Scalars['Int']['input']>;
  articleCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleCount_lt?: InputMaybe<Scalars['Int']['input']>;
  articleCount_lte?: InputMaybe<Scalars['Int']['input']>;
  articleCount_not?: InputMaybe<Scalars['Int']['input']>;
  articleCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  computedAt?: InputMaybe<Scalars['Date']['input']>;
  computedAt_gt?: InputMaybe<Scalars['Date']['input']>;
  computedAt_gte?: InputMaybe<Scalars['Date']['input']>;
  computedAt_in?: InputMaybe<Array<Scalars['Date']['input']>>;
  computedAt_lt?: InputMaybe<Scalars['Date']['input']>;
  computedAt_lte?: InputMaybe<Scalars['Date']['input']>;
  computedAt_not?: InputMaybe<Scalars['Date']['input']>;
  computedAt_not_in?: InputMaybe<Array<Scalars['Date']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  statusSwitchedAt?: InputMaybe<Scalars['Date']['input']>;
  statusSwitchedAt_gt?: InputMaybe<Scalars['Date']['input']>;
  statusSwitchedAt_gte?: InputMaybe<Scalars['Date']['input']>;
  statusSwitchedAt_in?: InputMaybe<Array<Scalars['Date']['input']>>;
  statusSwitchedAt_lt?: InputMaybe<Scalars['Date']['input']>;
  statusSwitchedAt_lte?: InputMaybe<Scalars['Date']['input']>;
  statusSwitchedAt_not?: InputMaybe<Scalars['Date']['input']>;
  statusSwitchedAt_not_in?: InputMaybe<Array<Scalars['Date']['input']>>;
  tag?: InputMaybe<TagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "TagBrandUsage" node with one of these unique combinations of values:
 * - _id
 * - brandKey, tag
 */
export type TagBrandUsageWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  tag?: InputMaybe<TagWhereUniqueInput>;
};

export type TagBrandUsageWithForcedTagCreateInput = {
  articleCount: Scalars['Int']['input'];
  brandKey: BrandKey;
  /** Last time the articleCount was computed */
  computedAt: Scalars['Date']['input'];
  isEnabled: Scalars['Boolean']['input'];
  /** Last time the articleCount status was changed */
  statusSwitchedAt: Scalars['Date']['input'];
};

export type TagBrandUsageWithForcedTagUpdateInput = {
  articleCount?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  /** Last time the articleCount was computed */
  computedAt?: InputMaybe<Scalars['Date']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last time the articleCount status was changed */
  statusSwitchedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** Given a forced "tag", identifies exactly one "TagBrandUsage" node. */
export type TagBrandUsageWithForcedTagWhereUniqueInput = {
  brandKey: BrandKey;
};

/**
 * Given a known "tag", identifies exactly one "TagBrandUsage" node with one of these unique combinations of values:
 * - _id
 * - brandKey, tag (optional)
 */
export type TagBrandUsageWithOptionalTagWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  tag?: InputMaybe<TagWhereUniqueInput>;
};

export type TagCreateInput = {
  /** Actions for the "Tag.articleTags" relation: "ArticleTag.tag"'s inverse relation */
  articleTags?: InputMaybe<TagNestedArticleTagsCreateInput>;
  /** Actions for the "Tag.cardTags" relation: "CardTag.tag"'s inverse relation */
  cardTags?: InputMaybe<TagNestedCardTagsCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** ISO 639-1 tag language */
  lang?: InputMaybe<TagLang>;
  mergedTo?: InputMaybe<Scalars['Int']['input']>;
  relationId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Tag.tagBrandUsages" relation: "TagBrandUsage.tag"'s inverse relation */
  tagBrandUsages?: InputMaybe<TagNestedTagBrandUsagesCreateInput>;
  title: Scalars['String']['input'];
  type: TagType;
};

export enum TagLang {
  DE = 'DE',
  EN = 'EN',
  ES = 'ES',
  FR = 'FR',
  IT = 'IT',
  PT = 'PT'
}

export type TagMergeResult = {
  __typename?: 'TagMergeResult';
  articlesMerged: Array<ArticleMergedResult>;
  articlesMergedCount: Scalars['Int']['output'];
};

export type TagNestedArticleTagsCreateInput = {
  /** Create new "ArticleTag" nodes and connect them to the new "Tag" node, through the "Tag.articleTags" relation. */
  create?: InputMaybe<Array<ArticleTagWithForcedTagCreateInput>>;
};

export type TagNestedArticleTagsUpdateInput = {
  /** Create new "ArticleTag" nodes and connect them to the existing "Tag" node, through the "Tag.articleTags" relation. */
  create?: InputMaybe<Array<ArticleTagWithForcedTagCreateInput>>;
  /** Delete existing "ArticleTag" nodes from the "Tag.articleTags" relation. */
  delete?: InputMaybe<Array<ArticleTagWithForcedTagWhereUniqueInput>>;
  /** Update existing "ArticleTag" nodes and connect them to the existing "Tag" node, through the "Tag.articleTags" relation. */
  update?: InputMaybe<Array<TagNestedUpdateArticleTagsUpdateInput>>;
  /** Upsert existing "ArticleTag" nodes and connect them to the existing "Tag" node, through the "Tag.articleTags" relation. */
  upsert?: InputMaybe<Array<TagNestedUpsertArticleTagsUpdateInput>>;
};

export type TagNestedCardTagsCreateInput = {
  /** Create new "CardTag" nodes and connect them to the new "Tag" node, through the "Tag.cardTags" relation. */
  create?: InputMaybe<Array<CardTagWithForcedTagCreateInput>>;
};

export type TagNestedCardTagsUpdateInput = {
  /** Create new "CardTag" nodes and connect them to the existing "Tag" node, through the "Tag.cardTags" relation. */
  create?: InputMaybe<Array<CardTagWithForcedTagCreateInput>>;
  /** Delete existing "CardTag" nodes from the "Tag.cardTags" relation. */
  delete?: InputMaybe<Array<CardTagWithForcedTagWhereUniqueInput>>;
  /** Update existing "CardTag" nodes and connect them to the existing "Tag" node, through the "Tag.cardTags" relation. */
  update?: InputMaybe<Array<TagNestedUpdateCardTagsUpdateInput>>;
  /** Upsert existing "CardTag" nodes and connect them to the existing "Tag" node, through the "Tag.cardTags" relation. */
  upsert?: InputMaybe<Array<TagNestedUpsertCardTagsUpdateInput>>;
};

export type TagNestedTagBrandUsagesCreateInput = {
  /** Connect existing "TagBrandUsage" nodes to the new "Tag" node, through the "Tag.tagBrandUsages" relation. */
  connect?: InputMaybe<Array<TagBrandUsageWhereUniqueInput>>;
  /** Create new "TagBrandUsage" nodes and connect them to the new "Tag" node, through the "Tag.tagBrandUsages" relation. */
  create?: InputMaybe<Array<TagBrandUsageWithForcedTagCreateInput>>;
};

export type TagNestedTagBrandUsagesUpdateInput = {
  /** Connect existing "TagBrandUsage" nodes to the existing "Tag" node, through the "Tag.tagBrandUsages" relation. */
  connect?: InputMaybe<Array<TagBrandUsageWhereUniqueInput>>;
  /** Create new "TagBrandUsage" nodes and connect them to the existing "Tag" node, through the "Tag.tagBrandUsages" relation. */
  create?: InputMaybe<Array<TagBrandUsageWithForcedTagCreateInput>>;
  /** Delete existing "TagBrandUsage" nodes from the "Tag.tagBrandUsages" relation. */
  delete?: InputMaybe<Array<TagBrandUsageWithForcedTagWhereUniqueInput>>;
  /** Update existing "TagBrandUsage" nodes and connect them to the existing "Tag" node, through the "Tag.tagBrandUsages" relation. */
  update?: InputMaybe<Array<TagNestedUpdateTagBrandUsagesUpdateInput>>;
  /** Upsert existing "TagBrandUsage" nodes and connect them to the existing "Tag" node, through the "Tag.tagBrandUsages" relation. */
  upsert?: InputMaybe<Array<TagNestedUpsertTagBrandUsagesUpdateInput>>;
};

export type TagNestedUpdateArticleTagsUpdateInput = {
  data: ArticleTagWithForcedTagUpdateInput;
  where: ArticleTagWithForcedTagWhereUniqueInput;
};

export type TagNestedUpdateCardTagsUpdateInput = {
  data: CardTagWithForcedTagUpdateInput;
  where: CardTagWithForcedTagWhereUniqueInput;
};

export type TagNestedUpdateTagBrandUsagesUpdateInput = {
  data: TagBrandUsageWithForcedTagUpdateInput;
  where: TagBrandUsageWithOptionalTagWhereUniqueInput;
};

export type TagNestedUpsertArticleTagsUpdateInput = {
  create: ArticleTagWithForcedTagCreateInput;
  update: ArticleTagWithForcedTagUpdateInput;
  where: ArticleTagWithForcedTagWhereUniqueInput;
};

export type TagNestedUpsertCardTagsUpdateInput = {
  create: CardTagWithForcedTagCreateInput;
  update: CardTagWithForcedTagUpdateInput;
  where: CardTagWithForcedTagWhereUniqueInput;
};

export type TagNestedUpsertTagBrandUsagesUpdateInput = {
  create: TagBrandUsageWithForcedTagCreateInput;
  update: TagBrandUsageWithForcedTagUpdateInput;
  where: TagBrandUsageWithOptionalTagWhereUniqueInput;
};

export enum TagNewsletterProviderName {
  Company = 'Company',
  Person = 'Person',
  Tag = 'Tag'
}

export type TagNewsletterProviderResult = {
  __typename?: 'TagNewsletterProviderResult';
  id?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type: TagType;
};

export type TagNewsletterSearchResult = {
  __typename?: 'TagNewsletterSearchResult';
  items: Array<TagNewsletterProviderResult>;
  /** Name of the "search" */
  name?: Maybe<TagNewsletterProviderName>;
};

export enum TagOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  lang_ASC = 'lang_ASC',
  lang_DESC = 'lang_DESC',
  mergedTo_ASC = 'mergedTo_ASC',
  mergedTo_DESC = 'mergedTo_DESC',
  relationId_ASC = 'relationId_ASC',
  relationId_DESC = 'relationId_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum TagProviderName {
  Company = 'Company',
  Destination = 'Destination',
  MedecineTag = 'MedecineTag',
  Person = 'Person',
  Tag = 'Tag',
  TvBy = 'TvBy',
  TvCollection = 'TvCollection',
  TvProgram = 'TvProgram',
  VideoTag = 'VideoTag'
}

export type TagProviderResult = {
  __typename?: 'TagProviderResult';
  /** Number of articles associated with this tag */
  articleCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  relationId?: Maybe<Scalars['ID']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: TagType;
};

export type TagSearchResult = {
  __typename?: 'TagSearchResult';
  itemCount: Scalars['Int']['output'];
  items: Array<TagProviderResult>;
  /** Name of the "search" */
  name: TagProviderName;
  scores: Array<SearchItemScoreType>;
};

export enum TagSearchTypes {
  Broadcast = 'Broadcast',
  Cinema = 'Cinema',
  Collection = 'Collection',
  VOD = 'VOD'
}

export type TagSuggestResult = {
  __typename?: 'TagSuggestResult';
  items: Array<TagProviderResult>;
};

export enum TagType {
  Company = 'Company',
  Destination = 'Destination',
  HubPage = 'HubPage',
  Isin = 'Isin',
  MedecineTag = 'MedecineTag',
  Person = 'Person',
  Recipe = 'Recipe',
  Semantic = 'Semantic',
  Tag = 'Tag',
  TvChannel = 'TvChannel',
  TvCollection = 'TvCollection',
  TvProgram = 'TvProgram',
  VideoTag = 'VideoTag'
}

export type TagUpdateInput = {
  /** Actions for the "Tag.articleTags" relation: "ArticleTag.tag"'s inverse relation */
  articleTags?: InputMaybe<TagNestedArticleTagsUpdateInput>;
  /** Actions for the "Tag.cardTags" relation: "CardTag.tag"'s inverse relation */
  cardTags?: InputMaybe<TagNestedCardTagsUpdateInput>;
  /** ISO 639-1 tag language */
  lang?: InputMaybe<TagLang>;
  mergedTo?: InputMaybe<Scalars['Int']['input']>;
  relationId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Tag.tagBrandUsages" relation: "TagBrandUsage.tag"'s inverse relation */
  tagBrandUsages?: InputMaybe<TagNestedTagBrandUsagesUpdateInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TagType>;
};

/** Filters the "Tag" nodes by specifying some conditions */
export type TagWhereInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<TagWhereInput>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleTags_some?: InputMaybe<ArticleTagWhereInput>;
  cardTags_some?: InputMaybe<CardTagWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lang?: InputMaybe<TagLang>;
  lang_in?: InputMaybe<Array<TagLang>>;
  lang_not?: InputMaybe<TagLang>;
  lang_not_in?: InputMaybe<Array<TagLang>>;
  mergedTo?: InputMaybe<Scalars['Int']['input']>;
  mergedTo_gt?: InputMaybe<Scalars['Int']['input']>;
  mergedTo_gte?: InputMaybe<Scalars['Int']['input']>;
  mergedTo_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mergedTo_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  mergedTo_lt?: InputMaybe<Scalars['Int']['input']>;
  mergedTo_lte?: InputMaybe<Scalars['Int']['input']>;
  mergedTo_not?: InputMaybe<Scalars['Int']['input']>;
  mergedTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  relationId?: InputMaybe<Scalars['ID']['input']>;
  relationId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  relationId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  relationId_not?: InputMaybe<Scalars['ID']['input']>;
  relationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tagBrandUsages_some?: InputMaybe<TagBrandUsageWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TagType>;
  type_in?: InputMaybe<Array<TagType>>;
  type_not?: InputMaybe<TagType>;
  type_not_in?: InputMaybe<Array<TagType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Tag" node with one of these unique combinations of values:
 * - _id
 * - id
 * - lang, title, type
 * - lang, slug, type
 */
export type TagWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<TagLang>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TagType>;
};

export enum TargetDevice {
  android = 'android',
  editorialAlert = 'editorialAlert',
  ios = 'ios'
}

export type TargetingPushType = {
  __typename?: 'TargetingPushType';
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  segments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Taxonomy data provided by the datascience team */
export type Taxonomy = {
  __typename?: 'Taxonomy';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "ArticleTaxonomy.taxonomy"'s inverse relation */
  articleTaxonomies: Array<ArticleTaxonomy>;
  /** "ArticleTaxonomy.taxonomy"'s inverse relation count */
  articleTaxonomyCount: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  level: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: TaxonomyType;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};


/** Taxonomy data provided by the datascience team */
export type TaxonomyArticleTaxonomiesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleTaxonomyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleTaxonomyWhereInput>;
};


/** Taxonomy data provided by the datascience team */
export type TaxonomyArticleTaxonomyCountArgs = {
  where?: InputMaybe<ArticleTaxonomyWhereInput>;
};

export type TaxonomyCreateInput = {
  /** Actions for the "Taxonomy.articleTaxonomies" relation: "ArticleTaxonomy.taxonomy"'s inverse relation */
  articleTaxonomies?: InputMaybe<TaxonomyNestedArticleTaxonomiesCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  level: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: TaxonomyType;
  version: Scalars['Int']['input'];
};

export type TaxonomyNestedArticleTaxonomiesCreateInput = {
  /** Create new "ArticleTaxonomy" nodes and connect them to the new "Taxonomy" node, through the "Taxonomy.articleTaxonomies" relation. */
  create?: InputMaybe<Array<ArticleTaxonomyWithForcedTaxonomyCreateInput>>;
};

export type TaxonomyNestedArticleTaxonomiesUpdateInput = {
  /** Create new "ArticleTaxonomy" nodes and connect them to the existing "Taxonomy" node, through the "Taxonomy.articleTaxonomies" relation. */
  create?: InputMaybe<Array<ArticleTaxonomyWithForcedTaxonomyCreateInput>>;
  /** Delete existing "ArticleTaxonomy" nodes from the "Taxonomy.articleTaxonomies" relation. */
  delete?: InputMaybe<Array<ArticleTaxonomyWithForcedTaxonomyWhereUniqueInput>>;
  /** Update existing "ArticleTaxonomy" nodes and connect them to the existing "Taxonomy" node, through the "Taxonomy.articleTaxonomies" relation. */
  update?: InputMaybe<Array<TaxonomyNestedUpdateArticleTaxonomiesUpdateInput>>;
  /** Upsert existing "ArticleTaxonomy" nodes and connect them to the existing "Taxonomy" node, through the "Taxonomy.articleTaxonomies" relation. */
  upsert?: InputMaybe<Array<TaxonomyNestedUpsertArticleTaxonomiesUpdateInput>>;
};

export type TaxonomyNestedUpdateArticleTaxonomiesUpdateInput = {
  data: ArticleTaxonomyWithForcedTaxonomyUpdateInput;
  where: ArticleTaxonomyWithForcedTaxonomyWhereUniqueInput;
};

export type TaxonomyNestedUpsertArticleTaxonomiesUpdateInput = {
  create: ArticleTaxonomyWithForcedTaxonomyCreateInput;
  update: ArticleTaxonomyWithForcedTaxonomyUpdateInput;
  where: ArticleTaxonomyWithForcedTaxonomyWhereUniqueInput;
};

export enum TaxonomyOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  level_ASC = 'level_ASC',
  level_DESC = 'level_DESC',
  provider_ASC = 'provider_ASC',
  provider_DESC = 'provider_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  version_ASC = 'version_ASC',
  version_DESC = 'version_DESC'
}

export enum TaxonomyType {
  IAB = 'IAB',
  Semantic = 'Semantic'
}

export type TaxonomyUpdateInput = {
  /** Actions for the "Taxonomy.articleTaxonomies" relation: "ArticleTaxonomy.taxonomy"'s inverse relation */
  articleTaxonomies?: InputMaybe<TaxonomyNestedArticleTaxonomiesUpdateInput>;
  level?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaxonomyType>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "Taxonomy" nodes by specifying some conditions */
export type TaxonomyWhereInput = {
  AND?: InputMaybe<Array<TaxonomyWhereInput>>;
  NOT?: InputMaybe<TaxonomyWhereInput>;
  OR?: InputMaybe<Array<TaxonomyWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleTaxonomies_some?: InputMaybe<ArticleTaxonomyWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_contains?: InputMaybe<Scalars['String']['input']>;
  level_ends_with?: InputMaybe<Scalars['String']['input']>;
  level_gt?: InputMaybe<Scalars['String']['input']>;
  level_gte?: InputMaybe<Scalars['String']['input']>;
  level_in?: InputMaybe<Array<Scalars['String']['input']>>;
  level_lt?: InputMaybe<Scalars['String']['input']>;
  level_lte?: InputMaybe<Scalars['String']['input']>;
  level_not?: InputMaybe<Scalars['String']['input']>;
  level_not_contains?: InputMaybe<Scalars['String']['input']>;
  level_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  level_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  level_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  level_starts_with?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_contains?: InputMaybe<Scalars['String']['input']>;
  provider_ends_with?: InputMaybe<Scalars['String']['input']>;
  provider_gt?: InputMaybe<Scalars['String']['input']>;
  provider_gte?: InputMaybe<Scalars['String']['input']>;
  provider_in?: InputMaybe<Array<Scalars['String']['input']>>;
  provider_lt?: InputMaybe<Scalars['String']['input']>;
  provider_lte?: InputMaybe<Scalars['String']['input']>;
  provider_not?: InputMaybe<Scalars['String']['input']>;
  provider_not_contains?: InputMaybe<Scalars['String']['input']>;
  provider_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  provider_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  provider_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  provider_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaxonomyType>;
  type_in?: InputMaybe<Array<TaxonomyType>>;
  type_not?: InputMaybe<TaxonomyType>;
  type_not_in?: InputMaybe<Array<TaxonomyType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Identifies exactly one "Taxonomy" node with one of these unique combinations of values:
 * - _id
 * - id
 * - level, provider, title, type, version
 * - level, provider, slug, type, version
 */
export type TaxonomyWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaxonomyType>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type TranslateArticleType = {
  __typename?: 'TranslateArticleType';
  body?: Maybe<Scalars['String']['output']>;
  lead?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** An article url */
export type Url = {
  __typename?: 'Url';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "ArticleUrl.url"'s inverse relation count */
  articleUrlCount: Scalars['Int']['output'];
  /** "ArticleUrl.url"'s inverse relation */
  articleUrls: Array<ArticleUrl>;
  brandKey: BrandKey;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  domain: Scalars['String']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  /** A strict positive integer, stringified, used to generate the path */
  publicId: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** An article url */
export type UrlArticleUrlCountArgs = {
  where?: InputMaybe<ArticleUrlWhereInput>;
};


/** An article url */
export type UrlArticleUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArticleUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleUrlWhereInput>;
};

export type UrlArticleUrlsUrlSearchWhereInput = {
  AND?: InputMaybe<Array<UrlArticleUrlsUrlSearchWhereInput>>;
  NOT?: InputMaybe<UrlArticleUrlsUrlSearchWhereInput>;
  OR?: InputMaybe<Array<UrlArticleUrlsUrlSearchWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_in?: InputMaybe<Array<Scalars['String']['input']>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UrlCreateInput = {
  /** Actions for the "Url.articleUrls" relation: "ArticleUrl.url"'s inverse relation */
  articleUrls?: InputMaybe<UrlNestedArticleUrlsCreateInput>;
  brandKey: BrandKey;
  domain: Scalars['String']['input'];
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  path: Scalars['String']['input'];
  /** A strict positive integer, stringified, used to generate the path */
  publicId: Scalars['String']['input'];
};

export type UrlNestedArticleUrlsCreateInput = {
  /** Create new "ArticleUrl" nodes and connect them to the new "Url" node, through the "Url.articleUrls" relation. */
  create?: InputMaybe<Array<ArticleUrlWithForcedUrlCreateInput>>;
};

export enum UrlOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  domain_ASC = 'domain_ASC',
  domain_DESC = 'domain_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  path_ASC = 'path_ASC',
  path_DESC = 'path_DESC',
  publicId_ASC = 'publicId_ASC',
  publicId_DESC = 'publicId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Filters the "Url" nodes by specifying some conditions */
export type UrlWhereInput = {
  AND?: InputMaybe<Array<UrlWhereInput>>;
  NOT?: InputMaybe<UrlWhereInput>;
  OR?: InputMaybe<Array<UrlWhereInput>>;
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  articleUrls_some?: InputMaybe<ArticleUrlWhereInput>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_contains?: InputMaybe<Scalars['String']['input']>;
  domain_ends_with?: InputMaybe<Scalars['String']['input']>;
  domain_gt?: InputMaybe<Scalars['String']['input']>;
  domain_gte?: InputMaybe<Scalars['String']['input']>;
  domain_in?: InputMaybe<Array<Scalars['String']['input']>>;
  domain_lt?: InputMaybe<Scalars['String']['input']>;
  domain_lte?: InputMaybe<Scalars['String']['input']>;
  domain_not?: InputMaybe<Scalars['String']['input']>;
  domain_not_contains?: InputMaybe<Scalars['String']['input']>;
  domain_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  domain_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  domain_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  domain_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_ends_with?: InputMaybe<Scalars['String']['input']>;
  path_gt?: InputMaybe<Scalars['String']['input']>;
  path_gte?: InputMaybe<Scalars['String']['input']>;
  path_in?: InputMaybe<Array<Scalars['String']['input']>>;
  path_lt?: InputMaybe<Scalars['String']['input']>;
  path_lte?: InputMaybe<Scalars['String']['input']>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  path_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  path_starts_with?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  publicId_contains?: InputMaybe<Scalars['String']['input']>;
  publicId_ends_with?: InputMaybe<Scalars['String']['input']>;
  publicId_gt?: InputMaybe<Scalars['String']['input']>;
  publicId_gte?: InputMaybe<Scalars['String']['input']>;
  publicId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  publicId_lt?: InputMaybe<Scalars['String']['input']>;
  publicId_lte?: InputMaybe<Scalars['String']['input']>;
  publicId_not?: InputMaybe<Scalars['String']['input']>;
  publicId_not_contains?: InputMaybe<Scalars['String']['input']>;
  publicId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  publicId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  publicId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  publicId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Url" node with one of these unique values:
 * - _id
 * - id
 */
export type UrlWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
};

export type OpenAiProcessReturnType = {
  __typename?: 'openAiProcessReturnType';
  /** Internal OpenAI Process ID */
  processId: Scalars['String']['output'];
};

export type SearchAffilizzDesignResult = {
  __typename?: 'searchAffilizzDesignResult';
  defaultDesign: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  originType: AffilizzDesignOriginTypeResult;
  publishedAt: Scalars['DateTime']['output'];
  renderingType: AffilizzDesignRenderingTypeResult;
  state: AffilizzDesignStateResult;
};

export type SearchAffilizzProductResult = {
  __typename?: 'searchAffilizzProductResult';
  content: Array<AffilizzProduct>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<SearchAffilizzProductResultPageable>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SearchAffilizzProductResultSort>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type SearchAffilizzProductResultPageable = {
  __typename?: 'searchAffilizzProductResultPageable';
  offset?: Maybe<Scalars['Int']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  paged?: Maybe<Scalars['Boolean']['output']>;
  sort?: Maybe<SearchAffilizzProductResultPageableSort>;
  unpaged?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchAffilizzProductResultPageableSort = {
  __typename?: 'searchAffilizzProductResultPageableSort';
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchAffilizzProductResultSort = {
  __typename?: 'searchAffilizzProductResultSort';
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchMediaArticleCountResultType = {
  __typename?: 'searchMediaArticleCountResultType';
  count: Scalars['Int']['output'];
  mediaElement: Scalars['String']['output'];
};

export type UpdateCampaignResult = {
  __typename?: 'updateCampaignResult';
  campaign_token: Scalars['String']['output'];
};

export type VertexAiRecipesIngredientsType = {
  __typename?: 'vertexAIRecipesIngredientsType';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type VertexAiRecipesResultType = {
  __typename?: 'vertexAIRecipesResultType';
  ingredients: Array<VertexAiRecipesIngredientsType>;
  recipesIds: Array<Scalars['String']['output']>;
};

export type SearchArticlesQuery_searchArticles_Article_articleCreatorData_ArticleCreatorData = {
  __typename?: 'ArticleCreatorData',
  name: string
};

export type SearchArticlesQuery_searchArticles_Article_articleUrls_ArticleUrl_url_Url = {
  __typename?: 'Url',
  path: string,
  domain: string
};

export type SearchArticlesQuery_searchArticles_Article_articleUrls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  url: SearchArticlesQuery_searchArticles_Article_articleUrls_ArticleUrl_url_Url
};

export type SearchArticlesQuery_searchArticles_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  body?: string | null,
  medias?: string | null,
  publishedAt?: string | null,
  status: ArticleStatus,
  articleCreatorData?: SearchArticlesQuery_searchArticles_Article_articleCreatorData_ArticleCreatorData | null,
  articleUrls: Array<SearchArticlesQuery_searchArticles_Article_articleUrls_ArticleUrl>
};

export type SearchArticlesQuery_Query = {
  __typename?: 'Query',
  searchArticles: Array<SearchArticlesQuery_searchArticles_Article>
};


export type SearchArticlesQueryVariables = Exact<{
  where?: InputMaybe<ArticleSearchWhereInput>;
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ArticleSearchOrderByInput> | ArticleSearchOrderByInput>;
}>;


export type SearchArticlesQuery = SearchArticlesQuery_Query;

export type GetAuthorsQuery_authors_Author = {
  __typename?: 'Author',
  id: string,
  name: string
};

export type GetAuthorsQuery_Query = {
  __typename?: 'Query',
  authors: Array<GetAuthorsQuery_authors_Author>
};


export type GetAuthorsQueryVariables = Exact<{
  where: AuthorWhereInput;
}>;


export type GetAuthorsQuery = GetAuthorsQuery_Query;

export type GetAuthorQuery_author_Author = {
  __typename?: 'Author',
  id: string,
  name: string
};

export type GetAuthorQuery_Query = {
  __typename?: 'Query',
  author?: GetAuthorQuery_author_Author | null
};


export type GetAuthorQueryVariables = Exact<{
  where: AuthorWhereUniqueInput;
}>;


export type GetAuthorQuery = GetAuthorQuery_Query;

export type GetBrandKeysQuery_categories_Category = {
  __typename?: 'Category',
  id: string,
  brandKey: BrandKey
};

export type GetBrandKeysQuery_Query = {
  __typename?: 'Query',
  categories: Array<GetBrandKeysQuery_categories_Category>
};


export type GetBrandKeysQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  where: CategoryWhereInput;
}>;


export type GetBrandKeysQuery = GetBrandKeysQuery_Query;

export type GetImageSourceCategoriesQuery_imageSourceCategories_ImageSourceCategory_imageSources_ImageSource = {
  __typename?: 'ImageSource',
  id: string,
  title: string
};

export type GetImageSourceCategoriesQuery_imageSourceCategories_ImageSourceCategory = {
  __typename?: 'ImageSourceCategory',
  id: string,
  title: string,
  imageSources: Array<GetImageSourceCategoriesQuery_imageSourceCategories_ImageSourceCategory_imageSources_ImageSource>
};

export type GetImageSourceCategoriesQuery_Query = {
  __typename?: 'Query',
  imageSourceCategories: Array<GetImageSourceCategoriesQuery_imageSourceCategories_ImageSourceCategory>
};


export type GetImageSourceCategoriesQueryVariables = Exact<{
  where?: InputMaybe<ImageSourceCategoryWhereInput>;
  sourceWhere?: InputMaybe<ImageSourceWhereInput>;
}>;


export type GetImageSourceCategoriesQuery = GetImageSourceCategoriesQuery_Query;


export const SearchArticlesDocument = gql`
    query SearchArticles($where: ArticleSearchWhereInput, $first: Int!, $skip: Int, $orderBy: [ArticleSearchOrderByInput!]) {
  searchArticles(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
    id
    title
    body
    medias
    publishedAt
    status
    articleCreatorData {
      name
    }
    articleUrls(first: 1, orderBy: order_ASC) {
      url {
        path
        domain
      }
    }
  }
}
    `;

/**
 * __useSearchArticlesQuery__
 *
 * To run a query within a React component, call `useSearchArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArticlesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSearchArticlesQuery(baseOptions: Apollo.QueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables> & ({ variables: SearchArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
      }
export function useSearchArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
        }
export function useSearchArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
        }
export type SearchArticlesQueryHookResult = ReturnType<typeof useSearchArticlesQuery>;
export type SearchArticlesLazyQueryHookResult = ReturnType<typeof useSearchArticlesLazyQuery>;
export type SearchArticlesSuspenseQueryHookResult = ReturnType<typeof useSearchArticlesSuspenseQuery>;
export type SearchArticlesQueryResult = Apollo.QueryResult<SearchArticlesQuery, SearchArticlesQueryVariables>;
export const GetAuthorsDocument = gql`
    query GetAuthors($where: AuthorWhereInput!) {
  authors(first: 100, where: $where, orderBy: name_ASC) {
    id
    name
  }
}
    `;

/**
 * __useGetAuthorsQuery__
 *
 * To run a query within a React component, call `useGetAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAuthorsQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorsQuery, GetAuthorsQueryVariables> & ({ variables: GetAuthorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, options);
      }
export function useGetAuthorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorsQuery, GetAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, options);
        }
export function useGetAuthorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorsQuery, GetAuthorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, options);
        }
export type GetAuthorsQueryHookResult = ReturnType<typeof useGetAuthorsQuery>;
export type GetAuthorsLazyQueryHookResult = ReturnType<typeof useGetAuthorsLazyQuery>;
export type GetAuthorsSuspenseQueryHookResult = ReturnType<typeof useGetAuthorsSuspenseQuery>;
export type GetAuthorsQueryResult = Apollo.QueryResult<GetAuthorsQuery, GetAuthorsQueryVariables>;
export const GetAuthorDocument = gql`
    query GetAuthor($where: AuthorWhereUniqueInput!) {
  author(where: $where) {
    id
    name
  }
}
    `;

/**
 * __useGetAuthorQuery__
 *
 * To run a query within a React component, call `useGetAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAuthorQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorQuery, GetAuthorQueryVariables> & ({ variables: GetAuthorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorQuery, GetAuthorQueryVariables>(GetAuthorDocument, options);
      }
export function useGetAuthorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorQuery, GetAuthorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorQuery, GetAuthorQueryVariables>(GetAuthorDocument, options);
        }
export function useGetAuthorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorQuery, GetAuthorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorQuery, GetAuthorQueryVariables>(GetAuthorDocument, options);
        }
export type GetAuthorQueryHookResult = ReturnType<typeof useGetAuthorQuery>;
export type GetAuthorLazyQueryHookResult = ReturnType<typeof useGetAuthorLazyQuery>;
export type GetAuthorSuspenseQueryHookResult = ReturnType<typeof useGetAuthorSuspenseQuery>;
export type GetAuthorQueryResult = Apollo.QueryResult<GetAuthorQuery, GetAuthorQueryVariables>;
export const GetBrandKeysDocument = gql`
    query GetBrandKeys($first: Int!, $where: CategoryWhereInput!) {
  categories(where: $where, first: $first) {
    id
    brandKey
  }
}
    `;

/**
 * __useGetBrandKeysQuery__
 *
 * To run a query within a React component, call `useGetBrandKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandKeysQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetBrandKeysQuery(baseOptions: Apollo.QueryHookOptions<GetBrandKeysQuery, GetBrandKeysQueryVariables> & ({ variables: GetBrandKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandKeysQuery, GetBrandKeysQueryVariables>(GetBrandKeysDocument, options);
      }
export function useGetBrandKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandKeysQuery, GetBrandKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandKeysQuery, GetBrandKeysQueryVariables>(GetBrandKeysDocument, options);
        }
export function useGetBrandKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandKeysQuery, GetBrandKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrandKeysQuery, GetBrandKeysQueryVariables>(GetBrandKeysDocument, options);
        }
export type GetBrandKeysQueryHookResult = ReturnType<typeof useGetBrandKeysQuery>;
export type GetBrandKeysLazyQueryHookResult = ReturnType<typeof useGetBrandKeysLazyQuery>;
export type GetBrandKeysSuspenseQueryHookResult = ReturnType<typeof useGetBrandKeysSuspenseQuery>;
export type GetBrandKeysQueryResult = Apollo.QueryResult<GetBrandKeysQuery, GetBrandKeysQueryVariables>;
export const GetImageSourceCategoriesDocument = gql`
    query GetImageSourceCategories($where: ImageSourceCategoryWhereInput, $sourceWhere: ImageSourceWhereInput) {
  imageSourceCategories(first: 100, orderBy: title_ASC, where: $where) {
    id
    title
    imageSources(first: 100, orderBy: title_ASC, where: $sourceWhere) {
      id
      title
    }
  }
}
    `;

/**
 * __useGetImageSourceCategoriesQuery__
 *
 * To run a query within a React component, call `useGetImageSourceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageSourceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageSourceCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      sourceWhere: // value for 'sourceWhere'
 *   },
 * });
 */
export function useGetImageSourceCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>(GetImageSourceCategoriesDocument, options);
      }
export function useGetImageSourceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>(GetImageSourceCategoriesDocument, options);
        }
export function useGetImageSourceCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>(GetImageSourceCategoriesDocument, options);
        }
export type GetImageSourceCategoriesQueryHookResult = ReturnType<typeof useGetImageSourceCategoriesQuery>;
export type GetImageSourceCategoriesLazyQueryHookResult = ReturnType<typeof useGetImageSourceCategoriesLazyQuery>;
export type GetImageSourceCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetImageSourceCategoriesSuspenseQuery>;
export type GetImageSourceCategoriesQueryResult = Apollo.QueryResult<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>;